export const SRIDEVI = {

"01/01/2024 to 01/07/2024": [
  ["367", "69", "568"],
  ["123", "61", "137"],
  ["336", "27", "124"],
  ["389", "06", "349"],
  ["145", "02", "246"],
  ["358", "61", "128"],
  ["134", "83", "779"]
],
"01/08/2024 to 01/14/2024": [
    ['578', '06', '367'],
    ['336', '25', '258'],
    ['690', '57', '377'],
    ['370', '03', '689'],                 
    ['369', '87', '278'],
    ['357', '59', '568'],
    ['178', '66', '556']
  ],
  "01/15/2024 to 01/21/2024": [
    ['123', '64', '130'],
    ['115', '79', '360'],
    ['258', '57', '124'],
    ['377', '75', '230'],
    ['247', '38', '378'],
    ['260', '80', '677'],
    ['477', '82', '679']
  ],
  "01/22/2024 to 01/28/2024": [
    ['123', '69', '478'],
    ['228', '21', '560'],
    ['350', '83', '247'],
    ['669', '13', '148'],
    ['***', '**', '***'],
    ['566', '73', '445'],
    ['470', '13', '256']
  ],
  "01/29/2024 to 02/04/2024": [
    ['223', '74', '167'],
    ['136', '00', '389'],
    ['260', '89', '144'],
    ['188', '79', '135'],
    ['146', '17', '359'],
    ['236', '14', '130'],
    ['168', '58', '800']
  ],
  "02/05/2024 to 02/11/2024": [
    ['589', '22', '499'],
    ['578', '00', '235'],
    ['568', '95', '456'],
    ['190', '04', '356'],
    ['467', '73', '139'],
    ['250', '74', '590'],
    ['359', '71', '678']
  ],
  "02/12/2024 to 02/18/2024": [
    ['127', '01', '579'],
    ['267', '54', '356'],
    ['239', '42', '480'],
    ['399', '13', '148'],
    ['127', '09', '225'],
    ['114', '69', '568'],
    ['780', '56', '259']
  ],
  "02/19/2024 to 02/25/2024": [
    ['790', '62', '345'],
    ['578', '03', '247'],
    ['245', '13', '157'],
    ['348', '58', '459'],
    ['189', '84', '239'],
    ['338', '49', '379'],
    ['469', '98', '279']
  ],
  "02/26/2024 to 03/03/2024": [
    ['138', '28', '459'],
    ['590', '49', '135'],
    ['489', '11', '236'],
    ['136', '04', '167'],
    ['456', '50', '127'],
    ['340', '70', '244'],
    ['279', '84', '680']
  ],
  "03/04/2024 to 03/10/2024": [
    ['899', '63', '148'],
    ['278', '71', '669'],
    ['137', '19', '270'],
    ['170', '89', '478'],
    ['459', '86', '178'],
    ['466', '68', '260'],
    ['456', '54', '257']
  ],
  "03/11/2024 to 03/17/2024": [
    ['566', '70', '299'],
    ['780', '55', '249'],
    ['588', '19', '234'],
    ['230', '55', '168'],
    ['379', '93', '670'],
    ['289', '90', '190'],
    ['330', '66', '899']
  ],
  "03/18/2024 to 03/24/2024": [
    ['146', '16', '349'],
    ['350', '82', '246'],
    ['349', '67', '250'],
    ['138', '29', '135'],
    ['260', '86', '178'],
    ['367', '64', '266'],
    ['248', '43', '490']
  ],
  "03/25/2024 to 03/31/2024": [
    ['***', '**', '***'],
    ['590', '48', '125'],
    ['259', '64', '699'],
    ['245', '12', '589'],
    ['170', '88', '459'],
    ['160', '74', '266'],
    ['579', '19', '388']
  ],
  "04/01/2024 to 04/07/2024": [
    ['368', '73', '788'],
    ['133', '72', '147'],
    ['255', '23', '788'],
    ['237', '26', '899'],
    ['899', '63', '247'],
    ['160', '70', '127'],
    ['260', '81', '579']
  ],
  "04/08/2024 to 04/14/2024": [
    ['289', '98', '134'],
    ['369', '81', '146'],
    ['150', '61', '245'],
    ['790', '67', '458'],
    ['569', '00', '370'],
    ['168', '52', '570'],
    ['249', '56', '790']
  ],
  "04/15/2024 to 04/21/2024": [
    ['357', '52', '156'],
    ['569', '04', '248'],
    ['178', '63', '670'],
    ['468', '87', '250'],
    ['130', '42', '237'],
    ['124', '76', '268'],
    ['233', '89', '270']
  ],
  "04/22/2024 to 04/28/2024": [
    ['668', '00', '127'],
    ['370', '08', '134'],
    ['556', '62', '589'],
    ['358', '60', '389'],
    ['600', '68', '567'],
    ['469', '98', '116'],
    ['389', '09', '270']
  ],
  "04/29/2024 to 05/05/2024": [
    ['456', '59', '144'],
    ['339', '57', '449'],
    ['158', '48', '477'],
    ['167', '48', '558'],
    ['678', '18', '224'],
    ['479', '03', '689'],
    ['559', '92', '110']
  ],
  "05/06/2024 to 05/12/2024": [
    ['169', '65', '780'],
    ['220', '42', '660'],
    ['239', '46', '600'],
    ['366', '57', '458'],
    ['489', '17', '377'],
    ['357', '53', '166'],
    ['360', '95', '159']
  ],
  "05/13/2024 to 05/19/2024": [
    ['880', '64', '112'],
    ['570', '29', '577'],
    ['478', '95', '267'],
    ['557', '70', '578'],
    ['346', '37', '467'],
    ['470', '19', '135'],
    ['179', '78', '567']
  ],
  "05/20/2024 to 05/26/2024": [
    ['190', '05', '159'],
    ['457', '68', '125'],
    ['245', '13', '580'],
    ['267', '53', '256'],
    ['370', '05', '230'],
    ['236', '13', '599'],
    ['890', '72', '156']
  ],
  "05/27/2024 to 06/02/2024": [
    ['147', '23', '346'],
    ['778', '25', '159'],
    ['140', '59', '180'],
    ['669', '16', '448'],
    ['588', '10', '127'],
    ['336', '28', '279'],
    ['179', '76', '259']
  ],
  "06/03/2024 to 06/09/2024": [
    ['246', '29', '450'],
    ['678', '16', '367'],
    ['359', '73', '256'],
    ['678', '15', '258'],
    ['690', '51', '290'],
    ['579', '19', '234'],
    ['670', '32', '345']
  ],
  "06/10/2024 to 06/16/2024": [
    ['589', '24', '789'],
    ['190', '01', '335'],
    ['145', '02', '138'],
    ['589', '29', '469'],
    ['789', '48', '170'],
    ['260', '84', '770'],
    ['130', '47', '566']
  ],
  "06/17/2024 to 06/23/2024": [
    ['267', '51', '560'],
    ['235', '08', '134'],
    ['256', '32', '138'],
    ['190', '01', '678'],
    ['266', '45', '168'],
    ['239', '42', '246'],
    ['257', '45', '348']
  ],
  "06/24/2024 to 06/30/2024": [
    ['128', '12', '147'],
    ['137', '18', '224'],
    ['147', '28', '350'],
    ['345', '23', '139'],
    ['368', '73', '490'],
    ['250', '76', '178'],
    ['279', '84', '356']
  ],
  "07/01/2024 to 07/07/2024": [
    ['780', '51', '560'],
    ['357', '50', '136'],
    ['690', '54', '590'],
    ['147', '21', '155'],
    ['158', '49', '270'],
    ['467', '76', '790'],
    ['140', '57', '269']
  ],
  "07/08/2024 to 07/14/2024": [
    ['890', '77', '223'],
    ['800', '88', '468'],
    ['566', '73', '247'],
    ['134', '88', '170'],
    ['360', '91', '579'],
    ['790', '60', '569'],
    ['168', '53', '148']
  ],
  "07/15/2024 to 07/21/2024": [
    ['450', '97', '890'],
    ['334', '00', '190'],
    ['459', '81', '669'],
    ['123', '69', '379'],
    ['360', '97', '359'],
    ['168', '57', '269'],
    ['467', '71', '470']
  ],
  "07/22/2024 to 07/28/2024": [
    ['168', '51', '579'],
    ['447', '53', '166'],
    ['136', '09', '126'],
    ['170', '83', '157'],
    ['370', '08', '170'],
    ['468', '82', '480'],
    ['356', '48', '369']
  ],
  "07/29/2024 to 08/04/2024": [
    ['257', '47', '160'],
    ['458', '77', '368'],
    ['267', '55', '258'],
    ['367', '63', '256'],
    ['169', '62', '679'],
    ['125', '85', '366'],
    ['258', '59', '577']
  ],
  "08/05/2024 to 08/11/2024": [
    ['380', '13', '670'],
    ['267', '59', '469'],
    ['245', '14', '167'],
    ['259', '62', '156'],
    ['790', '60', '127'],
    ['288', '87', '269'],
    ['244', '06', '123']
  ],
  "08/12/2024 to 08/18/2024": [
    ['378', '84', '257'],
    ['389', '08', '468'],
    ['129', '24', '356'],
    ['***', '**', '***'],
    ['569', '08', '459'],
    ['168', '54', '130'],
    ['289', '97', '269']
  ],
  "08/19/2024 to 08/25/2024": [
    ['178', '63', '247'],
    ['135', '99', '568'],
    ['680', '42', '156'],
    ['567', '89', '117'],
    ['447', '50', '226'],
    ['146', '16', '899'],
    ['678', '16', '457']
  ],
  "08/26/2024 to 09/01/2024": [
    ['137', '19', '450'],
    ['889', '52', '228'],
    ['125', '82', '345'],
    ['559', '96', '358'],
    ['578', '08', '170'],
    ['390', '28', '134'],
    ['124', '70', '479']
  ],
  "09/02/2024 to 09/08/2024": [
    ['156', '23', '157'],
    ['278', '76', '600'],
    ['700', '76', '123'],
    ['347', '41', '669'],
    ['590', '42', '570'],
    ['380', '19', '469'],
    ['137', '13', '157']
  ],
  "09/09/2024 to 09/15/2024": [
    ['378', '87', '340'],
    ['570', '23', '346'],
    ['660', '29', '270'],
    ['590', '41', '236'],
    ['277', '63', '670'],
    ['188', '76', '367'],
    ['330', '62', '480']
  ],
  "09/16/2024 to 09/22/2024": [
    ['479', '09', '667'],
    ['348', '52', '138'],
    ['179', '75', '780'],
    ['770', '43', '346'],
    ['158', '43', '139'],
    ['459', '81', '579'],
    ['257', '40', '136']
  ],
  "09/23/2024 to 09/29/2024": [
    ['579', '13', '157'],
    ['569', '06', '457'],
    ['114', '69', '199'],
    ['150', '67', '223'],
    ['136', '02', '778'],
    ['249', '53', '580'],
    ['348', '56', '123']
  ],
  "09/30/2024 to 10/06/2024": [
    ['260', '88', '134'],
    ['338', '43', '247'],
    ['169', '60', '136'],
    ['267', '55', '357'],
    ['124', '79', '667'],
    ['459', '81', '146'],
    ['348', '59', '135']
  ],
  "10/07/2024 to 10/13/2024": [
    ['248', '45', '122'],
    ['188', '77', '115'],
    ['290', '11', '470'],
    ['249', '59', '270'],
    ['345', '21', '335'],
    ['589', '29', '478'],
    ['278', '72', '679']
  ],
  "10/14/2024 to 10/20/2024": [
    ['570', '21', '236'],
    ['780', '54', '590'],
    ['356', '45', '799'],
    ['125', '89', '559'],
    ['378', '85', '456'],
    ['249', '55', '140'],
    ['990', '80', '479']
  ],
  "10/21/2024 to 10/27/2024": [
    ['788', '38', '459'],
    ['466', '69', '388'],
    ['278', '72', '480'],
    ['347', '42', '156'],
    ['235', '09', '360'],
    ['590', '49', '270'],
    ['112', '47', '160']
  ],
  "10/28/2024 to 11/03/2024": [
    ['458', '75', '159'],
    ['599', '32', '156'],
    ['359', '74', '266'],
    ['126', '98', '378'],
    ['134', '84', '347'],
    ['677', '06', '349'],
    ['224', '83', '148']
  ],
  "11/04/2024 to 11/10/2024": [
    ['458', '74', '257'],
    ['567', '81', '290'],
    ['268', '66', '150'],
    ['178', '66', '349'],
    ['467', '70', '136'],
    ['127', '02', '390'],
    ['259', '63', '256']
  ],
  "11/11/2024 to 11/17/2024": [
    ['127', '09', '900'],
    ['224', '82', '147'],
    ['556', '69', '450'],
    ['233', '88', '567'],
    ['790', '66', '556'],
    ['678', '19', '180'],
    ['356', '49', '289']
  ],
  "11/18/2024 to 11/24/2024": [
    ['160', '78', '558'],
    ['227', '16', '448'],
    ['226', '03', '229'],
    ['900', '95', '447'],
    ['789', '40', '370'],
    ['255', '29', '234'],
    ['367', '65', '780']
  ],
  "11/25/2024 to 12/01/2024": [
    ['560', '18', '369'],
    ['117', '96', '349'],
    ['660', '21', '128'],
    ['266', '41', '678'],
    ['570', '28', '800'],
    ['480', '23', '689'],
    ['258', '53', '580']
  ],
  "12/02/2024 to 12/08/2024": [
    ['447', '55', '357'],
    ['570', '26', '790'],
    ['688', '29', '289'],
    ['479', '08', '459'],
    ['256', '38', '279'],
    ['345', '23', '139'],
    ['180', '96', '150']
  ],
  "12/09/2024 to 12/15/2024": [
    ['149', '48', '260'],
    ['460', '08', '134'],
    ['267', '50', '389'],
    ['456', '52', '390'],
    ['350', '81', '146'],
    ['190', '08', '134'],
    ['890', '76', '448']
  ],
  "12/16/2024 to 12/22/2024": [
    ['560', '11', '678'],
    ['235', '04', '239'],
    ['189', '81', '669'],
    ['688', '22', '390'],
    ['139', '37', '566'],
    ['180', '98', '558'],
    ['147', '26', '240']
  ],
  "12/23/2024 to 12/29/2024": [
    ['678', '15', '168'],
    ['459', '88', '378'],
    ['345', '26', '367'],
    ['369', '86', '150'],
    ['390', '26', '358'],
    ['168', '58', '990'],
    ['690', '54', '149']
  ],
"12/30/2024 to 01/05/2025": [
  ["569", "04", "248"],
  ["348", "57", "557"],
  ["690", "57", "340"],
  ["240", "64", "167"],
  ["478", "96", "457"],
  ["270", "93", "148"],
  ["135", "96", "367"]
],
"01/06/2025 to 01/12/2025": [
  ["458", "70", "127"],
  ["378", "89", "450"],
  ["468", "81", "579"],
  ["679", "29", "469"],
  ["456", "54", "167"],
  ["480", "26", "240"],
  ["470", "17", "250"]
],
"01/13/2025 to 01/19/2025": [
  ["448", "65", "799"],
  ["199", "97", "377"],
  ["270", "98", "125"],
  ["477", "81", "678"],
  ["568", "97", "179"],
  ["990", "87", "359"],
  ["256", "35", "348"]
],
"01/20/2025 to 01/26/2025": [
  ["135", "93", "346"],
  ["579", "18", "125"],
  ["259", "63", "256"],
  ["780", "56", "150"],
  ["166", "30", "370"],
  ["120", "34", "770"],
  ["***", "**", "***"]
],
"01/27/2025 to 02/02/2025": [
  ["366", "59", "388"],
  ["336", "29", "379"],
  ["156", "23", "355"],
  ["237", "29", "270"],
  ["233", "87", "557"],
  ["248", "49", "126"],
  ["378", "80", "136"]
],
"02/03/2025 to 02/09/2025": [
  ["180", "97", "124"],
  ["469", "96", "114"],
  ["245", "16", "349"],
  ["349", "61", "146"],
  ["489", "12", "246"],
  ["367", "61", "236"],
  ["390", "28", "170"]
],
"02/10/2025 to 02/16/2025": [
  ["360", "94", "789"],
  ["778", "22", "138"],
  ["359", "70", "235"],
  ["679", "23", "445"],
  ["269", "76", "358"],
  ["159", "57", "124"],
  ["299", "01", "335"]
]
,
"02/17/2025 to 02/23/2025": [
  ["259", "61", "489"],
  ["367", "63", "689"],
  ["690", "53", "157"],
  ["190", "04", "239"],
  ["124", "72", "679"],
  ["267", "55", "780"],
  ["478", "97", "368"]
],
"02/24/2025 to 03/02/2025": [
  ["378", "80", "145"],
  ["467", "78", "468"],
  ["599", "34", "400"],
  ["157", "39", "478"],
  ["147", "21", "146"],
  ["467", "70", "136"],
  ["689", "34", "257"]
],
 "03/03/2025 to 03/09/2025": [
    ["160", "77", "359"],
    ["370", "04", "248"],
    ["136", "04", "149"],
    ["460", "06", "123"],
    ["378", "89", "180"],
    ["345", "28", "459"],
    ["567", "83", "346"]
  ],
  "03/10/2025 to 03/16/2025": [
    ["188", "71", "344"],
    ["330", "62", "778"],
    ["288", "84", "789"],
    ["568", "90", "244"],
    ["***", "**", "***"],
    ["578", "02", "688"],
    ["156", "28", "459"]
  ],
  "03/17/2025 to 03/23/2025": [
    ["799", "58", "260"],
    ["600", "60", "334"],
    ["667", "99", "360"],
    ["368", "77", "458"],
    ["289", "91", "579"],
    ["469", "95", "348"],
    ["899", "60", "145"]
  ],
  "03/24/2025 to 03/30/2025": [
    ["789", "42", "129"],
    ["150", "62", "138"],
    ["478", "98", "567"],
    ["779", "35", "348"],
    ["445", "32", "246"],
    ["680", "48", "170"],
    ["579", "14", "248"]
  ],
  "03/31/2025 to 04/06/2025": [
    ["669", "14", "158"],
    ["178", "67", "250"],
    ["290", "14", "266"],
    ["137", "14", "257"],
    ["569", "08", "279"],
    ["267", "50", "280"],
    ["346", "37", "557"]
  ],
  "04/07/2025 to 04/13/2025": [
    ["360", "99", "126"],
    ["146", "17", "890"],
    ["348", "51", "137"],
    ["125", "85", "168"],
    ["690", "56", "123"],
    ["249", "53", "148"],
    ["180", "97", "269"]
  ],
  "04/14/2025 to 04/20/2025": [
    ["380", "17", "278"],
    ["190", "05", "690"],
    ["456", "59", "289"],
    ["258", "54", "149"],
    ["335", "11", "489"],
    ["245", "17", "278"],
    ["115", "79", "900"]
  ],
  "04/21/2025 to 04/27/2025": [
    ["590", "44", "130"],
    ["379", "90", "578"],
    ["257", "49", "289"],
    ["469", "98", "279"],
    ["246", "29", "667"],
    ["269", "78", "350"],
    ["379", "92", "237"]
  ],
  "04/28/2025 to 05/04/2025": [
    ["167", "47", "124"],
    ["200", "26", "240"],
    ["299", "01", "560"],
    ["160", "70", "226"],
    ["577", "99", "450"],
    ["227", "11", "236"],
    ["114", "62", "688"]
  ],
  "05/05/2025 to 05/11/2025": [
    ["259", "68", "233"],
    ["570", "27", "179"],
    ["390", "26", "790"],
    ["234", "99", "469"],
    ["279", "84", "158"],
    ["559", "91", "344"],
    ["790", "65", "348"]
  ],
  "05/12/2025 to 05/18/2025": [
    ["178", "68", "468"],
    ["889", "56", "899"],
    ["348", "58", "125"],
    ["570", "28", "378"],
    ["240", "65", "168"],
    ["167", "45", "113"],
    ["156", "29", "478"]
  ],
  "05/19/2025 to 05/25/2025": [
    ["224", "88", "125"],
    ["148", "30", "190"],
    ["479", "08", "440"],
    ["479", "03", "139"],
    ["157", "38", "134"],
    ["347", "43", "490"],
    ["249", "59", "126"]
  ],
  "05/26/2025 to 06/01/2025": [
    ["349", "67", "566"],
    ["144", "96", "277"],
    ["339", "59", "559"],
    ["490", "30", "136"],
    ["158", "40", "235"],
    ["260", "88", "567"],
    ["140", "57", "467"]
  ],
  "06/02/2025 to 06/08/2025": [
    ["457", "63", "670"],
    ["267", "58", "170"],
    ["246", "23", "238"],
    ["467", "71", "678"],
    ["568", "96", "169"],
    ["590", "43", "256"],
    ["279", "84", "590"]
  ],
  "06/09/2025 to 06/15/2025": [
    ["570", "29", "379"],
    ["258", "51", "579"],
    ["189", "83", "670"],
    ["458", "75", "357"],
    ["670", "39", "478"],
    ["267", "51", "678"],
    ["148", "31", "128"]
  ],
  "06/16/2025 to 06/22/2025": [
    ["667", "90", "389"],
    ["248", "46", "277"],
    ["379", "96", "457"],
    ["588", "12", "147"],
    ["590", "42", "589"],
    ["258", "51", "560"],
    ["478", "90", "370"]
  ],
  "06/23/2025 to 06/29/2025": [
    ["124", "79", "289"],
    ["180", "90", "136"],
    ["458", "77", "340"],
    ["369", "84", "347"],
    ["377", "70", "460"],
    ["890", "70", "145"],
    ["134", "87", "458"]
  ],
  "06/30/2025 to 07/06/2025": [
    ["268", "62", "147"],
    ["440", "83", "346"],
    ["250", "70", "334"],
    ["269", "79", "126"],
    ["168", "55", "780"],
    ["579", "14", "257"],
    ["468", "84", "167"]
  ],
  "07/07/2025 to 07/13/2025": [
    ["160", "75", "889"],
    ["223", "77", "160"],
    ["230", "57", "124"],
    ["260", "84", "446"],
    ["560", "19", "360"],
    ["899", "67", "340"],
    ["789", "46", "240"]
  ],
  "07/14/2025 to 07/20/2025": [
    ["335", "11", "579"],
    ["366", "51", "128"],
    ["689", "35", "159"],
    ["456", "59", "388"],
    ["357", "56", "448"],
    ["337", "32", "228"],
    ["469", "93", "157"]
  ],
  "07/21/2025 to 07/27/2025": [
    ["338", "45", "366"],
    ["589", "21", "236"],
    ["478", "99", "126"],
    ["689", "37", "890"],
    ["350", "82", "679"],
    ["120", "32", "660"],
    ["346", "36", "268"]
  ],
  "07/28/2025 to 08/03/2025": [
    ["226", "04", "680"],
    ["270", "97", "278"],
    ["800", "82", "147"],
    ["233", "89", "117"],
    ["467", "70", "370"],
    ["133", "79", "180"],
    ["566", "74", "239"]
  ],
  "08/04/2025 to 08/10/2025": [
    ["568", "95", "500"],
    ["270", "90", "370"],
    ["267", "53", "120"],
    ["240", "60", "145"],
    ["468", "85", "249"],
    ["149", "45", "690"],
    ["359", "71", "678"]
  ],
  "08/11/2025 to 08/17/2025": [
    ["157", "35", "456"],
    ["155", "17", "700"],
    ["448", "67", "250"],
    ["149", "49", "360"],
    ["***", "**", "***"],
    ["180", "92", "138"],
    ["448", "60", "668"]
  ],
  "08/18/2025 to 08/24/2025": [
    ["169", "65", "168"],
    ["240", "63", "580"],
    ["569", "07", "179"],
    ["890", "75", "456"],
    ["136", "04", "167"],
    ["358", "60", "280"],
    ["270", "94", "590"]
  ],
  "08/25/2025 to 08/31/2025": [
    ["779", "30", "235"],
    ["570", "20", "244"],
    ["480", "26", "466"],
    ["279", "86", "457"],
    ["147", "20", "569"],
    ["148", "33", "256"],
    ["157", "37", "124"]
  ],
  "09/01/2025 to 09/07/2025": [
    ["279", "88", "459"],
    ["150", "62", "480"],
    ["190", "00", "460"],
    ["126", "94", "446"],
    ["455", "47", "223"],
    ["890", "71", "380"],
    ["356", "43", "580"]
  ],
  "09/08/2025 to 09/14/2025": [
    ["228", "24", "266"],
    ["590", "42", "660"],
    ["266", "49", "234"],
    ["379", "97", "458"],
    ["348", "50", "578"],
    ["289", "93", "256"],
    ["368", "75", "249"]
  ],
  "09/15/2025 to 09/21/2025": [
    ["144", "93", "689"],
    ["578", "00", "226"],
    ["590", "46", "169"],
    ["566", "72", "679"],
    ["168", "51", "588"],
    ["379", "95", "159"],
    ["267", "52", "129"]
  ],
  "09/22/2025 to 09/28/2025": [
    ["278", "73", "689"],
    ["890", "74", "347"],
    ["134", "86", "259"],
    ["269", "74", "130"],
    ["257", "43", "670"],
    ["145", "01", "470"],
    ["378", "81", "119"]
  ],
  "09/29/2025 to 10/05/2025": [
    ["369", "88", "350"],
    ["458", "74", "400"],
    ["233", "80", "127"],
    ["147", "27", "377"],
    ["468", "81", "470"],
    ["368", "75", "780"],
    ["347", "45", "267"]
  ],
  "10/06/2025 to 10/12/2025": [
    ["256", "37", "250"],
    ["234", "94", "158"],
    ["145", "02", "480"],
    ["249", "51", "146"],
    ["190", "07", "458"],
    ["238", "38", "477"],
    ["289", "97", "340"]
  ],
  "10/13/2025 to 10/19/2025": [
    ["889", "54", "248"],
    ["490", "38", "468"],
    ["238", "39", "270"],
    ["469", "91", "290"],
    ["260", "87", "890"],
    ["349", "60", "479"],
    ["345", "23", "120"]
  ],
  "10/20/2025 to 10/26/2025": [
    ["157", "38", "800"],
    ["467", "71", "155"],
    ["557", "78", "468"],
    ["340", "73", "157"],
    ["279", "86", "268"],
    ["178", "61", "470"],
    ["116", "84", "149"]
  ],
  "10/27/2025 to 11/02/2025": [
    ["224", "85", "258"],
    ["445", "33", "256"],
    ["489", "17", "124"],
    ["789", "42", "570"],
    ["126", "99", "234"],
    ["167", "49", "360"],
    ["457", "68", "170"]
  ],
  "11/03/2025 to 11/09/2025": [
    ["180", "99", "135"],
    ["778", "22", "138"],
    ["248", "47", "467"],
    ["157", "39", "144"],
    ["788", "31", "344"],
    ["568", "91", "146"],
    ["380", "12", "480"]
  ],
  "11/10/2025 to 11/16/2025": [
    ["125", "87", "160"],
    ["138", "22", "679"],
    ["589", "21", "678"],
    ["399", "17", "250"],
    ["359", "77", "179"],
    ["270", "91", "489"],
    ["467", "72", "237"]
  ],
  "11/17/2025 to 11/23/2025": [
    ["459", "81", "245"],
    ["347", "47", "890"],
    ["356", "45", "168"],
    ["338", "42", "679"],
    ["139", "35", "456"],
    ["477", "81", "579"],
    ["369", "89", "180"]
  ],
  "11/24/2025 to 11/30/2025": [
    ["390", "22", "480"],
    ["280", "01", "344"],
    ["339", "50", "280"],
    ["237", "22", "336"],
    ["230", "59", "270"],
    ["278", "78", "468"],
    ["140", "52", "156"]
  ],
  "12/01/2025 to 12/07/2025": [
    ["566", "79", "360"],
    ["128", "11", "489"],
    ["138", "22", "570"],
    ["245", "19", "478"],
    ["189", "84", "167"],
    ["670", "30", "145"],
    ["579", "14", "347"]
  ],
  "12/08/2025 to 12/14/2025": [
    ["689", "30", "677"],
    ["557", "79", "126"],
    ["120", "34", "789"],
    ["489", "13", "599"],
    ["167", "46", "880"],
    ["569", "04", "446"],
    ["559", "92", "688"]
  ],
  "12/15/2025 to 12/21/2025": [
    ["145", "08", "233"],
    ["157", "37", "449"],
    ["266", "40", "370"],
    ["367", "60", "389"],
    ["779", "37", "458"],
    ["347", "47", "160"],
    ["568", "98", "279"]
  ],
  "12/22/2025 to 12/28/2025": [
    ["244", "05", "267"],
    ["170", "83", "256"],
    ["280", "09", "234"],
    ["147", "28", "459"],
    ["268", "66", "790"],
    ["129", "23", "157"],
    ["358", "62", "156"]
  ],
  "12/29/2025 to 01/04/2026": [
    ["460", "09", "289"],
    ["450", "92", "246"],
    ["189", "83", "689"],
    ["155", "14", "680"],
    ["299", "00", "479"],
    ["250", "78", "170"],
    ["134", "89", "450"]
  ],
  "01/05/2026 to 01/11/2026": [
    ["378", "89", "469"],
    ["349", "66", "367"],
    ["280", "08", "468"],
    ["457", "67", "269"],
    ["458", "70", "479"],
    ["590", "46", "259"],
    ["279", "85", "168"]
  ],
  "01/12/2026 to 01/18/2026": [
    ["779", "31", "579"],
    ["457", "60", "226"],
    ["257", "48", "468"],
    ["479", "01", "146"],
    ["149", "48", "288"],
    ["256", "30", "488"],
    ["267", "57", "124"]
  ],
  "01/19/2026 to 01/25/2026": [
    ["133", "71", "245"],
    ["158", "45", "177"],
    ["146", "11", "335"],
    ["358", "61", "137"],
    ["259", "61", "380"],
    ["356", "43", "139"],
    ["149", "48", "170"]
  ],
  "01/26/2026 to 02/01/2026": [
    ["***", "**", "***"],
    ["567", "85", "249"],
    ["490", "36", "899"],
    ["130", "43", "788"],
    ["789", "45", "357"],
    ["126", "90", "569"],
    ["577", "96", "268"]
  ],
  "02/02/2026 to 02/08/2026": [
    ["440", "88", "567"],
    ["356", "45", "140"],
    ["349", "66", "123"],
    ["388", "90", "280"],
    ["149", "41", "489"],
    ["134", "83", "247"],
    ["268", "63", "670"]
  ],
  "02/09/2026 to 02/15/2026": [
    ["899", "63", "157"],
    ["380", "14", "400"],
    ["188", "73", "670"],
    ["778", "21", "155"],
    ["388", "91", "335"],
    ["688", "21", "380"],
    ["348", "58", "378"]
  ],
  "02/16/2026 to 02/22/2026": [
    ["340", "74", "455"],
    ["668", "07", "133"],
    ["569", "09", "577"],
    ["660", "25", "690"],
    ["478", "92", "679"],
    ["558", "87", "458"],
    ["356", "42", "129"]
  ],
  "02/23/2026 to 03/01/2026": [
    ["359", "72", "679"],
    ["146", "13", "256"],
    ["389", "04", "680"],
    ["258", "58", "170"],
    ["180", "99", "360"],
    ["145", "07", "160"],
    ["230", "56", "349"]
  ],
  "03/02/2026 to 03/08/2026": [
    ["167", "49", "234"],
    ["125", "84", "770"],
    ["***", "**", "***"],
    ["150", "65", "168"],
    ["380", "14", "239"],
    ["169", "62", "156"],
    ["130", "42", "246"]
  ],
  "03/09/2026 to 03/15/2026": [
    ["457", "60", "578"],
    ["180", "90", "389"],
    ["378", "89", "126"],
    ["138", "24", "167"],
    ["459", "88", "350"],
    ["279", "89", "450"],
    ["150", "62", "390"]
  ],
  "03/16/2026 to 03/22/2026": [
    ["480", "23", "490"],
    ["156", "25", "267"],
    ["348", "56", "457"],
    ["780", "59", "568"],
    ["557", "71", "489"],
    ["578", "04", "266"],
    ["145", "09", "568"]
  ]

};

export const TIMEBAZAR = {

  "01/01/2024 to 01/07/2024": [
    ["146", "13", "166"],
    ["580", "36", "240"],
    ["670", "35", "348"],
    ["249", "59", "225"],
    ["128", "17", "269"],
    ["578", "04", "257"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["689", "35", "348"],
    ["280", "06", "240"],
    ["446", "47", "340"],
    ["556", "61", "146"],
    ["156", "23", "670"],
    ["158", "40", "280"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["369", "83", "670"],
    ["179", "76", "448"],
    ["370", "00", "578"],
    ["140", "56", "457"],
    ["290", "11", "560"],
    ["356", "44", "257"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["119", "17", "449"],
    ["558", "85", "177"],
    ["389", "08", "350"],
    ["569", "03", "229"],
    ["***", "**", "***"],
    ["166", "33", "148"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["470", "14", "446"],
    ["166", "32", "679"],
    ["167", "44", "347"],
    ["134", "86", "169"],
    ["238", "37", "467"],
    ["560", "13", "670"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["126", "97", "188"],
    ["700", "73", "157"],
    ["227", "16", "330"],
    ["223", "79", "180"],
    ["389", "05", "168"],
    ["578", "08", "134"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["190", "07", "458"],
    ["113", "54", "356"],
    ["790", "68", "224"],
    ["457", "67", "359"],
    ["149", "42", "570"],
    ["347", "46", "240"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["350", "80", "299"],
    ["557", "71", "344"],
    ["689", "34", "149"],
    ["270", "94", "888"],
    ["119", "16", "259"],
    ["169", "65", "889"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["349", "65", "159"],
    ["380", "10", "668"],
    ["347", "43", "148"],
    ["138", "24", "356"],
    ["170", "84", "149"],
    ["145", "03", "689"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["379", "94", "167"],
    ["267", "59", "144"],
    ["179", "72", "200"],
    ["458", "71", "146"],
    ["369", "80", "370"],
    ["779", "30", "569"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["469", "96", "178"],
    ["249", "50", "280"],
    ["170", "89", "478"],
    ["250", "79", "234"],
    ["449", "71", "344"],
    ["124", "74", "130"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["189", "80", "145"],
    ["358", "61", "146"],
    ["149", "40", "118"],
    ["236", "12", "246"],
    ["569", "07", "124"],
    ["258", "59", "559"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["467", "71", "290"],
    ["160", "74", "257"],
    ["148", "37", "250"],
    ["148", "33", "148"],
    ["130", "49", "360"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["480", "24", "239"],
    ["238", "34", "149"],
    ["140", "53", "670"],
    ["155", "12", "499"],
    ["138", "29", "577"],
    ["399", "17", "250"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["155", "15", "159"],
    ["247", "38", "279"],
    ["137", "19", "559"],
    ["390", "27", "467"],
    ["270", "95", "230"],
    ["359", "70", "127"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["347", "40", "127"],
    ["458", "77", "124"],
    ["234", "96", "169"],
    ["110", "24", "158"],
    ["278", "77", "179"],
    ["456", "55", "357"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["250", "70", "280"],
    ["779", "30", "334"],
    ["246", "28", "279"],
    ["489", "12", "200"],
    ["399", "13", "337"],
    ["448", "69", "126"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["157", "30", "677"],
    ["189", "85", "140"],
    ["125", "89", "568"],
    ["245", "12", "480"],
    ["268", "64", "347"],
    ["169", "63", "670"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["689", "30", "244"],
    ["135", "91", "290"],
    ["255", "25", "357"],
    ["380", "14", "356"],
    ["133", "72", "200"],
    ["389", "04", "347"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["469", "95", "339"],
    ["790", "64", "590"],
    ["279", "87", "133"],
    ["137", "17", "890"],
    ["359", "77", "124"],
    ["489", "17", "467"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["360", "99", "289"],
    ["500", "59", "135"],
    ["150", "68", "369"],
    ["558", "84", "347"],
    ["445", "31", "146"],
    ["380", "14", "699"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["599", "30", "677"],
    ["670", "35", "456"],
    ["118", "02", "147"],
    ["499", "22", "255"],
    ["169", "60", "460"],
    ["179", "73", "139"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["146", "18", "189"],
    ["370", "00", "299"],
    ["389", "07", "250"],
    ["367", "61", "579"],
    ["359", "77", "269"],
    ["449", "76", "330"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["146", "14", "356"],
    ["990", "89", "180"],
    ["278", "77", "377"],
    ["255", "20", "578"],
    ["147", "26", "880"],
    ["135", "91", "146"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["124", "71", "236"],
    ["589", "22", "110"],
    ["458", "73", "346"],
    ["270", "90", "460"],
    ["148", "38", "125"],
    ["340", "73", "148"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["169", "69", "450"],
    ["470", "10", "244"],
    ["250", "78", "369"],
    ["356", "45", "140"],
    ["257", "49", "126"],
    ["247", "31", "777"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["278", "71", "489"],
    ["238", "31", "335"],
    ["466", "63", "247"],
    ["359", "78", "350"],
    ["590", "49", "117"],
    ["567", "82", "138"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["289", "91", "380"],
    ["129", "24", "248"],
    ["157", "30", "190"],
    ["456", "53", "788"],
    ["157", "36", "178"],
    ["245", "12", "660"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["679", "20", "190"],
    ["388", "92", "228"],
    ["556", "62", "237"],
    ["199", "95", "456"],
    ["159", "52", "237"],
    ["249", "56", "457"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["460", "06", "349"],
    ["400", "43", "788"],
    ["280", "05", "348"],
    ["333", "92", "589"],
    ["788", "34", "455"],
    ["477", "84", "400"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["366", "50", "334"],
    ["249", "52", "138"],
    ["580", "32", "589"],
    ["226", "00", "280"],
    ["680", "45", "267"],
    ["236", "16", "358"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["778", "25", "177"],
    ["270", "93", "166"],
    ["689", "39", "126"],
    ["299", "03", "337"],
    ["145", "02", "679"],
    ["190", "09", "379"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["350", "86", "150"],
    ["346", "33", "256"],
    ["358", "67", "188"],
    ["***", "**", "***"],
    ["599", "34", "220"],
    ["350", "82", "480"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["189", "83", "337"],
    ["267", "56", "790"],
    ["113", "51", "470"],
    ["260", "81", "335"],
    ["567", "82", "499"],
    ["160", "79", "360"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["159", "55", "690"],
    ["345", "21", "137"],
    ["145", "08", "558"],
    ["229", "35", "799"],
    ["457", "69", "568"],
    ["247", "31", "128"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["345", "27", "340"],
    ["168", "51", "236"],
    ["459", "86", "268"],
    ["137", "11", "489"],
    ["145", "02", "390"],
    ["***", "**", "***"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["235", "05", "357"],
    ["467", "72", "237"],
    ["289", "98", "233"],
    ["235", "02", "228"],
    ["234", "91", "579"],
    ["558", "86", "114"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["233", "88", "800"],
    ["558", "80", "118"],
    ["449", "75", "366"],
    ["460", "00", "389"],
    ["489", "19", "126"],
    ["349", "61", "470"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["189", "82", "228"],
    ["136", "05", "339"],
    ["467", "71", "560"],
    ["369", "89", "270"],
    ["334", "09", "450"],
    ["256", "35", "140"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["129", "21", "560"],
    ["138", "27", "250"],
    ["789", "41", "128"],
    ["168", "53", "120"],
    ["230", "58", "468"],
    ["267", "56", "150"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["440", "86", "457"],
    ["247", "39", "667"],
    ["699", "48", "369"],
    ["344", "10", "488"],
    ["258", "57", "278"],
    ["256", "37", "359"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["488", "05", "258"],
    ["670", "31", "579"],
    ["678", "13", "120"],
    ["380", "19", "144"],
    ["447", "52", "345"],
    ["579", "13", "247"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["358", "65", "122"],
    ["280", "04", "347"],
    ["290", "15", "500"],
    ["269", "77", "223"],
    ["157", "38", "125"],
    ["590", "41", "119"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["168", "51", "380"],
    ["337", "30", "145"],
    ["239", "47", "467"],
    ["367", "67", "467"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["140", "56", "178"],
    ["369", "88", "468"],
    ["140", "51", "245"],
    ["226", "08", "369"],
    ["677", "07", "458"],
    ["577", "92", "778"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["690", "57", "124"],
    ["479", "01", "146"],
    ["356", "48", "125"],
    ["779", "35", "258"],
    ["128", "15", "348"],
    ["190", "05", "258"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["600", "63", "346"],
    ["678", "12", "138"],
    ["330", "69", "559"],
    ["570", "21", "344"],
    ["466", "62", "200"],
    ["379", "96", "240"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["357", "57", "566"],
    ["170", "86", "259"],
    ["589", "24", "167"],
    ["168", "57", "278"],
    ["180", "98", "440"],
    ["226", "07", "250"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["459", "89", "478"],
    ["157", "37", "179"],
    ["479", "02", "345"],
    ["189", "80", "127"],
    ["255", "24", "680"],
    ["900", "92", "589"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["466", "64", "590"],
    ["380", "16", "268"],
    ["127", "05", "690"],
    ["146", "16", "349"],
    ["780", "51", "245"],
    ["560", "12", "147"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["450", "91", "588"],
    ["479", "06", "790"],
    ["239", "49", "478"],
    ["120", "33", "256"],
    ["347", "48", "369"],
    ["245", "16", "349"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["167", "41", "560"],
    ["129", "28", "233"],
    ["136", "08", "459"],
    ["240", "69", "450"],
    ["589", "25", "159"],
    ["690", "52", "390"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["289", "97", "467"],
    ["130", "44", "680"],
    ["356", "44", "167"],
    ["127", "04", "248"],
    ["349", "62", "237"],
    ["800", "88", "279"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["247", "33", "166"],
    ["230", "51", "119"],
    ["334", "05", "113"],
    ["390", "26", "457"],
    ["440", "83", "779"],
    ["277", "64", "356"]
  ],
  "01/20/2025 to 01/26/2025": [
    ["667", "92", "110"],
    ["149", "43", "355"],
    ["578", "00", "460"],
    ["248", "46", "556"],
    ["290", "18", "125"],
    ["246", "21", "489"]
  ],
  "01/27/2025 to 02/02/2025": [
    ["880", "67", "377"],
    ["260", "82", "390"],
    ["140", "56", "600"],
    ["888", "43", "599"],
    ["799", "58", "260"],
    ["477", "89", "180"]
  ],
  "02/03/2025 to 02/09/2025": [
    ["800", "89", "450"],
    ["799", "52", "390"],
    ["678", "19", "144"],
    ["112", "43", "166"],
    ["380", "10", "370"],
    ["358", "64", "590"]
  ],
  "02/10/2025 to 02/16/2025": [
    ["679", "26", "600"],
    ["136", "09", "559"],
    ["235", "01", "669"],
    ["477", "85", "159"],
    ["668", "06", "600"],
    ["239", "42", "660"]
  ],
  "02/17/2025 to 02/23/2025": [
    ["110", "24", "770"],
    ["250", "79", "199"],
    ["250", "75", "177"],
    ["150", "68", "170"],
    ["258", "54", "239"],
    ["135", "90", "668"]
  ],
  "02/24/2025 to 03/02/2025": [
    ["770", "41", "290"],
    ["258", "53", "689"],
    ["169", "63", "157"],
    ["399", "10", "334"],
    ["488", "03", "346"],
    ["290", "10", "488"]
  ],
  "03/03/2025 to 03/09/2025": [
    ["238", "39", "559"],
    ["379", "90", "389"],
    ["239", "48", "440"],
    ["188", "71", "560"],
    ["236", "19", "270"],
    ["689", "36", "123"]
  ],
  "03/10/2025 to 03/16/2025": [
    ["469", "93", "139"],
    ["788", "38", "666"],
    ["590", "46", "790"],
    ["558", "82", "390"],
    ["***", "**", "***"],
    ["347", "41", "579"]
  ],
  "03/17/2025 to 03/23/2025": [
    ["470", "13", "120"],
    ["669", "17", "359"],
    ["790", "61", "380"],
    ["190", "06", "556"],
    ["470", "17", "566"],
    ["240", "66", "880"]
  ],
  "03/24/2025 to 03/30/2025": [
    ["149", "43", "139"],
    ["233", "80", "145"],
    ["347", "49", "135"],
    ["280", "03", "788"],
    ["220", "45", "690"],
    ["250", "75", "113"]
  ],
  "03/31/2025 to 04/06/2025": [
    ["149", "48", "468"],
    ["147", "28", "468"],
    ["380", "15", "267"],
    ["240", "65", "889"],
    ["137", "17", "188"],
    ["459", "85", "447"]
  ],
  "04/07/2025 to 04/13/2025": [
    ["578", "09", "180"],
    ["356", "45", "500"],
    ["790", "67", "250"],
    ["178", "68", "369"],
    ["890", "74", "130"],
    ["589", "23", "157"]
  ],
  "04/14/2025 to 04/20/2025": [
    ["137", "11", "119"],
    ["147", "27", "467"],
    ["389", "07", "278"],
    ["246", "27", "557"],
    ["689", "39", "667"],
    ["678", "13", "120"]
  ],
  "04/21/2025 to 04/27/2025": [
    ["229","32","110"],
    ["166","30","334"],
    ["468","85","168"],
    ["488","00","488"],
    ["225","99","469"],
    ["350","85","159"]
  ],
  "04/28/2025 to 05/04/2025": [
    ["579","14","130"],
    ["460","08","369"],
    ["478","91","128"],
    ["800","82","156"],
    ["460","08","567"],
    ["789","44","257"]
  ],
  "05/05/2025 to 05/11/2025": [
    ["200","20","190"],
    ["190","02","156"],
    ["388","97","179"],
    ["378","80","244"],
    ["469","90","235"],
    ["159","58","189"]
  ],
  "05/12/2025 to 05/18/2025": [
    ["399","10","244"],
    ["145","09","135"],
    ["139","36","457"],
    ["780","53","247"],
    ["440","88","233"],
    ["248","47","340"]
  ],
  "05/19/2025 to 05/25/2025": [
    ["280","05","267"],
    ["123","67","458"],
    ["568","92","237"],
    ["345","21","290"],
    ["159","52","156"],
    ["177","54","220"]
  ],
  "05/26/2025 to 06/01/2025": [
    ["116","80","235"],
    ["345","27","278"],
    ["115","75","447"],
    ["770","47","115"],
    ["149","45","168"],
    ["699","42","138"]
  ],
  "06/02/2025 to 06/08/2025": [
    ["567","86","259"],
    ["116","85","177"],
    ["460","02","390"],
    ["478","91","470"],
    ["178","66","457"],
    ["260","87","278"]
  ],
  "06/09/2025 to 06/15/2025": [
    ["188","77","700"],
    ["357","51","236"],
    ["169","62","390"],
    ["450","92","336"],
    ["266","48","567"],
    ["480","22","138"]
  ],
  "06/16/2025 to 06/22/2025": [
    ["338","49","478"],
    ["346","37","377"],
    ["790","68","116"],
    ["367","65","500"],
    ["235","01","380"],
    ["127","08","224"]
  ],
  "06/23/2025 to 06/29/2025": [
    ["279","81","245"],
    ["247","33","139"],
    ["259","64","257"],
    ["578","03","490"],
    ["113","53","490"],
    ["340","72","246"]
  ],
  "06/30/2025 to 07/06/2025": [
    ["134","82","688"],
    ["468","86","457"],
    ["230","50","389"],
    ["390","25","140"],
    ["499","26","259"],
    ["340","77","340"]
  ],
  "07/07/2025 to 07/13/2025": [
    ["299","02","237"],
    ["578","03","689"],
    ["250","79","270"],
    ["128","15","258"],
    ["458","75","780"],
    ["169","64","680"]
  ],
  "07/14/2025 to 07/20/2025": [
    ["167","46","367"],
    ["145","04","680"],
    ["339","55","348"],
    ["268","61","579"],
    ["358","61","245"],
    ["357","55","357"]
  ],
  "07/21/2025 to 07/27/2025": [
    ["400","43","157"],
    ["347","44","248"],
    ["178","61","128"],
    ["146","10","668"],
    ["467","74","338"],
    ["120","34","239"]
  ],
  "07/28/2025 to 08/03/2025": [
    ["779","36","277"],
    ["447","55","230"],
    ["590","43","490"],
    ["124","72","200"],
    ["268","67","223"],
    ["478","98","350"]
  ],
  "08/04/2025 to 08/10/2025": [
    ["149","49","270"],
    ["148","39","234"],
    ["358","61","777"],
    ["289","91","335"],
    ["569","03","256"],
    ["578","06","240"]
  ],
  "08/11/2025 to 08/17/2025": [
    ["359","73","580"],
    ["160","74","400"],
    ["120","38","350"],
    ["246","29","469"],
    ["***","**","***"],
    ["478","99","126"]
  ],
  "08/18/2025 to 08/24/2025": [
    ["358","67","269"],
    ["779","32","336"],
    ["579","14","266"],
    ["569","03","580"],
    ["340","75","366"],
    ["689","35","456"]
  ],
  "08/25/2025 to 08/31/2025": [
    ["369","81","579"],
    ["127","09","135"],
    ["***","**","***"],
    ["459","82","345"],
    ["689","34","167"],
    ["266","41","146"]
  ],
  "09/01/2025 to 09/07/2025": [
    ["149","44","770"],
    ["580","38","233"],
    ["356","46","259"],
    ["345","22","589"],
    ["140","51","236"],
    ["456","52","390"]
  ],
  "09/08/2025 to 09/14/2025": [
    ["130","41","245"],
    ["245","15","366"],
    ["589","20","479"],
    ["199","96","600"],
    ["266","46","358"],
    ["125","86","178"]
  ],
  "09/15/2025 to 09/21/2025": [
    ["358","63","788"],
    ["236","18","440"],
    ["134","89","180"],
    ["159","59","379"],
    ["140","57","700"],
    ["680","44","130"]
  ],
  "09/22/2025 to 09/28/2025": [
    ["460","00","299"],
    ["236","11","588"],
    ["140","56","178"],
    ["270","92","129"],
    ["160","73","445"],
    ["280","00","280"]
  ],
  "09/29/2025 to 10/05/2025": [
    ["220","45","267"],
    ["244","05","267"],
    ["169","62","237"],
    ["558","86","169"],
    ["229","30","479"],
    ["369","84","167"]
  ],
  "10/06/2025 to 10/12/2025": [
    ["240","69","568"],
    ["157","39","559"],
    ["568","91","560"],
    ["168","50","479"],
    ["116","87","278"],
    ["358","67","160"]
  ],
  "10/13/2025 to 10/19/2025": [
    ["115","75","339"],
    ["227","18","477"],
    ["560","13","238"],
    ["478","93","670"],
    ["123","62","570"],
    ["***","**","***"]
  ],
  "10/20/2025 to 10/26/2025": [
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"]
  ],
  "10/27/2025 to 11/02/2025": [
    ["334","09","469"],
    ["178","65","366"],
    ["357","54","266"],
    ["257","41","489"],
    ["150","62","156"],
    ["129","23","670"]
  ],
  "11/03/2025 to 11/09/2025": [
    ["145","07","160"],
    ["250","74","356"],
    ["157","35","456"],
    ["134","81","489"],
    ["557","78","459"],
    ["679","23","256"]
  ],
  "11/10/2025 to 11/16/2025": [
    ["239","43","229"],
    ["259","62","246"],
    ["124","75","889"],
    ["356","46","790"],
    ["560","11","335"],
    ["890","77","160"]
  ],
  "11/17/2025 to 11/23/2025": [
    ["136","03","346"],
    ["120","33","120"],
    ["147","21","137"],
    ["233","80","677"],
    ["349","65","177"],
    ["120","35","500"]
  ],
  "11/24/2025 to 11/30/2025": [
    ["169","62","345"],
    ["477","89","450"],
    ["346","33","247"],
    ["345","20","190"],
    ["440","86","790"],
    ["110","28","189"]
  ],
  "12/01/2025 to 12/07/2025": [
    ["357","59","199"],
    ["344","15","889"],
    ["455","44","455"],
    ["250","73","689"],
    ["130","44","112"],
    ["680","44","130"]
  ],
  "12/08/2025 to 12/14/2025": [
    ["239","47","179"],
    ["249","55","230"],
    ["777","14","167"],
    ["570","29","135"],
    ["199","96","178"],
    ["170","89","478"]
  ],
  "12/15/2025 to 12/21/2025": [
    ["123","62","570"],
    ["478","90","389"],
    ["459","89","478"],
    ["800","81","678"],
    ["137","17","458"],
    ["270","97","223"]
  ],
  "12/22/2025 to 12/28/2025": [
    ["560","19","900"],
    ["679","28","224"],
    ["124","72","147"],
    ["670","38","459"],
    ["245","12","156"],
    ["389","05","690"]
  ],
  "12/29/2025 to 01/04/2026": [
    ["560","19","379"],
    ["345","27","250"],
    ["258","50","190"],
    ["139","36","114"],
    ["688","24","220"],
    ["136","08","990"]
  ],
  "01/05/2026 to 01/11/2026": [
    ["448","67","700"],
    ["690","57","160"],
    ["899","65","140"],
    ["448","61","380"],
    ["138","28","260"],
    ["690","53","256"]
  ],
  "01/12/2026 to 01/18/2026": [
    ["590","41","344"],
    ["799","59","234"],
    ["460","04","699"],
    ["350","87","160"],
    ["590","40","569"],
    ["568","90","145"]
  ],
  "01/19/2026 to 01/25/2026": [
    ["128","19","568"],
    ["167","43","490"],
    ["457","64","400"],
    ["229","31","146"],
    ["190","08","125"],
    ["159","51","128"]
  ],
  "01/26/2026 to 02/01/2026": [
    ["***","**","***"],
    ["388","95","258"],
    ["155","11","236"],
    ["334","09","270"],
    ["233","80","226"],
    ["124","77","458"]
  ],
  "02/02/2026 to 02/08/2026": [
    ["140","53","139"],
    ["456","58","350"],
    ["468","86","259"],
    ["237","27","133"],
    ["269","75","780"],
    ["566","79","234"]
  ],
  "02/09/2026 to 02/15/2026": [
    ["260","85","122"],
    ["678","14","338"],
    ["359","78","378"],
    ["288","83","490"],
    ["567","83","256"],
    ["137","11","146"]
  ],
  "02/16/2026 to 02/22/2026": [
    ["344","15","230"],
    ["550","04","130"],
    ["560","16","169"],
    ["279","89","234"],
    ["155","10","488"],
    ["590","41","227"]
  ],
  "02/23/2026 to 03/01/2026": [
    ["166","35","258"],
    ["490","33","670"],
    ["577","92","147"],
    ["259","67","467"],
    ["888","48","279"],
    ["136","04","699"]
  ],
  "03/02/2026 to 03/08/2026": [
    ["470","14","590"],
    ["788","31","245"],
    ["***","**","***"],
    ["446","46","790"],
    ["358","62","336"],
    ["677","00","550"]
  ],
  "03/09/2026 to 03/15/2026": [
    ["390","29","126"],
    ["258","50","235"],
    ["568","97","160"],
    ["266","44","158"],
    ["234","92","110"],
    ["349","66","277"]
  ],
  "03/16/2026 to 03/22/2026": [
    ["289","96","150"],
    ["279","83","689"],
    ["136","00","145"],
    ["190","03","139"],
    ["128","18","189"],
    ["228","23","580"]
  ]


};

export const MADHURDAY = {
  "01/01/2024 to 01/07/2024": [
    ["568", "93", "300"],
    ["233", "82", "480"],
    ["130", "44", "590"],
    ["790", "69", "667"],
    ["457", "60", "235"],
    ["129", "29", "450"],
    ["277", "64", "130"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["188", "75", "339"],
    ["188", "73", "148"],
    ["170", "88", "134"],
    ["289", "95", "168"],
    ["190", "01", "678"],
    ["778", "21", "137"],
    ["467", "76", "457"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["560", "12", "688"],
    ["288", "85", "889"],
    ["137", "16", "349"],
    ["156", "23", "166"],
    ["158", "42", "147"],
    ["280", "01", "146"],
    ["157", "38", "260"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["000", "01", "245"],
    ["445", "30", "244"],
    ["450", "91", "155"],
    ["568", "97", "890"],
    ["***", "**", "***"],
    ["590", "40", "145"],
    ["356", "48", "279"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["669", "14", "149"],
    ["599", "32", "246"],
    ["137", "14", "356"],
    ["347", "47", "250"],
    ["349", "66", "790"],
    ["116", "83", "490"],
    ["155", "10", "136"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["350", "88", "990"],
    ["499", "27", "133"],
    ["589", "21", "470"],
    ["336", "24", "347"],
    ["456", "59", "289"],
    ["190", "09", "469"],
    ["336", "27", "278"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["377", "72", "480"],
    ["367", "63", "689"],
    ["579", "10", "190"],
    ["299", "08", "288"],
    ["345", "24", "257"],
    ["369", "81", "137"],
    ["157", "35", "780"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["148", "31", "470"],
    ["125", "80", "389"],
    ["489", "17", "223"],
    ["356", "49", "360"],
    ["239", "42", "147"],
    ["260", "88", "369"],
    ["350", "86", "259"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["247", "34", "239"],
    ["130", "44", "239"],
    ["346", "30", "479"],
    ["127", "05", "159"],
    ["350", "88", "279"],
    ["550", "02", "156"],
    ["367", "64", "248"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["139", "34", "455"],
    ["560", "10", "460"],
    ["349", "62", "156"],
    ["690", "59", "180"],
    ["245", "19", "360"],
    ["667", "98", "233"],
    ["349", "66", "880"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["369", "80", "370"],
    ["290", "16", "899"],
    ["457", "69", "234"],
    ["355", "32", "138"],
    ["126", "94", "158"],
    ["447", "56", "349"],
    ["112", "44", "356"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["470", "11", "137"],
    ["790", "65", "140"],
    ["477", "80", "127"],
    ["678", "16", "259"],
    ["146", "13", "238"],
    ["890", "73", "166"],
    ["249", "54", "167"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["360", "91", "137"],
    ["455", "41", "146"],
    ["479", "03", "580"],
    ["299", "09", "135"],
    ["289", "93", "670"],
    ["479", "07", "179"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["267", "50", "190"],
    ["124", "71", "245"],
    ["160", "77", "223"],
    ["900", "94", "446"],
    ["990", "87", "269"],
    ["890", "77", "467"],
    ["134", "80", "235"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["380", "13", "238"],
    ["249", "52", "147"],
    ["158", "47", "467"],
    ["589", "23", "111"],
    ["256", "32", "345"],
    ["349", "68", "990"],
    ["790", "64", "248"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["289", "94", "167"],
    ["245", "19", "199"],
    ["588", "10", "145"],
    ["228", "23", "346"],
    ["180", "92", "499"],
    ["800", "86", "600"],
    ["120", "39", "135"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["299", "02", "679"],
    ["138", "25", "249"],
    ["349", "68", "800"],
    ["489", "16", "367"],
    ["479", "00", "677"],
    ["237", "24", "356"],
    ["359", "74", "347"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["577", "94", "770"],
    ["266", "45", "249"],
    ["139", "38", "800"],
    ["112", "42", "138"],
    ["567", "87", "458"],
    ["579", "19", "379"],
    ["339", "51", "290"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["269", "71", "399"],
    ["688", "21", "560"],
    ["118", "08", "459"],
    ["450", "97", "269"],
    ["356", "46", "899"],
    ["112", "44", "239"],
    ["578", "08", "567"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["377", "72", "570"],
    ["356", "47", "124"],
    ["226", "09", "568"],
    ["558", "86", "240"],
    ["178", "67", "700"],
    ["790", "65", "500"],
    ["389", "07", "188"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["600", "65", "348"],
    ["188", "79", "117"],
    ["380", "12", "778"],
    ["156", "21", "678"],
    ["677", "06", "169"],
    ["133", "77", "359"],
    ["799", "51", "146"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["290", "11", "128"],
    ["148", "31", "489"],
    ["125", "82", "147"],
    ["468", "82", "156"],
    ["357", "51", "344"],
    ["356", "46", "367"],
    ["125", "85", "690"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["260", "87", "269"],
    ["350", "82", "570"],
    ["678", "12", "390"],
    ["490", "32", "480"],
    ["360", "91", "236"],
    ["239", "42", "679"],
    ["470", "14", "257"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["256", "35", "258"],
    ["779", "34", "789"],
    ["117", "99", "234"],
    ["449", "73", "148"],
    ["679", "21", "227"],
    ["346", "32", "336"],
    ["160", "71", "560"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["146", "19", "478"],
    ["118", "01", "579"],
    ["550", "02", "147"],
    ["340", "76", "268"],
    ["136", "04", "680"],
    ["790", "60", "127"],
    ["446", "48", "260"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["478", "90", "569"],
    ["250", "70", "334"],
    ["457", "69", "234"],
    ["118", "08", "558"],
    ["125", "82", "688"],
    ["134", "81", "119"],
    ["268", "62", "480"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["688", "27", "566"],
    ["679", "23", "157"],
    ["130", "42", "480"],
    ["900", "99", "180"],
    ["367", "68", "468"],
    ["568", "97", "467"],
    ["250", "79", "289"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["578", "00", "334"],
    ["788", "36", "367"],
    ["129", "26", "556"],
    ["789", "48", "116"],
    ["389", "05", "357"],
    ["370", "08", "477"],
    ["499", "27", "278"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["680", "42", "138"],
    ["588", "10", "235"],
    ["500", "51", "470"],
    ["238", "30", "145"],
    ["466", "60", "244"],
    ["180", "93", "337"],
    ["237", "24", "149"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["249", "53", "670"],
    ["267", "58", "170"],
    ["190", "03", "580"],
    ["134", "81", "579"],
    ["800", "81", "588"],
    ["899", "63", "120"],
    ["459", "80", "226"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["380", "10", "479"],
    ["349", "65", "168"],
    ["479", "04", "220"],
    ["246", "23", "788"],
    ["368", "73", "670"],
    ["688", "28", "468"],
    ["110", "23", "148"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["689", "38", "477"],
    ["480", "26", "150"],
    ["578", "04", "149"],
    ["117", "97", "160"],
    ["455", "41", "128"],
    ["157", "38", "189"],
    ["370", "06", "790"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["150", "60", "389"],
    ["369", "84", "446"],
    ["248", "48", "350"],
    ["***", "**", "***"],
    ["239", "48", "134"],
    ["199", "97", "557"],
    ["368", "71", "236"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["228", "24", "680"],
    ["677", "05", "780"],
    ["450", "91", "146"],
    ["458", "71", "560"],
    ["229", "32", "679"],
    ["115", "74", "220"],
    ["234", "99", "135"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["115", "75", "456"],
    ["169", "66", "880"],
    ["126", "93", "599"],
    ["339", "57", "223"],
    ["446", "40", "118"],
    ["238", "32", "246"],
    ["479", "04", "400"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["446", "49", "360"],
    ["469", "92", "679"],
    ["345", "20", "118"],
    ["449", "77", "188"],
    ["359", "70", "127"],
    ["140", "52", "390"],
    ["237", "22", "246"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["889", "51", "579"],
    ["338", "40", "136"],
    ["335", "15", "780"],
    ["278", "73", "689"],
    ["289", "99", "379"],
    ["144", "96", "123"],
    ["599", "36", "466"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["480", "22", "589"],
    ["340", "73", "148"],
    ["700", "77", "359"],
    ["460", "01", "399"],
    ["159", "50", "190"],
    ["134", "80", "389"],
    ["150", "62", "390"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["235", "08", "170"],
    ["236", "13", "247"],
    ["460", "00", "118"],
    ["440", "86", "556"],
    ["226", "05", "357"],
    ["460", "04", "158"],
    ["125", "89", "388"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["277", "69", "135"],
    ["440", "83", "490"],
    ["788", "31", "579"],
    ["258", "58", "233"],
    ["156", "28", "224"],
    ["278", "74", "680"],
    ["350", "81", "128"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["350", "81", "380"],
    ["568", "90", "226"],
    ["240", "67", "368"],
    ["790", "69", "388"],
    ["140", "53", "120"],
    ["278", "77", "467"],
    ["168", "57", "269"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["337", "37", "467"],
    ["389", "09", "900"],
    ["126", "94", "699"],
    ["234", "93", "229"],
    ["780", "55", "258"],
    ["349", "62", "589"],
    ["180", "90", "569"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["889", "59", "144"],
    ["229", "37", "278"],
    ["247", "32", "345"],
    ["135", "99", "568"],
    ["358", "69", "234"],
    ["457", "62", "138"],
    ["***", "**", "***"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["779", "31", "678"],
    ["446", "47", "179"],
    ["670", "38", "260"],
    ["267", "57", "557"],
    ["260", "83", "166"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["900", "90", "334"],
    ["119", "16", "790"],
    ["567", "83", "247"],
    ["124", "78", "288"],
    ["178", "61", "579"],
    ["335", "16", "123"],
    ["389", "02", "237"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["260", "89", "126"],
    ["300", "34", "158"],
    ["378", "82", "345"],
    ["577", "94", "112"],
    ["247", "36", "268"],
    ["400", "44", "356"],
    ["455", "43", "490"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["470", "13", "120"],
    ["344", "12", "129"],
    ["123", "60", "569"],
    ["126", "97", "340"],
    ["670", "32", "778"],
    ["135", "94", "149"],
    ["367", "61", "380"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["557", "70", "127"],
    ["178", "61", "100"],
    ["680", "46", "178"],
    ["790", "64", "356"],
    ["589", "21", "470"],
    ["668", "02", "156"],
    ["890", "71", "470"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["169", "64", "590"],
    ["338", "49", "577"],
    ["379", "97", "278"],
    ["678", "10", "235"],
    ["170", "87", "566"],
    ["199", "97", "179"],
    ["390", "29", "577"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["990", "89", "135"],
    ["279", "86", "123"],
    ["155", "12", "570"],
    ["568", "90", "136"],
    ["466", "69", "450"],
    ["355", "38", "233"],
    ["478", "97", "160"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["556", "60", "488"],
    ["358", "65", "366"],
    ["560", "17", "359"],
    ["370", "06", "790"],
    ["227", "12", "138"],
    ["156", "23", "247"],
    ["136", "00", "488"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["790", "64", "248"],
    ["144", "93", "166"],
    ["148", "32", "147"],
    ["357", "57", "160"],
    ["126", "94", "248"],
    ["167", "41", "236"],
    ["466", "61", "678"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["700", "76", "178"],
    ["578", "01", "290"],
    ["124", "76", "556"],
    ["230", "55", "113"],
    ["239", "44", "130"],
    ["360", "93", "580"],
    ["177", "55", "168"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["480", "21", "227"],
    ["378", "83", "148"],
    ["689", "33", "445"],
    ["227", "14", "158"],
    ["550", "09", "117"],
    ["389", "00", "578"],
    ["490", "37", "269"]
  ],
  "01/20/2025 to 01/26/2025": [
    ["169", "63", "139"],
    ["448", "67", "700"],
    ["390", "21", "588"],
    ["679", "21", "245"],
    ["479", "03", "346"],
    ["660", "28", "558"],
    ["***", "**", "***"]
  ],
  "01/27/2025 to 02/02/2025": [
    ["229","39","450"],
    ["336","29","117"],
    ["200","26","880"],
    ["799","54","590"],
    ["245","17","449"],
    ["179","71","290"],
    ["189","80","127"]
  ],
  "02/03/2025 to 02/09/2025": [
    ["360","92","570"],
    ["160","74","590"],
    ["133","74","446"],
    ["236","15","339"],
    ["780","57","359"],
    ["334","00","479"],
    ["260","83","139"]
  ],
  "02/10/2025 to 02/16/2025": [
    ["478","95","177"],
    ["378","84","266"],
    ["134","89","126"],
    ["189","89","270"],
    ["223","71","560"],
    ["245","12","679"],
    ["690","59","135"]
  ],
  "02/17/2025 to 02/23/2025": [
    ["245","19","559"],
    ["677","05","447"],
    ["237","29","234"],
    ["778","26","259"],
    ["169","61","579"],
    ["166","38","350"],
    ["467","75","447"]
  ],
  "02/24/2025 to 03/02/2025": [
    ["270","92","129"],
    ["267","59","469"],
    ["123","66","367"],
    ["589","25","500"],
    ["880","64","347"],
    ["334","00","460"],
    ["368","72","390"]
  ],
  "03/03/2025 to 03/09/2025": [
    ["117","91","678"],
    ["338","46","448"],
    ["340","72","129"],
    ["158","42","129"],
    ["579","17","179"],
    ["570","29","135"],
    ["467","77","368"]
  ],
  "03/10/2025 to 03/16/2025": [
    ["146","17","115"],
    ["660","29","667"],
    ["150","60","136"],
    ["167","48","378"],
    ["***","**","***"],
    ["150","66","448"],
    ["270","99","234"]
  ],
  "03/17/2025 to 03/23/2025": [
    ["270","94","257"],
    ["148","38","233"],
    ["115","71","227"],
    ["300","39","270"],
    ["338","40","190"],
    ["560","12","246"],
    ["137","19","469"]
  ],
  "03/24/2025 to 03/30/2025": [
    ["455","49","379"],
    ["457","61","245"],
    ["145","01","489"],
    ["257","49","360"],
    ["467","74","680"],
    ["289","94","347"],
    ["128","10","190"]
  ],
  "03/31/2025 to 04/06/2025": [
    ["189","84","239"],
    ["246","22","138"],
    ["667","94","158"],
    ["146","13","490"],
    ["200","26","899"],
    ["337","38","350"],
    ["389","08","170"]
  ],
  "04/07/2025 to 04/13/2025": [
    ["355","36","114"],
    ["148","30","569"],
    ["459","87","250"],
    ["590","40","389"],
    ["348","50","235"],
    ["799","52","570"],
    ["358","66","790"]
  ],
  "04/14/2025 to 04/20/2025": [
    ["137","11","399"],
    ["334","00","127"],
    ["149","42","444"],
    ["367","60","370"],
    ["177","58","477"],
    ["560","13","490"],
    ["238","37","458"]
  ],
  "04/21/2025 to 04/27/2025": [
    ["667","91","560"],
    ["170","88","233"],
    ["570","21","155"],
    ["250","78","134"],
    ["178","60","145"],
    ["440","82","138"],
    ["689","37","160"]
  ],
  "04/28/2025 to 05/04/2025": [
    ["490","33","580"],
    ["220","46","457"],
    ["270","94","590"],
    ["156","27","890"],
    ["448","67","458"],
    ["227","19","360"],
    ["590","43","670"]
  ],
  "05/05/2025 to 05/11/2025": [
    ["344","17","377"],
    ["167","40","235"],
    ["360","95","249"],
    ["113","57","890"],
    ["250","72","138"],
    ["146","16","123"],
    ["170","87","890"]
  ],
  "05/12/2025 to 05/18/2025": [
    ["239","41","579"],
    ["158","41","470"],
    ["288","82","679"],
    ["577","90","389"],
    ["236","11","560"],
    ["680","48","350"],
    ["157","37","269"]
  ],
  "05/19/2025 to 05/25/2025": [
    ["289","91","245"],
    ["578","03","238"],
    ["260","83","670"],
    ["568","90","460"],
    ["700","75","113"],
    ["699","48","260"],
    ["356","47","368"]
  ],
  "05/26/2025 to 06/01/2025": [
    ["558","82","480"],
    ["367","64","257"],
    ["235","03","580"],
    ["680","41","579"],
    ["460","09","469"],
    ["579","12","345"],
    ["460","06","150"]
  ],
  "06/02/2025 to 06/08/2025": [
    ["399","13","580"],
    ["590","41","489"],
    ["470","11","100"],
    ["780","55","168"],
    ["458","78","567"],
    ["349","69","135"],
    ["149","41","146"]
  ],
  "06/09/2025 to 06/15/2025": [
    ["567","89","450"],
    ["490","37","269"],
    ["238","37","124"],
    ["268","61","470"],
    ["249","55","177"],
    ["678","10","118"],
    ["590","45","258"]
  ],
  "06/16/2025 to 06/22/2025": [
    ["336","25","348"],
    ["400","45","140"],
    ["390","20","145"],
    ["166","30","190"],
    ["478","99","577"],
    ["579","12","660"],
    ["278","71","489"]
  ],
  "06/23/2025 to 06/29/2025": [
    ["249","58","459"],
    ["668","08","260"],
    ["440","83","300"],
    ["449","75","339"],
    ["668","08","288"],
    ["390","22","688"],
    ["378","84","248"]
  ],
  "06/30/2025 to 07/06/2025": [
    ["259","61","579"],
    ["566","78","116"],
    ["247","33","139"],
    ["168","59","180"],
    ["278","73","300"],
    ["559","98","170"],
    ["247","38","350"]
  ],
  "07/07/2025 to 07/13/2025": [
    ["380","16","349"],
    ["290","10","460"],
    ["136","05","159"],
    ["268","62","570"],
    ["189","89","117"],
    ["356","44","347"],
    ["790","63","157"]
  ],
  "07/14/2025 to 07/20/2025": [
    ["168","54","699"],
    ["127","01","119"],
    ["112","44","167"],
    ["158","45","159"],
    ["125","81","560"],
    ["479","02","237"],
    ["459","88","125"]
  ],
  "07/21/2025 to 07/27/2025": [
    ["268","64","347"],
    ["149","40","136"],
    ["167","48","189"],
    ["280","08","558"],
    ["589","21","335"],
    ["578","03","157"],
    ["136","06","169"]
  ],
  "07/28/2025 to 08/03/2025": [
    ["455","41","380"],
    ["250","75","159"],
    ["459","87","223"],
    ["339","51","155"],
    ["770","40","550"],
    ["379","93","157"],
    ["279","86","178"]
  ],
  "08/04/2025 to 08/10/2025": [
    ["799","52","156"],
    ["788","37","278"],
    ["170","87","340"],
    ["350","89","270"],
    ["458","79","388"],
    ["148","34","130"],
    ["460","02","147"]
  ],
  "08/11/2025 to 08/17/2025": [
    ["668","05","780"],
    ["449","77","269"],
    ["780","58","459"],
    ["467","74","130"],
    ["***","**","***"],
    ["278","79","450"],
    ["160","70","389"]
  ],
  "08/18/2025 to 08/24/2025": [
    ["270","96","457"],
    ["368","72","156"],
    ["290","10","280"],
    ["113","58","288"],
    ["349","64","158"],
    ["478","90","569"],
    ["245","10","677"]
  ],
  "08/25/2025 to 08/31/2025": [
    ["267","57","449"],
    ["569","08","116"],
    ["560","13","256"],
    ["224","82","345"],
    ["250","77","458"],
    ["589","23","689"],
    ["457","69","180"]
  ],
  "09/01/2025 to 09/07/2025": [
    ["589","21","344"],
    ["559","92","147"],
    ["127","06","259"],
    ["114","69","126"],
    ["334","04","680"],
    ["240","62","480"],
    ["789","41","146"]
  ],
  "09/08/2025 to 09/14/2025": [
    ["440","84","770"],
    ["249","58","477"],
    ["779","36","150"],
    ["369","88","170"],
    ["240","64","590"],
    ["459","80","244"],
    ["570","25","780"]
  ],
  "09/15/2025 to 09/21/2025": [
    ["370","06","240"],
    ["259","69","469"],
    ["466","62","336"],
    ["470","13","346"],
    ["488","01","227"],
    ["229","39","126"],
    ["234","91","137"]
  ],
  "09/22/2025 to 09/28/2025": [
    ["260","86","899"],
    ["290","12","570"],
    ["380","15","690"],
    ["180","99","450"],
    ["488","07","124"],
    ["115","75","267"],
    ["188","77","566"]
  ],
  "09/29/2025 to 10/05/2025": [
    ["478","90","145"],
    ["126","94","239"],
    ["168","57","179"],
    ["148","38","468"],
    ["149","40","235"],
    ["120","31","146"],
    ["259","66","178"]
  ],
  "10/06/2025 to 10/12/2025": [
    ["225","93","247"],
    ["124","78","558"],
    ["346","32","138"],
    ["140","55","447"],
    ["359","70","389"],
    ["589","22","147"],
    ["445","30","668"]
  ],
  "10/13/2025 to 10/19/2025": [
    ["250","77","160"],
    ["333","90","389"],
    ["134","82","499"],
    ["338","43","238"],
    ["390","29","234"],
    ["***","**","***"],
    ["***","**","***"]
  ],
  "10/20/2025 to 10/26/2025": [
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"],
    ["***","**","***"]
  ],
  "10/27/2025 to 11/02/2025": [
    ["124","76","457"],
    ["147","24","699"],
    ["135","90","244"],
    ["579","12","237"],
    ["667","94","158"],
    ["156","21","335"],
    ["158","40","389"]
  ],
  "11/03/2025 to 11/09/2025": [
    ["669","17","566"],
    ["389","09","270"],
    ["470","18","350"],
    ["233","87","557"],
    ["279","80","677"],
    ["246","24","239"],
    ["556","69","379"]
  ],
  "11/10/2025 to 11/16/2025": [
    ["338","40","370"],
    ["390","29","234"],
    ["679","22","246"],
    ["250","71","137"],
    ["178","60","127"],
    ["357","56","600"],
    ["267","59","450"]
  ],
  "11/17/2025 to 11/23/2025": [
    ["268","69","289"],
    ["256","34","248"],
    ["245","10","488"],
    ["188","77","458"],
    ["345","28","459"],
    ["660","24","455"],
    ["679","20","127"]
  ],
  "11/24/2025 to 11/30/2025": [
    ["138","20","136"],
    ["557","71","236"],
    ["190","06","240"],
    ["799","53","490"],
    ["479","06","358"],
    ["368","74","149"],
    ["569","05","230"]
  ],
  "12/01/2025 to 12/07/2025": [
    ["600","60","460"],
    ["470","12","156"],
    ["188","77","359"],
    ["366","53","139"],
    ["368","77","160"],
    ["455","43","300"],
    ["257","46","448"]
  ],
  "12/08/2025 to 12/14/2025": [
    ["788","31","137"],
    ["220","49","360"],
    ["378","84","130"],
    ["679","20","569"],
    ["339","53","580"],
    ["348","53","689"],
    ["469","98","233"]
  ],
  "12/15/2025 to 12/21/2025": [
    ["127","00","190"],
    ["277","61","669"],
    ["338","40","578"],
    ["689","32","480"],
    ["112","45","780"],
    ["470","10","136"],
    ["137","14","356"]
  ],
  "12/22/2025 to 12/28/2025": [
    ["135","94","446"],
    ["470","10","569"],
    ["499","28","558"],
    ["368","76","358"],
    ["458","74","220"],
    ["136","05","168"],
    ["145","03","490"]
  ],
  "12/29/2025 to 01/04/2026": [
    ["477","89","270"],
    ["237","22","246"],
    ["170","86","178"],
    ["229","34","149"],
    ["256","31","245"],
    ["188","70","569"],
    ["590","45","159"]
  ],
  "01/05/2026 to 01/11/2026": [
    ["259","66","457"],
    ["136","09","180"],
    ["133","70","677"],
    ["235","04","356"],
    ["360","97","890"],
    ["234","91","470"],
    ["170","85","249"]
  ],
  "01/12/2026 to 01/18/2026": [
    ["169","61","128"],
    ["230","50","280"],
    ["227","10","578"],
    ["227","13","139"],
    ["370","00","244"],
    ["557","77","278"],
    ["245","17","467"]
  ],
  "01/19/2026 to 01/25/2026": [
    ["580","31","344"],
    ["379","93","445"],
    ["144","98","800"],
    ["688","28","134"],
    ["236","10","145"],
    ["480","23","229"],
    ["349","68","990"]
  ],
  "01/26/2026 to 02/01/2026": [
    ["***","**","***"],
    ["790","66","349"],
    ["160","78","369"],
    ["380","12","570"],
    ["660","28","189"],
    ["119","17","359"],
    ["569","08","279"]
  ],
  "02/02/2026 to 02/08/2026": [
    ["450","94","590"],
    ["189","82","129"],
    ["234","99","270"],
    ["349","66","240"],
    ["369","89","117"],
    ["500","58","288"],
    ["577","96","899"]
  ],
  "02/09/2026 to 02/15/2026": [
    ["890","77","250"],
    ["344","11","290"],
    ["460","08","170"],
    ["160","79","144"],
    ["557","74","239"],
    ["259","62","228"],
    ["467","79","568"]
  ],
  "02/16/2026 to 02/22/2026": [
    ["889","53","670"],
    ["255","21","290"],
    ["445","38","288"],
    ["390","25","168"],
    ["699","44","347"],
    ["289","99","126"],
    ["113","59","289"]
  ],
  "02/23/2026 to 03/01/2026": [
    ["468","88","369"],
    ["127","02","156"],
    ["199","95","249"],
    ["330","64","167"],
    ["789","43","580"],
    ["450","98","134"],
    ["158","41","236"]
  ],
  "03/02/2026 to 03/08/2026": [
    ["357","56","880"],
    ["256","33","120"],
    ["***","**","***"],
    ["468","88","170"],
    ["660","21","380"],
    ["189","86","367"],
    ["379","98","350"]
  ],
  "03/09/2026 to 03/15/2026": [
    ["244","03","779"],
    ["225","98","567"],
    ["579","16","358"],
    ["129","25","159"],
    ["460","00","569"],
    ["779","31","137"],
    ["670","35","456"]
  ],
  "03/16/2026 to 03/22/2026": [
    ["459","80","479"],
    ["280","03","120"],
    ["259","61","678"],
    ["169","69","126"],
    ["589","22","480"],
    ["588","17","160"],
    ["490","33","346"]
  ]
};
export const MADHURNIGHT = {
   "01/01/2024 to 01/07/2024": [
    ["890", "75", "168"],
    ["159", "54", "699"],
    ["357", "50", "127"],
    ["349", "69", "126"],
    ["780", "56", "240"],
    ["880", "62", "480"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["660", "23", "445"],
    ["560", "15", "249"],
    ["379", "98", "378"],
    ["345", "26", "114"],
    ["249", "55", "230"],
    ["569", "05", "456"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["558", "89", "360"],
    ["457", "60", "578"],
    ["290", "12", "679"],
    ["346", "31", "579"],
    ["269", "74", "699"],
    ["346", "39", "234"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["449", "76", "457"],
    ["236", "16", "259"],
    ["477", "80", "226"],
    ["234", "92", "138"],
    ["***", "**", "***"],
    ["120", "31", "560"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["147", "23", "139"],
    ["480", "25", "258"],
    ["899", "67", "340"],
    ["116", "88", "233"],
    ["230", "58", "125"],
    ["580", "36", "150"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["368", "72", "345"],
    ["589", "20", "460"],
    ["358", "61", "290"],
    ["128", "19", "450"],
    ["380", "13", "670"],
    ["116", "86", "259"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["590", "46", "448"],
    ["337", "37", "700"],
    ["890", "72", "345"],
    ["280", "08", "378"],
    ["599", "37", "160"],
    ["670", "35", "456"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["778", "20", "190"],
    ["123", "63", "148"],
    ["550", "01", "245"],
    ["190", "02", "138"],
    ["226", "06", "240"],
    ["348", "56", "123"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["147", "27", "124"],
    ["667", "94", "257"],
    ["129", "21", "236"],
    ["350", "83", "337"],
    ["789", "44", "149"],
    ["480", "21", "399"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["556", "60", "479"],
    ["359", "73", "346"],
    ["550", "09", "225"],
    ["467", "70", "235"],
    ["359", "75", "456"],
    ["689", "37", "188"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["366", "59", "126"],
    ["468", "88", "350"],
    ["699", "45", "168"],
    ["189", "87", "133"],
    ["159", "59", "450"],
    ["570", "23", "157"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["600", "65", "168"],
    ["125", "84", "347"],
    ["289", "94", "149"],
    ["357", "55", "348"],
    ["188", "71", "245"],
    ["890", "77", "340"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["156", "27", "368"],
    ["278", "78", "279"],
    ["246", "28", "260"],
    ["556", "62", "345"],
    ["579", "10", "235"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["335", "14", "590"],
    ["467", "73", "256"],
    ["224", "86", "150"],
    ["190", "08", "279"],
    ["240", "69", "144"],
    ["260", "83", "247"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["156", "28", "170"],
    ["788", "31", "128"],
    ["270", "96", "349"],
    ["128", "14", "257"],
    ["234", "90", "280"],
    ["690", "53", "346"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["237", "20", "145"],
    ["148", "39", "478"],
    ["778", "24", "257"],
    ["188", "70", "578"],
    ["140", "55", "168"],
    ["114", "67", "124"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["130", "45", "159"],
    ["590", "44", "789"],
    ["489", "12", "255"],
    ["249", "52", "147"],
    ["557", "73", "238"],
    ["380", "15", "456"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["778", "26", "240"],
    ["880", "60", "389"],
    ["470", "10", "578"],
    ["360", "94", "400"],
    ["560", "12", "228"],
    ["589", "21", "128"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["267", "53", "247"],
    ["700", "72", "147"],
    ["568", "93", "490"],
    ["449", "75", "447"],
    ["469", "90", "244"],
    ["378", "81", "236"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["468", "81", "137"],
    ["700", "77", "223"],
    ["660", "29", "234"],
    ["246", "22", "570"],
    ["489", "11", "579"],
    ["117", "94", "257"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["133", "71", "579"],
    ["235", "03", "490"],
    ["168", "50", "460"],
    ["267", "56", "268"],
    ["139", "31", "128"],
    ["335", "18", "990"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["899", "63", "779"],
    ["235", "02", "390"],
    ["289", "91", "560"],
    ["690", "58", "170"],
    ["157", "30", "668"],
    ["278", "77", "449"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["157", "36", "169"],
    ["477", "87", "449"],
    ["240", "63", "120"],
    ["190", "00", "145"],
    ["589", "25", "267"],
    ["599", "31", "119"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["670", "38", "350"],
    ["380", "14", "338"],
    ["445", "36", "880"],
    ["290", "12", "390"],
    ["156", "28", "134"],
    ["469", "98", "800"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["145", "08", "260"],
    ["488", "07", "179"],
    ["369", "82", "237"],
    ["110", "24", "167"],
    ["240", "61", "236"],
    ["249", "59", "469"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["279", "88", "567"],
    ["113", "52", "660"],
    ["700", "75", "258"],
    ["127", "07", "368"],
    ["237", "28", "125"],
    ["230", "58", "260"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["356", "43", "580"],
    ["558", "87", "359"],
    ["560", "10", "145"],
    ["150", "62", "589"],
    ["127", "01", "579"],
    ["244", "04", "248"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["889", "59", "450"],
    ["589", "26", "259"],
    ["479", "07", "566"],
    ["457", "60", "370"],
    ["237", "27", "160"],
    ["469", "94", "590"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["578", "08", "125"],
    ["234", "94", "158"],
    ["466", "65", "366"],
    ["145", "01", "380"],
    ["167", "42", "147"],
    ["258", "50", "389"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["359", "74", "446"],
    ["467", "71", "236"],
    ["380", "18", "260"],
    ["127", "05", "357"],
    ["248", "43", "788"],
    ["457", "66", "349"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["346", "32", "570"],
    ["268", "61", "227"],
    ["348", "54", "130"],
    ["345", "20", "389"],
    ["288", "81", "100"],
    ["169", "60", "280"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["126", "98", "350"],
    ["139", "30", "190"],
    ["288", "86", "169"],
    ["448", "64", "257"],
    ["699", "41", "669"],
    ["135", "94", "130"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["799", "55", "366"],
    ["160", "73", "670"],
    ["477", "89", "450"],
    ["***", "**", "***"],
    ["880", "61", "155"],
    ["269", "71", "146"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["466", "67", "269"],
    ["678", "19", "270"],
    ["236", "14", "680"],
    ["370", "04", "248"],
    ["489", "15", "249"],
    ["340", "76", "178"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["480", "20", "145"],
    ["600", "65", "258"],
    ["268", "63", "157"],
    ["680", "42", "138"],
    ["166", "34", "149"],
    ["445", "30", "118"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["234", "91", "588"],
    ["227", "16", "358"],
    ["344", "18", "189"],
    ["350", "84", "239"],
    ["344", "16", "330"],
    ["339", "55", "249"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["570", "27", "179"],
    ["147", "28", "125"],
    ["267", "54", "455"],
    ["167", "46", "268"],
    ["489", "10", "299"],
    ["123", "69", "270"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["147", "24", "699"],
    ["267", "59", "126"],
    ["300", "30", "280"],
    ["157", "30", "370"],
    ["566", "71", "344"],
    ["788", "37", "250"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["258", "57", "278"],
    ["688", "29", "117"],
    ["680", "49", "289"],
    ["160", "70", "460"],
    ["180", "97", "269"],
    ["116", "84", "266"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["157", "32", "129"],
    ["129", "23", "148"],
    ["178", "64", "347"],
    ["790", "65", "159"],
    ["455", "44", "680"],
    ["190", "00", "488"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["788", "36", "222"],
    ["488", "09", "270"],
    ["146", "16", "169"],
    ["589", "25", "249"],
    ["490", "31", "119"],
    ["567", "85", "159"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["157", "34", "167"],
    ["100", "13", "247"],
    ["145", "00", "244"],
    ["667", "94", "590"],
    ["169", "60", "578"],
    ["267", "51", "560"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["157", "32", "589"],
    ["347", "44", "257"],
    ["260", "82", "138"],
    ["237", "20", "118"],
    ["469", "92", "237"],
    ["247", "31", "489"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["579", "15", "159"],
    ["348", "52", "570"],
    ["380", "12", "228"],
    ["670", "31", "290"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["456", "55", "348"],
    ["380", "19", "478"],
    ["990", "88", "134"],
    ["112", "42", "255"],
    ["236", "13", "120"],
    ["240", "68", "125"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["255", "25", "258"],
    ["890", "78", "170"],
    ["389", "01", "128"],
    ["123", "66", "899"],
    ["270", "92", "660"],
    ["228", "24", "446"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["499", "26", "277"],
    ["270", "98", "440"],
    ["234", "98", "125"],
    ["577", "92", "147"],
    ["127", "04", "400"],
    ["339", "58", "125"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["345", "21", "588"],
    ["456", "55", "177"],
    ["360", "94", "112"],
    ["125", "87", "340"],
    ["679", "26", "790"],
    ["399", "19", "379"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["277", "69", "900"],
    ["668", "03", "445"],
    ["378", "85", "140"],
    ["245", "11", "236"],
    ["236", "18", "459"],
    ["255", "21", "245"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["366", "50", "578"],
    ["249", "50", "550"],
    ["157", "39", "360"],
    ["169", "61", "579"],
    ["135", "96", "268"],
    ["248", "48", "189"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["127", "04", "149"],
    ["359", "75", "780"],
    ["227", "18", "459"],
    ["135", "98", "350"],
    ["445", "33", "300"],
    ["189", "87", "377"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["336", "21", "100"],
    ["248", "44", "338"],
    ["248", "45", "177"],
    ["130", "43", "445"],
    ["290", "16", "178"],
    ["567", "81", "489"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["179", "77", "124"],
    ["689", "36", "259"],
    ["226", "09", "568"],
    ["578", "04", "149"],
    ["359", "72", "660"],
    ["560", "16", "457"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["128", "15", "230"],
    ["290", "10", "190"],
    ["289", "95", "366"],
    ["233", "87", "223"],
    ["378", "88", "125"],
    ["367", "64", "248"]
  ],
  "01/20/2025 to 01/26/2025": [
    ["469", "99", "126"],
    ["189", "84", "220"],
    ["136", "07", "124"],
    ["140", "52", "147"],
    ["129", "26", "114"],
    ["780", "53", "148"]
  ],
   "01/27/2025 to 02/02/2025": [
    ["240", "63", "779"],
    ["490", "35", "456"],
    ["388", "99", "117"],
    ["170", "84", "167"],
    ["270", "91", "245"],
    ["690", "51", "399"]
  ],
  "02/03/2025 to 02/09/2025": [
    ["390", "22", "778"],
    ["123", "61", "489"],
    ["556", "68", "350"],
    ["470", "10", "244"],
    ["900", "92", "255"],
    ["469", "97", "340"]
  ],
  "02/10/2025 to 02/16/2025": [
    ["569", "00", "190"],
    ["699", "43", "580"],
    ["360", "91", "560"],
    ["126", "95", "168"],
    ["250", "76", "259"],
    ["237", "25", "348"]
  ],
  "02/17/2025 to 02/23/2025": [
    ["570", "26", "178"],
    ["145", "06", "240"],
    ["233", "83", "355"],
    ["128", "18", "233"],
    ["239", "47", "557"],
    ["579", "14", "130"]
  ],
  "02/24/2025 to 03/02/2025": [
    ["120", "33", "346"],
    ["348", "50", "389"],
    ["339", "57", "250"],
    ["389", "00", "578"],
    ["124", "72", "390"],
    ["146", "14", "158"]
  ],
  "03/03/2025 to 03/09/2025": [
    ["340", "78", "125"],
    ["399", "12", "110"],
    ["468", "86", "349"],
    ["134", "81", "669"],
    ["345", "23", "670"],
    ["345", "27", "124"]
  ],
  "03/10/2025 to 03/16/2025": [
    ["690", "53", "148"],
    ["589", "20", "370"],
    ["245", "19", "360"],
    ["599", "30", "235"],
    ["***", "**", "***"],
    ["589", "20", "479"]
  ],
  "03/17/2025 to 03/23/2025": [
    ["457", "64", "248"],
    ["147", "25", "889"],
    ["790", "66", "178"],
    ["178", "61", "380"],
    ["290", "13", "139"],
    ["490", "30", "550"]
  ],
  "03/24/2025 to 03/30/2025": [
    ["180", "97", "340"],
    ["350", "83", "580"],
    ["237", "25", "357"],
    ["478", "95", "267"],
    ["138", "21", "128"],
    ["145", "02", "147"]
  ],
  "03/31/2025 to 04/06/2025": [
    ["366", "54", "248"],
    ["680", "43", "689"],
    ["259", "61", "560"],
    ["239", "43", "355"],
    ["227", "18", "279"],
    ["368", "77", "359"]
  ],
  "04/07/2025 to 04/13/2025": [
    ["500", "51", "588"],
    ["480", "23", "490"],
    ["300", "35", "357"],
    ["134", "87", "278"],
    ["279", "86", "880"],
    ["230", "54", "680"]
  ],
  "04/14/2025 to 04/20/2025": [
    ["457", "63", "247"],
    ["569", "01", "128"],
    ["266", "40", "677"],
    ["679", "24", "347"],
    ["246", "28", "170"],
    ["578", "09", "568"]
  ],
  "04/21/2025 to 04/27/2025": [
    ["224", "88", "440"],
    ["250", "70", "460"],
    ["889", "57", "179"],
    ["146", "11", "470"],
    ["567", "81", "470"],
    ["349", "60", "136"]
  ],
  "04/28/2025 to 05/04/2025": [
    ["449", "72", "570"],
    ["344", "13", "238"],
    ["799", "59", "577"],
    ["679", "22", "679"],
    ["468", "88", "369"],
    ["133", "74", "347"]
  ],
  "05/05/2025 to 05/11/2025": [
    ["239", "48", "134"],
    ["450", "99", "379"],
    ["235", "07", "359"],
    ["128", "15", "456"],
    ["236", "18", "116"],
    ["260", "88", "567"]
  ],
  "05/12/2025 to 05/18/2025": [
    ["566", "78", "189"],
    ["137", "10", "145"],
    ["136", "02", "156"],
    ["279", "83", "247"],
    ["266", "42", "246"],
    ["668", "00", "569"]
  ],
  "05/19/2025 to 05/25/2025": [
    ["220", "49", "667"],
    ["459", "86", "600"],
    ["570", "23", "490"],
    ["390", "28", "468"],
    ["233", "87", "160"],
    ["345", "23", "580"]
  ],
  "05/26/2025 to 06/01/2025": [
    ["300", "36", "367"],
    ["269", "77", "566"],
    ["266", "46", "259"],
    ["346", "30", "235"],
    ["129", "25", "258"],
    ["249", "57", "188"]
  ],
  "06/02/2025 to 06/08/2025": [
    ["335", "17", "188"],
    ["390", "29", "469"],
    ["345", "23", "148"],
    ["358", "64", "149"],
    ["150", "60", "145"],
    ["236", "13", "490"]
  ],
  "06/09/2025 to 06/15/2025": [
    ["460", "05", "159"],
    ["466", "61", "588"],
    ["249", "56", "899"],
    ["599", "35", "258"],
    ["579", "12", "589"],
    ["590", "46", "240"]
  ],
  "06/16/2025 to 06/22/2025": [
    ["460", "02", "390"],
    ["268", "68", "567"],
    ["270", "97", "368"],
    ["359", "78", "279"],
    ["478", "93", "139"],
    ["288", "84", "338"]
  ],
  "06/23/2025 to 06/29/2025": [
    ["223", "77", "890"],
    ["490", "31", "245"],
    ["667", "96", "268"],
    ["360", "98", "567"],
    ["260", "83", "157"],
    ["680", "44", "356"]
  ],
  "06/30/2025 to 07/06/2025": [
    ["166", "33", "689"],
    ["124", "74", "400"],
    ["169", "63", "256"],
    ["146", "18", "459"],
    ["550", "07", "340"],
    ["160", "74", "248"]
  ],
  "07/07/2025 to 07/13/2025": [
    ["278", "73", "580"],
    ["290", "10", "136"],
    ["130", "48", "378"],
    ["570", "28", "459"],
    ["239", "44", "167"],
    ["150", "60", "389"]
  ],
  "07/14/2025 to 07/20/2025": [
    ["556", "61", "560"],
    ["223", "78", "224"],
    ["550", "05", "690"],
    ["160", "79", "126"],
    ["130", "41", "470"],
    ["247", "39", "469"]
  ],
  "07/21/2025 to 07/27/2025": [
    ["347", "43", "670"],
    ["277", "68", "170"],
    ["457", "64", "130"],
    ["590", "45", "140"],
    ["235", "01", "344"],
    ["280", "01", "245"]
  ],
  "07/28/2025 to 08/03/2025": [
    ["147", "28", "125"],
    ["257", "43", "148"],
    ["440", "80", "190"],
    ["178", "67", "467"],
    ["478", "91", "380"],
    ["156", "20", "370"]
  ],
  "08/04/2025 to 08/10/2025": [
    ["379", "97", "449"],
    ["480", "27", "368"],
    ["990", "80", "118"],
    ["150", "64", "257"],
    ["466", "66", "367"],
    ["400", "41", "470"]
  ],
  "08/11/2025 to 08/17/2025": [
    ["380", "13", "247"],
    ["589", "26", "259"],
    ["450", "97", "160"],
    ["113", "55", "159"],
    ["***", "**", "***"],
    ["349", "67", "124"]
  ],
  "08/18/2025 to 08/24/2025": [
    ["390", "22", "679"],
    ["168", "50", "244"],
    ["440", "84", "347"],
    ["139", "38", "288"],
    ["490", "38", "369"],
    ["230", "53", "580"]
  ],
  "08/25/2025 to 08/31/2025": [
    ["380", "11", "470"],
    ["446", "45", "140"],
    ["333", "96", "277"],
    ["490", "32", "237"],
    ["339", "59", "180"],
    ["136", "09", "126"]
  ],
  "09/01/2025 to 09/07/2025": [
    ["500", "51", "245"],
    ["246", "22", "147"],
    ["480", "20", "479"],
    ["140", "59", "135"],
    ["266", "44", "167"],
    ["456", "57", "458"]
  ],
  "09/08/2025 to 09/14/2025": [
    ["466", "66", "259"],
    ["440", "85", "230"],
    ["460", "03", "670"],
    ["247", "33", "346"],
    ["239", "48", "279"],
    ["234", "99", "360"]
  ],
  "09/15/2025 to 09/21/2025": [
    ["350", "84", "400"],
    ["458", "72", "570"],
    ["340", "74", "149"],
    ["169", "64", "590"],
    ["345", "26", "178"],
    ["349", "62", "138"]
  ],
  "09/22/2025 to 09/28/2025": [
    ["248", "47", "115"],
    ["257", "43", "256"],
    ["380", "15", "348"],
    ["234", "91", "678"],
    ["170", "82", "147"],
    ["126", "94", "130"]
  ],
  "09/29/2025 to 10/05/2025": [
    ["569", "00", "389"],
    ["348", "54", "680"],
    ["135", "93", "157"],
    ["269", "79", "478"],
    ["137", "12", "480"],
    ["188", "78", "800"]
  ],
  "10/06/2025 to 10/12/2025": [
    ["256", "39", "180"],
    ["130", "47", "160"],
    ["469", "99", "135"],
    ["335", "11", "579"],
    ["770", "42", "778"],
    ["370", "04", "680"]
  ],
  "10/13/2025 to 10/19/2025": [
    ["347", "43", "689"],
    ["456", "59", "379"],
    ["145", "00", "280"],
    ["280", "06", "277"],
    ["260", "81", "236"],
    ["***", "**", "***"]
  ],
  "10/20/2025 to 10/26/2025": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "10/27/2025 to 11/02/2025": [
    ["223", "72", "246"],
    ["778", "26", "150"],
    ["688", "21", "290"],
    ["366", "51", "119"],
    ["167", "45", "258"],
    ["157", "36", "790"]
  ],
  "11/03/2025 to 11/09/2025": [
    ["790", "66", "358"],
    ["558", "80", "389"],
    ["380", "18", "288"],
    ["168", "54", "590"],
    ["156", "21", "489"],
    ["244", "01", "137"]
  ],
  "11/10/2025 to 11/16/2025": [
    ["357", "54", "770"],
    ["340", "78", "233"],
    ["689", "32", "390"],
    ["146", "10", "280"],
    ["490", "32", "237"],
    ["127", "05", "889"]
  ],
  "11/17/2025 to 11/23/2025": [
    ["569", "04", "400"],
    ["779", "30", "145"],
    ["346", "38", "134"],
    ["899", "60", "145"],
    ["477", "80", "136"],
    ["178", "63", "670"]
  ],
  "11/24/2025 to 11/30/2025": [
    ["280", "09", "225"],
    ["347", "46", "259"],
    ["279", "83", "238"],
    ["788", "30", "460"],
    ["177", "53", "490"],
    ["790", "69", "360"]
  ],
  "12/01/2025 to 12/07/2025": [
    ["120", "32", "138"],
    ["457", "61", "227"],
    ["168", "59", "469"],
    ["370", "02", "138"],
    ["134", "86", "259"],
    ["240", "62", "679"]
  ],
  "12/08/2025 to 12/14/2025": [
    ["670", "35", "168"],
    ["466", "64", "699"],
    ["557", "72", "138"],
    ["279", "89", "667"],
    ["239", "44", "590"],
    ["229", "33", "580"]
  ],
  "12/15/2025 to 12/21/2025": [
    ["248", "40", "569"],
    ["128", "10", "235"],
    ["349", "65", "258"],
    ["460", "02", "246"],
    ["179", "73", "256"],
    ["227", "17", "368"]
  ],
  "12/22/2025 to 12/28/2025": [
    ["158", "48", "288"],
    ["378", "84", "356"],
    ["670", "37", "467"],
    ["150", "69", "469"],
    ["579", "17", "359"],
    ["239", "47", "115"]
  ],
  "12/29/2025 to 01/04/2026": [
    ["470", "13", "238"],
    ["360", "96", "259"],
    ["155", "17", "269"],
    ["240", "67", "700"],
    ["230", "53", "238"],
    ["146", "16", "178"]
  ],
  "01/05/2026 to 01/11/2026": [
    ["459", "87", "160"],
    ["179", "70", "370"],
    ["166", "33", "139"],
    ["449", "76", "123"],
    ["499", "24", "347"],
    ["457", "66", "367"]
  ],
  "01/12/2026 to 01/18/2026": [
    ["446", "42", "480"],
    ["148", "35", "159"],
    ["458", "76", "600"],
    ["169", "68", "440"],
    ["460", "00", "280"],
    ["779", "39", "450"]
  ],
  "01/19/2026 to 01/25/2026": [
    ["127", "01", "579"],
    ["477", "87", "557"],
    ["269", "73", "355"],
    ["399", "18", "170"],
    ["356", "48", "459"],
    ["557", "70", "244"]
  ],
  "01/26/2026 to 02/01/2026": [
    ["***", "**", "***"],
    ["355", "35", "230"],
    ["277", "62", "390"],
    ["289", "99", "450"],
    ["380", "14", "167"],
    ["146", "11", "489"]
  ],
  "02/02/2026 to 02/08/2026": [
    ["458", "79", "360"],
    ["145", "03", "256"],
    ["556", "67", "133"],
    ["366", "57", "223"],
    ["147", "21", "227"],
    ["499", "29", "270"]
  ],
  "02/09/2026 to 02/15/2026": [
    ["246", "25", "230"],
    ["128", "14", "356"],
    ["660", "26", "448"],
    ["246", "21", "236"],
    ["249", "54", "590"],
    ["150", "65", "447"]
  ],
  "02/16/2026 to 02/22/2026": [
    ["167", "48", "125"],
    ["345", "25", "177"],
    ["570", "20", "370"],
    ["350", "81", "137"],
    ["169", "62", "156"],
    ["679", "29", "478"]
  ],
  "02/23/2026 to 03/01/2026": [
    ["190", "04", "347"],
    ["100", "19", "360"],
    ["112", "45", "780"],
    ["390", "20", "145"],
    ["660", "23", "490"],
    ["270", "96", "240"]
  ],
  "03/02/2026 to 03/08/2026": [
    ["358", "69", "559"],
    ["260", "85", "690"],
    ["***", "**", "***"],
    ["348", "53", "148"],
    ["346", "36", "240"],
    ["126", "91", "669"]
  ],
  "03/09/2026 to 03/15/2026": [
    ["800", "82", "499"],
    ["678", "11", "290"],
    ["468", "82", "589"],
    ["568", "90", "145"],
    ["390", "24", "167"],
    ["127", "00", "370"]
  ],
  "03/16/2026 to 03/22/2026": [
    ["448", "60", "370"],
    ["126", "95", "230"],
    ["234", "95", "357"],
    ["158", "41", "335"],
    ["168", "50", "460"],
    ["148", "34", "789"]
  ]
};
export const RAJDHANIDAY = {
  "01/01/2024 to 01/07/2024": [
    ["129", "23", "148"],
    ["135", "99", "126"],
    ["179", "70", "479"],
    ["389", "05", "339"],
    ["246", "21", "678"],
    ["135", "99", "900"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["255", "26", "123"],
    ["790", "64", "347"],
    ["118", "08", "350"],
    ["258", "50", "479"],
    ["180", "99", "577"],
    ["447", "50", "280"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["678", "16", "790"],
    ["489", "17", "188"],
    ["179", "70", "460"],
    ["134", "83", "580"],
    ["770", "40", "389"],
    ["360", "91", "380"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["790", "63", "355"],
    ["680", "45", "140"],
    ["150", "62", "147"],
    ["900", "95", "168"],
    ["***", "**", "***"],
    ["570", "21", "344"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["247", "33", "148"],
    ["680", "46", "268"],
    ["158", "44", "130"],
    ["457", "60", "479"],
    ["677", "02", "480"],
    ["268", "62", "246"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["126", "96", "358"],
    ["448", "67", "890"],
    ["125", "88", "477"],
    ["369", "81", "380"],
    ["127", "02", "345"],
    ["355", "31", "128"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["149", "44", "356"],
    ["679", "23", "148"],
    ["446", "47", "359"],
    ["457", "64", "455"],
    ["580", "31", "236"],
    ["368", "70", "668"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["479", "08", "459"],
    ["259", "66", "240"],
    ["278", "78", "558"],
    ["145", "03", "599"],
    ["577", "93", "580"],
    ["127", "00", "569"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["289", "93", "120"],
    ["500", "57", "368"],
    ["380", "19", "568"],
    ["588", "13", "256"],
    ["360", "96", "178"],
    ["570", "28", "224"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["300", "34", "220"],
    ["269", "73", "247"],
    ["499", "23", "689"],
    ["246", "28", "369"],
    ["257", "41", "678"],
    ["369", "84", "239"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["133", "71", "236"],
    ["340", "77", "557"],
    ["200", "28", "189"],
    ["149", "42", "679"],
    ["359", "76", "349"],
    ["800", "89", "450"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["289", "95", "168"],
    ["123", "66", "114"],
    ["880", "61", "128"],
    ["260", "80", "190"],
    ["145", "05", "456"],
    ["116", "83", "256"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["590", "45", "140"],
    ["122", "58", "260"],
    ["669", "13", "166"],
    ["236", "10", "479"],
    ["190", "07", "890"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["149", "41", "245"],
    ["689", "33", "300"],
    ["136", "09", "270"],
    ["680", "41", "146"],
    ["136", "03", "139"],
    ["166", "38", "288"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["289", "99", "568"],
    ["460", "08", "189"],
    ["445", "37", "269"],
    ["349", "68", "369"],
    ["170", "81", "669"],
    ["146", "11", "227"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["240", "63", "689"],
    ["300", "37", "179"],
    ["279", "82", "589"],
    ["127", "06", "457"],
    ["380", "15", "690"],
    ["155", "16", "169"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["467", "75", "113"],
    ["449", "72", "570"],
    ["357", "53", "490"],
    ["125", "84", "680"],
    ["226", "05", "230"],
    ["229", "33", "670"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["267", "56", "457"],
    ["136", "02", "679"],
    ["116", "88", "170"],
    ["357", "59", "126"],
    ["660", "22", "138"],
    ["336", "24", "347"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["128", "12", "138"],
    ["389", "05", "140"],
    ["470", "14", "239"],
    ["448", "61", "146"],
    ["125", "80", "299"],
    ["189", "80", "578"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["579", "19", "379"],
    ["330", "65", "348"],
    ["149", "40", "334"],
    ["489", "14", "167"],
    ["790", "67", "269"],
    ["477", "80", "389"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["128", "16", "178"],
    ["189", "83", "238"],
    ["115", "71", "579"],
    ["340", "74", "590"],
    ["468", "84", "220"],
    ["110", "22", "156"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["236", "15", "230"],
    ["790", "63", "670"],
    ["559", "97", "340"],
    ["580", "33", "247"],
    ["180", "95", "177"],
    ["122", "54", "347"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["490", "31", "560"],
    ["579", "18", "440"],
    ["570", "22", "480"],
    ["246", "28", "260"],
    ["279", "87", "223"],
    ["700", "76", "150"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["490", "30", "235"],
    ["680", "48", "260"],
    ["447", "51", "669"],
    ["459", "82", "110"],
    ["489", "15", "267"],
    ["669", "16", "169"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["179", "71", "470"],
    ["250", "79", "180"],
    ["690", "55", "140"],
    ["260", "81", "489"],
    ["224", "83", "157"],
    ["800", "84", "167"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["580", "33", "256"],
    ["158", "46", "448"],
    ["123", "64", "590"],
    ["240", "63", "247"],
    ["668", "08", "990"],
    ["480", "29", "270"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["489", "19", "469"],
    ["236", "13", "139"],
    ["156", "29", "199"],
    ["780", "56", "123"],
    ["179", "75", "159"],
    ["557", "79", "478"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["259", "68", "468"],
    ["113", "53", "238"],
    ["159", "57", "133"],
    ["588", "14", "248"],
    ["468", "81", "290"],
    ["480", "26", "457"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["580", "30", "550"],
    ["579", "14", "590"],
    ["339", "54", "149"],
    ["489", "12", "156"],
    ["356", "40", "479"],
    ["233", "82", "570"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["458", "70", "370"],
    ["348", "54", "590"],
    ["288", "85", "258"],
    ["158", "41", "678"],
    ["340", "74", "446"],
    ["570", "29", "469"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["457", "63", "580"],
    ["250", "79", "469"],
    ["459", "88", "116"],
    ["770", "44", "149"],
    ["280", "02", "390"],
    ["339", "57", "368"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["570", "26", "448"],
    ["380", "18", "350"],
    ["567", "89", "379"],
    ["300", "38", "468"],
    ["136", "07", "179"],
    ["377", "77", "359"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["146", "10", "370"],
    ["579", "18", "378"],
    ["569", "04", "248"],
    ["***", "**", "***"],
    ["280", "01", "290"],
    ["466", "69", "577"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["239", "40", "370"],
    ["369", "82", "345"],
    ["578", "05", "780"],
    ["147", "25", "159"],
    ["233", "86", "150"],
    ["380", "19", "126"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["560", "11", "290"],
    ["257", "49", "180"],
    ["667", "97", "250"],
    ["359", "77", "160"],
    ["556", "64", "239"],
    ["250", "71", "678"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["899", "69", "234"],
    ["348", "51", "100"],
    ["790", "61", "245"],
    ["188", "70", "550"],
    ["126", "91", "579"],
    ["344", "18", "350"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["159", "59", "469"],
    ["677", "04", "158"],
    ["149", "41", "290"],
    ["456", "52", "688"],
    ["468", "88", "369"],
    ["289", "94", "266"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["446", "42", "156"],
    ["379", "96", "790"],
    ["177", "51", "579"],
    ["589", "23", "445"],
    ["550", "09", "135"],
    ["140", "58", "260"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["556", "69", "135"],
    ["280", "05", "267"],
    ["389", "05", "348"],
    ["257", "40", "136"],
    ["790", "61", "588"],
    ["110", "25", "357"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["270", "91", "137"],
    ["136", "03", "580"],
    ["350", "82", "390"],
    ["660", "29", "559"],
    ["148", "37", "449"],
    ["688", "21", "489"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["567", "81", "137"],
    ["340", "77", "458"],
    ["137", "10", "280"],
    ["140", "52", "390"],
    ["119", "10", "235"],
    ["359", "74", "789"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["590", "42", "246"],
    ["344", "16", "330"],
    ["450", "99", "469"],
    ["680", "42", "570"],
    ["159", "51", "245"],
    ["780", "54", "167"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["466", "62", "390"],
    ["280", "06", "123"],
    ["779", "30", "370"],
    ["238", "32", "570"],
    ["350", "80", "488"],
    ["270", "91", "380"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["467", "79", "199"],
    ["450", "98", "459"],
    ["278", "73", "247"],
    ["469", "92", "237"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["118", "06", "259"],
    ["579", "10", "280"],
    ["188", "74", "248"],
    ["789", "48", "134"],
    ["600", "66", "268"],
    ["157", "38", "468"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["167", "43", "148"],
    ["579", "19", "450"],
    ["368", "78", "189"],
    ["335", "15", "140"],
    ["270", "93", "300"],
    ["400", "48", "189"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["368", "77", "160"],
    ["580", "38", "459"],
    ["238", "32", "390"],
    ["358", "63", "346"],
    ["679", "24", "590"],
    ["380", "13", "300"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["370", "05", "357"],
    ["990", "85", "267"],
    ["789", "44", "356"],
    ["479", "07", "557"],
    ["466", "60", "235"],
    ["680", "42", "345"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["667", "91", "470"],
    ["120", "37", "377"],
    ["157", "31", "470"],
    ["138", "26", "150"],
    ["336", "25", "168"],
    ["134", "81", "146"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["678", "10", "235"],
    ["123", "64", "130"],
    ["245", "10", "127"],
    ["124", "76", "240"],
    ["135", "92", "499"],
    ["266", "40", "127"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["457", "66", "259"],
    ["235", "09", "144"],
    ["180", "94", "356"],
    ["360", "95", "177"],
    ["135", "90", "280"],
    ["269", "75", "500"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["678", "11", "236"],
    ["770", "40", "569"],
    ["357", "52", "147"],
    ["490", "39", "559"],
    ["146", "10", "136"],
    ["220", "45", "456"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["357", "59", "360"],
    ["136", "05", "168"],
    ["470", "14", "590"],
    ["257", "41", "588"],
    ["229", "35", "456"],
    ["457", "66", "358"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["137", "19", "117"],
    ["139", "38", "369"],
    ["110", "29", "469"],
    ["248", "42", "390"],
    ["160", "78", "279"],
    ["569", "05", "799"]
  ],
  "01/20/2025 to 01/26/2025": [
    ["580", "39", "478"],
    ["556", "66", "466"],
    ["178", "64", "149"],
    ["570", "20", "190"],
    ["477", "86", "259"],
    ["339", "53", "580"]
  ],
  "01/27/2025 to 02/02/2025": [
    ["150", "63", "148"],
    ["137", "11", "669"],
    ["357", "50", "235"],
    ["189", "82", "200"],
    ["800", "82", "390"],
    ["129", "25", "690"]
  ],
  "02/03/2025 to 02/09/2025": [
    ["556", "63", "346"],
    ["127", "00", "190"],
    ["470", "14", "590"],
    ["340", "70", "578"],
    ["388", "91", "335"],
    ["158", "40", "370"]
  ],
  "02/10/2025 to 02/16/2025": [
    ["224", "87", "359"],
    ["235", "09", "469"],
    ["456", "54", "112"],
    ["558", "83", "670"],
    ["168", "51", "380"],
    ["569", "05", "177"]
  ],
  "02/17/2025 to 02/23/2025": [
    ["240", "67", "359"],
    ["146", "12", "156"],
    ["260", "87", "278"],
    ["277", "69", "126"],
    ["477", "87", "458"],
    ["258", "50", "668"]
  ],
  "02/24/2025 to 03/02/2025": [
    ["268", "65", "690"],
    ["256", "33", "148"],
    ["113", "50", "460"],
    ["135", "99", "270"],
    ["269", "75", "258"],
    ["380", "12", "246"]
  ],
  "03/03/2025 to 03/09/2025": [
    ["159", "52", "688"],
    ["117", "97", "368"],
    ["120", "35", "348"],
    ["488", "08", "350"],
    ["789", "46", "790"],
    ["337", "33", "247"]
  ],
  "03/10/2025 to 03/16/2025": [
    ["378", "83", "157"],
    ["334", "05", "177"],
    ["138", "22", "129"],
    ["368", "78", "477"],
    ["***", "**", "***"],
    ["359", "71", "489"]
  ],
  "03/17/2025 to 03/23/2025": [
    ["349", "65", "113"],
    ["119", "13", "355"],
    ["345", "29", "478"],
    ["137", "17", "124"],
    ["135", "98", "125"],
    ["120", "35", "780"]
  ],
  "03/24/2025 to 03/30/2025": [
    ["180", "96", "367"],
    ["357", "52", "110"],
    ["144", "90", "190"],
    ["349", "64", "149"],
    ["339", "51", "344"],
    ["570", "29", "135"]
  ],
  "03/31/2025 to 04/06/2025": [
    ["590", "40", "460"],
    ["345", "27", "890"],
    ["470", "15", "799"],
    ["770", "46", "466"],
    ["270", "99", "450"],
    ["169", "60", "460"]
  ],
  "04/07/2025 to 04/13/2025": [
    ["160", "73", "490"],
    ["167", "49", "117"],
    ["247", "33", "670"],
    ["356", "49", "379"],
    ["125", "83", "346"],
    ["199", "96", "240"]
  ],
  "04/14/2025 to 04/20/2025": [
    ["235", "05", "230"],
    ["469", "97", "340"],
    ["479", "02", "570"],
    ["467", "74", "167"],
    ["149", "40", "389"],
    ["990", "81", "678"]
  ],
  "04/21/2025 to 04/27/2025": [
    ["139", "37", "250"],
    ["339", "50", "127"],
    ["280", "08", "224"],
    ["258", "55", "177"],
    ["120", "31", "669"],
    ["460", "02", "237"]
  ],
  "04/28/2025 to 05/04/2025": [
    ["478", "96", "240"],
    ["169", "65", "249"],
    ["229", "32", "480"],
    ["470", "15", "690"],
    ["490", "33", "139"],
    ["669", "12", "246"]
  ],
  "05/05/2025 to 05/11/2025": [
    ["300", "30", "190"],
    ["180", "94", "248"],
    ["249", "52", "138"],
    ["448", "60", "280"],
    ["678", "16", "349"],
    ["117", "91", "560"]
  ],
  "05/12/2025 to 05/18/2025": [
    ["260", "80", "677"],
    ["799", "59", "117"],
    ["120", "37", "890"],
    ["566", "72", "345"],
    ["670", "34", "149"],
    ["290", "13", "337"]
  ],
  "05/19/2025 to 05/25/2025": [
    ["234", "90", "127"],
    ["238", "37", "160"],
    ["267", "50", "299"],
    ["266", "46", "240"],
    ["168", "50", "190"],
    ["144", "94", "446"]
  ],
  "05/26/2025 to 06/01/2025": [
    ["347", "40", "389"],
    ["249", "54", "680"],
    ["270", "95", "168"],
    ["240", "69", "450"],
    ["466", "66", "150"],
    ["890", "76", "899"]
  ],
  "06/02/2025 to 06/08/2025": [
    ["579", "14", "167"],
    ["247", "36", "169"],
    ["146", "17", "188"],
    ["259", "63", "238"],
    ["590", "41", "245"],
    ["570", "22", "688"]
  ],
  "06/09/2025 to 06/15/2025": [
    ["569", "07", "250"],
    ["110", "27", "160"],
    ["380", "18", "468"],
    ["670", "36", "880"],
    ["340", "78", "125"],
    ["166", "39", "450"]
  ],
  "06/16/2025 to 06/22/2025": [
    ["237", "20", "145"],
    ["248", "41", "678"],
    ["389", "08", "567"],
    ["499", "20", "145"],
    ["379", "98", "134"],
    ["120", "33", "148"]
  ],
  "06/23/2025 to 06/29/2025": [
    ["680", "41", "588"],
    ["134", "83", "670"],
    ["390", "27", "368"],
    ["450", "97", "250"],
    ["469", "91", "236"],
    ["257", "47", "278"]
  ],
  "06/30/2025 to 07/06/2025": [
    ["400", "40", "389"],
    ["458", "77", "160"],
    ["570", "23", "355"],
    ["112", "46", "150"],
    ["779", "30", "235"],
    ["688", "24", "149"]
  ],
  "07/07/2025 to 07/13/2025": [
    ["129", "20", "127"],
    ["580", "37", "278"],
    ["135", "95", "339"],
    ["279", "89", "270"],
    ["227", "12", "237"],
    ["300", "39", "360"]
  ],
  "07/14/2025 to 07/20/2025": [
    ["347", "45", "357"],
    ["345", "21", "146"],
    ["300", "32", "156"],
    ["124", "78", "477"],
    ["159", "51", "560"],
    ["349", "65", "780"]
  ],
  "07/21/2025 to 07/27/2025": [
    ["700", "74", "149"],
    ["150", "66", "358"],
    ["156", "28", "369"],
    ["770", "43", "670"],
    ["256", "39", "469"],
    ["470", "13", "355"]
  ],
  "07/28/2025 to 08/03/2025": [
    ["260", "87", "700"],
    ["468", "81", "146"],
    ["557", "77", "179"],
    ["168", "54", "680"],
    ["147", "20", "190"],
    ["579", "11", "128"]
  ],
  "08/04/2025 to 08/10/2025": [
    ["238", "35", "690"],
    ["557", "79", "900"],
    ["350", "82", "138"],
    ["468", "85", "456"],
    ["448", "62", "778"],
    ["340", "71", "100"]
  ],
  "08/11/2025 to 08/17/2025": [
    ["234", "90", "460"],
    ["169", "68", "440"],
    ["126", "95", "230"],
    ["330", "67", "467"],
    ["***", "**", "***"],
    ["134", "86", "268"]
  ],
  "08/18/2025 to 08/24/2025": [
    ["460", "08", "279"],
    ["170", "82", "129"],
    ["240", "65", "357"],
    ["147", "21", "380"],
    ["239", "43", "346"],
    ["579", "19", "289"]
  ],
  "08/25/2025 to 08/31/2025": [
    ["468", "84", "167"],
    ["166", "37", "179"],
    ["136", "05", "348"],
    ["224", "80", "334"],
    ["146", "11", "380"],
    ["134", "85", "690"]
  ],
  "09/01/2025 to 09/07/2025": [
    ["450", "94", "590"],
    ["250", "73", "229"],
    ["359", "74", "400"],
    ["155", "11", "678"],
    ["290", "14", "770"],
    ["130", "42", "570"]
  ],
  "09/08/2025 to 09/14/2025": [
    ["237", "29", "234"],
    ["450", "97", "340"],
    ["236", "19", "379"],
    ["330", "61", "146"],
    ["180", "98", "134"],
    ["456", "57", "458"]
  ],
  "09/15/2025 to 09/21/2025": [
    ["570", "26", "169"],
    ["136", "04", "257"],
    ["137", "10", "479"],
    ["356", "48", "224"],
    ["113", "56", "240"],
    ["370", "00", "334"]
  ],
  "09/22/2025 to 09/28/2025": [
    ["169", "67", "458"],
    ["240", "61", "678"],
    ["449", "73", "670"],
    ["133", "75", "357"],
    ["789", "41", "560"],
    ["568", "94", "130"]
  ],
  "09/29/2025 to 10/05/2025": [
    ["134", "83", "238"],
    ["778", "21", "128"],
    ["589", "23", "490"],
    ["169", "67", "124"],
    ["449", "70", "226"],
    ["670", "30", "190"]
  ],
  "10/06/2025 to 10/12/2025": [
    ["123", "66", "457"],
    ["156", "27", "890"],
    ["235", "06", "367"],
    ["270", "95", "690"],
    ["600", "67", "449"],
    ["225", "90", "460"]
  ],
  "10/13/2025 to 10/19/2025": [
    ["145", "08", "477"],
    ["349", "69", "360"],
    ["668", "06", "259"],
    ["480", "24", "257"],
    ["359", "71", "678"],
    ["***", "**", "***"]
  ],
  "10/20/2025 to 10/26/2025": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "10/27/2025 to 11/02/2025": [
    ["189", "81", "399"],
    ["367", "67", "250"],
    ["235", "05", "357"],
    ["223", "78", "125"],
    ["138", "22", "237"],
    ["899", "64", "130"]
  ],
  "11/03/2025 to 11/09/2025": [
    ["680", "44", "158"],
    ["558", "86", "123"],
    ["570", "22", "200"],
    ["368", "70", "235"],
    ["190", "09", "568"],
    ["135", "93", "337"]
  ],
  "11/10/2025 to 11/16/2025": [
    ["280", "08", "350"],
    ["129", "27", "115"],
    ["138", "22", "589"],
    ["119", "14", "590"],
    ["150", "63", "157"],
    ["479", "05", "230"]
  ],
  "11/17/2025 to 11/23/2025": [
    ["238", "34", "149"],
    ["449", "72", "480"],
    ["228", "26", "150"],
    ["245", "14", "248"],
    ["135", "97", "269"],
    ["379", "97", "557"]
  ],
  "11/24/2025 to 11/30/2025": [
    ["156", "20", "479"],
    ["770", "49", "180"],
    ["246", "27", "467"],
    ["348", "50", "136"],
    ["138", "20", "370"],
    ["180", "96", "899"]
  ],
  "12/01/2025 to 12/07/2025": [
    ["170", "84", "167"],
    ["680", "44", "356"],
    ["380", "15", "177"],
    ["688", "22", "110"],
    ["880", "67", "368"],
    ["160", "75", "456"]
  ],
  "12/08/2025 to 12/14/2025": [
    ["179", "70", "479"],
    ["237", "29", "667"],
    ["117", "91", "290"],
    ["357", "57", "557"],
    ["122", "52", "156"],
    ["344", "17", "458"]
  ],
  "12/15/2025 to 12/21/2025": [
    ["179", "70", "370"],
    ["358", "68", "440"],
    ["660", "24", "590"],
    ["166", "31", "669"],
    ["350", "84", "455"],
    ["368", "77", "188"]
  ],
  "12/22/2025 to 12/28/2025": [
    ["278", "75", "780"],
    ["680", "44", "248"],
    ["489", "16", "259"],
    ["234", "92", "237"],
    ["899", "60", "578"],
    ["457", "69", "379"]
  ],
  "12/29/2025 to 01/04/2026": [
    ["190", "01", "560"],
    ["136", "06", "358"],
    ["570", "25", "799"],
    ["233", "80", "370"],
    ["345", "23", "256"],
    ["389", "01", "470"]
  ],
  "01/05/2026 to 01/11/2026": [
    ["126", "99", "360"],
    ["368", "79", "270"],
    ["239", "48", "378"],
    ["479", "00", "578"],
    ["367", "64", "130"],
    ["237", "20", "299"]
  ],
  "01/12/2026 to 01/18/2026": [
    ["234", "94", "789"],
    ["233", "87", "124"],
    ["390", "26", "349"],
    ["459", "88", "224"],
    ["356", "47", "188"],
    ["136", "08", "378"]
  ],
  "01/19/2026 to 01/25/2026": [
    ["114", "60", "389"],
    ["469", "98", "990"],
    ["125", "82", "499"],
    ["570", "23", "580"],
    ["118", "01", "380"],
    ["357", "58", "378"]
  ],
  "01/26/2026 to 02/01/2026": [
    ["***", "**", "***"],
    ["117", "99", "450"],
    ["279", "81", "380"],
    ["335", "13", "238"],
    ["799", "55", "230"],
    ["146", "12", "480"]
  ],
  "02/02/2026 to 02/08/2026": [
    ["668", "00", "460"],
    ["119", "15", "168"],
    ["170", "84", "130"],
    ["130", "40", "460"],
    ["456", "59", "478"],
    ["446", "43", "157"]
  ],
  "02/09/2026 to 02/15/2026": [
    ["450", "95", "140"],
    ["500", "57", "223"],
    ["478", "92", "237"],
    ["278", "75", "447"],
    ["460", "03", "157"],
    ["440", "82", "246"]
  ],
  "02/16/2026 to 02/22/2026": [
    ["160", "79", "360"],
    ["455", "44", "680"],
    ["169", "60", "460"],
    ["370", "01", "399"],
    ["146", "19", "126"],
    ["670", "30", "488"]
  ],
  "02/23/2026 to 03/01/2026": [
    ["380", "14", "347"],
    ["556", "60", "145"],
    ["267", "53", "229"],
    ["560", "10", "280"],
    ["668", "01", "290"],
    ["789", "48", "567"]
  ],
  "03/02/2026 to 03/08/2026": [
    ["670", "38", "170"],
    ["277", "61", "560"],
    ["***", "**", "***"],
    ["489", "17", "269"],
    ["889", "57", "377"],
    ["690", "53", "120"]
  ],
  "03/09/2026 to 03/15/2026": [
    ["145", "04", "220"],
    ["149", "42", "138"],
    ["130", "49", "270"],
    ["238", "38", "990"],
    ["337", "32", "156"],
    ["489", "10", "136"]
  ],
  "03/16/2026 to 03/22/2026": [
    ["356", "42", "570"],
    ["500", "51", "245"],
    ["480", "28", "350"],
    ["135", "92", "138"],
    ["278", "73", "670"],
    ["133", "73", "779"]
  ]
};

export const MILANDAY = {
  "01/01/2024 to 01/07/2024": [
    ["399", "15", "168"],
    ["458", "72", "138"],
    ["246", "26", "899"],
    ["450", "96", "358"],
    ["290", "16", "150"],
    ["357", "55", "249"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["269", "76", "114"],
    ["115", "74", "149"],
    ["125", "88", "279"],
    ["188", "76", "899"],
    ["135", "93", "120"],
    ["469", "98", "459"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["470", "19", "126"],
    ["159", "56", "169"],
    ["477", "81", "669"],
    ["146", "17", "458"],
    ["389", "02", "156"],
    ["289", "96", "330"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["247", "39", "568"],
    ["134", "87", "133"],
    ["140", "52", "147"],
    ["448", "65", "780"],
    ["***", "**", "***"],
    ["118", "02", "129"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["560", "17", "700"],
    ["358", "64", "356"],
    ["235", "07", "278"],
    ["237", "26", "330"],
    ["469", "91", "245"],
    ["270", "98", "260"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["289", "98", "125"],
    ["157", "30", "668"],
    ["240", "62", "345"],
    ["128", "13", "689"],
    ["137", "17", "179"],
    ["389", "01", "560"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["677", "06", "367"],
    ["288", "80", "578"],
    ["379", "95", "140"],
    ["338", "43", "229"],
    ["889", "55", "690"],
    ["359", "78", "279"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["240", "63", "337"],
    ["159", "51", "245"],
    ["380", "15", "267"],
    ["257", "41", "236"],
    ["449", "71", "146"],
    ["347", "40", "578"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["144", "97", "223"],
    ["118", "08", "477"],
    ["145", "09", "234"],
    ["480", "26", "123"],
    ["345", "27", "368"],
    ["160", "76", "600"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["188", "76", "114"],
    ["359", "73", "779"],
    ["188", "78", "116"],
    ["144", "99", "577"],
    ["160", "71", "137"],
    ["278", "71", "236"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["468", "83", "355"],
    ["245", "16", "114"],
    ["500", "59", "117"],
    ["370", "08", "224"],
    ["447", "54", "400"],
    ["169", "65", "140"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["269", "77", "458"],
    ["250", "75", "447"],
    ["236", "11", "399"],
    ["379", "98", "260"],
    ["124", "70", "280"],
    ["280", "01", "399"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["577", "94", "347"],
    ["369", "83", "120"],
    ["479", "04", "266"],
    ["248", "49", "360"],
    ["458", "79", "234"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["489", "10", "244"],
    ["270", "92", "480"],
    ["568", "91", "335"],
    ["190", "03", "779"],
    ["588", "18", "233"],
    ["123", "63", "247"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["246", "25", "249"],
    ["448", "60", "226"],
    ["249", "56", "268"],
    ["148", "37", "557"],
    ["138", "21", "579"],
    ["138", "26", "259"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["269", "70", "668"],
    ["340", "72", "570"],
    ["778", "25", "177"],
    ["125", "88", "350"],
    ["567", "86", "178"],
    ["370", "04", "167"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["246", "27", "179"],
    ["235", "07", "700"],
    ["358", "66", "358"],
    ["226", "06", "240"],
    ["445", "31", "119"],
    ["260", "80", "235"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["346", "33", "139"],
    ["189", "89", "126"],
    ["469", "95", "357"],
    ["369", "89", "379"],
    ["177", "56", "169"],
    ["268", "66", "178"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["600", "64", "158"],
    ["179", "79", "135"],
    ["357", "54", "347"],
    ["688", "29", "199"],
    ["900", "94", "112"],
    ["124", "77", "269"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["279", "82", "138"],
    ["147", "29", "234"],
    ["167", "49", "379"],
    ["457", "65", "140"],
    ["334", "08", "170"],
    ["599", "37", "115"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["114", "65", "690"],
    ["160", "77", "340"],
    ["135", "94", "789"],
    ["257", "43", "670"],
    ["689", "35", "267"],
    ["238", "38", "170"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["339", "59", "270"],
    ["479", "02", "246"],
    ["990", "86", "259"],
    ["380", "16", "178"],
    ["344", "10", "136"],
    ["577", "98", "440"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["127", "01", "146"],
    ["240", "62", "147"],
    ["349", "69", "333"],
    ["345", "25", "267"],
    ["588", "12", "480"],
    ["234", "94", "257"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["468", "86", "880"],
    ["167", "44", "158"],
    ["146", "15", "258"],
    ["670", "39", "667"],
    ["178", "60", "370"],
    ["340", "78", "558"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["334", "00", "235"],
    ["290", "14", "158"],
    ["490", "32", "147"],
    ["149", "47", "467"],
    ["128", "10", "235"],
    ["445", "31", "128"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["112", "40", "145"],
    ["880", "66", "123"],
    ["337", "34", "167"],
    ["236", "16", "880"],
    ["260", "88", "260"],
    ["257", "49", "180"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["115", "71", "399"],
    ["237", "21", "560"],
    ["230", "50", "389"],
    ["113", "54", "400"],
    ["280", "08", "224"],
    ["144", "91", "245"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["456", "50", "299"],
    ["568", "96", "466"],
    ["789", "41", "245"],
    ["229", "38", "468"],
    ["150", "67", "890"],
    ["369", "83", "120"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["660", "26", "150"],
    ["360", "97", "278"],
    ["270", "99", "379"],
    ["115", "78", "224"],
    ["567", "87", "467"],
    ["267", "58", "468"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["470", "17", "467"],
    ["899", "65", "456"],
    ["140", "57", "160"],
    ["369", "89", "568"],
    ["480", "20", "370"],
    ["480", "28", "170"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["499", "23", "120"],
    ["400", "48", "468"],
    ["478", "94", "220"],
    ["268", "68", "990"],
    ["280", "09", "270"],
    ["268", "63", "256"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["679", "26", "150"],
    ["229", "30", "190"],
    ["234", "94", "356"],
    ["579", "11", "560"],
    ["458", "79", "360"],
    ["347", "40", "479"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["490", "34", "239"],
    ["239", "47", "278"],
    ["390", "20", "370"],
    ["***", "**", "***"],
    ["160", "70", "677"],
    ["177", "53", "300"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["588", "14", "248"],
    ["130", "40", "118"],
    ["128", "18", "468"],
    ["127", "01", "399"],
    ["135", "98", "990"],
    ["478", "93", "670"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["118", "01", "560"],
    ["148", "35", "889"],
    ["268", "66", "240"],
    ["245", "17", "124"],
    ["125", "88", "459"],
    ["660", "29", "289"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["149", "42", "237"],
    ["478", "95", "799"],
    ["990", "85", "258"],
    ["558", "82", "200"],
    ["580", "34", "446"],
    ["***", "**", "***"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["260", "87", "223"],
    ["590", "44", "266"],
    ["155", "11", "344"],
    ["279", "86", "457"],
    ["134", "86", "150"],
    ["147", "28", "378"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["250", "78", "233"],
    ["340", "78", "170"],
    ["468", "82", "129"],
    ["138", "21", "335"],
    ["149", "44", "356"],
    ["348", "50", "235"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["226", "06", "600"],
    ["367", "63", "580"],
    ["560", "11", "335"],
    ["690", "55", "177"],
    ["678", "15", "339"],
    ["280", "06", "466"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["246", "29", "234"],
    ["570", "27", "188"],
    ["999", "71", "290"],
    ["560", "11", "290"],
    ["778", "27", "160"],
    ["700", "75", "889"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["156", "23", "157"],
    ["135", "94", "770"],
    ["245", "19", "900"],
    ["379", "98", "288"],
    ["366", "53", "788"],
    ["677", "04", "789"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["778", "21", "245"],
    ["147", "22", "345"],
    ["589", "26", "123"],
    ["169", "69", "478"],
    ["247", "39", "180"],
    ["278", "79", "568"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["138", "29", "379"],
    ["488", "03", "788"],
    ["238", "31", "470"],
    ["140", "54", "158"],
    ["290", "15", "140"],
    ["130", "44", "112"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["246", "22", "660"],
    ["377", "75", "456"],
    ["670", "37", "449"],
    ["229", "39", "144"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["889", "51", "100"],
    ["168", "58", "116"],
    ["557", "79", "126"],
    ["229", "38", "567"],
    ["445", "33", "139"],
    ["157", "36", "268"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["189", "83", "670"],
    ["337", "30", "280"],
    ["267", "50", "370"],
    ["270", "93", "120"],
    ["456", "53", "355"],
    ["678", "19", "270"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["155", "10", "299"],
    ["279", "81", "146"],
    ["550", "09", "126"],
    ["245", "16", "466"],
    ["337", "32", "390"],
    ["247", "36", "330"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["448", "61", "399"],
    ["278", "72", "138"],
    ["146", "11", "579"],
    ["458", "75", "267"],
    ["479", "00", "136"],
    ["890", "73", "670"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["440", "82", "336"],
    ["880", "65", "230"],
    ["340", "76", "790"],
    ["568", "90", "235"],
    ["147", "24", "356"],
    ["668", "05", "799"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["136", "07", "179"],
    ["189", "86", "178"],
    ["139", "32", "138"],
    ["380", "18", "134"],
    ["348", "56", "790"],
    ["470", "14", "239"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["788", "34", "220"],
    ["778", "20", "280"],
    ["134", "89", "900"],
    ["159", "51", "560"],
    ["390", "27", "340"],
    ["589", "28", "477"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["558", "88", "990"],
    ["145", "06", "169"],
    ["348", "53", "337"],
    ["366", "59", "180"],
    ["390", "21", "119"],
    ["159", "59", "379"],
  ],
  "01/06/2025 to 01/12/2025": [
    ["139", "32", "237"],
    ["388", "95", "780"],
    ["150", "67", "179"],
    ["488", "06", "349"],
    ["356", "45", "348"],
    ["168", "52", "156"],
  ],
  "01/13/2025 to 01/19/2025": [
    ["157", "39", "126"],
    ["466", "68", "440"],
    ["268", "68", "134"],
    ["279", "83", "148"],
    ["366", "56", "240"],
    ["157", "37", "458"],
  ],
 "01/20/2025 to 01/26/2025": [
    ["360", "92", "660"],
    ["178", "63", "689"],
    ["277", "60", "569"],
    ["490", "38", "558"],
    ["146", "10", "569"],
    ["277", "60", "280"]
  ],
  "01/27/2025 to 02/02/2025": [
    ["679", "22", "110"],
    ["348", "59", "900"],
    ["477", "88", "558"],
    ["178", "67", "269"],
    ["135", "99", "126"],
    ["180", "91", "560"]
  ],
  "02/03/2025 to 02/09/2025": [
    ["170", "85", "889"],
    ["123", "64", "590"],
    ["239", "40", "479"],
    ["590", "48", "170"],
    ["237", "21", "245"],
    ["277", "60", "299"]
  ],
  "02/10/2025 to 02/16/2025": [
    ["789", "49", "568"],
    ["570", "23", "157"],
    ["336", "20", "578"],
    ["166", "38", "233"],
    ["178", "64", "239"],
    ["669", "13", "337"]
  ],
  "02/17/2025 to 02/23/2025": [
    ["135", "95", "258"],
    ["130", "42", "679"],
    ["350", "86", "178"],
    ["670", "37", "269"],
    ["237", "23", "120"],
    ["578", "04", "699"]
  ],
  "02/24/2025 to 03/02/2025": [
    ["266", "47", "458"],
    ["359", "75", "456"],
    ["690", "50", "389"],
    ["267", "59", "469"],
    ["569", "07", "359"],
    ["340", "78", "260"]
  ],
  "03/03/2025 to 03/09/2025": [
    ["247", "37", "368"],
    ["115", "78", "468"],
    ["135", "96", "123"],
    ["230", "52", "156"],
    ["578", "02", "237"],
    ["260", "81", "470"]
  ],
  "03/10/2025 to 03/16/2025": [
    ["239", "44", "248"],
    ["678", "13", "148"],
    ["345", "29", "144"],
    ["770", "42", "255"],
    ["***", "**", "***"],
    ["149", "47", "278"]
  ],
  "03/17/2025 to 03/23/2025": [
    ["120", "36", "114"],
    ["579", "12", "589"],
    ["388", "95", "177"],
    ["138", "28", "477"],
    ["359", "79", "126"],
    ["880", "66", "277"]
  ],
  "03/24/2025 to 03/30/2025": [
    ["138", "28", "260"],
    ["788", "37", "250"],
    ["346", "38", "170"],
    ["160", "71", "380"],
    ["148", "34", "356"],
    ["145", "03", "670"]
  ],
  "03/31/2025 to 04/06/2025": [
    ["455", "45", "159"],
    ["670", "36", "367"],
    ["236", "19", "469"],
    ["688", "26", "448"],
    ["889", "54", "356"],
    ["120", "34", "590"]
  ],
  "04/07/2025 to 04/13/2025": [
    ["366", "51", "290"],
    ["247", "36", "268"],
    ["150", "61", "489"],
    ["149", "40", "479"],
    ["446", "42", "110"],
    ["169", "66", "114"]
  ],
  "04/14/2025 to 04/20/2025": [
    ["667", "97", "377"],
    ["180", "92", "246"],
    ["347", "44", "158"],
    ["157", "38", "459"],
    ["450", "91", "137"],
    ["557", "72", "589"]
  ],
  "04/21/2025 to 04/27/2025": [
    ["200", "26", "899"],
    ["590", "41", "245"],
    ["128", "17", "278"],
    ["237", "20", "578"],
    ["134", "85", "230"],
    ["289", "90", "136"]
  ],
  "04/28/2025 to 05/04/2025": [
    ["238", "33", "346"],
    ["170", "86", "240"],
    ["444", "25", "168"],
    ["389", "03", "238"],
    ["179", "74", "699"],
    ["246", "29", "450"]
  ],
  "05/05/2025 to 05/11/2025": [
    ["135", "99", "379"],
    ["449", "78", "350"],
    ["336", "26", "880"],
    ["248", "48", "279"],
    ["166", "30", "479"],
    ["590", "48", "189"]
  ],
  "05/12/2025 to 05/18/2025": [
    ["135", "96", "268"],
    ["288", "89", "360"],
    ["890", "73", "580"],
    ["120", "31", "669"],
    ["668", "08", "134"],
    ["256", "34", "239"]
  ],
  "05/19/2025 to 05/25/2025": [
    ["368", "77", "340"],
    ["380", "12", "345"],
    ["278", "70", "136"],
    ["269", "70", "389"],
    ["123", "60", "145"],
    ["169", "67", "250"]
  ],
  "05/26/2025 to 06/01/2025": [
    ["579", "17", "368"],
    ["500", "54", "248"],
    ["570", "28", "369"],
    ["347", "40", "145"],
    ["677", "03", "346"],
    ["570", "28", "459"]
  ],
  "06/02/2025 to 06/08/2025": [
    ["579", "15", "258"],
    ["468", "82", "345"],
    ["248", "43", "166"],
    ["690", "59", "289"],
    ["468", "86", "349"],
    ["114", "63", "256"]
  ],
  "06/09/2025 to 06/15/2025": [
    ["245", "14", "770"],
    ["450", "97", "557"],
    ["560", "12", "110"],
    ["190", "04", "149"],
    ["239", "44", "239"],
    ["240", "64", "266"]
  ],
  "06/16/2025 to 06/22/2025": [
    ["489", "12", "570"],
    ["246", "21", "344"],
    ["137", "15", "258"],
    ["800", "87", "160"],
    ["457", "67", "458"],
    ["599", "35", "113"]
  ],
  "06/23/2025 to 06/29/2025": [
    ["350", "83", "355"],
    ["570", "21", "470"],
    ["145", "06", "457"],
    ["247", "33", "300"],
    ["245", "10", "127"],
    ["459", "86", "150"]
  ],
  "06/30/2025 to 07/06/2025": [
    ["278", "74", "680"],
    ["567", "89", "117"],
    ["899", "62", "499"],
    ["167", "46", "259"],
    ["580", "30", "334"],
    ["120", "32", "255"]
  ],
  "07/07/2025 to 07/13/2025": [
    ["370", "04", "248"],
    ["660", "29", "117"],
    ["220", "45", "500"],
    ["124", "72", "660"],
    ["290", "16", "178"],
    ["347", "40", "244"]
  ],
  "07/14/2025 to 07/20/2025": [
    ["339", "55", "690"],
    ["589", "21", "678"],
    ["240", "61", "380"],
    ["990", "89", "234"],
    ["169", "68", "468"],
    ["667", "99", "559"]
  ],
  "07/21/2025 to 07/27/2025": [
    ["146", "19", "199"],
    ["780", "54", "239"],
    ["368", "70", "578"],
    ["119", "13", "229"],
    ["589", "22", "390"],
    ["118", "06", "169"]
  ],
  "07/28/2025 to 08/03/2025": [
    ["560", "10", "578"],
    ["155", "17", "449"],
    ["236", "11", "290"],
    ["127", "08", "468"],
    ["124", "70", "569"],
    ["288", "82", "246"]
  ],
  "08/04/2025 to 08/10/2025": [
    ["449", "70", "226"],
    ["166", "33", "580"],
    ["378", "82", "570"],
    ["159", "54", "158"],
    ["178", "65", "366"],
    ["360", "94", "158"]
  ],
  "08/11/2025 to 08/17/2025": [
    ["568", "91", "344"],
    ["225", "97", "188"],
    ["568", "97", "700"],
    ["188", "73", "139"],
    ["***", "**", "***"],
    ["257", "49", "360"]
  ],
  "08/18/2025 to 08/24/2025": [
    ["800", "87", "250"],
    ["480", "25", "267"],
    ["789", "49", "117"],
    ["120", "34", "112"],
    ["260", "89", "559"],
    ["279", "80", "136"]
  ],
  "08/25/2025 to 08/31/2025": [
    ["125", "88", "125"],
    ["124", "71", "588"],
    ["***", "**", "***"],
    ["238", "34", "248"],
    ["166", "32", "138"],
    ["139", "35", "267"]
  ],
  "09/01/2025 to 09/07/2025": [
    ["136", "04", "338"],
    ["239", "43", "670"],
    ["233", "85", "267"],
    ["358", "66", "268"],
    ["229", "36", "367"],
    ["335", "11", "227"]
  ],
  "09/08/2025 to 09/14/2025": [
    ["379", "98", "378"],
    ["357", "59", "126"],
    ["560", "16", "790"],
    ["469", "96", "790"],
    ["238", "38", "279"],
    ["140", "55", "348"]
  ],
  "09/15/2025 to 09/21/2025": [
    ["288", "86", "178"],
    ["179", "75", "348"],
    ["667", "96", "277"],
    ["120", "35", "690"],
    ["588", "15", "348"],
    ["148", "35", "780"]
  ],
  "09/22/2025 to 09/28/2025": [
    ["400", "41", "128"],
    ["224", "89", "270"],
    ["570", "20", "460"],
    ["588", "15", "230"],
    ["128", "12", "156"],
    ["699", "47", "115"]
  ],
  "09/29/2025 to 10/05/2025": [
    ["100", "19", "360"],
    ["268", "66", "349"],
    ["238", "30", "569"],
    ["279", "82", "679"],
    ["390", "20", "578"],
    ["260", "89", "379"]
  ],
  "10/06/2025 to 10/12/2025": [
    ["446", "43", "157"],
    ["460", "09", "126"],
    ["670", "34", "257"],
    ["560", "19", "469"],
    ["124", "75", "366"],
    ["267", "50", "460"]
  ],
  "10/13/2025 to 10/19/2025": [
    ["678", "13", "166"],
    ["355", "36", "150"],
    ["488", "01", "119"],
    ["379", "96", "899"],
    ["458", "79", "289"],
    ["***", "**", "***"]
  ],
  "10/20/2025 to 10/26/2025": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "10/27/2025 to 11/02/2025": [
    ["159", "57", "368"],
    ["166", "35", "113"],
    ["339", "58", "233"],
    ["234", "91", "678"],
    ["467", "75", "690"],
    ["490", "33", "346"]
  ],
  "11/03/2025 to 11/09/2025": [
    ["234", "91", "560"],
    ["239", "40", "569"],
    ["149", "45", "267"],
    ["338", "47", "890"],
    ["660", "21", "579"],
    ["130", "47", "133"]
  ],
  "11/10/2025 to 11/16/2025": [
    ["800", "86", "240"],
    ["680", "46", "178"],
    ["248", "47", "269"],
    ["148", "36", "899"],
    ["569", "06", "268"],
    ["170", "86", "600"]
  ],
  "11/17/2025 to 11/23/2025": [
    ["116", "85", "799"],
    ["268", "60", "299"],
    ["128", "17", "890"],
    ["780", "58", "134"],
    ["136", "07", "458"],
    ["390", "21", "119"]
  ],
  "11/24/2025 to 11/30/2025": [
    ["137", "18", "189"],
    ["168", "59", "126"],
    ["199", "95", "366"],
    ["667", "90", "280"],
    ["225", "97", "278"],
    ["590", "48", "260"]
  ],
  "12/01/2025 to 12/07/2025": [
    ["699", "42", "200"],
    ["249", "51", "128"],
    ["128", "13", "120"],
    ["135", "98", "189"],
    ["680", "48", "170"],
    ["479", "05", "267"]
  ],
  "12/08/2025 to 12/14/2025": [
    ["167", "45", "230"],
    ["690", "53", "256"],
    ["149", "43", "490"],
    ["168", "59", "270"],
    ["117", "97", "449"],
    ["238", "34", "347"]
  ],
  "12/15/2025 to 12/21/2025": [
    ["380", "12", "570"],
    ["110", "29", "450"],
    ["270", "90", "235"],
    ["124", "72", "200"],
    ["399", "13", "157"],
    ["129", "28", "468"]
  ],
  "12/22/2025 to 12/28/2025": [
    ["370", "08", "350"],
    ["359", "70", "370"],
    ["267", "55", "140"],
    ["357", "57", "269"],
    ["168", "52", "147"],
    ["148", "35", "690"]
  ],
  "12/29/2025 to 01/04/2026": [
    ["678", "15", "447"],
    ["248", "42", "679"],
    ["160", "72", "129"],
    ["350", "83", "247"],
    ["139", "33", "247"],
    ["268", "66", "268"]
  ],
  "01/05/2026 to 01/11/2026": [
    ["680", "48", "468"],
    ["367", "68", "558"],
    ["479", "00", "136"],
    ["466", "64", "356"],
    ["112", "46", "349"],
    ["239", "41", "579"]
  ],
  "01/12/2026 to 01/18/2026": [
    ["458", "75", "159"],
    ["129", "21", "678"],
    ["128", "18", "279"],
    ["580", "36", "123"],
    ["235", "05", "267"],
    ["445", "38", "440"]
  ],
  "01/19/2026 to 01/25/2026": [
    ["300", "31", "489"],
    ["347", "46", "169"],
    ["570", "29", "577"],
    ["390", "29", "234"],
    ["340", "70", "370"],
    ["128", "17", "124"]
  ],
  "01/26/2026 to 02/01/2026": [
    ["***", "**", "***"],
    ["236", "16", "259"],
    ["119", "13", "779"],
    ["479", "08", "116"],
    ["239", "49", "126"],
    ["345", "28", "233"]
  ],
  "02/02/2026 to 02/08/2026": [
    ["246", "21", "236"],
    ["170", "87", "124"],
    ["599", "30", "460"],
    ["240", "66", "448"],
    ["234", "95", "230"],
    ["146", "13", "139"]
  ],
  "02/09/2026 to 02/15/2026": [
    ["460", "08", "800"],
    ["249", "53", "148"],
    ["177", "53", "670"],
    ["379", "96", "330"],
    ["440", "89", "289"],
    ["366", "58", "189"]
  ],
  "02/16/2026 to 02/22/2026": [
    ["269", "77", "160"],
    ["380", "19", "469"],
    ["190", "02", "156"],
    ["260", "89", "900"],
    ["568", "98", "468"],
    ["478", "94", "158"]
  ],
  "02/23/2026 to 03/01/2026": [
    ["114", "60", "677"],
    ["200", "28", "468"],
    ["578", "04", "888"],
    ["259", "69", "478"],
    ["235", "06", "556"],
    ["380", "19", "117"]
  ],
  "03/02/2026 to 03/08/2026": [
    ["334", "05", "456"],
    ["469", "91", "399"],
    ["***", "**", "***"],
    ["248", "42", "228"],
    ["570", "21", "669"],
    ["559", "96", "899"]
  ],
  "03/09/2026 to 03/15/2026": [
    ["450", "92", "129"],
    ["167", "45", "159"],
    ["568", "95", "780"],
    ["388", "94", "338"],
    ["378", "82", "129"],
    ["447", "52", "237"]
  ],
  "03/16/2026 to 03/22/2026": [
    ["135", "92", "110"],
    ["366", "50", "118"],
    ["126", "98", "459"],
    ["699", "44", "167"],
    ["379", "97", "269"],
    ["127", "06", "330"]
  ]
};

export const KALYAN = {
   "01/01/2024 to 01/07/2024": [
    ["446", "41", "560"],
    ["169", "60", "280"],
    ["135", "95", "267"],
    ["240", "63", "355"],
    ["480", "25", "690"],
    ["245", "15", "140"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["467", "73", "238"],
    ["112", "42", "138"],
    ["200", "29", "577"],
    ["790", "63", "355"],
    ["256", "38", "134"],
    ["290", "12", "345"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["449", "75", "339"],
    ["890", "75", "140"],
    ["345", "27", "890"],
    ["280", "05", "690"],
    ["589", "25", "339"],
    ["490", "37", "160"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["689", "30", "226"],
    ["300", "37", "269"],
    ["230", "51", "380"],
    ["137", "14", "680"],
    ["***", "**", "***"],
    ["237", "20", "145"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["568", "91", "489"],
    ["124", "72", "589"],
    ["139", "30", "668"],
    ["167", "45", "690"],
    ["334", "04", "149"],
    ["455", "48", "378"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["137", "16", "268"],
    ["556", "62", "688"],
    ["770", "45", "159"],
    ["368", "72", "499"],
    ["189", "87", "700"],
    ["379", "98", "170"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["578", "01", "344"],
    ["126", "97", "124"],
    ["578", "06", "150"],
    ["226", "07", "278"],
    ["447", "52", "237"],
    ["390", "25", "168"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["446", "44", "266"],
    ["479", "04", "257"],
    ["159", "52", "129"],
    ["112", "40", "460"],
    ["569", "03", "779"],
    ["558", "89", "478"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["779", "32", "390"],
    ["668", "08", "378"],
    ["348", "58", "170"],
    ["168", "56", "457"],
    ["699", "47", "340"],
    ["450", "96", "178"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["234", "93", "670"],
    ["467", "76", "358"],
    ["120", "37", "467"],
    ["124", "72", "110"],
    ["226", "03", "689"],
    ["479", "03", "256"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["599", "39", "360"],
    ["480", "27", "458"],
    ["580", "39", "225"],
    ["145", "08", "288"],
    ["589", "28", "189"],
    ["289", "96", "457"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["267", "59", "568"],
    ["790", "60", "370"],
    ["237", "27", "359"],
    ["580", "33", "256"],
    ["123", "66", "790"],
    ["446", "40", "235"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["577", "97", "250"],
    ["348", "55", "249"],
    ["256", "39", "234"],
    ["677", "08", "990"],
    ["478", "91", "560"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["900", "96", "448"],
    ["880", "64", "338"],
    ["667", "97", "359"],
    ["455", "41", "470"],
    ["680", "49", "289"],
    ["148", "36", "123"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["347", "44", "338"],
    ["355", "32", "255"],
    ["233", "88", "558"],
    ["170", "83", "229"],
    ["600", "64", "347"],
    ["367", "67", "223"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["112", "46", "790"],
    ["270", "97", "160"],
    ["357", "52", "679"],
    ["990", "81", "137"],
    ["370", "02", "345"],
    ["235", "04", "680"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["569", "03", "256"],
    ["248", "49", "577"],
    ["257", "42", "147"],
    ["160", "78", "468"],
    ["358", "67", "890"],
    ["569", "02", "390"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["779", "33", "580"],
    ["568", "92", "138"],
    ["230", "58", "189"],
    ["349", "60", "136"],
    ["145", "08", "468"],
    ["390", "24", "257"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["147", "27", "250"],
    ["589", "21", "335"],
    ["116", "83", "670"],
    ["359", "79", "180"],
    ["668", "01", "489"],
    ["158", "44", "789"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["234", "98", "369"],
    ["149", "40", "569"],
    ["347", "45", "249"],
    ["568", "96", "457"],
    ["267", "53", "779"],
    ["238", "30", "190"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["156", "26", "150"],
    ["349", "66", "114"],
    ["133", "70", "118"],
    ["136", "02", "589"],
    ["399", "16", "240"],
    ["347", "42", "147"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["370", "00", "578"],
    ["259", "63", "120"],
    ["126", "94", "130"],
    ["455", "44", "338"],
    ["400", "46", "178"],
    ["157", "34", "680"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["688", "27", "890"],
    ["178", "63", "599"],
    ["799", "50", "127"],
    ["113", "53", "599"],
    ["269", "72", "390"],
    ["277", "62", "390"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["688", "29", "379"],
    ["223", "75", "690"],
    ["144", "90", "389"],
    ["116", "82", "228"],
    ["359", "70", "677"],
    ["556", "65", "249"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["669", "15", "249"],
    ["480", "25", "140"],
    ["359", "75", "780"],
    ["237", "26", "600"],
    ["247", "31", "146"],
    ["234", "98", "170"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["789", "45", "168"],
    ["660", "26", "268"],
    ["349", "64", "149"],
    ["130", "47", "115"],
    ["880", "66", "457"],
    ["560", "15", "690"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["467", "77", "458"],
    ["123", "66", "358"],
    ["138", "24", "167"],
    ["268", "64", "347"],
    ["489", "13", "445"],
    ["468", "84", "356"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["679", "26", "367"],
    ["450", "91", "335"],
    ["129", "29", "900"],
    ["260", "88", "116"],
    ["578", "04", "400"],
    ["177", "55", "168"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["450", "95", "690"],
    ["148", "37", "467"],
    ["668", "02", "480"],
    ["900", "99", "289"],
    ["458", "70", "226"],
    ["459", "82", "679"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["690", "55", "267"],
    ["560", "13", "120"],
    ["689", "34", "266"],
    ["346", "31", "560"],
    ["256", "39", "234"],
    ["125", "89", "135"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["900", "94", "167"],
    ["679", "23", "229"],
    ["129", "27", "115"],
    ["489", "13", "247"],
    ["369", "81", "146"],
    ["699", "49", "270"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["488", "07", "179"],
    ["150", "67", "188"],
    ["130", "46", "448"],
    ["220", "49", "270"],
    ["330", "64", "239"],
    ["459", "87", "160"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["489", "16", "457"],
    ["568", "99", "360"],
    ["130", "40", "479"],
    ["***", "**", "***"],
    ["599", "33", "247"],
    ["125", "82", "138"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["389", "04", "266"],
    ["446", "45", "249"],
    ["688", "24", "356"],
    ["669", "16", "367"],
    ["189", "89", "144"],
    ["138", "28", "378"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["129", "28", "116"],
    ["237", "25", "140"],
    ["669", "16", "268"],
    ["560", "12", "147"],
    ["246", "20", "280"],
    ["259", "65", "159"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["130", "46", "169"],
    ["125", "85", "348"],
    ["289", "90", "578"],
    ["890", "72", "589"],
    ["340", "72", "679"],
    ["126", "93", "238"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["268", "69", "450"],
    ["124", "76", "600"],
    ["489", "12", "345"],
    ["680", "45", "348"],
    ["247", "30", "389"],
    ["128", "14", "356"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["370", "08", "260"],
    ["369", "85", "267"],
    ["369", "87", "160"],
    ["356", "40", "235"],
    ["245", "13", "148"],
    ["380", "14", "699"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["113", "54", "400"],
    ["459", "82", "200"],
    ["247", "34", "248"],
    ["179", "70", "235"],
    ["348", "57", "359"],
    ["578", "03", "256"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["134", "85", "230"],
    ["330", "64", "699"],
    ["770", "47", "250"],
    ["170", "87", "340"],
    ["116", "85", "159"],
    ["289", "97", "250"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["447", "58", "350"],
    ["578", "06", "268"],
    ["780", "51", "344"],
    ["588", "13", "490"],
    ["269", "74", "158"],
    ["157", "39", "289"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["126", "91", "245"],
    ["788", "35", "168"],
    ["350", "82", "138"],
    ["159", "53", "139"],
    ["230", "56", "349"],
    ["127", "07", "124"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["178", "62", "480"],
    ["137", "10", "136"],
    ["680", "49", "478"],
    ["456", "51", "470"],
    ["470", "19", "379"],
    ["456", "56", "367"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["369", "80", "136"],
    ["348", "52", "147"],
    ["170", "84", "590"],
    ["350", "87", "179"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["140", "51", "489"],
    ["577", "91", "128"],
    ["257", "41", "137"],
    ["456", "57", "377"],
    ["588", "19", "478"],
    ["379", "95", "258"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["460", "05", "168"],
    ["667", "90", "479"],
    ["557", "74", "770"],
    ["136", "06", "259"],
    ["119", "19", "234"],
    ["268", "63", "689"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["379", "90", "280"],
    ["346", "34", "400"],
    ["260", "82", "200"],
    ["370", "09", "144"],
    ["589", "28", "260"],
    ["137", "19", "577"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["467", "72", "480"],
    ["337", "34", "347"],
    ["138", "21", "380"],
    ["580", "32", "156"],
    ["156", "21", "489"],
    ["158", "42", "129"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["168", "58", "170"],
    ["224", "84", "347"],
    ["488", "00", "299"],
    ["114", "67", "359"],
    ["677", "06", "277"],
    ["667", "98", "378"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["479", "03", "157"],
    ["468", "82", "589"],
    ["679", "29", "667"],
    ["379", "90", "226"],
    ["560", "14", "455"],
    ["114", "66", "367"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["578", "02", "589"],
    ["699", "40", "235"],
    ["199", "92", "345"],
    ["116", "85", "780"],
    ["569", "00", "136"],
    ["800", "88", "260"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["580", "39", "144"],
    ["379", "94", "257"],
    ["229", "33", "599"],
    ["447", "58", "125"],
    ["344", "11", "470"],
    ["178", "63", "337"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["388", "91", "100"],
    ["178", "69", "135"],
    ["358", "60", "127"],
    ["449", "71", "128"],
    ["350", "85", "267"],
    ["390", "20", "370"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["180", "95", "357"],
    ["138", "28", "279"],
    ["236", "11", "588"],
    ["679", "29", "270"],
    ["390", "28", "350"],
    ["470", "18", "189"]
  ],
  "01/20/2025 to 01/26/2025": [
    ["257", "47", "458"],
    ["800", "83", "148"],
    ["149", "45", "357"],
    ["260", "80", "145"],
    ["256", "33", "689"],
    ["489", "18", "369"]
  ],
  "01/27/2025 to 02/02/2025": [
    ["289", "96", "349"],
    ["589", "25", "267"],
    ["250", "78", "369"],
    ["690", "59", "478"],
    ["580", "30", "550"],
    ["270", "94", "167"]
  ],
  "02/03/2025 to 02/09/2025": [
    ["136", "08", "189"],
    ["267", "55", "357"],
    ["280", "04", "239"],
    ["678", "14", "149"],
    ["159", "55", "690"],
    ["348", "51", "678"]
  ],
  "02/10/2025 to 02/16/2025": [
    ["359", "71", "470"],
    ["336", "27", "179"],
    ["480", "21", "155"],
    ["679", "23", "670"],
    ["180", "95", "348"],
    ["138", "29", "225"]
  ],
  "02/17/2025 to 02/23/2025": [
    ["255", "21", "137"],
    ["470", "19", "900"],
    ["247", "33", "788"],
    ["399", "17", "179"],
    ["269", "76", "556"],
    ["224", "84", "455"]
  ],
  "02/24/2025 to 03/02/2025": [
    ["447", "57", "269"],
    ["367", "65", "267"],
    ["136", "06", "457"],
    ["180", "97", "179"],
    ["270", "93", "337"],
    ["690", "53", "120"]
  ],
  "03/03/2025 to 03/09/2025": [
    ["778", "21", "588"],
    ["460", "01", "669"],
    ["558", "80", "677"],
    ["300", "39", "289"],
    ["129", "20", "460"],
    ["370", "01", "128"]
  ],
  "03/10/2025 to 03/16/2025": [
    ["789", "49", "568"],
    ["125", "89", "469"],
    ["369", "83", "157"],
    ["156", "29", "180"],
    ["***", "**", "***"],
    ["130", "44", "789"]
  ],
  "03/17/2025 to 03/23/2025": [
    ["558", "82", "778"],
    ["244", "01", "290"],
    ["579", "14", "347"],
    ["120", "33", "788"],
    ["160", "70", "677"],
    ["588", "13", "670"]
  ],
  "03/24/2025 to 03/30/2025": [
    ["111", "33", "139"],
    ["677", "00", "334"],
    ["470", "10", "550"],
    ["890", "79", "289"],
    ["257", "41", "155"],
    ["234", "96", "556"]
  ],
  "03/31/2025 to 04/06/2025": [
    ["128", "12", "336"],
    ["460", "04", "356"],
    ["880", "66", "367"],
    ["178", "61", "560"],
    ["169", "62", "138"],
    ["235", "02", "679"]
  ],
  "04/07/2025 to 04/13/2025": [
    ["180", "91", "588"],
    ["247", "31", "119"],
    ["789", "44", "239"],
    ["277", "63", "670"],
    ["345", "23", "238"],
    ["469", "93", "689"]
  ],
  "04/14/2025 to 04/20/2025": [
    ["257", "40", "389"],
    ["270", "96", "268"],
    ["169", "62", "570"],
    ["558", "80", "226"],
    ["489", "15", "168"],
    ["359", "76", "240"]
  ],
  "04/21/2025 to 04/27/2025": [
    ["247", "35", "500"],
    ["469", "91", "335"],
    ["149", "44", "248"],
    ["299", "08", "459"],
    ["490", "34", "789"],
    ["257", "46", "268"]
  ],
  "04/28/2025 to 05/04/2025": [
    ["789", "43", "256"],
    ["128", "14", "167"],
    ["345", "25", "168"],
    ["150", "69", "180"],
    ["136", "05", "159"],
    ["127", "00", "569"]
  ],
  "05/05/2025 to 05/11/2025": [
    ["135", "98", "116"],
    ["479", "04", "112"],
    ["136", "03", "148"],
    ["123", "62", "138"],
    ["158", "47", "269"],
    ["257", "45", "258"]
  ],
  "05/12/2025 to 05/18/2025": [
    ["233", "82", "336"],
    ["569", "00", "389"],
    ["278", "74", "590"],
    ["288", "83", "157"],
    ["389", "08", "468"],
    ["690", "57", "160"]
  ],
  "05/19/2025 to 05/25/2025": [
    ["900", "99", "360"],
    ["190", "00", "145"],
    ["167", "47", "340"],
    ["237", "21", "137"],
    ["179", "72", "129"],
    ["390", "26", "367"]
  ],
  "05/26/2025 to 06/01/2025": [
    ["148", "30", "145"],
    ["259", "61", "128"],
    ["470", "16", "457"],
    ["125", "81", "678"],
    ["790", "65", "690"],
    ["247", "38", "170"]
  ],
  "06/02/2025 to 06/08/2025": [
    ["229", "34", "455"],
    ["899", "62", "138"],
    ["778", "21", "470"],
    ["244", "02", "336"],
    ["255", "23", "247"],
    ["110", "24", "248"]
  ],
  "06/09/2025 to 06/15/2025": [
    ["579", "11", "335"],
    ["990", "89", "568"],
    ["356", "40", "578"],
    ["160", "76", "790"],
    ["158", "44", "167"],
    ["133", "75", "159"]
  ],
  "06/16/2025 to 06/22/2025": [
    ["578", "07", "115"],
    ["220", "42", "138"],
    ["446", "48", "125"],
    ["148", "33", "599"],
    ["278", "72", "390"],
    ["689", "34", "770"]
  ],
  "06/23/2025 to 06/29/2025": [
    ["159", "53", "247"],
    ["125", "81", "236"],
    ["279", "81", "137"],
    ["248", "48", "800"],
    ["256", "31", "344"],
    ["349", "64", "590"]
  ],
  "06/30/2025 to 07/06/2025": [
    ["145", "06", "349"],
    ["470", "14", "699"],
    ["334", "02", "660"],
    ["470", "15", "780"],
    ["369", "89", "126"],
    ["223", "75", "267"]
  ],
  "07/07/2025 to 07/13/2025": [
    ["189", "81", "380"],
    ["233", "88", "224"],
    ["378", "88", "189"],
    ["699", "41", "335"],
    ["248", "48", "125"],
    ["458", "77", "467"]
  ],
  "07/14/2025 to 07/20/2025": [
    ["789", "44", "248"],
    ["116", "85", "140"],
    ["138", "28", "189"],
    ["359", "72", "138"],
    ["689", "36", "268"],
    ["678", "13", "346"]
  ],
  "07/21/2025 to 07/27/2025": [
    ["790", "68", "350"],
    ["678", "10", "299"],
    ["389", "05", "456"],
    ["377", "71", "669"],
    ["378", "82", "345"],
    ["150", "61", "678"]
  ],
  "07/28/2025 to 08/03/2025": [
    ["334", "05", "168"],
    ["578", "08", "350"],
    ["359", "76", "150"],
    ["367", "67", "566"],
    ["190", "03", "238"],
    ["456", "58", "459"]
  ],
  "08/04/2025 to 08/10/2025": [
    ["235", "06", "899"],
    ["579", "11", "290"],
    ["578", "09", "225"],
    ["235", "09", "478"],
    ["114", "68", "459"],
    ["123", "69", "379"]
  ],
  "08/11/2025 to 08/17/2025": [
    ["260", "83", "157"],
    ["568", "91", "579"],
    ["278", "75", "780"],
    ["149", "42", "147"],
    ["***", "**", "***"],
    ["250", "72", "390"]
  ],
  "08/18/2025 to 08/24/2025": [
    ["348", "54", "455"],
    ["467", "75", "348"],
    ["399", "14", "770"],
    ["355", "39", "478"],
    ["899", "68", "279"],
    ["347", "43", "148"]
  ],
  "08/25/2025 to 08/31/2025": [
    ["259", "68", "125"],
    ["340", "73", "779"],
    ["336", "20", "569"],
    ["488", "05", "339"],
    ["257", "40", "677"],
    ["148", "38", "468"]
  ],
  "09/01/2025 to 09/07/2025": [
    ["778", "25", "780"],
    ["340", "75", "447"],
    ["268", "61", "489"],
    ["590", "43", "445"],
    ["128", "17", "458"],
    ["200", "24", "112"]
  ],
  "09/08/2025 to 09/14/2025": [
    ["128", "14", "770"],
    ["114", "63", "788"],
    ["224", "87", "115"],
    ["370", "01", "137"],
    ["267", "51", "137"],
    ["690", "58", "279"]
  ],
  "09/15/2025 to 09/21/2025": [
    ["667", "99", "478"],
    ["590", "42", "129"],
    ["699", "44", "167"],
    ["579", "16", "367"],
    ["780", "56", "268"],
    ["670", "38", "459"]
  ],
  "09/22/2025 to 09/28/2025": [
    ["447", "52", "480"],
    ["690", "58", "260"],
    ["590", "49", "478"],
    ["790", "69", "135"],
    ["458", "79", "126"],
    ["557", "71", "128"]
  ],
  "09/29/2025 to 10/05/2025": [
    ["223", "71", "399"],
    ["160", "79", "135"],
    ["133", "73", "346"],
    ["134", "87", "458"],
    ["134", "80", "145"],
    ["560", "19", "450"]
  ],
  "10/06/2025 to 10/12/2025": [
    ["119", "12", "589"],
    ["379", "96", "448"],
    ["359", "79", "450"],
    ["238", "36", "150"],
    ["260", "84", "590"],
    ["225", "97", "124"]
  ],
  "10/13/2025 to 10/19/2025": [
    ["770", "40", "460"],
    ["125", "85", "140"],
    ["568", "95", "258"],
    ["139", "31", "128"],
    ["146", "15", "348"],
    ["***", "**", "***"]
  ],
  "10/20/2025 to 10/26/2025": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "10/27/2025 to 11/02/2025": [
    ["159", "59", "117"],
    ["158", "44", "220"],
    ["159", "59", "568"],
    ["789", "42", "589"],
    ["379", "90", "127"],
    ["569", "08", "125"]
  ],
  "11/03/2025 to 11/09/2025": [
    ["780", "55", "168"],
    ["578", "02", "138"],
    ["147", "23", "120"],
    ["578", "00", "460"],
    ["578", "05", "258"],
    ["129", "27", "368"]
  ],
  "11/10/2025 to 11/16/2025": [
    ["135", "91", "128"],
    ["335", "16", "790"],
    ["189", "84", "266"],
    ["129", "20", "370"],
    ["125", "84", "590"],
    ["149", "47", "133"]
  ],
  "11/17/2025 to 11/23/2025": [
    ["780", "52", "570"],
    ["469", "96", "268"],
    ["348", "53", "256"],
    ["560", "11", "290"],
    ["160", "70", "479"],
    ["279", "82", "255"]
  ],
  "11/24/2025 to 11/30/2025": [
    ["126", "91", "560"],
    ["126", "97", "890"],
    ["268", "67", "278"],
    ["458", "79", "180"],
    ["136", "09", "234"],
    ["279", "87", "449"]
  ],
  "12/01/2025 to 12/07/2025": [
    ["557", "78", "990"],
    ["456", "52", "246"],
    ["669", "12", "255"],
    ["449", "72", "147"],
    ["349", "64", "239"],
    ["560", "17", "250"]
  ],
  "12/08/2025 to 12/14/2025": [
    ["678", "16", "259"],
    ["680", "43", "490"],
    ["890", "78", "350"],
    ["270", "91", "137"],
    ["480", "27", "368"],
    ["490", "30", "235"]
  ],
  "12/15/2025 to 12/21/2025": [
    ["349", "64", "248"],
    ["599", "30", "569"],
    ["478", "97", "188"],
    ["456", "55", "339"],
    ["180", "97", "223"],
    ["139", "39", "478"]
  ],
  "12/22/2025 to 12/28/2025": [
    ["157", "33", "238"],
    ["445", "38", "558"],
    ["366", "53", "229"],
    ["238", "32", "200"],
    ["260", "84", "789"],
    ["477", "82", "390"]
  ],
  "12/29/2025 to 01/04/2026": [
    ["899", "60", "136"],
    ["168", "57", "359"],
    ["445", "36", "240"],
    ["180", "94", "167"],
    ["267", "52", "200"],
    ["880", "68", "378"]
  ],
  "01/05/2026 to 01/11/2026": [
    ["235", "04", "248"],
    ["338", "46", "600"],
    ["367", "65", "168"],
    ["488", "04", "158"],
    ["145", "04", "770"],
    ["278", "74", "680"]
  ],
  "01/12/2026 to 01/18/2026": [
    ["278", "77", "250"],
    ["249", "51", "678"],
    ["578", "04", "149"],
    ["346", "34", "167"],
    ["168", "55", "366"],
    ["130", "42", "390"]
  ],
  "01/19/2026 to 01/25/2026": [
    ["235", "02", "156"],
    ["670", "39", "135"],
    ["334", "06", "150"],
    ["790", "67", "124"],
    ["457", "69", "126"],
    ["348", "54", "149"]
  ],
  "01/26/2026 to 02/01/2026": [
    ["***", "**", "***"],
    ["250", "76", "600"],
    ["348", "59", "234"],
    ["788", "35", "159"],
    ["146", "12", "778"],
    ["700", "70", "235"]
  ],
  "02/02/2026 to 02/08/2026": [
    ["379", "91", "489"],
    ["188", "78", "378"],
    ["279", "82", "138"],
    ["147", "20", "145"],
    ["456", "54", "789"],
    ["259", "65", "267"]
  ],
  "02/09/2026 to 02/15/2026": [
    ["458", "77", "250"],
    ["479", "00", "244"],
    ["788", "36", "457"],
    ["147", "25", "113"],
    ["260", "88", "378"],
    ["156", "27", "269"]
  ],
  "02/16/2026 to 02/22/2026": [
    ["270", "94", "789"],
    ["670", "31", "380"],
    ["230", "55", "690"],
    ["130", "49", "199"],
    ["678", "18", "350"],
    ["146", "15", "357"]
  ],
  "02/23/2026 to 03/01/2026": [
    ["577", "97", "700"],
    ["699", "49", "469"],
    ["250", "71", "489"],
    ["146", "17", "223"],
    ["588", "12", "589"],
    ["148", "33", "689"]
  ],
  "03/02/2026 to 03/08/2026": [
    ["137", "13", "148"],
    ["289", "94", "680"],
    ["***", "**", "***"],
    ["234", "90", "578"],
    ["140", "56", "123"],
    ["150", "63", "670"]
  ],
  "03/09/2026 to 03/15/2026": [
    ["890", "70", "127"],
    ["129", "21", "100"],
    ["445", "30", "370"],
    ["260", "88", "134"],
    ["335", "15", "230"],
    ["357", "54", "248"]
  ],
  "03/16/2026 to 03/22/2026": [
    ["249", "58", "224"],
    ["588", "13", "256"],
    ["368", "72", "480"],
    ["589", "25", "177"],
    ["578", "06", "457"],
    ["189", "82", "156"]
  ]
};

export const KALYANNIGHT = {
    "01/01/2024 to 01/07/2024": [
    ["568", "93", "779"],
    ["770", "42", "345"],
    ["360", "98", "116"],
    ["700", "76", "880"],
    ["257", "42", "570"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["128", "19", "126"],
    ["356", "47", "160"],
    ["158", "47", "223"],
    ["124", "75", "456"],
    ["166", "36", "790"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["139", "36", "448"],
    ["679", "29", "568"],
    ["278", "79", "234"],
    ["144", "97", "458"],
    ["690", "51", "236"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["160", "79", "478"],
    ["268", "68", "468"],
    ["355", "35", "447"],
    ["120", "32", "589"],
    ["***", "**", "***"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["467", "70", "118"],
    ["250", "70", "280"],
    ["148", "34", "338"],
    ["139", "30", "235"],
    ["455", "42", "156"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["289", "95", "230"],
    ["459", "85", "122"],
    ["790", "62", "480"],
    ["279", "80", "569"],
    ["568", "91", "579"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["679", "28", "459"],
    ["238", "31", "227"],
    ["457", "63", "238"],
    ["447", "51", "146"],
    ["168", "54", "400"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["499", "28", "170"],
    ["580", "35", "258"],
    ["778", "24", "699"],
    ["170", "83", "148"],
    ["113", "52", "200"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["289", "90", "677"],
    ["499", "28", "125"],
    ["440", "87", "340"],
    ["268", "66", "457"],
    ["336", "28", "477"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["770", "44", "699"],
    ["226", "06", "790"],
    ["135", "96", "358"],
    ["670", "33", "256"],
    ["456", "52", "480"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["467", "77", "458"],
    ["350", "80", "668"],
    ["570", "21", "128"],
    ["178", "67", "368"],
    ["147", "25", "249"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["890", "74", "130"],
    ["370", "05", "456"],
    ["348", "59", "577"],
    ["788", "33", "689"],
    ["259", "63", "120"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["356", "44", "239"],
    ["599", "31", "100"],
    ["445", "32", "246"],
    ["679", "29", "469"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["367", "64", "770"],
    ["445", "33", "670"],
    ["380", "15", "357"],
    ["370", "03", "120"],
    ["789", "45", "249"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["244", "01", "470"],
    ["280", "01", "137"],
    ["389", "07", "449"],
    ["367", "65", "348"],
    ["560", "16", "268"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["679", "29", "568"],
    ["560", "16", "457"],
    ["469", "96", "457"],
    ["340", "71", "579"],
    ["250", "75", "258"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["150", "64", "680"],
    ["137", "12", "499"],
    ["167", "42", "336"],
    ["457", "66", "349"],
    ["169", "61", "290"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["560", "16", "268"],
    ["259", "62", "688"],
    ["147", "26", "240"],
    ["490", "32", "138"],
    ["339", "50", "479"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["590", "49", "559"],
    ["138", "22", "570"],
    ["149", "46", "240"],
    ["680", "42", "237"],
    ["159", "55", "140"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["349", "64", "130"],
    ["668", "07", "566"],
    ["569", "05", "159"],
    ["688", "24", "789"],
    ["345", "20", "479"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["160", "75", "159"],
    ["357", "51", "227"],
    ["117", "95", "799"],
    ["223", "77", "359"],
    ["150", "60", "677"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["188", "71", "146"],
    ["490", "33", "490"],
    ["136", "07", "124"],
    ["249", "59", "126"],
    ["330", "68", "170"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["157", "30", "569"],
    ["780", "59", "144"],
    ["788", "34", "338"],
    ["349", "60", "569"],
    ["370", "02", "679"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["449", "78", "125"],
    ["150", "67", "269"],
    ["250", "70", "460"],
    ["259", "60", "488"],
    ["589", "23", "445"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["668", "07", "115"],
    ["278", "76", "268"],
    ["229", "36", "448"],
    ["358", "61", "470"],
    ["169", "68", "440"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["567", "81", "470"],
    ["116", "84", "130"],
    ["459", "84", "239"],
    ["360", "91", "137"],
    ["137", "18", "170"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["368", "74", "248"],
    ["680", "43", "256"],
    ["368", "79", "469"],
    ["112", "47", "359"],
    ["578", "05", "799"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["127", "00", "370"],
    ["169", "60", "460"],
    ["588", "12", "255"],
    ["238", "31", "236"],
    ["128", "12", "147"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["690", "57", "557"],
    ["269", "77", "179"],
    ["470", "15", "348"],
    ["225", "97", "278"],
    ["368", "77", "467"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["340", "78", "378"],
    ["157", "37", "890"],
    ["134", "84", "455"],
    ["560", "13", "580"],
    ["669", "13", "139"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["689", "39", "270"],
    ["148", "32", "345"],
    ["367", "69", "289"],
    ["234", "90", "145"],
    ["238", "36", "114"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["158", "46", "150"],
    ["128", "16", "330"],
    ["334", "02", "570"],
    ["458", "70", "235"],
    ["379", "97", "179"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["157", "34", "356"],
    ["459", "85", "168"],
    ["880", "61", "470"],
    ["***", "**", "***"],
    ["258", "52", "246"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["279", "81", "669"],
    ["146", "14", "789"],
    ["690", "52", "336"],
    ["257", "41", "489"],
    ["229", "38", "459"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["390", "21", "119"],
    ["790", "61", "380"],
    ["134", "82", "390"],
    ["490", "31", "227"],
    ["460", "01", "236"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["236", "13", "599"],
    ["578", "08", "279"],
    ["446", "45", "258"],
    ["338", "40", "578"],
    ["266", "47", "467"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["349", "64", "158"],
    ["130", "42", "570"],
    ["158", "45", "799"],
    ["558", "81", "678"],
    ["478", "98", "350"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["477", "88", "260"],
    ["570", "27", "557"],
    ["449", "72", "129"],
    ["230", "58", "134"],
    ["379", "97", "359"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["558", "88", "350"],
    ["990", "84", "680"],
    ["890", "73", "157"],
    ["669", "14", "338"],
    ["367", "64", "789"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["477", "89", "144"],
    ["790", "66", "178"],
    ["116", "89", "667"],
    ["348", "55", "780"],
    ["378", "85", "249"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["456", "55", "799"],
    ["467", "73", "599"],
    ["780", "58", "189"],
    ["370", "06", "466"],
    ["579", "14", "239"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["168", "53", "599"],
    ["130", "45", "249"],
    ["469", "92", "589"],
    ["267", "55", "258"],
    ["290", "12", "237"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["358", "65", "258"],
    ["270", "96", "358"],
    ["770", "42", "336"],
    ["278", "76", "349"],
    ["124", "70", "334"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["140", "54", "130"],
    ["689", "31", "380"],
    ["157", "37", "377"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["500", "54", "338"],
    ["178", "61", "579"],
    ["268", "60", "145"],
    ["200", "27", "566"],
    ["466", "63", "166"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["167", "40", "334"],
    ["125", "88", "260"],
    ["367", "61", "669"],
    ["230", "58", "369"],
    ["134", "87", "566"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["178", "66", "277"],
    ["245", "15", "456"],
    ["270", "95", "258"],
    ["680", "48", "125"],
    ["146", "17", "250"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["458", "78", "233"],
    ["600", "62", "228"],
    ["136", "08", "459"],
    ["140", "51", "245"],
    ["244", "00", "389"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["336", "20", "370"],
    ["270", "96", "556"],
    ["450", "96", "259"],
    ["670", "31", "380"],
    ["389", "06", "330"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["367", "60", "190"],
    ["236", "19", "126"],
    ["157", "35", "500"],
    ["139", "33", "599"],
    ["788", "35", "456"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["256", "31", "560"],
    ["990", "89", "126"],
    ["146", "14", "248"],
    ["678", "14", "130"],
    ["236", "12", "129"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["378", "84", "347"],
    ["568", "97", "179"],
    ["478", "93", "139"],
    ["259", "64", "158"],
    ["380", "18", "125"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["279", "87", "449"],
    ["669", "17", "890"],
    ["450", "97", "269"],
    ["247", "39", "289"],
    ["569", "01", "380"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["379", "95", "249"],
    ["267", "54", "347"],
    ["339", "57", "700"],
    ["269", "72", "246"],
    ["278", "78", "260"]
  ],
  "01/20/2025 to 01/26/2025": [
    ["568", "92", "778"],
    ["490", "36", "358"],
    ["380", "14", "167"],
    ["780", "59", "388"],
    ["700", "78", "468"]
  ],
  "01/27/2025 To 02/02/2025": [
    ["688", "27", "160"],
    ["120", "39", "234"],
    ["120", "34", "590"],
    ["266", "48", "224"],
    ["390", "29", "478"]
  ],
  "02/03/2025 To 02/09/2025": [
    ["145", "03", "120"],
    ["238", "30", "127"],
    ["789", "47", "124"],
    ["122", "57", "124"],
    ["778", "28", "558"]
  ],
  "02/10/2025 To 02/16/2025": [
    ["347", "40", "578"],
    ["347", "40", "190"],
    ["227", "17", "377"],
    ["590", "41", "128"],
    ["667", "96", "178"]
  ],
  "02/17/2025 To 02/23/2025": [
    ["136", "02", "147"],
    ["280", "06", "790"],
    ["300", "36", "169"],
    ["567", "84", "130"],
    ["168", "52", "345"]
  ],
  "02/24/2025 To 03/02/2025": [
    ["290", "13", "166"],
    ["689", "39", "270"],
    ["799", "56", "150"],
    ["366", "54", "167"],
    ["247", "31", "489"]
  ],
  "03/03/2025 To 03/09/2025": [
    ["500", "50", "280"],
    ["277", "60", "136"],
    ["489", "13", "788"],
    ["248", "40", "460"],
    ["456", "57", "890"]
  ],
  "03/10/2025 To 03/16/2025": [
    ["569", "02", "480"],
    ["135", "98", "567"],
    ["168", "57", "467"],
    ["590", "41", "678"],
    ["***", "**", "***"]
  ],
  "03/17/2025 To 03/23/2025": [
    ["166", "32", "570"],
    ["580", "32", "156"],
    ["226", "03", "120"],
    ["135", "90", "235"],
    ["156", "29", "234"]
  ],
  "03/24/2025 To 03/30/2025": [
    ["340", "71", "227"],
    ["590", "46", "169"],
    ["450", "98", "378"],
    ["778", "20", "578"],
    ["599", "32", "480"]
  ],
  "03/31/2025 To 04/06/2025": [
    ["469", "92", "129"],
    ["170", "89", "126"],
    ["367", "63", "157"],
    ["466", "67", "160"],
    ["158", "44", "220"]
  ],
  "04/07/2025 To 04/13/2025": [
    ["145", "04", "167"],
    ["258", "55", "258"],
    ["690", "55", "249"],
    ["567", "88", "125"],
    ["499", "25", "249"]
  ],
  "04/14/2025 To 04/20/2025": [
    ["337", "37", "368"],
    ["457", "66", "259"],
    ["390", "26", "169"],
    ["580", "34", "167"],
    ["778", "29", "360"]
  ],
  "04/21/2025 To 04/27/2025": [
    ["245", "13", "788"],
    ["169", "61", "236"],
    ["447", "51", "335"],
    ["289", "99", "360"],
    ["268", "60", "569"]
  ],
  "04/28/2025 To 05/04/2025": [
    ["360", "90", "460"],
    ["788", "33", "139"],
    ["570", "24", "699"],
    ["279", "83", "490"],
    ["344", "16", "259"]
  ],
  "05/05/2025 To 05/11/2025": [
    ["367", "66", "169"],
    ["770", "44", "257"],
    ["390", "26", "259"],
    ["116", "81", "489"],
    ["250", "79", "180"]
  ],
  "05/12/2025 To 05/18/2025": [
    ["135", "98", "279"],
    ["255", "23", "157"],
    ["277", "69", "450"],
    ["255", "22", "228"],
    ["468", "82", "499"]
  ],
  "05/19/2025 To 05/25/2025": [
    ["578", "02", "499"],
    ["488", "05", "348"],
    ["688", "22", "246"],
    ["158", "48", "233"],
    ["770", "45", "366"]
  ],
  "05/26/2025 To 06/01/2025": [
    ["347", "43", "689"],
    ["678", "14", "400"],
    ["890", "72", "156"],
    ["359", "78", "369"],
    ["246", "21", "290"]
  ],
  "06/02/2025 To 06/08/2025": [
    ["478", "92", "255"],
    ["248", "41", "579"],
    ["390", "26", "150"],
    ["129", "21", "236"],
    ["680", "42", "156"]
  ],
  "06/09/2025 To 06/15/2025": [
    ["567", "87", "368"],
    ["238", "39", "360"],
    ["180", "90", "460"],
    ["140", "57", "278"],
    ["578", "09", "225"]
  ],
  "06/16/2025 To 06/22/2025": [
    ["289", "98", "459"],
    ["238", "31", "380"],
    ["488", "06", "169"],
    ["120", "39", "469"],
    ["459", "86", "880"]
  ],
  "06/23/2025 To 06/29/2025": [
    ["344", "15", "258"],
    ["167", "42", "336"],
    ["579", "15", "230"],
    ["139", "32", "237"],
    ["224", "88", "350"]
  ],
  "06/30/2025 To 07/06/2025": [
    ["359", "75", "230"],
    ["779", "38", "440"],
    ["224", "87", "278"],
    ["478", "96", "268"],
    ["128", "17", "557"]
  ],
  "07/07/2025 To 07/13/2025": [
    ["440", "87", "368"],
    ["467", "78", "558"],
    ["689", "33", "490"],
    ["190", "08", "459"],
    ["660", "28", "378"]
  ],
  "07/14/2025 To 07/20/2025": [
    ["237", "28", "567"],
    ["128", "14", "158"],
    ["120", "39", "450"],
    ["679", "24", "590"],
    ["466", "60", "299"]
  ],
  "07/21/2025 To 07/27/2025": [
    ["800", "82", "156"],
    ["230", "54", "130"],
    ["479", "08", "567"],
    ["126", "95", "456"],
    ["180", "95", "230"]
  ],
  "07/28/2025 To 08/03/2025": [
    ["177", "58", "558"],
    ["150", "69", "469"],
    ["257", "44", "356"],
    ["289", "91", "227"],
    ["350", "86", "259"]
  ],
  "08/04/2025 To 08/10/2025": [
    ["378", "84", "112"],
    ["499", "21", "335"],
    ["469", "92", "246"],
    ["127", "07", "250"],
    ["124", "79", "180"]
  ],
  "08/11/2025 To 08/17/2025": [
    ["267", "50", "578"],
    ["157", "33", "445"],
    ["299", "09", "568"],
    ["269", "77", "458"],
    ["***", "**", "***"]
  ],
  "08/18/2025 To 08/24/2025": [
    ["199", "99", "234"],
    ["124", "70", "190"],
    ["245", "15", "168"],
    ["190", "06", "150"],
    ["579", "17", "124"]
  ],
  "08/25/2025 To 08/31/2025": [
    ["458", "77", "368"],
    ["349", "65", "168"],
    ["780", "57", "133"],
    ["370", "09", "117"],
    ["348", "50", "235"]
  ],
  "09/01/2025 To 09/07/2025": [
    ["189", "81", "137"],
    ["290", "16", "268"],
    ["348", "52", "345"],
    ["880", "64", "257"],
    ["133", "79", "379"]
  ],
  "09/08/2025 To 09/14/2025": [
    ["550", "01", "489"],
    ["136", "05", "159"],
    ["127", "03", "689"],
    ["280", "07", "124"],
    ["679", "22", "156"]
  ],
  "09/15/2025 To 09/21/2025": [
    ["137", "16", "466"],
    ["130", "48", "567"],
    ["244", "09", "388"],
    ["149", "44", "167"],
    ["250", "70", "569"]
  ],
  "09/22/2025 To 09/28/2025": [
    ["240", "67", "557"],
    ["339", "50", "370"],
    ["237", "26", "457"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "09/29/2025 To 10/05/2025": [
    ["***", "**", "***"],
    ["278", "74", "112"],
    ["469", "93", "148"],
    ["557", "75", "168"],
    ["890", "78", "477"]
  ],
  "10/06/2025 To 10/12/2025": [
    ["236", "12", "570"],
    ["344", "16", "790"],
    ["457", "67", "278"],
    ["127", "02", "480"],
    ["256", "30", "460"]
  ],
  "10/13/2025 To 10/19/2025": [
    ["259", "66", "556"],
    ["123", "63", "300"],
    ["139", "38", "260"],
    ["334", "05", "348"],
    ["390", "26", "358"]
  ],
  "10/20/2025 To 10/26/2025": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "10/27/2025 To 11/02/2025": [
    ["689", "33", "139"],
    ["235", "05", "799"],
    ["336", "25", "339"],
    ["499", "26", "457"],
    ["446", "40", "479"]
  ],
  "11/03/2025 To 11/09/2025": [
    ["890", "71", "678"],
    ["679", "23", "148"],
    ["440", "88", "189"],
    ["447", "57", "377"],
    ["267", "59", "450"]
  ],
  "11/10/2025 To 11/16/2025": [
    ["279", "86", "169"],
    ["126", "99", "180"],
    ["277", "67", "250"],
    ["780", "59", "559"],
    ["569", "07", "269"]
  ],
  "11/17/2025 To 11/23/2025": [
    ["356", "49", "469"],
    ["336", "29", "234"],
    ["680", "40", "136"],
    ["280", "03", "346"],
    ["236", "17", "269"]
  ],
  "11/24/2025 To 11/30/2025": [
    ["158", "47", "566"],
    ["579", "18", "170"],
    ["190", "00", "334"],
    ["127", "03", "247"],
    ["468", "86", "259"]
  ],
  "12/01/2025 To 12/07/2025": [
    ["148", "38", "468"],
    ["457", "69", "234"],
    ["490", "31", "579"],
    ["279", "82", "570"],
    ["480", "27", "890"]
  ],
  "12/08/2025 To 12/14/2025": [
    ["450", "97", "160"],
    ["678", "19", "180"],
    ["588", "11", "245"],
    ["579", "19", "234"],
    ["138", "27", "269"]
  ],
  "12/15/2025 To 12/21/2025": [
    ["240", "61", "344"],
    ["138", "27", "458"],
    ["488", "03", "580"],
    ["277", "63", "247"],
    ["479", "07", "179"]
  ],
  "12/22/2025 To 12/28/2025": [
    ["468", "86", "457"],
    ["466", "69", "667"],
    ["379", "92", "499"],
    ["124", "71", "560"],
    ["135", "97", "458"]
  ],
  "12/29/2025 To 01/04/2026": [
    ["256", "31", "146"],
    ["269", "75", "258"],
    ["244", "08", "459"],
    ["346", "39", "379"],
    ["190", "03", "120"]
  ],
  "01/05/2026 To 01/11/2026": [
    ["148", "37", "179"],
    ["270", "95", "230"],
    ["468", "81", "579"],
    ["136", "01", "245"],
    ["370", "08", "477"]
  ],
  "01/12/2026 To 01/18/2026": [
    ["578", "06", "790"],
    ["467", "73", "580"],
    ["790", "60", "280"],
    ["899", "65", "456"],
    ["133", "71", "146"]
  ],
  "01/19/2026 To 01/25/2026": [
    ["115", "73", "490"],
    ["127", "02", "237"],
    ["699", "49", "135"],
    ["468", "82", "499"],
    ["126", "91", "489"]
  ],
  "01/26/2026 To 02/01/2026": [
    ["***", "**", "***"],
    ["256", "31", "399"],
    ["249", "53", "148"],
    ["290", "15", "168"],
    ["679", "26", "880"]
  ],
  "02/02/2026 To 02/08/2026": [
    ["378", "88", "125"],
    ["440", "89", "577"],
    ["356", "40", "244"],
    ["899", "66", "790"],
    ["259", "62", "778"]
  ],
  "02/09/2026 To 02/15/2026": [
    ["449", "79", "126"],
    ["699", "47", "467"],
    ["135", "95", "780"],
    ["699", "42", "156"],
    ["140", "51", "245"]
  ],
  "02/16/2026 To 02/22/2026": [
    ["229", "33", "238"],
    ["669", "18", "279"],
    ["117", "93", "139"],
    ["257", "46", "358"],
    ["158", "41", "137"]
  ],
  "02/23/2026 To 03/01/2026": [
    ["100", "19", "478"],
    ["566", "75", "500"],
    ["229", "35", "113"],
    ["779", "33", "689"],
    ["238", "39", "450"]
  ],
  "03/02/2026 To 03/08/2026": [
    ["335", "14", "680"],
    ["113", "50", "569"],
    ["***", "**", "***"],
    ["336", "24", "338"],
    ["158", "44", "770"]
  ],
  "03/09/2026 To 03/15/2026": [
    ["147", "24", "590"],
    ["156", "22", "589"],
    ["140", "53", "139"],
    ["357", "52", "679"],
    ["177", "58", "378"]
  ],
  "03/16/2026 To 03/22/2026": [
    ["469", "99", "568"],
    ["567", "87", "467"],
    ["137", "18", "567"],
    ["489", "16", "114"],
    ["338", "45", "168"]
  ]
};

export const SRIDEVINIGHT = {
 
  "01/01/2024 to 01/07/2024": [
    ["800", "87", "377"],
    ["467", "70", "334"],
    ["477", "86", "169"],
    ["890", "70", "244"],
    ["228", "26", "899"],
    ["450", "93", "490"],
    ["122", "56", "268"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["448", "61", "236"],
    ["668", "04", "248"],
    ["147", "22", "129"],
    ["488", "01", "128"],
    ["119", "18", "459"],
    ["257", "40", "190"],
    ["699", "41", "489"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["146", "19", "289"],
    ["180", "94", "347"],
    ["568", "93", "490"],
    ["134", "82", "138"],
    ["457", "68", "567"],
    ["236", "11", "290"],
    ["458", "71", "245"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["266", "47", "188"],
    ["134", "85", "447"],
    ["448", "65", "348"],
    ["478", "98", "189"],
    ["***", "**", "***"],
    ["129", "21", "146"],
    ["346", "39", "360"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["678", "19", "225"],
    ["156", "23", "670"],
    ["369", "87", "179"],
    ["125", "82", "679"],
    ["167", "40", "569"],
    ["690", "59", "180"],
    ["259", "64", "699"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["338", "44", "239"],
    ["279", "88", "990"],
    ["367", "60", "578"],
    ["334", "08", "350"],
    ["459", "83", "346"],
    ["660", "22", "390"],
    ["356", "48", "477"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["246", "22", "237"],
    ["125", "88", "260"],
    ["446", "45", "267"],
    ["790", "60", "136"],
    ["359", "77", "890"],
    ["577", "92", "255"],
    ["559", "90", "370"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["789", "48", "369"],
    ["600", "60", "190"],
    ["357", "51", "470"],
    ["169", "65", "230"],
    ["179", "79", "126"],
    ["788", "33", "256"],
    ["246", "26", "457"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["255", "27", "359"],
    ["137", "17", "115"],
    ["260", "80", "226"],
    ["140", "58", "477"],
    ["267", "58", "279"],
    ["478", "92", "679"],
    ["290", "15", "258"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["880", "69", "270"],
    ["479", "00", "668"],
    ["334", "08", "134"],
    ["579", "19", "568"],
    ["250", "79", "289"],
    ["128", "15", "249"],
    ["157", "39", "568"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["578", "07", "160"],
    ["255", "28", "189"],
    ["127", "09", "180"],
    ["470", "16", "880"],
    ["557", "74", "770"],
    ["669", "16", "178"],
    ["589", "28", "279"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["122", "55", "258"],
    ["455", "48", "459"],
    ["344", "15", "267"],
    ["800", "81", "227"],
    ["226", "09", "117"],
    ["677", "05", "249"],
    ["457", "61", "155"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["447", "51", "236"],
    ["156", "27", "223"],
    ["160", "74", "699"],
    ["167", "49", "559"],
    ["247", "39", "379"],
    ["467", "78", "125"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["370", "07", "250"],
    ["299", "00", "668"],
    ["289", "97", "557"],
    ["400", "48", "567"],
    ["388", "95", "122"],
    ["158", "43", "670"],
    ["236", "12", "570"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["334", "07", "458"],
    ["112", "44", "257"],
    ["500", "56", "349"],
    ["990", "80", "668"],
    ["289", "90", "479"],
    ["260", "81", "290"],
    ["689", "35", "113"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["180", "97", "467"],
    ["499", "21", "245"],
    ["135", "94", "266"],
    ["236", "14", "257"],
    ["139", "36", "358"],
    ["158", "41", "560"],
    ["567", "83", "490"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["138", "24", "149"],
    ["566", "73", "445"],
    ["269", "78", "233"],
    ["369", "86", "240"],
    ["168", "55", "159"],
    ["137", "14", "239"],
    ["169", "60", "127"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["140", "55", "258"],
    ["156", "21", "489"],
    ["679", "20", "190"],
    ["125", "85", "159"],
    ["490", "35", "690"],
    ["579", "14", "130"],
    ["128", "13", "238"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["457", "64", "446"],
    ["230", "57", "269"],
    ["679", "23", "580"],
    ["258", "51", "678"],
    ["138", "22", "345"],
    ["128", "17", "467"],
    ["990", "84", "257"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["259", "61", "489"],
    ["290", "16", "259"],
    ["440", "80", "569"],
    ["239", "44", "158"],
    ["479", "07", "890"],
    ["127", "01", "678"],
    ["270", "93", "346"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["450", "98", "233"],
    ["340", "77", "377"],
    ["458", "72", "480"],
    ["347", "41", "344"],
    ["667", "90", "145"],
    ["244", "07", "223"],
    ["257", "47", "269"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["800", "89", "117"],
    ["446", "41", "236"],
    ["136", "02", "237"],
    ["257", "45", "249"],
    ["369", "88", "459"],
    ["166", "35", "690"],
    ["789", "40", "668"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["266", "45", "113"],
    ["150", "62", "138"],
    ["259", "60", "389"],
    ["580", "35", "267"],
    ["358", "62", "660"],
    ["578", "00", "479"],
    ["269", "72", "688"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["379", "98", "350"],
    ["468", "82", "390"],
    ["667", "92", "200"],
    ["180", "96", "600"],
    ["290", "13", "120"],
    ["128", "13", "157"],
    ["178", "64", "699"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["359", "77", "179"],
    ["248", "44", "158"],
    ["568", "94", "257"],
    ["260", "85", "357"],
    ["280", "01", "470"],
    ["240", "62", "480"],
    ["134", "87", "179"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["299", "03", "689"],
    ["145", "03", "157"],
    ["158", "44", "789"],
    ["679", "24", "239"],
    ["358", "69", "135"],
    ["259", "64", "130"],
    ["238", "39", "270"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["890", "78", "224"],
    ["345", "21", "579"],
    ["479", "04", "158"],
    ["445", "36", "600"],
    ["337", "39", "360"],
    ["145", "00", "479"],
    ["556", "60", "578"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["370", "01", "146"],
    ["778", "29", "126"],
    ["349", "61", "678"],
    ["689", "31", "489"],
    ["580", "31", "290"],
    ["368", "79", "469"],
    ["458", "76", "240"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["159", "53", "580"],
    ["679", "22", "246"],
    ["557", "78", "558"],
    ["229", "30", "677"],
    ["448", "61", "146"],
    ["126", "90", "235"],
    ["229", "30", "389"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["367", "61", "119"],
    ["247", "35", "339"],
    ["133", "78", "189"],
    ["120", "37", "340"],
    ["113", "59", "234"],
    ["400", "41", "579"],
    ["110", "23", "256"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["339", "51", "227"],
    ["140", "59", "270"],
    ["356", "44", "130"],
    ["780", "57", "359"],
    ["145", "03", "247"],
    ["156", "24", "455"],
    ["468", "83", "157"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["899", "62", "255"],
    ["578", "01", "579"],
    ["448", "67", "223"],
    ["237", "23", "599"],
    ["147", "21", "100"],
    ["220", "48", "800"],
    ["112", "41", "678"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["559", "90", "569"],
    ["145", "08", "990"],
    ["558", "89", "180"],
    ["***", "**", "***"],
    ["560", "13", "238"],
    ["570", "27", "458"],
    ["125", "88", "567"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["280", "05", "357"],
    ["150", "65", "447"],
    ["469", "96", "349"],
    ["680", "41", "470"],
    ["260", "83", "247"],
    ["278", "70", "190"],
    ["180", "95", "168"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["133", "74", "699"],
    ["236", "15", "177"],
    ["355", "31", "678"],
    ["889", "59", "180"],
    ["780", "58", "477"],
    ["667", "98", "170"],
    ["579", "15", "168"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["477", "80", "677"],
    ["580", "31", "489"],
    ["126", "93", "670"],
    ["380", "12", "345"],
    ["379", "96", "150"],
    ["138", "24", "789"],
    ["234", "95", "348"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["499", "22", "156"],
    ["250", "70", "127"],
    ["170", "88", "378"],
    ["470", "11", "290"],
    ["255", "25", "339"],
    ["668", "05", "249"],
    ["890", "72", "138"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["378", "84", "158"],
    ["569", "03", "670"],
    ["359", "70", "479"],
    ["389", "06", "358"],
    ["129", "22", "237"],
    ["780", "59", "478"],
    ["566", "71", "344"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["224", "81", "290"],
    ["279", "88", "189"],
    ["358", "63", "139"],
    ["190", "04", "455"],
    ["350", "88", "279"],
    ["136", "09", "135"],
    ["357", "50", "569"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["345", "26", "358"],
    ["257", "41", "137"],
    ["558", "89", "577"],
    ["670", "38", "468"],
    ["340", "75", "267"],
    ["167", "42", "147"],
    ["680", "48", "134"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["789", "42", "480"],
    ["126", "92", "110"],
    ["289", "95", "113"],
    ["458", "70", "460"],
    ["240", "60", "235"],
    ["489", "18", "279"],
    ["259", "63", "157"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["128", "15", "159"],
    ["138", "21", "146"],
    ["490", "37", "124"],
    ["479", "00", "569"],
    ["346", "33", "148"],
    ["178", "67", "368"],
    ["138", "27", "278"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["450", "92", "345"],
    ["468", "83", "490"],
    ["166", "32", "679"],
    ["290", "15", "177"],
    ["399", "16", "466"],
    ["379", "95", "348"],
    ["126", "96", "556"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["356", "40", "235"],
    ["449", "78", "800"],
    ["567", "84", "257"],
    ["235", "03", "445"],
    ["567", "84", "248"],
    ["258", "54", "149"],
    ["236", "15", "780"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["250", "78", "350"],
    ["688", "24", "789"],
    ["455", "47", "133"],
    ["566", "71", "678"],
    ["256", "30", "578"],
    ["117", "95", "447"],
    ["670", "30", "136"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["490", "34", "356"],
    ["570", "24", "347"],
    ["116", "80", "244"],
    ["149", "42", "237"],
    ["160", "72", "688"],
    ["146", "11", "137"],
    ["148", "34", "130"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["339", "58", "440"],
    ["135", "98", "170"],
    ["780", "52", "679"],
    ["349", "62", "156"],
    ["489", "14", "167"],
    ["380", "10", "244"],
    ["247", "34", "149"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["670", "32", "390"],
    ["490", "39", "469"],
    ["146", "10", "280"],
    ["459", "85", "780"],
    ["378", "81", "489"],
    ["170", "86", "268"],
    ["156", "26", "790"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["590", "40", "389"],
    ["569", "07", "368"],
    ["380", "16", "240"],
    ["234", "92", "345"],
    ["449", "70", "118"],
    ["369", "80", "460"],
    ["126", "93", "346"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["268", "65", "348"],
    ["120", "37", "269"],
    ["146", "16", "367"],
    ["269", "77", "467"],
    ["255", "22", "499"],
    ["479", "02", "237"],
    ["368", "75", "267"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["127", "06", "277"],
    ["178", "65", "348"],
    ["790", "65", "140"],
    ["169", "68", "350"],
    ["158", "43", "238"],
    ["699", "41", "380"],
    ["667", "93", "229"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["390", "22", "156"],
    ["788", "31", "227"],
    ["220", "47", "467"],
    ["199", "98", "440"],
    ["359", "73", "148"],
    ["150", "69", "225"],
    ["458", "72", "688"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["566", "78", "459"],
    ["113", "50", "127"],
    ["789", "46", "268"],
    ["568", "92", "390"],
    ["140", "51", "245"],
    ["588", "10", "389"],
    ["389", "09", "478"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["223", "72", "390"],
    ["340", "70", "127"],
    ["280", "07", "368"],
    ["144", "94", "356"],
    ["178", "66", "880"],
    ["590", "41", "678"],
    ["456", "52", "228"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["239", "49", "234"],
    ["160", "76", "330"],
    ["699", "40", "280"],
    ["255", "21", "290"],
    ["556", "67", "359"],
    ["244", "02", "570"],
    ["349", "65", "168"]
  ],
  "01/20/2025 to 01/26/2025": [
    ["679", "24", "266"],
    ["344", "19", "667"],
    ["230", "53", "139"],
    ["258", "51", "678"],
    ["280", "02", "246"],
    ["279", "83", "346"],
    ["***", "**", "***"]
  ],
  "01/27/2025 to 02/02/2025": [
    ["235", "00", "127"],
    ["159", "53", "490"],
    ["489", "14", "590"],
    ["177", "55", "348"],
    ["246", "22", "138"],
    ["160", "79", "360"],
    ["456", "55", "249"]
  ],
  "02/03/2025 to 02/09/2025": [
    ["277", "65", "690"],
    ["200", "21", "588"],
    ["589", "28", "125"],
    ["117", "90", "145"],
    ["124", "79", "199"],
    ["346", "34", "167"],
    ["128", "13", "788"]
  ],
  "02/10/2025 to 02/16/2025": [
    ["136", "04", "167"],
    ["899", "61", "245"],
    ["234", "96", "268"],
    ["159", "57", "359"],
    ["139", "33", "346"],
    ["177", "55", "357"],
    ["368", "74", "248"]
  ],
  "02/17/2025 to 02/23/2025": [
    ["249", "55", "258"],
    ["338", "49", "180"],
    ["390", "22", "390"],
    ["388", "96", "556"],
    ["117", "96", "790"],
    ["139", "30", "569"],
    ["160", "72", "778"]
  ],
    "02/24/2025 to 03/02/2025": [
    ["660", "22", "129"],
    ["248", "49", "360"],
    ["234", "98", "189"],
    ["360", "98", "125"],
    ["450", "93", "247"],
    ["244", "05", "366"],
    ["560", "12", "156"]
  ],
  "03/03/2025 to 03/09/2025": [
    ["259", "61", "236"],
    ["145", "00", "190"],
    ["700", "74", "789"],
    ["140", "52", "778"],
    ["256", "39", "900"],
    ["234", "97", "449"],
    ["490", "39", "379"]
  ],
  "03/10/2025 to 03/16/2025": [
    ["667", "97", "368"],
    ["468", "87", "890"],
    ["136", "01", "579"],
    ["333", "94", "789"],
    ["***", "**", "***"],
    ["158", "44", "167"],
    ["677", "02", "138"]
  ],
  "03/17/2025 to 03/23/2025": [
    ["167", "40", "136"],
    ["580", "34", "770"],
    ["127", "01", "470"],
    ["160", "70", "479"],
    ["145", "08", "260"],
    ["250", "74", "680"],
    ["259", "64", "257"]
  ],
  "03/24/2025 to 03/30/2025": [
    ["236", "14", "356"],
    ["899", "69", "469"],
    ["599", "37", "269"],
    ["227", "11", "560"],
    ["355", "31", "579"],
    ["188", "77", "359"],
    ["139", "39", "568"]
  ],
  "03/31/2025 to 04/06/2025": [
    ["136", "08", "440"],
    ["249", "55", "258"],
    ["560", "12", "336"],
    ["699", "46", "240"],
    ["680", "42", "345"],
    ["368", "79", "478"],
    ["789", "45", "690"]
  ],
  "04/07/2025 to 04/13/2025": [
    ["237", "26", "277"],
    ["550", "02", "778"],
    ["470", "13", "256"],
    ["899", "63", "346"],
    ["460", "01", "137"],
    ["146", "15", "357"],
    ["300", "35", "140"]
  ],
  "04/14/2025 to 04/20/2025": [
    ["136", "00", "370"],
    ["448", "67", "188"],
    ["339", "50", "190"],
    ["277", "60", "479"],
    ["449", "78", "233"],
    ["335", "11", "290"],
    ["355", "39", "234"]
  ],
  "04/21/2025 to 04/27/2025": [
    ["133", "77", "458"],
    ["490", "33", "247"],
    ["568", "95", "230"],
    ["112", "45", "690"],
    ["700", "75", "690"],
    ["157", "34", "248"],
    ["469", "92", "499"]
  ],
  "04/28/2025 to 05/04/2025": [
    ["347", "43", "300"],
    ["579", "10", "569"],
    ["248", "49", "469"],
    ["340", "78", "468"],
    ["660", "27", "179"],
    ["590", "48", "378"],
    ["355", "35", "357"]
  ],
  "05/05/2025 to 05/11/2025": [
    ["266", "46", "790"],
    ["228", "27", "250"],
    ["146", "13", "580"],
    ["390", "28", "369"],
    ["570", "23", "490"],
    ["580", "35", "140"],
    ["160", "78", "125"]
  ],
  "05/12/2025 to 05/18/2025": [
    ["580", "34", "356"],
    ["170", "81", "560"],
    ["480", "23", "247"],
    ["569", "07", "359"],
    ["140", "51", "344"],
    ["467", "79", "450"],
    ["389", "06", "790"]
  ],
  "05/19/2025 to 05/25/2025": [
    ["569", "04", "356"],
    ["148", "32", "390"],
    ["130", "47", "160"],
    ["170", "83", "490"],
    ["330", "63", "670"],
    ["455", "49", "469"],
    ["468", "87", "359"]
  ],
  "05/26/2025 to 06/01/2025": [
    ["248", "43", "256"],
    ["125", "86", "880"],
    ["259", "66", "268"],
    ["668", "00", "370"],
    ["248", "44", "257"],
    ["770", "41", "669"],
    ["168", "56", "358"]
  ],
  "06/02/2025 to 06/08/2025": [
    ["579", "13", "599"],
    ["257", "40", "460"],
    ["267", "55", "348"],
    ["230", "53", "247"],
    ["389", "06", "178"],
    ["550", "06", "457"],
    ["233", "88", "170"]
  ],
  "06/09/2025 to 06/15/2025": [
    ["267", "55", "357"],
    ["339", "55", "168"],
    ["790", "63", "580"],
    ["490", "39", "568"],
    ["128", "11", "245"],
    ["189", "89", "225"],
    ["670", "39", "379"]
  ],
  "06/16/2025 to 06/22/2025": [
    ["689", "31", "236"],
    ["399", "19", "270"],
    ["450", "90", "389"],
    ["479", "06", "123"],
    ["158", "41", "146"],
    ["469", "96", "367"],
    ["168", "54", "338"]
  ],
  "06/23/2025 to 06/29/2025": [
    ["447", "58", "134"],
    ["149", "44", "167"],
    ["236", "18", "260"],
    ["778", "26", "240"],
    ["779", "32", "570"],
    ["190", "09", "478"],
    ["679", "26", "240"]
  ],
  "06/30/2025 to 07/06/2025": [
    ["669", "11", "290"],
    ["770", "40", "136"],
    ["366", "59", "478"],
    ["200", "20", "136"],
    ["157", "38", "567"],
    ["256", "31", "100"],
    ["477", "82", "228"]
  ],
  "07/07/2025 to 07/13/2025": [
    ["357", "50", "235"],
    ["190", "02", "200"],
    ["357", "54", "149"],
    ["180", "98", "260"],
    ["190", "04", "130"],
    ["137", "15", "456"],
    ["456", "56", "169"]
  ],
  "07/14/2025 to 07/20/2025": [
    ["278", "72", "156"],
    ["589", "29", "568"],
    ["789", "42", "156"],
    ["124", "75", "258"],
    ["120", "38", "468"],
    ["670", "35", "799"],
    ["158", "42", "480"]
  ],
  "07/21/2025 to 07/27/2025": [
    ["779", "32", "778"],
    ["900", "96", "123"],
    ["360", "95", "799"],
    ["227", "17", "368"],
    ["360", "95", "159"],
    ["380", "18", "279"],
    ["467", "75", "780"]
  ],
  "07/28/2025 to 08/03/2025": [
    ["344", "11", "100"],
    ["359", "72", "345"],
    ["234", "97", "188"],
    ["288", "80", "127"],
    ["440", "85", "366"],
    ["123", "66", "178"],
    ["280", "09", "126"]
  ],
  "08/04/2025 to 08/10/2025": [
    ["278", "77", "467"],
    ["135", "90", "479"],
    ["245", "17", "340"],
    ["669", "10", "280"],
    ["139", "39", "469"],
    ["159", "51", "227"],
    ["258", "59", "360"]
  ],
  "08/11/2025 to 08/17/2025": [
    ["160", "78", "369"],
    ["149", "40", "460"],
    ["167", "48", "369"],
    ["368", "72", "246"],
    ["***", "**", "***"],
    ["358", "69", "126"],
    ["470", "18", "125"]
  ],
  "08/18/2025 to 08/24/2025": [
    ["349", "64", "680"],
    ["225", "93", "238"],
    ["466", "68", "350"],
    ["246", "22", "345"],
    ["137", "18", "170"],
    ["238", "33", "120"],
    ["800", "86", "790"]
  ],
  "08/25/2025 to 08/31/2025": [
    ["667", "96", "240"],
    ["257", "41", "290"],
    ["349", "64", "789"],
    ["456", "54", "347"],
    ["224", "82", "480"],
    ["900", "94", "356"],
    ["345", "26", "259"]
  ],
  "09/01/2025 to 09/07/2025": [
    ["780", "56", "600"],
    ["188", "71", "128"],
    ["149", "42", "228"],
    ["399", "19", "388"],
    ["600", "69", "135"],
    ["260", "88", "459"],
    ["134", "81", "146"]
  ],
  "09/08/2025 to 09/14/2025": [
    ["244", "03", "788"],
    ["115", "77", "467"],
    ["250", "75", "159"],
    ["468", "82", "480"],
    ["330", "67", "250"],
    ["267", "52", "246"],
    ["469", "94", "158"]
  ],
  "09/15/2025 to 09/21/2025": [
    ["300", "30", "190"],
    ["557", "79", "450"],
    ["140", "56", "358"],
    ["130", "43", "157"],
    ["339", "56", "466"],
    ["890", "70", "136"],
    ["236", "18", "558"]
  ],
  "09/22/2025 to 09/28/2025": [
    ["220", "45", "500"],
    ["789", "43", "490"],
    ["660", "25", "366"],
    ["266", "44", "455"],
    ["129", "23", "580"],
    ["346", "35", "177"],
    ["256", "34", "789"]
  ],
  "09/29/2025 to 10/05/2025": [
    ["155", "11", "579"],
    ["570", "23", "247"],
    ["350", "83", "670"],
    ["127", "09", "180"],
    ["790", "61", "137"],
    ["150", "60", "578"],
    ["136", "01", "128"]
  ],
  "10/06/2025 to 10/12/2025": [
    ["369", "82", "138"],
    ["140", "51", "470"],
    ["448", "60", "479"],
    ["258", "52", "688"],
    ["788", "31", "290"],
    ["800", "87", "124"],
    ["346", "31", "489"]
  ],
  "10/13/2025 to 10/19/2025": [
    ["479", "00", "127"],
    ["380", "11", "678"],
    ["389", "07", "368"],
    ["366", "54", "158"],
    ["990", "82", "679"],
    ["189", "85", "690"],
    ["269", "77", "124"]
  ],
  "10/20/2025 to 10/26/2025": [
    ["569", "04", "248"],
    ["370", "04", "347"],
    ["359", "78", "170"],
    ["290", "12", "156"],
    ["170", "80", "235"],
    ["157", "37", "278"],
    ["457", "61", "245"]
  ],
  "10/27/2025 to 11/02/2025": [
    ["359", "70", "190"],
    ["150", "63", "599"],
    ["138", "20", "235"],
    ["258", "55", "348"],
    ["889", "52", "336"],
    ["269", "70", "127"],
    ["467", "73", "490"]
  ],
  "11/03/2025 to 11/09/2025": [
    ["259", "63", "139"],
    ["259", "62", "679"],
    ["257", "47", "124"],
    ["356", "48", "125"],
    ["147", "26", "240"],
    ["990", "82", "499"],
    ["233", "82", "237"]
  ],
  "11/10/2025 to 11/16/2025": [
    ["134", "86", "358"],
    ["446", "40", "280"],
    ["156", "26", "448"],
    ["220", "41", "155"],
    ["457", "60", "145"],
    ["390", "23", "247"],
    ["357", "51", "146"]
  ],
  "11/17/2025 to 11/23/2025": [
    ["236", "12", "246"],
    ["489", "13", "300"],
    ["159", "59", "379"],
    ["440", "89", "379"],
    ["250", "78", "459"],
    ["480", "29", "388"],
    ["330", "65", "348"]
  ],
  "11/24/2025 to 11/30/2025": [
    ["147", "28", "116"],
    ["138", "28", "468"],
    ["227", "14", "158"],
    ["669", "10", "389"],
    ["670", "36", "349"],
    ["348", "50", "479"],
    ["130", "42", "336"]
  ],
  "12/01/2025 to 12/07/2025": [
    ["370", "03", "166"],
    ["449", "78", "279"],
    ["258", "51", "470"],
    ["589", "29", "667"],
    ["890", "73", "139"],
    ["347", "43", "256"],
    ["123", "67", "458"]
  ],
  "12/08/2025 to 12/14/2025": [
    ["380", "17", "269"],
    ["357", "50", "127"],
    ["570", "22", "156"],
    ["240", "62", "499"],
    ["478", "93", "346"],
    ["479", "09", "117"],
    ["226", "06", "466"]
  ],
  "12/15/2025 to 12/21/2025": [
    ["599", "33", "148"],
    ["160", "71", "588"],
    ["250", "76", "268"],
    ["245", "17", "700"],
    ["234", "96", "123"],
    ["679", "22", "156"],
    ["789", "42", "237"]
  ],
  "12/22/2025 to 12/28/2025": [
    ["269", "71", "489"],
    ["479", "04", "248"],
    ["360", "90", "569"],
    ["267", "57", "340"],
    ["140", "58", "378"],
    ["166", "33", "670"],
    ["270", "93", "247"]
  ],
  "12/29/2025 to 01/04/2026": [
    ["230", "55", "456"],
    ["349", "60", "370"],
    ["677", "00", "190"],
    ["189", "87", "124"],
    ["334", "07", "377"],
    ["279", "89", "360"],
    ["245", "15", "799"]
  ],
  "01/05/2026 to 01/11/2026": [
    ["350", "81", "236"],
    ["990", "84", "130"],
    ["689", "36", "123"],
    ["138", "23", "148"],
    ["170", "85", "249"],
    ["478", "94", "347"],
    ["570", "22", "390"]
  ],
  "01/12/2026 to 01/18/2026": [
    ["480", "25", "258"],
    ["127", "07", "179"],
    ["334", "07", "115"],
    ["150", "61", "290"],
    ["166", "35", "113"],
    ["550", "01", "146"],
    ["450", "95", "168"]
  ],
  "01/19/2026 to 01/25/2026": [
    ["479", "00", "578"],
    ["568", "96", "268"],
    ["890", "73", "580"],
    ["367", "64", "590"],
    ["347", "48", "260"],
    ["358", "66", "367"],
    ["223", "79", "568"]
  ],
  "01/26/2026 to 02/01/2026": [
    ["***", "**", "***"],
    ["226", "00", "677"],
    ["599", "35", "249"],
    ["689", "33", "157"],
    ["247", "31", "245"],
    ["137", "14", "680"],
    ["357", "59", "289"]
  ],
  "02/02/2026 to 02/08/2026": [
    ["679", "24", "158"],
    ["890", "71", "155"],
    ["113", "59", "568"],
    ["360", "98", "378"],
    ["200", "27", "467"],
    ["778", "21", "335"],
    ["150", "61", "560"]
  ],
  "02/09/2026 to 02/15/2026": [
    ["880", "66", "349"],
    ["290", "15", "258"],
    ["880", "62", "336"],
    ["230", "57", "890"],
    ["289", "94", "239"],
    ["277", "64", "130"],
    ["147", "27", "359"]
  ],
  "02/16/2026 to 02/22/2026": [
    ["470", "10", "389"],
    ["135", "90", "668"],
    ["158", "45", "249"],
    ["280", "09", "270"],
    ["568", "92", "138"],
    ["140", "57", "467"],
    ["680", "43", "300"]
  ],
  "02/23/2026 to 03/01/2026": [
    ["569", "02", "228"],
    ["147", "20", "145"],
    ["247", "37", "359"],
    ["167", "43", "346"],
    ["169", "62", "138"],
    ["235", "08", "369"],
    ["136", "06", "178"]
  ],
  "03/02/2026 to 03/08/2026": [
    ["224", "87", "160"],
    ["146", "14", "347"],
    ["***", "**", "***"],
    ["478", "90", "127"],
    ["448", "61", "236"],
    ["440", "88", "189"],
    ["348", "58", "468"]
  ],
  "03/09/2026 to 03/15/2026": [
    ["300", "33", "157"],
    ["278", "74", "158"],
    ["280", "07", "467"],
    ["567", "82", "129"],
    ["160", "75", "168"],
    ["234", "92", "138"],
    ["200", "24", "149"]
  ],
  "03/16/2026 to 03/22/2026": [
    ["122", "58", "134"],
    ["446", "41", "119"],
    ["136", "01", "119"],
    ["338", "45", "799"],
    ["258", "59", "234"],
    ["349", "65", "267"],
    ["149", "46", "790"]
  ]
};

export const MILANNIGHT = {
  "01/01/2024 to 01/07/2024": [
    ["230", "50", "280"],
    ["279", "88", "288"],
    ["459", "80", "488"],
    ["568", "96", "349"],
    ["150", "69", "270"],
    ["340", "79", "478"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["790", "61", "777"],
    ["299", "02", "480"],
    ["889", "50", "190"],
    ["349", "68", "468"],
    ["127", "02", "345"],
    ["156", "27", "250"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["890", "77", "188"],
    ["145", "08", "189"],
    ["369", "88", "440"],
    ["244", "01", "380"],
    ["890", "77", "458"],
    ["290", "18", "369"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["568", "91", "146"],
    ["169", "61", "380"],
    ["570", "28", "279"],
    ["123", "64", "149"],
    ["***", "**", "***"],
    ["789", "44", "789"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["137", "12", "480"],
    ["456", "50", "145"],
    ["226", "05", "456"],
    ["135", "99", "478"],
    ["550", "05", "357"],
    ["145", "04", "257"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["250", "70", "190"],
    ["180", "95", "159"],
    ["134", "87", "368"],
    ["134", "81", "245"],
    ["239", "41", "678"],
    ["249", "58", "189"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["149", "40", "578"],
    ["123", "66", "178"],
    ["158", "44", "149"],
    ["456", "52", "480"],
    ["118", "05", "230"],
    ["358", "62", "246"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["225", "97", "115"],
    ["156", "20", "479"],
    ["455", "40", "479"],
    ["235", "08", "666"],
    ["790", "67", "449"],
    ["670", "36", "358"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["460", "01", "155"],
    ["569", "05", "780"],
    ["699", "46", "178"],
    ["234", "94", "455"],
    ["129", "27", "250"],
    ["450", "92", "570"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["560", "17", "368"],
    ["449", "70", "280"],
    ["600", "63", "229"],
    ["248", "47", "890"],
    ["568", "95", "258"],
    ["237", "24", "699"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["678", "13", "166"],
    ["180", "98", "260"],
    ["370", "01", "579"],
    ["160", "78", "350"],
    ["159", "53", "670"],
    ["236", "19", "180"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["347", "44", "248"],
    ["578", "01", "245"],
    ["146", "12", "156"],
    ["399", "16", "240"],
    ["238", "34", "347"],
    ["240", "66", "349"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["157", "37", "340"],
    ["378", "84", "257"],
    ["670", "30", "569"],
    ["267", "57", "250"],
    ["257", "46", "358"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["169", "67", "269"],
    ["178", "62", "228"],
    ["689", "39", "270"],
    ["244", "04", "680"],
    ["689", "32", "138"],
    ["800", "88", "224"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["126", "91", "399"],
    ["160", "78", "567"],
    ["230", "51", "560"],
    ["280", "04", "347"],
    ["578", "06", "358"],
    ["139", "35", "168"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["455", "41", "137"],
    ["479", "03", "238"],
    ["467", "73", "490"],
    ["670", "39", "478"],
    ["779", "39", "360"],
    ["669", "10", "578"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["126", "90", "569"],
    ["179", "71", "560"],
    ["178", "69", "478"],
    ["148", "31", "669"],
    ["240", "65", "168"],
    ["146", "13", "148"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["278", "78", "459"],
    ["155", "19", "379"],
    ["256", "39", "900"],
    ["336", "29", "180"],
    ["235", "02", "129"],
    ["280", "09", "450"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["468", "82", "129"],
    ["400", "40", "244"],
    ["137", "17", "449"],
    ["239", "43", "247"],
    ["279", "89", "478"],
    ["478", "91", "137"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["445", "35", "140"],
    ["167", "43", "346"],
    ["167", "46", "880"],
    ["590", "42", "589"],
    ["350", "84", "158"],
    ["149", "47", "557"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["590", "40", "127"],
    ["246", "25", "690"],
    ["350", "86", "349"],
    ["249", "57", "160"],
    ["789", "43", "139"],
    ["249", "57", "250"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["380", "19", "478"],
    ["170", "89", "379"],
    ["157", "35", "230"],
    ["148", "32", "679"],
    ["269", "76", "268"],
    ["230", "59", "568"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["567", "85", "267"],
    ["358", "63", "148"],
    ["680", "43", "788"],
    ["148", "30", "280"],
    ["137", "15", "889"],
    ["557", "79", "360"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["349", "67", "340"],
    ["360", "95", "690"],
    ["236", "15", "230"],
    ["278", "72", "138"],
    ["369", "89", "135"],
    ["680", "48", "189"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["370", "01", "236"],
    ["668", "00", "190"],
    ["390", "22", "200"],
    ["170", "88", "567"],
    ["137", "13", "120"],
    ["266", "42", "778"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["569", "00", "578"],
    ["170", "86", "790"],
    ["779", "31", "588"],
    ["337", "33", "346"],
    ["126", "95", "113"],
    ["778", "23", "689"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["688", "25", "230"],
    ["358", "68", "279"],
    ["380", "14", "112"],
    ["660", "28", "558"],
    ["350", "88", "468"],
    ["559", "96", "268"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["358", "62", "156"],
    ["790", "62", "228"],
    ["179", "72", "147"],
    ["269", "76", "123"],
    ["140", "54", "239"],
    ["790", "68", "170"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["789", "48", "260"],
    ["239", "43", "256"],
    ["157", "36", "349"],
    ["347", "40", "677"],
    ["458", "72", "679"],
    ["226", "08", "125"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["459", "88", "369"],
    ["136", "06", "268"],
    ["236", "11", "678"],
    ["789", "41", "236"],
    ["450", "90", "190"],
    ["780", "55", "159"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["346", "39", "135"],
    ["579", "12", "390"],
    ["124", "70", "145"],
    ["120", "39", "469"],
    ["890", "73", "599"],
    ["458", "73", "689"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["124", "77", "269"],
    ["389", "09", "289"],
    ["123", "66", "600"],
    ["678", "13", "346"],
    ["679", "21", "290"],
    ["677", "07", "890"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["279", "84", "699"],
    ["246", "20", "668"],
    ["567", "89", "289"],
    ["***", "**", "***"],
    ["455", "41", "100"],
    ["115", "70", "280"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["599", "38", "350"],
    ["223", "77", "340"],
    ["125", "84", "149"],
    ["190", "03", "148"],
    ["345", "28", "468"],
    ["134", "86", "790"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["578", "04", "356"],
    ["180", "91", "137"],
    ["579", "15", "159"],
    ["230", "52", "679"],
    ["556", "68", "369"],
    ["248", "45", "357"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["129", "29", "379"],
    ["128", "10", "668"],
    ["680", "48", "477"],
    ["477", "88", "260"],
    ["267", "51", "579"],
    ["***", "**", "***"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["169", "61", "290"],
    ["340", "74", "130"],
    ["257", "49", "469"],
    ["459", "87", "340"],
    ["590", "49", "126"],
    ["160", "71", "380"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["600", "64", "680"],
    ["240", "65", "555"],
    ["690", "57", "269"],
    ["579", "11", "245"],
    ["246", "28", "378"],
    ["250", "71", "236"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["889", "55", "258"],
    ["167", "42", "688"],
    ["688", "23", "580"],
    ["700", "74", "680"],
    ["130", "42", "589"],
    ["458", "79", "469"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["457", "66", "240"],
    ["156", "23", "580"],
    ["128", "19", "469"],
    ["125", "80", "578"],
    ["148", "34", "257"],
    ["145", "05", "780"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["356", "43", "689"],
    ["240", "61", "236"],
    ["330", "61", "470"],
    ["347", "46", "114"],
    ["125", "88", "224"],
    ["179", "75", "690"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["179", "79", "270"],
    ["445", "35", "159"],
    ["679", "29", "360"],
    ["679", "21", "128"],
    ["460", "04", "248"],
    ["139", "31", "335"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["149", "49", "478"],
    ["259", "62", "570"],
    ["145", "02", "237"],
    ["268", "60", "280"],
    ["577", "90", "190"],
    ["145", "09", "289"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["389", "07", "467"],
    ["155", "16", "114"],
    ["890", "73", "256"],
    ["257", "48", "233"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["278", "73", "670"],
    ["390", "22", "778"],
    ["446", "45", "500"],
    ["259", "60", "226"],
    ["369", "89", "289"],
    ["340", "77", "458"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["170", "86", "880"],
    ["270", "92", "679"],
    ["230", "59", "450"],
    ["270", "94", "590"],
    ["478", "93", "256"],
    ["580", "35", "267"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["568", "92", "778"],
    ["349", "62", "237"],
    ["260", "89", "360"],
    ["558", "82", "237"],
    ["560", "18", "233"],
    ["490", "32", "390"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["267", "53", "689"],
    ["119", "12", "345"],
    ["235", "03", "247"],
    ["400", "41", "155"],
    ["348", "54", "266"],
    ["488", "04", "455"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["447", "53", "490"],
    ["118", "01", "489"],
    ["600", "68", "477"],
    ["578", "01", "119"],
    ["457", "66", "259"],
    ["679", "22", "246"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["490", "31", "227"],
    ["780", "55", "799"],
    ["126", "93", "157"],
    ["459", "84", "130"],
    ["237", "27", "890"],
    ["260", "87", "890"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["140", "58", "369"],
    ["125", "85", "267"],
    ["116", "82", "589"],
    ["147", "27", "890"],
    ["249", "55", "456"],
    ["356", "46", "358"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["345", "28", "134"],
    ["169", "69", "360"],
    ["199", "98", "233"],
    ["678", "19", "180"],
    ["130", "46", "150"],
    ["169", "68", "350"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["567", "81", "678"],
    ["479", "03", "247"],
    ["480", "24", "130"],
    ["169", "67", "359"],
    ["579", "19", "360"],
    ["490", "38", "369"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["480", "26", "880"],
    ["278", "72", "156"],
    ["127", "08", "468"],
    ["235", "07", "160"],
    ["260", "88", "189"],
    ["140", "56", "259"]
  ],
  "01/20/2025 To 01/26/2025": [
    ["489", "16", "367"],
    ["137", "19", "388"],
    ["179", "70", "460"],
    ["268", "66", "178"],
    ["258", "54", "446"],
    ["249", "53", "120"]
  ],
  "01/27/2025 To 02/02/2025": [
    ["569", "08", "134"],
    ["357", "54", "112"],
    ["179", "74", "770"],
    ["158", "43", "337"],
    ["378", "88", "279"],
    ["467", "73", "346"]
  ],
  "02/03/2025 To 02/09/2025": [
    ["177", "53", "120"],
    ["589", "28", "224"],
    ["110", "24", "266"],
    ["247", "35", "168"],
    ["389", "04", "347"],
    ["145", "09", "478"]
  ],
  "02/10/2025 To 02/16/2025": [
    ["235", "02", "246"],
    ["136", "08", "800"],
    ["366", "55", "267"],
    ["499", "29", "180"],
    ["234", "98", "350"],
    ["158", "45", "140"]
  ],
  "02/17/2025 To 02/23/2025": [
    ["116", "89", "234"],
    ["159", "57", "160"],
    ["260", "82", "570"],
    ["238", "36", "114"],
    ["358", "62", "110"],
    ["780", "52", "390"]
  ],
  "02/24/2025 To 03/02/2025": [
    ["370", "05", "447"],
    ["358", "63", "238"],
    ["556", "65", "230"],
    ["250", "79", "270"],
    ["388", "94", "699"],
    ["118", "03", "238"]
  ],
  "03/03/2025 To 03/09/2025": [
    ["126", "95", "456"],
    ["124", "70", "244"],
    ["330", "67", "890"],
    ["578", "09", "379"],
    ["237", "26", "600"],
    ["369", "89", "568"]
  ],
  "03/10/2025 To 03/16/2025": [
    ["467", "78", "459"],
    ["458", "78", "477"],
    ["379", "93", "346"],
    ["349", "69", "379"],
    ["***", "**", "***"],
    ["490", "31", "146"]
  ],
  "03/17/2025 To 03/23/2025": [
    ["467", "77", "269"],
    ["113", "51", "380"],
    ["558", "82", "156"],
    ["440", "89", "270"],
    ["456", "55", "456"],
    ["125", "85", "168"]
  ],
  "03/24/2025 To 03/30/2025": [
    ["299", "02", "345"],
    ["199", "90", "370"],
    ["112", "46", "349"],
    ["138", "21", "560"],
    ["345", "23", "139"],
    ["116", "88", "350"]
  ],
  "03/31/2025 To 04/06/2025": [
    ["247", "37", "179"],
    ["690", "51", "137"],
    ["337", "33", "247"],
    ["120", "37", "449"],
    ["200", "23", "247"],
    ["260", "84", "239"]
  ],
  "04/07/2025 To 04/13/2025": [
    ["280", "09", "234"],
    ["880", "65", "690"],
    ["457", "61", "380"],
    ["129", "25", "690"],
    ["880", "64", "158"],
    ["590", "45", "177"]
  ],
  "04/14/2025 To 04/20/2025": [
    ["369", "80", "334"],
    ["568", "93", "157"],
    ["160", "76", "268"],
    ["170", "87", "160"],
    ["244", "07", "160"],
    ["240", "62", "570"]
  ],
  "04/21/2025 To 04/27/2025": [
    ["145", "05", "168"],
    ["246", "28", "189"],
    ["680", "44", "167"],
    ["156", "27", "160"],
    ["235", "05", "690"],
    ["126", "94", "149"]
  ],
  "04/28/2025 To 05/04/2025": [
    ["239", "45", "177"],
    ["280", "05", "780"],
    ["158", "47", "133"],
    ["159", "51", "678"],
    ["668", "05", "140"],
    ["234", "96", "240"]
  ],
  "05/05/2025 To 05/11/2025": [
    ["259", "64", "266"],
    ["348", "57", "340"],
    ["357", "59", "379"],
    ["258", "56", "178"],
    ["279", "86", "880"],
    ["167", "44", "149"]
  ],
  "05/12/2025 To 05/18/2025": [
    ["467", "79", "270"],
    ["235", "06", "600"],
    ["179", "74", "239"],
    ["170", "82", "390"],
    ["678", "12", "345"],
    ["580", "32", "237"]
  ],
  "05/19/2025 To 05/25/2025": [
    ["589", "29", "199"],
    ["780", "56", "123"],
    ["267", "50", "145"],
    ["126", "95", "159"],
    ["116", "81", "155"],
    ["700", "77", "467"]
  ],
  "05/26/2025 To 06/01/2025": [
    ["128", "18", "477"],
    ["146", "17", "890"],
    ["460", "03", "599"],
    ["167", "41", "399"],
    ["558", "87", "250"],
    ["399", "13", "256"]
  ],
  "06/02/2025 To 06/08/2025": [
    ["224", "81", "470"],
    ["677", "06", "358"],
    ["123", "69", "900"],
    ["369", "86", "268"],
    ["150", "64", "220"],
    ["368", "71", "470"]
  ],
  "06/09/2025 To 06/15/2025": [
    ["169", "60", "479"],
    ["490", "37", "340"],
    ["235", "05", "780"],
    ["235", "03", "689"],
    ["177", "55", "258"],
    ["389", "02", "589"]
  ],
  "06/16/2025 To 06/22/2025": [
    ["499", "22", "688"],
    ["290", "13", "355"],
    ["570", "29", "360"],
    ["280", "01", "560"],
    ["177", "59", "379"],
    ["447", "56", "367"]
  ],
  "06/23/2025 To 06/29/2025": [
    ["250", "70", "299"],
    ["136", "09", "117"],
    ["279", "87", "278"],
    ["356", "40", "479"],
    ["560", "18", "170"],
    ["236", "10", "280"]
  ],
  "06/30/2025 To 07/06/2025": [
    ["245", "19", "559"],
    ["360", "98", "459"],
    ["356", "42", "129"],
    ["460", "09", "360"],
    ["560", "18", "468"],
    ["899", "68", "125"]
  ],
  "07/07/2025 To 07/13/2025": [
    ["679", "25", "159"],
    ["589", "24", "248"],
    ["400", "46", "457"],
    ["357", "57", "223"],
    ["470", "17", "278"],
    ["990", "85", "348"]
  ],
  "07/14/2025 To 07/20/2025": [
    ["224", "81", "678"],
    ["688", "24", "220"],
    ["278", "75", "140"],
    ["159", "58", "260"],
    ["335", "10", "460"],
    ["799", "56", "367"]
  ],
  "07/21/2025 To 07/27/2025": [
    ["269", "70", "136"],
    ["456", "52", "138"],
    ["234", "91", "560"],
    ["157", "38", "279"],
    ["348", "52", "480"],
    ["239", "42", "570"]
  ],
  "07/28/2025 To 08/03/2025": [
    ["460", "01", "236"],
    ["114", "69", "478"],
    ["460", "04", "167"],
    ["458", "71", "560"],
    ["688", "21", "146"],
    ["369", "80", "190"]
  ],
  "08/04/2025 To 08/10/2025": [
    ["289", "92", "246"],
    ["150", "68", "350"],
    ["379", "93", "490"],
    ["146", "11", "137"],
    ["337", "31", "137"],
    ["235", "08", "459"]
  ],
  "08/11/2025 To 08/17/2025": [
    ["456", "59", "667"],
    ["290", "11", "245"],
    ["235", "08", "468"],
    ["399", "18", "279"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "08/18/2025 To 08/24/2025": [
    ["117", "93", "355"],
    ["110", "25", "447"],
    ["280", "03", "256"],
    ["670", "35", "159"],
    ["579", "17", "458"],
    ["340", "74", "149"]
  ],
  "08/25/2025 To 08/31/2025": [
    ["448", "66", "899"],
    ["168", "50", "190"],
    ["***", "**", "***"],
    ["156", "21", "290"],
    ["440", "87", "124"],
    ["160", "79", "478"]
  ],
  "09/01/2025 To 09/07/2025": [
    ["169", "64", "356"],
    ["340", "74", "789"],
    ["138", "20", "127"],
    ["358", "60", "127"],
    ["112", "45", "159"],
    ["***", "**", "***"]
  ],
  "09/08/2025 To 09/14/2025": [
    ["579", "10", "127"],
    ["345", "28", "170"],
    ["137", "18", "170"],
    ["250", "71", "678"],
    ["369", "86", "899"],
    ["290", "19", "360"]
  ],
  "09/15/2025 To 09/21/2025": [
    ["257", "49", "559"],
    ["226", "07", "160"],
    ["890", "71", "470"],
    ["126", "96", "222"],
    ["178", "64", "248"],
    ["238", "37", "278"]
  ],
  "09/22/2025 To 09/28/2025": [
    ["880", "67", "223"],
    ["239", "44", "257"],
    ["689", "32", "246"],
    ["248", "40", "280"],
    ["130", "43", "689"],
    ["356", "44", "149"]
  ],
  "09/29/2025 To 10/05/2025": [
    ["255", "24", "455"],
    ["138", "27", "278"],
    ["455", "49", "667"],
    ["460", "09", "469"],
    ["688", "22", "138"],
    ["670", "32", "480"]
  ],
  "10/06/2025 To 10/12/2025": [
    ["200", "25", "780"],
    ["116", "89", "180"],
    ["490", "38", "468"],
    ["169", "69", "135"],
    ["137", "11", "380"],
    ["677", "05", "366"]
  ],
  "10/13/2025 To 10/19/2025": [
    ["145", "03", "490"],
    ["446", "43", "670"],
    ["267", "54", "400"],
    ["780", "56", "150"],
    ["355", "32", "156"],
    ["***", "**", "***"]
  ],
  "10/20/2025 To 10/26/2025": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "10/27/2025 To 11/02/2025": [
    ["340", "72", "660"],
    ["277", "68", "116"],
    ["200", "25", "799"],
    ["347", "42", "390"],
    ["135", "93", "779"],
    ["267", "59", "478"]
  ],
  "11/03/2025 To 11/09/2025": [
    ["230", "50", "334"],
    ["225", "92", "660"],
    ["558", "80", "370"],
    ["349", "67", "179"],
    ["446", "43", "490"],
    ["128", "16", "349"]
  ],
  "11/10/2025 To 11/16/2025": [
    ["336", "28", "666"],
    ["358", "65", "177"],
    ["788", "37", "340"],
    ["570", "22", "480"],
    ["139", "34", "680"],
    ["288", "84", "680"]
  ],
  "11/17/2025 To 11/23/2025": [
    ["899", "60", "677"],
    ["555", "55", "258"],
    ["258", "53", "490"],
    ["130", "40", "127"],
    ["389", "04", "257"],
    ["379", "97", "124"]
  ],
  "11/24/2025 To 11/30/2025": [
    ["189", "80", "389"],
    ["124", "70", "578"],
    ["299", "01", "236"],
    ["344", "17", "188"],
    ["277", "60", "578"],
    ["570", "25", "456"]
  ],
  "12/01/2025 To 12/07/2025": [
    ["123", "60", "127"],
    ["128", "13", "580"],
    ["457", "69", "180"],
    ["790", "63", "689"],
    ["159", "56", "790"],
    ["468", "88", "189"]
  ],
  "12/08/2025 To 12/14/2025": [
    ["123", "69", "450"],
    ["600", "66", "277"],
    ["148", "31", "380"],
    ["256", "31", "399"],
    ["226", "02", "138"],
    ["259", "69", "379"]
  ],
  "12/15/2025 To 12/21/2025": [
    ["255", "20", "244"],
    ["689", "30", "190"],
    ["136", "08", "260"],
    ["689", "38", "170"],
    ["456", "57", "250"],
    ["158", "40", "280"]
  ],
  "12/22/2025 To 12/28/2025": [
    ["699", "46", "259"],
    ["450", "93", "300"],
    ["469", "97", "368"],
    ["577", "97", "124"],
    ["579", "17", "467"],
    ["223", "75", "177"]
  ],
  "12/29/2025 To 01/04/2026": [
    ["130", "44", "446"],
    ["389", "06", "880"],
    ["449", "73", "689"],
    ["147", "29", "379"],
    ["678", "11", "236"],
    ["379", "98", "279"]
  ],
  "01/05/2026 To 01/11/2026": [
    ["166", "39", "450"],
    ["447", "52", "138"],
    ["225", "98", "440"],
    ["150", "63", "779"],
    ["357", "51", "380"],
    ["345", "24", "158"]
  ],
  "01/12/2026 To 01/18/2026": [
    ["890", "71", "669"],
    ["180", "94", "257"],
    ["129", "22", "589"],
    ["137", "16", "457"],
    ["246", "22", "390"],
    ["569", "01", "380"]
  ],
  "01/19/2026 To 01/25/2026": [
    ["169", "66", "466"],
    ["359", "77", "359"],
    ["127", "08", "990"],
    ["135", "94", "789"],
    ["180", "93", "445"],
    ["570", "21", "290"]
  ],
  "01/26/2026 To 02/01/2026": [
    ["***", "**", "***"],
    ["110", "27", "890"],
    ["466", "69", "234"],
    ["779", "31", "236"],
    ["135", "93", "256"],
    ["346", "37", "160"]
  ],
  "02/02/2026 To 02/08/2026": [
    ["788", "30", "244"],
    ["256", "38", "800"],
    ["334", "00", "127"],
    ["240", "66", "169"],
    ["458", "73", "580"],
    ["259", "60", "145"]
  ],
  "02/09/2026 To 02/15/2026": [
    ["270", "97", "467"],
    ["250", "72", "480"],
    ["570", "24", "356"],
    ["449", "70", "479"],
    ["137", "10", "280"],
    ["138", "26", "169"]
  ],
  "02/16/2026 To 02/22/2026": [
    ["689", "33", "490"],
    ["248", "45", "258"],
    ["167", "41", "137"],
    ["489", "13", "689"],
    ["230", "53", "139"],
    ["360", "94", "680"]
  ],
  "02/23/2026 To 03/01/2026": [
    ["155", "19", "469"],
    ["280", "06", "349"],
    ["689", "39", "199"],
    ["479", "02", "200"],
    ["590", "47", "179"],
    ["239", "47", "124"]
  ],
  "03/02/2026 To 03/08/2026": [
    ["466", "69", "126"],
    ["290", "11", "579"],
    ["***", "**", "***"],
    ["246", "25", "249"],
    ["570", "21", "335"],
    ["225", "95", "258"]
  ],
  "03/09/2026 To 03/15/2026": [
    ["580", "37", "368"],
    ["389", "06", "169"],
    ["179", "77", "458"],
    ["100", "16", "268"],
    ["117", "92", "147"],
    ["467", "77", "115"]
  ],
  "03/16/2026 To 03/22/2026": [
    ["359", "77", "890"],
    ["455", "43", "670"],
    ["150", "64", "248"],
    ["368", "78", "378"],
    ["248", "40", "578"],
    ["***", "**", "***"]
  ]
};

export const RAJDHANINIGHT = {
    "01/01/2024 to 01/07/2024": [
    ["138", "22", "499"],
    ["990", "86", "169"],
    ["170", "85", "357"],
    ["236", "18", "189"],
    ["589", "22", "660"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["699", "47", "368"],
    ["167", "41", "678"],
    ["399", "17", "458"],
    ["280", "09", "135"],
    ["255", "25", "500"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["234", "90", "235"],
    ["380", "12", "228"],
    ["235", "01", "344"],
    ["570", "21", "678"],
    ["348", "52", "679"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["120", "33", "256"],
    ["178", "64", "789"],
    ["166", "31", "579"],
    ["150", "68", "170"],
    ["***", "**", "***"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["779", "38", "170"],
    ["117", "95", "230"],
    ["589", "24", "789"],
    ["270", "90", "479"],
    ["259", "60", "299"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["340", "77", "359"],
    ["660", "22", "679"],
    ["567", "83", "670"],
    ["480", "28", "260"],
    ["359", "72", "129"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["389", "03", "580"],
    ["556", "60", "677"],
    ["120", "36", "880"],
    ["370", "07", "449"],
    ["347", "45", "357"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["123", "60", "460"],
    ["579", "11", "669"],
    ["349", "60", "226"],
    ["126", "91", "155"],
    ["179", "77", "467"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["346", "38", "459"],
    ["279", "84", "590"],
    ["490", "36", "367"],
    ["368", "79", "144"],
    ["469", "91", "137"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["458", "79", "270"],
    ["570", "23", "247"],
    ["800", "86", "600"],
    ["278", "74", "338"],
    ["170", "86", "556"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["150", "68", "260"],
    ["147", "25", "690"],
    ["567", "85", "258"],
    ["890", "79", "450"],
    ["470", "17", "179"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["133", "76", "358"],
    ["470", "13", "490"],
    ["247", "34", "239"],
    ["267", "56", "169"],
    ["889", "51", "579"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["128", "18", "116"],
    ["157", "31", "470"],
    ["170", "83", "120"],
    ["366", "55", "140"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["347", "48", "350"],
    ["236", "14", "400"],
    ["360", "91", "489"],
    ["223", "77", "458"],
    ["460", "09", "667"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["680", "43", "238"],
    ["167", "41", "380"],
    ["122", "54", "239"],
    ["136", "02", "345"],
    ["268", "63", "670"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["236", "16", "240"],
    ["338", "40", "280"],
    ["247", "32", "480"],
    ["170", "80", "145"],
    ["344", "13", "238"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["480", "28", "459"],
    ["290", "18", "189"],
    ["390", "29", "450"],
    ["446", "48", "279"],
    ["334", "05", "267"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["246", "21", "245"],
    ["248", "49", "360"],
    ["560", "14", "446"],
    ["140", "56", "466"],
    ["168", "52", "156"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["370", "05", "230"],
    ["149", "46", "178"],
    ["577", "96", "349"],
    ["245", "18", "134"],
    ["169", "64", "266"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["130", "42", "570"],
    ["177", "50", "127"],
    ["125", "80", "190"],
    ["389", "08", "558"],
    ["147", "20", "280"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["789", "40", "136"],
    ["499", "21", "489"],
    ["480", "25", "140"],
    ["679", "27", "278"],
    ["466", "63", "247"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["235", "08", "125"],
    ["267", "51", "579"],
    ["134", "87", "278"],
    ["122", "57", "467"],
    ["459", "81", "227"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["179", "72", "138"],
    ["390", "20", "370"],
    ["780", "53", "670"],
    ["455", "41", "137"],
    ["168", "55", "267"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["680", "41", "579"],
    ["230", "58", "477"],
    ["234", "97", "269"],
    ["277", "66", "169"],
    ["257", "47", "359"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["270", "99", "289"],
    ["134", "85", "348"],
    ["479", "01", "227"],
    ["370", "08", "279"],
    ["490", "39", "469"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["688", "25", "249"],
    ["900", "93", "580"],
    ["366", "57", "250"],
    ["579", "13", "300"],
    ["480", "23", "670"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["256", "37", "188"],
    ["240", "67", "890"],
    ["290", "11", "678"],
    ["457", "61", "579"],
    ["359", "78", "369"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["470", "12", "228"],
    ["568", "98", "440"],
    ["467", "77", "890"],
    ["778", "23", "490"],
    ["247", "33", "256"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["160", "77", "278"],
    ["445", "38", "134"],
    ["590", "49", "478"],
    ["480", "27", "340"],
    ["588", "17", "890"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["134", "81", "579"],
    ["279", "82", "138"],
    ["690", "51", "489"],
    ["400", "45", "140"],
    ["379", "98", "369"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["445", "39", "289"],
    ["247", "34", "446"],
    ["230", "58", "990"],
    ["236", "12", "246"],
    ["238", "31", "579"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["360", "91", "100"],
    ["669", "12", "589"],
    ["280", "08", "134"],
    ["590", "45", "339"],
    ["123", "67", "359"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["150", "67", "890"],
    ["589", "27", "269"],
    ["226", "03", "166"],
    ["***", "**", "***"],
    ["290", "16", "349"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["235", "06", "367"],
    ["557", "71", "236"],
    ["460", "06", "880"],
    ["550", "01", "380"],
    ["580", "39", "126"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["125", "82", "589"],
    ["140", "53", "445"],
    ["233", "80", "479"],
    ["157", "33", "580"],
    ["133", "75", "140"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["280", "05", "690"],
    ["225", "98", "233"],
    ["467", "77", "160"],
    ["600", "68", "116"],
    ["158", "42", "570"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["800", "83", "157"],
    ["459", "84", "789"],
    ["460", "07", "359"],
    ["356", "48", "189"],
    ["334", "04", "130"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["134", "80", "569"],
    ["347", "41", "560"],
    ["789", "46", "178"],
    ["169", "67", "160"],
    ["235", "08", "350"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["160", "79", "478"],
    ["140", "57", "458"],
    ["568", "90", "578"],
    ["127", "00", "226"],
    ["112", "49", "360"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["680", "42", "679"],
    ["146", "13", "247"],
    ["177", "56", "259"],
    ["488", "08", "260"],
    ["266", "47", "557"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["238", "39", "270"],
    ["250", "70", "578"],
    ["189", "84", "167"],
    ["146", "10", "479"],
    ["899", "67", "179"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["100", "11", "344"],
    ["235", "04", "257"],
    ["158", "45", "690"],
    ["460", "01", "489"],
    ["580", "33", "166"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["130", "43", "490"],
    ["699", "42", "778"],
    ["589", "21", "335"],
    ["138", "29", "126"],
    ["560", "18", "990"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["560", "11", "245"],
    ["225", "95", "140"],
    ["180", "94", "149"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["690", "58", "800"],
    ["239", "44", "455"],
    ["890", "72", "138"],
    ["490", "30", "145"],
    ["580", "31", "128"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["199", "99", "117"],
    ["370", "02", "147"],
    ["133", "79", "126"],
    ["246", "27", "368"],
    ["349", "60", "299"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["339", "50", "569"],
    ["130", "45", "357"],
    ["400", "44", "680"],
    ["133", "75", "366"],
    ["789", "49", "234"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["690", "50", "136"],
    ["156", "22", "390"],
    ["560", "16", "277"],
    ["116", "82", "237"],
    ["346", "36", "349"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["370", "03", "166"],
    ["249", "52", "570"],
    ["348", "58", "468"],
    ["256", "30", "569"],
    ["299", "08", "189"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["456", "52", "679"],
    ["157", "31", "380"],
    ["990", "89", "469"],
    ["115", "77", "458"],
    ["269", "76", "259"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["567", "83", "779"],
    ["780", "54", "789"],
    ["468", "89", "450"],
    ["469", "92", "156"],
    ["660", "24", "338"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["147", "22", "345"],
    ["590", "40", "136"],
    ["790", "60", "479"],
    ["489", "13", "247"],
    ["267", "54", "680"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["155", "16", "178"],
    ["578", "00", "190"],
    ["448", "62", "345"],
    ["280", "04", "257"],
    ["245", "19", "234"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["249", "58", "567"],
    ["355", "32", "570"],
    ["339", "53", "238"],
    ["123", "68", "558"],
    ["480", "27", "160"]
  ],
  "01/20/2025 to 01/26/2025": [
    ["129", "23", "689"],
    ["489", "11", "579"],
    ["128", "16", "457"],
    ["469", "98", "378"],
    ["337", "34", "158"]
  ],
"01/27/2025 to 02/02/2025": [
  ["356", "47", "467"],
  ["128", "17", "160"],
  ["588", "15", "456"],
  ["137", "19", "234"],
  ["267", "57", "179"]
],
"02/03/2025 to 02/09/2025": [
  ["456", "55", "889"],
  ["278", "79", "270"],
  ["100", "15", "348"],
  ["239", "43", "580"],
  ["569", "08", "224"]
],
"02/10/2025 to 02/16/2025": [
  ["690", "51", "245"],
  ["379", "93", "355"],
  ["380", "15", "113"],
  ["138", "27", "359"],
  ["880", "64", "248"]
],
"02/17/2025 to 02/23/2025": [
  ["160", "76", "277"],
  ["123", "65", "230"],
  ["557", "74", "356"],
  ["134", "87", "124"],
  ["455", "45", "780"]
],
"02/24/2025 to 03/02/2025": [
  ["357", "58", "233"],
  ["134", "85", "249"],
  ["118", "06", "123"],
  ["145", "04", "770"],
  ["379", "97", "250"]
],
"03/03/2025 to 03/09/2025": [
  ["269", "79", "180"],
  ["137", "11", "236"],
  ["499", "21", "560"],
  ["269", "76", "169"],
  ["280", "00", "370"]
],
"03/10/2025 to 03/16/2025": [
  ["348", "52", "156"],
  ["400", "48", "468"],
  ["147", "25", "456"],
  ["158", "41", "335"],
  ["***", "**", "***"]
],
"03/17/2025 to 03/23/2025": [
  ["156", "28", "116"],
  ["400", "44", "590"],
  ["690", "55", "348"],
  ["225", "96", "240"],
  ["450", "94", "239"]
],
"03/24/2025 to 03/30/2025": [
  ["140", "57", "188"],
  ["120", "36", "457"],
  ["570", "21", "399"],
  ["147", "28", "369"],
  ["227", "17", "359"]
],
"03/31/2025 to 04/06/2025": [
  ["770", "40", "578"],
  ["467", "70", "280"],
  ["235", "02", "156"],
  ["277", "68", "170"],
  ["258", "53", "337"]
],
"04/07/2025 to 04/13/2025": [
  ["147", "27", "179"],
  ["330", "62", "499"],
  ["459", "81", "380"],
  ["236", "17", "340"],
  ["369", "83", "148"]
],
"04/14/2025 to 04/20/2025": [
  ["115", "72", "129"],
  ["269", "71", "236"],
  ["170", "82", "156"],
  ["445", "39", "270"],
  ["590", "46", "349"]
],
"04/21/2025 to 04/27/2025": [
  ["122", "54", "158"],
  ["134", "86", "899"],
  ["458", "77", "188"],
  ["890", "74", "248"],
  ["257", "44", "239"]
],
"04/28/2025 to 05/04/2025": [
  ["238", "37", "269"],
  ["169", "62", "246"],
  ["346", "38", "800"],
  ["147", "22", "110"],
  ["128", "13", "120"]
],
"05/05/2025 to 05/11/2025": [
  ["360", "91", "236"],
  ["348", "51", "128"],
  ["445", "34", "167"],
  ["248", "48", "260"],
  ["344", "10", "127"]
],
"05/12/2025 to 05/18/2025": [
  ["257", "48", "233"],
  ["279", "84", "770"],
  ["270", "98", "440"],
  ["490", "35", "690"],
  ["278", "71", "678"]
],
"05/19/2025 to 05/25/2025": [
  ["299", "04", "149"],
  ["246", "29", "478"],
  ["448", "63", "689"],
  ["469", "96", "240"],
  ["299", "03", "247"]
],
"05/26/2025 to 06/01/2025": [
  ["127", "08", "990"],
  ["133", "74", "248"],
  ["460", "08", "125"],
  ["468", "86", "457"],
  ["689", "37", "557"]
],
"06/02/2025 to 06/08/2025": [
  ["467", "76", "277"],
  ["100", "14", "167"],
  ["588", "10", "479"],
  ["489", "13", "580"],
  ["237", "21", "399"]
],
"06/09/2025 to 06/15/2025": [
  ["170", "89", "667"],
  ["125", "87", "250"],
  ["560", "16", "259"],
  ["356", "47", "133"],
  ["680", "46", "150"]
],
"06/16/2025 to 06/22/2025": [
  ["334", "07", "467"],
  ["489", "10", "389"],
  ["267", "52", "255"],
  ["169", "60", "190"],
  ["100", "13", "670"]
],
"06/23/2025 to 06/29/2025": [
  ["400", "41", "579"],
  ["130", "45", "159"],
  ["470", "18", "567"],
  ["679", "29", "667"],
  ["578", "04", "239"]
],
"06/30/2025 to 07/06/2025": [
  ["568", "98", "468"],
  ["680", "43", "788"],
  ["246", "25", "357"],
  ["669", "10", "460"],
  ["279", "87", "160"]
],
"07/07/2025 to 07/13/2025": [
  ["124", "73", "580"],
  ["889", "59", "559"],
  ["137", "19", "478"],
  ["167", "46", "268"],
  ["558", "86", "150"]
],
"07/14/2025 to 07/20/2025": [
  ["138", "28", "378"],
  ["477", "83", "238"],
  ["368", "76", "150"],
  ["246", "23", "139"],
  ["359", "71", "344"]
],
"07/21/2025 to 07/27/2025": [
  ["566", "77", "223"],
  ["590", "40", "244"],
  ["155", "16", "169"],
  ["369", "83", "247"],
  ["235", "00", "370"]
],
"07/28/2025 to 08/03/2025": [
  ["347", "48", "378"],
  ["229", "31", "155"],
  ["490", "34", "446"],
  ["789", "41", "489"],
  ["560", "14", "266"]
],
"08/04/2025 to 08/10/2025": [
  ["336", "20", "127"],
  ["370", "04", "149"],
  ["136", "09", "900"],
  ["380", "16", "114"],
  ["167", "45", "447"]
],
"08/11/2025 to 08/17/2025": [
  ["123", "60", "226"],
  ["456", "55", "168"],
  ["250", "73", "346"],
  ["113", "58", "990"],
  ["***", "**", "***"]
],
"08/18/2025 to 08/24/2025": [
  ["900", "92", "390"],
  ["579", "13", "670"],
  ["240", "64", "239"],
  ["380", "15", "168"],
  ["677", "07", "269"]
],
"08/25/2025 to 08/31/2025": [
  ["260", "89", "450"],
  ["122", "50", "244"],
  ["489", "12", "499"],
  ["250", "74", "347"],
  ["478", "91", "588"]
],
"09/01/2025 to 09/07/2025": [
  ["466", "65", "799"],
  ["200", "20", "370"],
  ["169", "69", "379"],
  ["228", "20", "389"],
  ["367", "65", "267"]
],
"09/08/2025 to 09/14/2025": [
  ["129", "26", "150"],
  ["357", "59", "144"],
  ["226", "02", "237"],
  ["390", "25", "258"],
  ["235", "07", "269"]
],
"09/15/2025 to 09/21/2025": [
  ["177", "51", "245"],
  ["590", "47", "278"],
  ["179", "76", "358"],
  ["667", "98", "134"],
  ["110", "20", "389"]
],
"09/22/2025 to 09/28/2025": [
  ["140", "50", "299"],
  ["456", "58", "170"],
  ["356", "42", "570"],
  ["468", "81", "579"],
  ["780", "52", "589"]
],
"09/29/2025 to 10/05/2025": [
  ["267", "57", "278"],
  ["459", "83", "490"],
  ["899", "62", "246"],
  ["244", "05", "456"],
  ["779", "39", "126"]
],
"10/06/2025 to 10/12/2025": [
  ["890", "71", "678"],
  ["160", "71", "470"],
  ["457", "61", "236"],
  ["569", "09", "270"],
  ["690", "58", "459"]
],
"10/13/2025 to 10/19/2025": [
  ["157", "38", "468"],
  ["688", "20", "136"],
  ["358", "64", "248"],
  ["500", "54", "266"],
  ["125", "85", "168"]
],
"10/20/2025 to 10/26/2025": [
  ["***", "**", "***"],
  ["***", "**", "***"],
  ["***", "**", "***"],
  ["***", "**", "***"],
  ["***", "**", "***"]
],
"10/27/2025 to 11/02/2025": [
  ["190", "06", "150"],
  ["457", "64", "167"],
  ["247", "36", "330"],
  ["490", "32", "156"],
  ["130", "48", "170"]
],
"11/03/2025 to 11/09/2025": [
  ["127", "04", "266"],
  ["259", "63", "256"],
  ["799", "52", "679"],
  ["244", "00", "389"],
  ["490", "32", "138"]
],
"11/10/2025 to 11/16/2025": [
  ["356", "40", "479"],
  ["900", "92", "237"],
  ["279", "89", "667"],
  ["350", "81", "137"],
  ["579", "10", "280"]
],
"11/17/2025 to 11/23/2025": [
  ["156", "29", "135"],
  ["190", "05", "799"],
  ["460", "03", "490"],
  ["233", "87", "269"],
  ["149", "43", "256"]
],
"11/24/2025 to 11/30/2025": [
  ["335", "19", "900"],
  ["689", "35", "690"],
  ["247", "38", "800"],
  ["120", "36", "150"],
  ["116", "81", "678"]
],
"12/01/2025 to 12/07/2025": [
  ["688", "20", "488"],
  ["460", "00", "145"],
  ["128", "17", "223"],
  ["168", "57", "377"],
  ["239", "45", "177"]
],
"12/08/2025 to 12/14/2025": [
  ["239", "42", "147"],
  ["469", "92", "138"],
  ["130", "43", "300"],
  ["889", "57", "179"],
  ["110", "22", "480"]
],
"12/15/2025 to 12/21/2025": [
  ["120", "37", "359"],
  ["233", "86", "169"],
  ["237", "27", "557"],
  ["378", "80", "578"],
  ["134", "85", "500"]
],
"12/22/2025 to 12/28/2025": [
  ["220", "41", "470"],
  ["160", "76", "466"],
  ["600", "67", "449"],
  ["680", "47", "340"],
  ["336", "27", "368"]
],
"12/29/2025 to 01/04/2026": [
  ["259", "63", "599"],
  ["340", "75", "348"],
  ["250", "71", "344"],
  ["136", "05", "140"],
  ["123", "64", "699"]
],
"01/05/2026 to 01/11/2026": [
  ["477", "86", "178"],
  ["458", "73", "580"],
  ["355", "34", "338"],
  ["239", "46", "259"],
  ["123", "67", "188"]
],
"01/12/2026 to 01/18/2026": [
  ["490", "33", "148"],
  ["190", "09", "126"],
  ["479", "08", "468"],
  ["116", "84", "770"],
  ["358", "62", "147"]
],
"01/19/2026 to 01/25/2026": [
  ["148", "35", "258"],
  ["125", "86", "169"],
  ["336", "20", "136"],
  ["199", "96", "330"],
  ["258", "59", "559"]
],
"01/26/2026 to 02/01/2026": [
  ["***", "**", "***"],
  ["120", "30", "118"],
  ["679", "23", "346"],
  ["134", "83", "247"],
  ["249", "52", "138"]
],
"02/02/2026 to 02/08/2026": [
  ["129", "28", "170"],
  ["249", "55", "780"],
  ["570", "20", "677"],
  ["377", "73", "247"],
  ["134", "87", "458"]
],
"02/09/2026 to 02/15/2026": [
  ["378", "82", "778"],
  ["126", "93", "157"],
  ["679", "22", "570"],
  ["139", "34", "400"],
  ["689", "30", "145"]
],
"02/16/2026 to 02/22/2026": [
  ["347", "46", "358"],
  ["156", "29", "568"],
  ["779", "38", "233"],
  ["126", "92", "246"],
  ["123", "65", "456"]
],
"02/23/2026 to 03/01/2026": [
  ["250", "76", "457"],
  ["229", "39", "469"],
  ["266", "48", "170"],
  ["168", "53", "580"],
  ["145", "09", "568"]
],
"03/02/2026 to 03/08/2026": [
  ["130", "47", "269"],
  ["244", "03", "247"],
  ["***", "**", "***"],
  ["257", "48", "279"],
  ["466", "65", "249"]
],
"03/09/2026 to 03/15/2026": [
  ["236", "16", "240"],
  ["168", "56", "880"],
  ["578", "05", "889"],
  ["248", "43", "148"],
  ["334", "09", "135"]
],
"03/16/2026 to 03/22/2026": [
  ["456", "56", "899"],
  ["200", "21", "380"],
  ["460", "02", "499"],
  ["127", "02", "138"],
  ["670", "38", "378"]
]

};

export const MAINBAZAR = {
  "01/01/2024 to 01/07/2024": [
    ["170", "81", "137"],
    ["279", "85", "159"],
    ["237", "25", "159"],
    ["440", "82", "688"],
    ["670", "34", "338"]
  ],
  "01/08/2024 to 01/14/2024": [
    ["279", "85", "500"],
    ["390", "21", "560"],
    ["235", "02", "237"],
    ["667", "90", "460"],
    ["345", "23", "238"]
  ],
  "01/15/2024 to 01/21/2024": [
    ["789", "45", "267"],
    ["245", "11", "470"],
    ["124", "78", "170"],
    ["570", "25", "555"],
    ["133", "74", "167"]
  ],
  "01/22/2024 to 01/28/2024": [
    ["990", "89", "469"],
    ["338", "47", "368"],
    ["118", "04", "446"],
    ["236", "16", "358"],
    ["***", "**", "***"]
  ],
  "01/29/2024 to 02/04/2024": [
    ["249", "58", "233"],
    ["223", "70", "280"],
    ["357", "55", "159"],
    ["125", "87", "359"],
    ["160", "72", "129"]
  ],
  "02/05/2024 to 02/11/2024": [
    ["589", "28", "477"],
    ["469", "99", "469"],
    ["467", "72", "570"],
    ["460", "01", "380"],
    ["123", "65", "357"]
  ],
  "02/12/2024 to 02/18/2024": [
    ["668", "04", "338"],
    ["890", "77", "133"],
    ["348", "55", "140"],
    ["456", "52", "336"],
    ["124", "77", "223"]
  ],
  "02/19/2024 to 02/25/2024": [
    ["160", "70", "145"],
    ["126", "96", "150"],
    ["267", "54", "400"],
    ["180", "94", "167"],
    ["489", "14", "356"]
  ],
  "02/26/2024 to 03/03/2024": [
    ["249", "50", "190"],
    ["460", "04", "257"],
    ["259", "68", "288"],
    ["550", "03", "670"],
    ["456", "55", "168"]
  ],
  "03/04/2024 to 03/10/2024": [
    ["355", "31", "399"],
    ["459", "88", "279"],
    ["237", "20", "280"],
    ["290", "11", "344"],
    ["800", "82", "246"]
  ],
  "03/11/2024 to 03/17/2024": [
    ["588", "15", "230"],
    ["245", "15", "690"],
    ["700", "71", "669"],
    ["135", "90", "389"],
    ["680", "41", "335"]
  ],
  "03/18/2024 to 03/24/2024": [
    ["144", "98", "288"],
    ["356", "42", "228"],
    ["457", "63", "599"],
    ["269", "71", "470"],
    ["578", "02", "156"]
  ],
  "03/25/2024 to 03/31/2024": [
    ["***", "**", "***"],
    ["470", "12", "589"],
    ["890", "71", "560"],
    ["369", "84", "770"],
    ["460", "08", "378"]
  ],
  "04/01/2024 to 04/07/2024": [
    ["123", "67", "377"],
    ["889", "54", "680"],
    ["124", "71", "560"],
    ["190", "03", "256"],
    ["147", "22", "688"]
  ],
  "04/08/2024 to 04/14/2024": [
    ["169", "61", "489"],
    ["144", "97", "340"],
    ["355", "38", "189"],
    ["578", "01", "489"],
    ["250", "79", "289"]
  ],
  "04/15/2024 to 04/21/2024": [
    ["790", "63", "670"],
    ["559", "90", "136"],
    ["116", "85", "249"],
    ["240", "64", "590"],
    ["799", "58", "189"]
  ],
  "04/22/2024 to 04/28/2024": [
    ["267", "55", "456"],
    ["347", "44", "257"],
    ["489", "11", "470"],
    ["233", "87", "160"],
    ["344", "14", "257"]
  ],
  "04/29/2024 to 05/05/2024": [
    ["245", "11", "236"],
    ["358", "66", "178"],
    ["356", "40", "569"],
    ["347", "44", "130"],
    ["167", "40", "488"]
  ],
  "05/06/2024 to 05/12/2024": [
    ["349", "67", "269"],
    ["688", "20", "280"],
    ["670", "32", "200"],
    ["189", "86", "268"],
    ["358", "67", "359"]
  ],
  "05/13/2024 to 05/19/2024": [
    ["136", "03", "148"],
    ["117", "98", "260"],
    ["125", "80", "127"],
    ["345", "20", "127"],
    ["138", "29", "469"]
  ],
  "05/20/2024 to 05/26/2024": [
    ["159", "54", "789"],
    ["189", "81", "236"],
    ["145", "04", "680"],
    ["270", "97", "368"],
    ["347", "46", "330"]
  ],
  "05/27/2024 to 06/02/2024": [
    ["490", "39", "559"],
    ["346", "36", "240"],
    ["447", "58", "233"],
    ["139", "32", "156"],
    ["359", "74", "789"]
  ],
  "06/03/2024 to 06/09/2024": [
    ["335", "19", "234"],
    ["466", "67", "458"],
    ["277", "68", "224"],
    ["238", "32", "200"],
    ["330", "65", "348"]
  ],
  "06/10/2024 to 06/16/2024": [
    ["257", "46", "178"],
    ["246", "25", "230"],
    ["469", "91", "579"],
    ["230", "51", "335"],
    ["129", "22", "138"]
  ],
  "06/17/2024 to 06/23/2024": [
    ["445", "35", "159"],
    ["146", "13", "247"],
    ["236", "11", "560"],
    ["380", "18", "369"],
    ["367", "65", "690"]
  ],
  "06/24/2024 to 06/30/2024": [
    ["590", "48", "369"],
    ["270", "93", "445"],
    ["780", "52", "589"],
    ["144", "97", "458"],
    ["144", "97", "700"]
  ],
  "07/01/2024 to 07/07/2024": [
    ["148", "32", "200"],
    ["159", "50", "578"],
    ["356", "47", "179"],
    ["369", "89", "568"],
    ["245", "12", "138"]
  ],
  "07/08/2024 to 07/14/2024": [
    ["389", "09", "469"],
    ["270", "96", "150"],
    ["228", "25", "366"],
    ["579", "13", "490"],
    ["279", "81", "146"]
  ],
  "07/15/2024 to 07/21/2024": [
    ["459", "82", "156"],
    ["150", "67", "179"],
    ["360", "95", "267"],
    ["169", "68", "170"],
    ["789", "44", "248"]
  ],
  "07/22/2024 to 07/28/2024": [
    ["770", "40", "136"],
    ["356", "45", "267"],
    ["130", "40", "370"],
    ["125", "82", "778"],
    ["588", "13", "148"]
  ],
  "07/29/2024 to 08/04/2024": [
    ["289", "94", "680"],
    ["590", "43", "166"],
    ["248", "42", "688"],
    ["147", "23", "139"],
    ["146", "12", "336"]
  ],
  "08/05/2024 to 08/11/2024": [
    ["579", "14", "220"],
    ["256", "30", "136"],
    ["226", "06", "277"],
    ["247", "35", "113"],
    ["780", "52", "679"]
  ],
  "08/12/2024 to 08/18/2024": [
    ["488", "04", "356"],
    ["579", "11", "380"],
    ["578", "07", "700"],
    ["***", "**", "***"],
    ["468", "84", "680"]
  ],
  "08/19/2024 to 08/25/2024": [
    ["135", "91", "236"],
    ["500", "57", "449"],
    ["459", "81", "290"],
    ["247", "30", "488"],
    ["177", "58", "459"]
  ],
  "08/26/2024 to 09/01/2024": [
    ["180", "93", "670"],
    ["449", "72", "156"],
    ["556", "60", "389"],
    ["690", "59", "199"],
    ["299", "06", "349"]
  ],
  "09/02/2024 to 09/08/2024": [
    ["113", "56", "880"],
    ["669", "11", "245"],
    ["560", "13", "238"],
    ["145", "09", "667"],
    ["679", "20", "389"]
  ],
  "09/09/2024 to 09/15/2024": [
    ["350", "88", "459"],
    ["140", "58", "170"],
    ["160", "77", "160"],
    ["480", "23", "247"],
    ["245", "13", "229"]
  ],
  "09/16/2024 to 09/22/2024": [
    ["680", "40", "190"],
    ["778", "26", "790"],
    ["467", "73", "238"],
    ["335", "16", "277"],
    ["446", "48", "369"]
  ],
  "09/23/2024 to 09/29/2024": [
    ["249", "59", "289"],
    ["337", "37", "269"],
    ["256", "38", "459"],
    ["369", "82", "138"],
    ["189", "87", "124"]
  ],
  "09/30/2024 to 10/06/2024": [
    ["347", "43", "157"],
    ["400", "49", "289"],
    ["268", "67", "278"],
    ["239", "47", "124"],
    ["268", "62", "138"]
  ],
  "10/07/2024 to 10/13/2024": [
    ["677", "05", "140"],
    ["188", "75", "799"],
    ["579", "15", "230"],
    ["130", "48", "350"],
    ["339", "58", "233"]
  ],
  "10/14/2024 to 10/20/2024": [
    ["125", "80", "299"],
    ["157", "39", "135"],
    ["178", "66", "349"],
    ["135", "96", "178"],
    ["290", "12", "679"]
  ],
  "10/21/2024 to 10/27/2024": [
    ["800", "89", "568"],
    ["138", "20", "118"],
    ["179", "73", "599"],
    ["680", "41", "227"],
    ["478", "99", "135"]
  ],
  "10/28/2024 to 11/03/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["***", "**", "***"]
  ],
  "11/04/2024 to 11/10/2024": [
    ["***", "**", "***"],
    ["***", "**", "***"],
    ["278", "72", "390"],
    ["299", "06", "123"],
    ["179", "70", "280"]
  ],
  "11/11/2024 to 11/17/2024": [
    ["117", "95", "799"],
    ["679", "23", "166"],
    ["190", "08", "134"],
    ["880", "62", "129"],
    ["157", "36", "600"]
  ],
  "11/18/2024 to 11/24/2024": [
    ["589", "23", "148"],
    ["148", "36", "123"],
    ["129", "23", "490"],
    ["889", "59", "144"],
    ["448", "67", "124"]
  ],
  "11/25/2024 to 12/01/2024": [
    ["246", "21", "290"],
    ["136", "05", "113"],
    ["139", "34", "239"],
    ["168", "54", "257"],
    ["599", "36", "457"]
  ],
  "12/02/2024 to 12/08/2024": [
    ["689", "38", "558"],
    ["144", "98", "990"],
    ["138", "27", "269"],
    ["345", "27", "458"],
    ["249", "52", "147"]
  ],
  "12/09/2024 to 12/15/2024": [
    ["448", "60", "190"],
    ["279", "85", "230"],
    ["345", "24", "257"],
    ["123", "67", "269"],
    ["250", "72", "444"]
  ],
  "12/16/2024 to 12/22/2024": [
    ["290", "16", "259"],
    ["460", "00", "136"],
    ["260", "81", "146"],
    ["125", "83", "256"],
    ["236", "16", "268"]
  ],
  "12/23/2024 to 12/29/2024": [
    ["670", "38", "189"],
    ["477", "86", "556"],
    ["267", "53", "490"],
    ["699", "45", "799"],
    ["390", "24", "789"]
  ],
  "12/30/2024 to 01/05/2025": [
    ["190", "06", "123"],
    ["277", "69", "117"],
    ["134", "80", "550"],
    ["689", "36", "556"],
    ["260", "81", "470"]
  ],
  "01/06/2025 to 01/12/2025": [
    ["780", "55", "230"],
    ["470", "16", "268"],
    ["155", "14", "130"],
    ["560", "12", "679"],
    ["480", "20", "145"]
  ],
  "01/13/2025 to 01/19/2025": [
    ["380", "12", "138"],
    ["690", "51", "236"],
    ["129", "21", "146"],
    ["380", "10", "578"],
    ["149", "49", "333"]
  ],
"01/20/2025 to 01/26/2025": [
  ["690", "55", "177"],
  ["226", "04", "266"],
  ["679", "28", "369"],
  ["900", "91", "146"],
  ["156", "20", "479"]
],
"01/27/2025 to 02/02/2025": [
  ["358", "66", "457"],
  ["469", "96", "448"],
  ["480", "28", "279"],
  ["337", "33", "120"],
  ["157", "33", "689"]
],
"02/03/2025 to 02/09/2025": [
  ["367", "68", "189"],
  ["589", "26", "556"],
  ["270", "96", "790"],
  ["880", "64", "239"],
  ["115", "78", "134"]
],
"02/10/2025 to 02/16/2025": [
  ["269", "70", "280"],
  ["239", "46", "448"],
  ["158", "46", "358"],
  ["148", "35", "780"],
  ["128", "10", "479"]
],
"02/17/2025 to 02/23/2025": [
  ["156", "29", "388"],
  ["250", "71", "290"],
  ["479", "05", "456"],
  ["249", "59", "225"],
  ["890", "76", "150"]
],
"02/24/2025 to 03/02/2025": [
  ["360", "99", "379"],
  ["344", "14", "130"],
  ["568", "97", "458"],
  ["336", "29", "126"],
  ["367", "65", "113"]
],
"03/03/2025 to 03/09/2025": [
  ["477", "80", "677"],
  ["900", "99", "568"],
  ["580", "33", "238"],
  ["456", "57", "458"],
  ["336", "27", "124"]
],
"03/10/2025 to 03/16/2025": [
  ["360", "96", "277"],
  ["128", "16", "268"],
  ["337", "35", "348"],
  ["166", "37", "467"],
  ["***", "**", "***"]
],
"03/17/2025 to 03/23/2025": [
  ["369", "89", "135"],
  ["236", "16", "790"],
  ["334", "03", "139"],
  ["347", "44", "590"],
  ["124", "76", "367"]
],
"03/24/2025 to 03/30/2025": [
  ["790", "69", "180"],
  ["457", "67", "890"],
  ["577", "93", "599"],
  ["277", "60", "145"],
  ["580", "39", "126"]
],
"03/31/2025 to 04/06/2025": [
  ["780", "50", "244"],
  ["190", "07", "449"],
  ["128", "16", "240"],
  ["589", "27", "115"],
  ["134", "82", "499"]
],
"04/07/2025 to 04/13/2025": [
  ["339", "53", "670"],
  ["115", "70", "244"],
  ["258", "50", "145"],
  ["457", "68", "459"],
  ["589", "23", "256"]
],
"04/14/2025 to 04/20/2025": [
  ["779", "38", "350"],
  ["446", "45", "140"],
  ["155", "13", "120"],
  ["136", "03", "779"],
  ["112", "47", "124"]
],
"04/21/2025 to 04/27/2025": [
  ["569", "09", "289"],
  ["559", "90", "244"],
  ["269", "79", "180"],
  ["568", "90", "226"],
  ["460", "00", "136"]
],
"04/28/2025 to 05/04/2025": [
  ["135", "95", "780"],
  ["124", "76", "150"],
  ["169", "63", "490"],
  ["380", "13", "256"],
  ["345", "21", "380"]
],
"05/05/2025 to 05/11/2025": [
  ["690", "57", "890"],
  ["160", "75", "889"],
  ["377", "74", "455"],
  ["479", "05", "177"],
  ["225", "98", "279"]
],
"05/12/2025 to 05/18/2025": [
  ["234", "94", "248"],
  ["350", "83", "490"],
  ["124", "71", "588"],
  ["299", "09", "234"],
  ["330", "61", "227"]
],
"05/19/2025 to 05/25/2025": [
  ["166", "34", "130"],
  ["278", "79", "478"],
  ["240", "67", "467"],
  ["390", "29", "270"],
  ["700", "74", "130"]
],
"05/26/2025 to 06/01/2025": [
  ["233", "84", "149"],
  ["599", "33", "166"],
  ["680", "42", "129"],
  ["668", "05", "500"],
  ["190", "03", "689"]
],
"06/02/2025 to 06/08/2025": [
  ["599", "36", "123"],
  ["699", "42", "237"],
  ["288", "84", "770"],
  ["160", "73", "229"],
  ["457", "64", "167"]
],
"06/09/2025 to 06/15/2025": [
  ["129", "26", "150"],
  ["370", "00", "000"],
  ["889", "54", "158"],
  ["157", "32", "480"],
  ["148", "37", "269"]
],
"06/16/2025 to 06/22/2025": [
  ["120", "33", "157"],
  ["470", "19", "180"],
  ["669", "13", "157"],
  ["340", "75", "780"],
  ["479", "09", "450"]
],
"06/23/2025 to 06/29/2025": [
  ["237", "20", "578"],
  ["667", "93", "445"],
  ["780", "57", "223"],
  ["335", "19", "478"],
  ["348", "53", "229"]
],
"06/30/2025 to 07/06/2025": [
  ["226", "07", "278"],
  ["469", "93", "670"],
  ["350", "87", "269"],
  ["277", "61", "137"],
  ["688", "29", "360"]
],
"07/07/2025 to 07/13/2025": [
  ["477", "83", "689"],
  ["356", "46", "277"],
  ["259", "62", "679"],
  ["670", "32", "499"],
  ["347", "49", "667"]
],
"07/14/2025 to 07/20/2025": [
  ["560", "14", "338"],
  ["589", "21", "128"],
  ["368", "79", "289"],
  ["790", "69", "289"],
  ["236", "13", "256"]
],
"07/21/2025 to 07/27/2025": [
  ["140", "52", "778"],
  ["338", "45", "140"],
  ["267", "59", "900"],
  ["368", "78", "170"],
  ["350", "87", "278"]
],
"07/28/2025 to 08/03/2025": [
  ["137", "13", "779"],
  ["188", "73", "490"],
  ["499", "25", "690"],
  ["247", "36", "169"],
  ["100", "15", "177"]
],
"08/04/2025 to 08/10/2025": [
  ["199", "97", "269"],
  ["277", "60", "569"],
  ["167", "40", "244"],
  ["577", "94", "167"],
  ["356", "46", "259"]
],
"08/11/2025 to 08/17/2025": [
  ["340", "77", "269"],
  ["780", "55", "267"],
  ["234", "96", "178"],
  ["370", "04", "770"],
  ["***", "**", "***"]
],
"08/18/2025 to 08/24/2025": [
  ["340", "76", "466"],
  ["368", "71", "155"],
  ["290", "14", "699"],
  ["348", "50", "235"],
  ["566", "76", "790"]
],
"08/25/2025 to 08/31/2025": [
  ["500", "51", "669"],
  ["170", "83", "148"],
  ["230", "57", "368"],
  ["780", "51", "380"],
  ["189", "87", "359"]
],
"09/01/2025 to 09/07/2025": [
  ["348", "54", "789"],
  ["149", "44", "149"],
  ["238", "37", "557"],
  ["679", "23", "247"],
  ["445", "30", "190"]
],
"09/08/2025 to 09/14/2025": [
  ["347", "47", "340"],
  ["590", "42", "345"],
  ["800", "86", "123"],
  ["135", "91", "579"],
  ["690", "51", "470"]
],
"09/15/2025 to 09/21/2025": [
  ["145", "09", "360"],
  ["234", "93", "148"],
  ["290", "15", "500"],
  ["177", "59", "450"],
  ["344", "19", "379"]
],
"09/22/2025 to 09/28/2025": [
  ["468", "83", "157"],
  ["157", "31", "678"],
  ["234", "93", "166"],
  ["145", "03", "247"],
  ["678", "17", "700"]
],
"09/29/2025 to 10/05/2025": [
  ["578", "04", "446"],
  ["268", "62", "778"],
  ["399", "14", "257"],
  ["169", "66", "358"],
  ["177", "52", "345"]
],
"10/06/2025 to 10/12/2025": [
  ["470", "19", "126"],
  ["556", "68", "224"],
  ["260", "88", "477"],
  ["556", "66", "457"],
  ["269", "74", "356"]
],
"10/13/2025 to 10/19/2025": [
  ["370", "00", "389"],
  ["126", "94", "356"],
  ["167", "47", "115"],
  ["279", "88", "279"],
  ["590", "49", "568"]
],
"10/20/2025 to 10/26/2025": [
  ["***", "**", "***"],
  ["***", "**", "***"],
  ["***", "**", "***"],
  ["***", "**", "***"],
  ["***", "**", "***"]
],
"10/27/2025 to 11/02/2025": [
  ["170", "85", "168"],
  ["249", "59", "478"],
  ["268", "66", "448"],
  ["579", "12", "147"],
  ["149", "47", "890"]
],
"11/03/2025 to 11/09/2025": [
  ["344", "11", "560"],
  ["125", "86", "240"],
  ["388", "94", "266"],
  ["133", "72", "499"],
  ["269", "79", "289"]
],
"11/10/2025 to 11/16/2025": [
  ["226", "04", "400"],
  ["670", "37", "890"],
  ["670", "36", "457"],
  ["390", "25", "348"],
  ["228", "25", "249"]
],
"11/17/2025 to 11/23/2025": [
  ["446", "44", "158"],
  ["237", "20", "244"],
  ["178", "66", "169"],
  ["160", "72", "255"],
  ["368", "76", "178"]
],
"11/24/2025 to 11/30/2025": [
  ["478", "92", "255"],
  ["468", "84", "356"],
  ["990", "81", "399"],
  ["178", "65", "447"],
  ["789", "46", "169"]
],
"12/01/2025 to 12/07/2025": [
  ["116", "82", "129"],
  ["137", "14", "167"],
  ["600", "65", "230"],
  ["250", "70", "299"],
  ["366", "59", "577"]
],
"12/08/2025 to 12/14/2025": [
  ["569", "07", "269"],
  ["280", "05", "159"],
  ["235", "05", "168"],
  ["269", "78", "378"],
  ["156", "28", "800"]
],
"12/15/2025 to 12/21/2025": [
  ["368", "77", "458"],
  ["223", "79", "135"],
  ["120", "34", "158"],
  ["235", "03", "238"],
  ["450", "90", "569"]
],
"12/22/2025 to 12/28/2025": [
  ["250", "71", "399"],
  ["477", "81", "155"],
  ["579", "15", "889"],
  ["670", "39", "450"],
  ["190", "06", "457"]
],
"12/29/2025 to 01/04/2026": [
  ["150", "67", "133"],
  ["256", "34", "590"],
  ["339", "54", "167"],
  ["600", "63", "139"],
  ["240", "65", "690"]
],
"01/05/2026 to 01/11/2026": [
  ["299", "01", "335"],
  ["370", "04", "149"],
  ["499", "21", "678"],
  ["789", "47", "467"],
  ["220", "48", "350"]
],
"01/12/2026 to 01/18/2026": [
  ["259", "63", "247"],
  ["120", "37", "223"],
  ["228", "20", "235"],
  ["590", "45", "267"],
  ["479", "02", "679"]
],
"01/19/2026 to 01/25/2026": [
  ["368", "71", "344"],
  ["889", "56", "123"],
  ["279", "80", "190"],
  ["155", "12", "499"],
  ["158", "45", "140"]
],
"01/26/2026 to 02/01/2026": [
  ["***", "**", "***"],
  ["247", "30", "235"],
  ["357", "53", "670"],
  ["699", "47", "188"],
  ["339", "57", "557"]
],
"02/02/2026 to 02/08/2026": [
  ["379", "97", "340"],
  ["147", "21", "579"],
  ["899", "61", "579"],
  ["466", "67", "359"],
  ["279", "80", "569"]
],
"02/09/2026 to 02/15/2026": [
  ["135", "99", "360"],
  ["134", "80", "389"],
  ["388", "96", "457"],
  ["468", "86", "349"],
  ["134", "80", "677"]
],
"02/16/2026 to 02/22/2026": [
  ["125", "85", "168"],
  ["378", "85", "249"],
  ["456", "54", "266"],
  ["259", "68", "260"],
  ["139", "39", "117"]
],
"02/23/2026 to 03/01/2026": [
  ["445", "32", "147"],
  ["990", "82", "246"],
  ["779", "32", "778"],
  ["150", "64", "590"],
  ["223", "76", "448"]
],
"03/02/2026 to 03/08/2026": [
  ["117", "99", "469"],
  ["158", "43", "229"],
  ["***", "**", "***"],
  ["149", "49", "289"],
  ["230", "59", "360"]
],
"03/09/2026 to 03/15/2026": [
  ["270", "94", "356"],
  ["228", "20", "136"],
  ["499", "23", "670"],
  ["458", "79", "469"],
  ["458", "72", "156"]
],
"03/16/2026 to 03/22/2026": [
  ["579", "11", "669"],
  ["336", "25", "339"],
  ["259", "60", "370"],
  ["455", "43", "256"],
  ["113", "55", "258"]
]
};

export const MAYAMORNING = {
 "01/01/2024 to 01/07/2024": [
  ["245", "16", "169"],
  ["480", "27", "124"],
  ["677", "09", "577"],
  ["120", "36", "448"],
  ["180", "92", "345"],
  ["125", "87", "188"],
  ["338", "41", "236"]
],
"01/08/2024 to 01/14/2024": [
  ["368", "74", "167"],
  ["559", "98", "260"],
  ["880", "69", "225"],
  ["489", "12", "200"],
  ["290", "17", "188"],
  ["249", "51", "128"],
  ["460", "03", "256"]
],
"01/15/2024 to 01/21/2024": [
  ["369", "88", "378"],
  ["679", "24", "149"],
  ["345", "28", "233"],
  ["380", "13", "689"],
  ["248", "44", "356"],
  ["127", "05", "140"],
  ["568", "90", "578"]
],
"01/22/2024 to 01/28/2024": [
  ["579", "13", "670"],
  ["470", "11", "344"],
  ["268", "65", "456"],
  ["147", "20", "145"],
  ["679", "24", "149"],
  ["489", "12", "200"],
  ["170", "88", "459"]
],
"01/29/2024 to 02/04/2024": [
  ["115", "72", "129"],
  ["479", "05", "159"],
  ["189", "84", "220"],
  ["123", "62", "390"],
  ["190", "05", "447"],
  ["670", "32", "138"],
  ["347", "45", "690"]
],
"02/05/2024 to 02/11/2024": [
  ["156", "24", "789"],
  ["267", "59", "360"],
  ["249", "54", "356"],
  ["156", "26", "457"],
  ["146", "12", "237"],
  ["288", "80", "668"],
  ["349", "63", "157"]
],
"02/12/2024 to 02/18/2024": [
  ["139", "35", "230"],
  ["257", "49", "289"],
  ["778", "29", "135"],
  ["288", "85", "780"],
  ["389", "08", "134"],
  ["125", "86", "600"],
  ["148", "38", "279"]
],
"02/19/2024 to 02/25/2024": [
  ["137", "19", "478"],
  ["466", "67", "278"],
  ["457", "65", "177"],
  ["348", "52", "679"],
  ["467", "72", "147"],
  ["235", "07", "368"],
  ["577", "94", "167"]
],
"02/26/2024 to 03/03/2024": [
  ["359", "71", "146"],
  ["590", "49", "379"],
  ["358", "68", "468"],
  ["357", "55", "780"],
  ["579", "11", "245"],
  ["570", "20", "460"],
  ["225", "90", "389"]
],
"03/04/2024 to 03/10/2024": [
  ["778", "28", "369"],
  ["350", "89", "180"],
  ["390", "20", "479"],
  ["156", "28", "279"],
  ["158", "46", "790"],
  ["259", "63", "256"],
  ["278", "76", "169"]
],
"03/11/2024 to 03/17/2024": [
  ["178", "66", "268"],
  ["350", "89", "180"],
  ["145", "00", "280"],
  ["337", "39", "234"],
  ["235", "05", "168"],
  ["459", "87", "269"],
  ["345", "28", "125"]
],
"03/18/2024 to 03/24/2024": [
  ["456", "52", "237"],
  ["789", "48", "567"],
  ["370", "00", "370"],
  ["158", "46", "790"],
  ["347", "40", "226"],
  ["470", "18", "279"],
  ["138", "23", "580"]
]
,
"03/25/2024 to 03/31/2024": [
  ["370", "03", "247"],
  ["160", "79", "289"],
  ["589", "27", "359"],
  ["137", "13", "247"],
  ["489", "15", "348"],
  ["260", "89", "270"],
  ["158", "42", "147"]
],
"04/01/2024 to 04/07/2024": [
  ["478", "91", "155"],
  ["589", "25", "267"],
  ["156", "28", "279"],
  ["790", "60", "127"],
  ["456", "55", "249"],
  ["130", "43", "148"],
  ["148", "30", "127"]
],
"04/08/2024 to 04/14/2024": [
  ["699", "41", "399"],
  ["388", "91", "236"],
  ["256", "33", "120"],
  ["117", "98", "369"],
  ["144", "96", "259"],
  ["123", "66", "240"],
  ["259", "93", "256"]
],
"04/15/2024 to 04/21/2024": [
  ["450", "98", "350"],
  ["568", "90", "136"],
  ["258", "53", "139"],
  ["457", "66", "358"],
  ["235", "08", "288"],
  ["390", "29", "568"],
  ["450", "96", "358"]
],
"04/22/2024 to 04/28/2024": [
  ["278", "73", "148"],
  ["559", "91", "137"],
  ["169", "68", "189"],
  ["389", "01", "470"],
  ["160", "71", "146"],
  ["378", "87", "133"],
  ["559", "91", "470"]
],
"04/29/2024 to 05/05/2024": [
  ["347", "46", "448"],
  ["380", "11", "560"],
  ["377", "72", "480"],
  ["147", "27", "133"],
  ["336", "26", "556"],
  ["130", "42", "480"],
  ["377", "74", "130"]
],
"05/06/2024 to 05/12/2024": [
  ["117", "98", "369"],
  ["668", "06", "790"],
  ["246", "24", "158"],
  ["170", "83", "580"],
  ["267", "57", "115"],
  ["468", "87", "890"],
  ["668", "07", "115"]
],
"05/13/2024 to 05/19/2024": [
  ["369", "84", "239"],
  ["780", "50", "370"],
  ["117", "98", "369"],
  ["789", "46", "259"],
  ["780", "53", "256"],
  ["126", "97", "160"],
  ["468", "88", "369"]
],
"05/20/2024 to 05/26/2024": [
  ["336", "20", "370"],
  ["134", "80", "136"],
  ["668", "09", "289"],
  ["448", "65", "122"],
  ["590", "48", "279"],
  ["669", "10", "118"],
  ["246", "24", "158"]
],
"05/27/2024 to 06/02/2024": [
  ["117", "98", "369"],
  ["668", "06", "790"],
  ["246", "24", "158"],
  ["170", "83", "580"],
  ["267", "57", "115"],
  ["468", "87", "890"],
  ["448", "65", "122"]
],
"06/03/2024 to 06/09/2024": [
  ["369", "84", "239"],
  ["780", "50", "370"],
  ["668", "09", "289"],
  ["789", "46", "259"],
  ["780", "53", "256"],
  ["126", "97", "160"],
  ["668", "09", "289"]
],
"06/10/2024 to 06/16/2024": [
  ["336", "20", "370"],
  ["134", "80", "136"],
  ["668", "09", "289"],
  ["448", "65", "122"],
  ["590", "48", "279"],
  ["669", "10", "118"],
  ["170", "83", "580"]
]
,
  "06/17/2024 to 06/23/2024": [
     ["200", "22", "345"],
     ["250", "76", "178"],
     ["144", "94", "356"],
     ["122", "57", "278"],
     ["238", "34", "248"],
     ["128", "12", "156"],
     ["134", "80", "136"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["180", "90", "280"],
     ["239", "45", "258"],
     ["188", "72", "345"],
     ["268", "68", "279"],
     ["247", "33", "256"],
     ["290", "18", "990"],
     ["150", "66", "330"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["167", "44", "699"],
     ["189", "85", "159"],
     ["146", "13", "148"],
     ["900", "90", "127"],
     ["560", "40", "320"],
     ["167", "55", "889"],
     ["448", "65", "122"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["129", "22", "778"],
     ["123", "67", "179"],
     ["680", "48", "567"],
     ["160", "77", "449"],
     ["247", "23", "355"],
     ["355", "39", "289"],
     ["577", "90", "280"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["990", "88", "288"],
     ["146", "12", "255"],
     ["115", "77", "250"],
     ["120", "33", "300"],
     ["448", "64", "220"],
     ["360", "90", "000"],
     ["140", "53", "670"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["459", "88", "369"],
     ["136", "06", "268"],
     ["236", "11", "678"],
     ["789", "41", "236"],
     ["450", "90", "190"],
     ["780", "55", "159"],
     ["126", "90", "244"],
  ],
  "07/29/2024 to 08/04/2024": [
     ["169", "66", "899"],
     ["356", "47", "124"],
     ["469", "93", "355"],
     ["137", "15", "500"],
     ["120", "34", "158"],
     ["122", "58", "558"],
     ["000", "06", "114"],
  ],
  "08/05/2024 to 08/11/2024": [
     ["778", "25", "177"],
     ["270", "93", "166"],
     ["689", "39", "126"],
     ["299", "03", "337"],
     ["145", "02", "679"],
     ["190", "09", "379"],
     ["155", "14", "220"],
  ],
  "08/12/2024 to 08/18/2024": [
     ["258", "89", "370"],
     ["456", "64", "245"],
     ["170", "30", "389"],
     ["289", "75", "472"],
     ["304", "52", "278"],
     ["496", "11", "355"],
     [457, 64, 287],
  ],
  "08/19/2024 to 08/25/2024": [
     ["239", "90", "377"],
     ["478", "35", "256"],
     ["192", "83", "460"],
     ["357", "14", "328"],
     ["496", "22", "178"],
     ["278", "99", "462"],
     ["148", "33", "445"],
  ],
  "08/26/2024 to 09/01/2024": [
     ["356", "67", "220"],
     ["299", "88", "431"],
     ["175", "43", "379"],
     ["489", "56", "293"],
     ["214", "90", "457"],
     ["388", "27", "345"],
     ["240", "64", "139"],
  ],
  "09/02/2024 to 09/08/2024": [
     ["312", "64", "287"],
     ["489", "23", "358"],
     ["157", "82", "274"],
     ["236", "47", "190"],
     ["413", "55", "369"],
     ["278", "68", "305"],
     ["169", "67", "269"],
  ],
};

export const INDRAMORNING = {
  "01/01/2024 to 01/07/2024": [
     ["880", "66", "600"],
     ["467", "77", "179"],
     ["888", "42", "246"],
     ["226", "09", "568"],
     ["177", "53", "120"],
     ["577", "96", "466"],
     ["111", "39", "333"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["110", "23", "337"],
     ["240", "66", "169"],
     ["479", "03", "355"],
     ["689", "30", "677"],
     ["249", "50", "488"],
     ["160", "71", "489"],
     ["140", "54", "158"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["236", "14", "158"],
     ["880", "60", "550"],
     ["349", "61", "100"],
     ["358", "60", "226"],
     ["590", "41", "678"],
     ["349", "68", "990"],
     ["136", "03", "337"],
  ],
  "01/22/2024 to 01/28/2024": [
     ["338", "49", "180"],
     ["589", "27", "250"],
     ["488", "05", "230"],
     ["290", "17", "188"],
     ["355", "32", "156"],
     ["112", "42", "228"],
     ["777", "14", "220"],
  ],
  "01/29/2024 to 02/04/2024": [
     ["112", "41", "100"],
     ["138", "29", "117"],
     ["579", "10", "370"],
     ["347", "45", "168"],
     ["267", "54", "338"],
     ["138", "22", "390"],
     ["259", "64", "455"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["445", "33", "139"],
     ["136", "00", "550"],
     ["258", "59", "289"],
     ["158", "41", "560"],
     ["456", "58", "224"],
     ["777", "15", "249"],
     ["468", "80", "226"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["236", "15", "357"],
     ["446", "47", "124"],
     ["337", "31", "146"],
     ["990", "83", "689"],
     ["357", "51", "236"],
     ["199", "92", "570"],
     ["146", "15", "780"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["900", "92", "336"],
     ["139", "31", "128"],
     ["680", "42", "110"],
     ["256", "32", "345"],
     ["149", "42", "660"],
     ["119", "10", "145"],
     ["577", "95", "113"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["489", "13", "346"],
     ["125", "80", "488"],
     ["139", "35", "140"],
     ["456", "55", "348"],
     ["669", "19", "379"],
     ["489", "10", "389"],
     ["390", "23", "599"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["127", "04", "149"],
     ["468", "89", "577"],
     ["356", "49", "360"],
     ["370", "02", "336"],
     ["459", "83", "670"],
     ["660", "21", "245"],
     ["356", "43", "337"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["550", "01", "489"],
     ["244", "08", "558"],
     ["455", "49", "289"],
     ["299", "05", "357"],
     ["246", "22", "499"],
     ["189", "88", "170"],
     ["339", "52", "589"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["456", "52", "345"],
     ["128", "11", "470"],
     ["268", "65", "366"],
     ["467", "78", "279"],
     ["120", "30", "550"],
     ["223", "70", "488"],
     ["236", "14", "167"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["117", "90", "226"],
     ["470", "18", "990"],
     ["117", "90", "000"],
     ["337", "39", "135"],
     ["346", "31", "579"],
     ["500", "55", "168"],
     ["457", "66", "150"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["556", "67", "250"],
     ["300", "31", "380"],
     ["289", "90", "118"],
     ["180", "94", "680"],
     ["368", "79", "450"],
     ["356", "46", "259"],
     ["440", "82", "345"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["150", "64", "347"],
     ["560", "12", "110"],
     ["358", "69", "135"],
     ["348", "53", "157"],
     ["145", "03", "247"],
     ["340", "78", "189"],
     ["338", "42", "129"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["679", "27", "890"],
     ["260", "83", "139"],
     ["179", "70", "190"],
     ["569", "05", "339"],
     ["126", "98", "170"],
     ["233", "82", "255"],
     ["667", "99", "478"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["990", "80", "460"],
     ["300", "32", "589"],
     ["469", "96", "448"],
     ["459", "86", "277"],
     ["349", "67", "223"],
     ["566", "77", "458"],
     ["220", "47", "368"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["223", "79", "117"],
     ["370", "09", "568"],
     ["228", "29", "900"],
     ["359", "74", "130"],
     ["148", "39", "234"],
     ["348", "56", "150"],
     ["270", "95", "140"],
  ],
  "05/06/2024 to 05/12/2024": [
     ["239", "45", "456"],
     ["378", "84", "356"],
     ["127", "08", "459"],
     ["168", "55", "690"],
     ["269", "75", "258"],
     ["360", "94", "789"],
     ["590", "40", "145"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["156", "23", "120"],
     ["136", "07", "890"],
     ["345", "24", "257"],
     ["455", "48", "459"],
     ["159", "51", "489"],
     ["117", "99", "126"],
     ["600", "63", "355"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["579", "19", "225"],
     ["448", "68", "567"],
     ["570", "22", "679"],
     ["127", "01", "560"],
     ["667", "96", "899"],
     ["399", "17", "124"],
     ["668", "08", "440"],
  ],

  "05/27/2024 to 06/02/2024": [
     ["880", "61", "380"],
     ["470", "10", "226"],
     ["134", "83", "346"],
     ["360", "91", "137"],
     ["238", "35", "456"],
     ["467", "79", "379"],
     ["390", "27", "278"],
  ],
  "06/03/2024 to 06/09/2024": [
     ["170", "88", "224"],
     ["466", "67", "890"],
     ["340", "77", "124"],
     ["156", "22", "679"],
     ["125", "82", "228"],
     ["157", "30", "136"],
     ["560", "18", "369"],
  ],
  "06/10/2024 to 06/16/2024": [
     ["780", "58", "170"],
     ["138", "25", "168"],
     ["459", "82", "246"],
     ["340", "75", "690"],
     ["479", "08", "233"],
     ["457", "62", "156"],
     ["200", "20", "127"],
  ],
  "06/17/2024 to 06/23/2024": [
     ["260", "80", "145"],
     ["259", "64", "248"],
     ["245", "15", "889"],
     ["234", "97", "377"],
     ["169", "65", "348"],
     ["369", "87", "160"],
     ["379", "96", "330"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["457", "61", "128"],
     ["379", "99", "289"],
     ["245", "15", "889"],
     ["256", "39", "270"],
     ["477", "81", "119"],
     ["679", "25", "168"],
     ["179", "77", "340"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["177", "58", "459"],
     ["680", "49", "360"],
     ["579", "17", "124"],
     ["990", "80", "569"],
     ["289", "93", "247"],
     ["300", "30", "460"],
     ["129", "22", "228"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["180", "99", "126"],
     ["589", "21", "344"],
     ["358", "67", "115"],
     ["244", "07", "278"],
     ["113", "51", "470"],
     ["340", "74", "149"],
     ["146", "13", "247"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["440", "89", "900"],
     ["113", "55", "249"],
     ["689", "31", "137"],
     ["559", "97", "890"],
     ["279", "88", "350"],
     ["490", "30", "389"],
     ["135", "96", "899"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["557", "73", "148"],
     ["478", "93", "346"],
     ["259", "67", "133"],
     ["799", "50", "460"],
     ["678", "15", "357"],
     ["247", "32", "138"],
     ["560", "19", "388"],
  ],
  "07/29/2024 to 08/04/2024": [
     ["258", "51", "669"],
     ["490", "34", "789"],
     ["568", "99", "126"],
     ["670", "35", "348"],
     ["566", "70", "479"],
     ["129", "28", "260"],
     ["347", "44", "158"],
  ],
  "08/05/2024 to 08/11/2024": [
     ["570", "27", "467"],
     ["190", "05", "339"],
     ["266", "45", "122"],
     ["568", "99", "126"],
     ["170", "84", "699"],
     ["377", "75", "447"],
     ["470", "17", "133"],
  ],
  "08/12/2024 to 08/18/2024": [
     ["150", "67", "557"],
     ["568", "96", "178"],
     ["680", "40", "145"],
     ["489", "13", "670"],
     ["358", "60", "235"],
     ["290", "11", "579"],
     ["346", "34", "130"],
  ],
  "08/19/2024 to 08/25/2024": [
     ["148", "30", "127"],
     ["570", "23", "256"],
     ["679", "21", "470"],
     ["125", "88", "378"],
     ["789", "41", "380"],
     ["458", "78", "134"],
     ["238", "37", "890"],
  ],
  "08/26/2024 to 09/01/2024": [
     ["130", "49", "270"],
     ["399", "10", "578"],
     ["589", "21", "146"],
     ["460", "02", "688"],
     ["566", "70", "280"],
     ["245", "16", "358"],
     ["679", "25", "140"],
  ],
  "09/02/2024 to 09/08/2024": [
     ["457", "66", "880"],
     ["239", "41", "344"],
     ["478", "99", "180"],
     ["579", "15", "366"],
     ["267", "59", "568"],
     ["170", "89", "900"],
     ["138", "20", "370"],
  ],
  "09/09/2024 to 09/15/2024": [
     ["499", "24", "158"],
     ["260", "80", "569"],
     ["440", "86", "358"],
     ["188", "71", "236"],
     ["799", "54", "347"],
     ["259", "66", "150"],
     ["137", "17", "458"],
  ],
};
export const INDRADAY = {
  "01/01/2024 to 07/01/2024": [
     ["278", "73", "139"],
     ["150", "61", "290"],
     ["235", "04", "220"],
     ["448", "69", "559"],
     ["278", "76", "367"],
     ["280", "04", "266"],
     ["288", "85", "122"],
  ],
  "08/01/2024 to 14/01/2024": [
    ["160", "77", "179"],
    ["379", "96", "367"],
    ["377", "73", "779"],
    ["680", "42", "589"],
    ["347", "43", "670"],
    ["148", "35", "690"],
    ["379", "96", "466"],
  ],
  "15/01/2024 to 21/01/2024": [
    ["689", "37", "467"],
    ["668", "03", "599"],
    ["299", "01", "678"],
    ["389", "04", "789"],
    ["234", "97", "890"],
    ["577", "95", "168"],
    ["666", "83", "779"],
  ],
  "22/01/2024 to 28/01/2024": [
    ["357", "54", "455"],
    ["339", "58", "378"],
    ["669", "14", "347"],
    ["389", "07", "223"],
    ["690", "51", "669"],
    ["479", "07", "467"],
    ["266", "46", "448"],
  ],
  "29/01/2024 to 04/02/2024": [
    ["679", "24", "789"],
    ["360", "99", "900"],
    ["260", "85", "113"],
    ["279", "82", "228"],
    ["578", "00", "389"],
    ["269", "79", "577"],
    ["288", "86", "899"],
  ],
  "05/02/2024 to 11/02/2024": [
    ["339", "51", "678"],
    ["159", "57", "188"],
    ["268", "62", "589"],
    ["240", "62", "228"],
    ["379", "94", "149"],
    ["690", "58", "233"],
    ["388", "97", "115"],
  ],
  "12/02/2024 to 18/02/2024": [
    ["260", "87", "269"],
    ["668", "00", "578"],
    ["367", "64", "789"],
    ["189", "82", "129"],
    ["240", "67", "179"],
    ["677", "05", "889"],
    ["589", "26", "330"],
  ],
  "19/02/2024 to 25/02/2024": [
    ["578", "06", "358"],
    ["127", "02", "147"],
    ["390", "27", "124"],
    ["126", "96", "790"],
    ["367", "64", "789"],
    ["156", "22", "480"],
    ["446", "40", "334"],
  ],
  "26/02/2024 to 03/03/2024": [
    ["790", "67", "458"],
    ["679", "25", "159"],
    ["137", "19", "135"],
    ["289", "98", "440"],
    ["234", "95", "780"],
    ["234", "95", "780"],
    ["899", "68", "558"],
  ],
  "04/03/2024 to 10/03/2024": [
    ["560", "19", "379"],
    ["167", "46", "790"],
    ["358", "68", "567"],
    ["177", "59", "667"],
    ["116", "87", "467"],
    ["157", "32", "156"],
    ["336", "24", "266"],
  ],
  "11/03/2024 to 17/03/2024": [
    ["157", "34", "167"],
    ["190", "09", "270"],
    ["180", "94", "680"],
    ["257", "46", "358"],
    ["569", "09", "126"],
    ["356", "49", "469"],
    ["257", "47", "359"],
  ],
  "19/03/2024 to 25/03/2024": [
    ["389", "01", "588"],
    ["230", "51", "678"],
    ["149", "47", "359"],
    ["579", "19", "478"],
    ["220", "48", "477"],
    ["357", "57", "890"],
    ["559", "97", "368"],
  ],
  "26/03/2024 to 01/04/2024": [
    ["189", "89", "135"],
    ["123", "64", "158"],
    ["125", "88", "260"],
    ["260", "84", "257"],
    ["570", "29", "478"],
    ["480", "26", "600"],
    ["899", "62", "255"],
  ],
  "02/04/2024 to 08/04/2024": [
    ["159", "54", "167"],
    ["123", "60", "460"],
    ["380", "14", "130"],
    ["234", "94", "770"],
    ["126", "94", "680"],
    ["267", "59", "478"],
    ["189", "87", "467"],
  ],
  "09/04/2024 to 15/04/2024": [
    ["157", "39", "577"],
    ["247", "35", "690"],
    ["113", "57", "278"],
    ["270", "96", "240"],
    ["578", "01", "489"],
    ["579", "14", "112"],
    ["459", "82", "228"],
  ],
  "16/04/2024 to 22/04/2024": [
    ["168", "55", "357"],
    ["770", "45", "456"],
    ["147", "25", "140"],
    ["347", "49", "180"],
    ["456", "58", "468"],
    ["129", "22", "480"],
    ["146", "19", "379"],
  ],
  "23/04/2024 to 29/04/2024": [
    ["235", "01", "678"],
    ["178", "60", "127"],
    ["670", "38", "800"],
    ["235", "04", "239"],
    ["880", "60", "190"],
    ["700", "79", "568"],
    ["278", "72", "390"],
  ],
  "30/04/2024 to 06/05/2024": [
    ["680", "47", "890"],
    ["145", "09", "135"],
    ["280", "08", "369"],
    ["479", "09", "135"],
    ["167", "49", "469"],
    ["334", "06", "268"],
    ["126", "94", "130"],
  ],
  "07/05/2024 to 13/05/2024": [
    ["280", "08", "369"],
    ["369", "81", "560"],
    ["368", "71", "128"],
    ["179", "71", "678"],
    ["245", "18", "567"],
    ["130", "48", "189"],
    ["138", "29", "469"],
  ],
  "14/05/2024 to 20/05/2024": [
    ["459", "86", "150"],
    ["236", "13", "139"],
    ["568", "97", "359"],
    ["678", "17", "458"],
    ["230", "56", "268"],
    ["189", "84", "590"],
    ["579", "16", "169"],
  ],
  "21/05/2024 to 27/05/2024": [
    ["367", "64", "167"],
    ["270", "90", "235"],
    ["139", "35", "230"],
    ["367", "62", "679"],
    ["579", "18", "468"],
    ["268", "63", "346"],
    ["688", "21", "227"],
  ],
  "28/05/2024 to 03/06/2024": [
    ["178", "60", "578"],
    ["350", "82", "246"],
    ["240", "69", "126"],
    ["124", "79", "450"],
    ["578", "01", "137"],
    ["350", "85", "267"],
    ["289", "98", "260"],
  ],
  "04/06/2024 to 10/06/2024": [
    ["244", "05", "780"],
    ["150", "61", "227"],
    ["359", "70", "578"],
    ["269", "70", "370"],
    ["299", "03", "788"],
    ["123", "60", "578"],
    ["257", "45", "177"],
  ],
  "11/06/2024 to 17/06/2024": [
    ["290", "14", "130"],
    ["358", "68", "990"],
    ["389", "00", "569"],
    ["445", "32", "200"],
    ["479", "02", "778"],
    ["190", "06", "448"],
    ["138", "22", "147"],
  ],
  "18/06/2024 to 24/06/2024": [
    ["699", "43", "599"],
    ["689", "36", "259"],
    ["240", "64", "789"],
    ["179", "79", "199"],
    ["160", "79", "568"],
    ["667", "91", "579"],
    ["890", "77", "179"],
  ],
  "25/06/2024 to 01/07/2024": [
    ["140", "58", "125"],
    ["460", "04", "590"],
    ["690", "50", "677"],
    ["134", "86", "349"],
    ["379", "92", "679"],
    ["380", "11", "236"],
    ["670", "30", "299"],
  ],
  "02/07/2024 to 08/07/2024": [
    ["688", "28", "369"],
    ["137", "19", "289"],
    ["168", "53", "229"],
    ["239", "46", "114"],
    ["167", "47", "278"],
    ["188", "76", "367"],
    ["137", "12", "336"],
  ],
  "09/07/2024 to 15/07/2024": [
    ["559", "92", "255"],
    ["457", "63", "157"],
    ["460", "07", "250"],
    ["158", "41", "245"],
    ["249", "57", "250"],
    ["128", "13", "580"],
    ["369", "81", "560"],
  ],
  "16/07/2024 to 22/07/2024": [
    ["269", "79", "379"],
    ["780", "54", "167"],
    ["170", "80", "145"],
    ["489", "13", "689"],
    ["670", "37", "467"],
    ["122", "59", "559"],
    ["136", "08", "279"],
  ],
  "23/07/2024 to 29/07/2024": [
    ["450", "98", "125"],
    ["260", "82", "679"],
    ["880", "64", "257"],
    ["248", "40", "280"],
    ["130", "48", "468"],
    ["267", "58", "378"],
    ["990", "89", "117"],
  ],
  "30/07/2024 to 05/08/2024": [
    ["560", "15", "366"],
    ["339", "51", "227"],
    ["179", "71", "137"],
    ["170", "88", "116"],
    ["258", "59", "577"],
    ["158", "44", "770"],
    ["489", "17", "368"],
  ],
  "06/08/2024 to 12/08/2024": [
    ["288", "84", "239"],
    ["479", "06", "240"],
    ["249", "58", "116"],
    ["179", "75", "168"],
    ["889", "55", "267"],
    ["560", "13", "599"],
    ["480", "26", "259"],
  ],
  "13/08/2024 to 19/08/2024": [
    ["347", "46", "123"],
    ["788", "35", "168"],
    ["569", "05", "348"],
    ["479", "06", "240"],
    ["559", "97", "278"],
    ["156", "21", "128"],
    ["149", "44", "257"],
  ],
  "20/08/2024 to 26/08/2024": [
    ["579", "17", "467"],
    ["688", "22", "345"],
    ["350", "85", "113"],
    ["236", "19", "225"],
    ["124", "72", "129"],
    ["244", "04", "266"],
    ["236", "10", "244"],
  ],
  "27/08/2024 to 02/09/2024": [
    ["123", "65", "258"],
    ["346", "33", "490"],
    ["277", "65", "113"],
    ["770", "41", "146"],
    ["126", "92", "390"],
    ["344", "17", "458"],
    ["569", "09", "568"],
  ],
  "03/09/2024 to 09/09/2024": [
    ["234", "94", "220"],
    ["122", "54", "356"],
    ["126", "98", "350"],
    ["123", "63", "166"],
    ["680", "44", "770"],
    ["134", "89", "117"],
    ["225", "94", "590"],
  ],
  "10/09/2024 to 15/09/2024": [
    ["400", "43", "157"],
    ["240", "62", "778"],
    ["227", "11", "678"],
    ["500", "52", "156"],
    ["136", "02", "345"],
    ["134", "82", "147"],
    ["790", "64", "356"],
  ],
};

export const INDRANIGHT = {
  "01/01/2024 to 07/01/2024": [
    ["100", "16", "448"],
    ["122", "51", "227"],
    ["589", "24", "248"],
    ["115", "71", "579"],
    ["667", "97", "160"],
    ["166", "39", "568"],
    ["246", "23", "337"],
  ],
  "08/01/2024 to 14/01/2024": [
    ["148", "39", "333"],
    ["468", "88", "170"],
    ["800", "82", "444"],
    ["278", "76", "556"],
    ["134", "82", "444"],
    ["133", "78", "440"],
    ["168", "59", "225"],
  ],
  "15/01/2024 to 21/01/2024": [
    ["134", "86", "457"],
    ["559", "95", "122"],
    ["334", "03", "157"],
    ["770", "43", "300"],
    ["267", "55", "357"],
    ["477", "81", "489"],
    ["250", "78", "260"],
  ],
  "22/01/2024 to 28/01/2024": [
    ["600", "65", "348"],
    ["390", "22", "147"],
    ["278", "70", "569"],
    ["257", "45", "177"],
    ["280", "08", "260"],
    ["288", "82", "589"],
    ["269", "71", "588"],
  ],
  "29/01/2024 to 04/02/2024": [
    ["339", "58", "666"],
    ["179", "75", "889"],
    ["660", "23", "490"],
    ["280", "09", "478"],
    ["111", "35", "889"],
    ["578", "07", "340"],
    ["256", "36", "899"],
  ],
  "05/02/2024 to 11/02/2024": [
    ["556", "65", "122"],
    ["259", "68", "666"],
    ["000", "08", "558"],
    ["700", "73", "247"],
    ["499", "28", "279"],
    ["790", "60", "460"],
    ["157", "36", "240"],
  ],
  "12/02/2024 to 18/02/2024": [
    ["990", "83", "445"],
    ["590", "41", "588"],
    ["223", "70", "668"],
    ["470", "16", "790"],
    ["244", "06", "358"],
    ["367", "69", "199"],
    ["599", "32", "660"],
  ],
  "19/02/2024 to 25/02/2024": [
    ["889", "52", "660"],
    ["123", "62", "390"],
    ["888", "49", "333"],
    ["578", "07", "890"],
    ["488", "03", "779"],
    ["880", "67", "368"],
    ["344", "18", "477"],
  ],
  "26/02/2024 to 03/03/2024": [
    ["477", "86", "790"],
    ["158", "48", "350"],
    ["138", "28", "116"],
    ["360", "94", "149"],
    ["290", "12", "499"],
    ["669", "12", "129"],
    ["289", "91", "290"],
  ],
  "04/03/2024 to 10/03/2024": [
    ["116", "86", "259"],
    ["550", "08", "800"],
    ["777", "11", "128"],
    ["119", "11", "669"],
    ["227", "17", "160"],
    ["366", "55", "267"],
    ["157", "37", "458"],
  ],
  "11/03/2024 to 17/03/2024": [
    ["245", "14", "590"],
    ["338", "45", "230"],
    ["666", "87", "278"],
    ["230", "58", "189"],
    ["990", "89", "559"],
    ["180", "98", "224"],
    ["150", "64", "149"],
  ],
  "18/03/2024 to 24/03/2024": [
    ["666", "89", "225"],
    ["167", "45", "339"],
    ["223", "74", "167"],
    ["567", "83", "247"],
    ["168", "50", "569"],
    ["358", "62", "255"],
    ["100", "11", "290"],
  ],
  "25/03/2024 to 31/03/2024": [
    ["350", "87", "359"],
    ["446", "44", "888"],
    ["990", "81", "579"],
    ["680", "43", "256"],
    ["257", "43", "157"],
    ["199", "98", "369"],
    ["339", "56", "222"],
  ],
  "01/04/2024 to 07/04/2024": [
    ["377", "78", "369"],
    ["135", "91", "678"],
    ["579", "19", "333"],
    ["479", "08", "477"],
    ["660", "26", "169"],
    ["115", "73", "139"],
    ["237", "20", "488"],
  ],
  "08/04/2024 to 14/04/2024": [
    ["455", "43", "346"],
    ["200", "20", "460"],
    ["478", "95", "348"],
    ["235", "07", "467"],
    ["389", "01", "380"],
    ["227", "11", "344"],
    ["189", "88", "558"],
  ],
  "15/04/2024 to 21/04/2024": [
    ["112", "49", "469"],
    ["270", "90", "389"],
    ["440", "83", "580"],
    ["579", "16", "899"],
    ["138", "24", "167"],
    ["118", "04", "400"],
    ["256", "30", "460"],
  ],
  "22/04/2024 to 28/04/2024": [
    ["290", "13", "346"],
    ["589", "21", "335"],
    ["788", "39", "577"],
    ["225", "99", "180"],
    ["469", "93", "580"],
    ["366", "52", "228"],
    ["345", "22", "156"],
  ],
  "29/04/2024 to 05/05/2024": [
    ["130", "46", "457"],
    ["178", "60", "479"],
    ["370", "01", "137"],
    ["200", "20", "127"],
    ["359", "74", "149"],
    ["567", "84", "158"],
    ["330", "67", "890"],
  ],
  "06/05/2024 to 12/05/2024": [
    ["299", "04", "257"],
    ["133", "79", "667"],
    ["134", "86", "169"],
    ["590", "41", "470"],
    ["229", "37", "269"],
    ["289", "97", "115"],
    ["136", "00", "578"],
  ],
  "13/05/2024 to 19/05/2024": [
    ["558", "81", "128"],
    ["138", "26", "150"],
    ["250", "73", "166"],
    ["157", "31", "399"],
    ["126", "96", "169"],
    ["167", "43", "238"],
    ["236", "18", "477"],
  ],
  "11/03/2024 to 17/03/2024": [
    ["245", "14", "590"],
    ["338", "45", "230"],
    ["666", "87", "278"],
    ["230", "58", "189"],
    ["990", "89", "559"],
    ["180", "98", "224"],
    ["150", "64", "149"],
  ],
  "18/03/2024 to 24/03/2024": [
    ["666", "89", "225"],
    ["167", "45", "339"],
    ["223", "74", "167"],
    ["567", "83", "247"],
    ["168", "50", "569"],
    ["358", "62", "255"],
    ["100", "11", "290"],
  ],
  "25/03/2024 to 31/03/2024": [
    ["350", "87", "359"],
    ["446", "44", "888"],
    ["990", "81", "579"],
    ["680", "43", "256"],
    ["257", "43", "157"],
    ["199", "98", "369"],
    ["339", "56", "222"],
  ],
  "01/04/2024 to 07/04/2024": [
    ["377", "78", "369"],
    ["135", "91", "678"],
    ["579", "19", "333"],
    ["479", "08", "477"],
    ["660", "26", "169"],
    ["115", "73", "139"],
    ["237", "20", "488"],
  ],
  "08/04/2024 to 14/04/2024": [
    ["455", "43", "346"],
    ["200", "20", "460"],
    ["478", "95", "348"],
    ["235", "07", "467"],
    ["389", "01", "380"],
    ["227", "11", "344"],
    ["189", "88", "558"],
  ],
  "15/04/2024 to 21/04/2024": [
    ["112", "49", "469"],
    ["270", "90", "389"],
    ["440", "83", "580"],
    ["579", "16", "899"],
    ["138", "24", "167"],
    ["118", "04", "400"],
    ["256", "30", "460"],
  ],
  "22/04/2024 to 28/04/2024": [
    ["290", "13", "346"],
    ["589", "21", "335"],
    ["788", "39", "577"],
    ["225", "99", "180"],
    ["469", "93", "580"],
    ["366", "52", "228"],
    ["345", "22", "156"],
  ],
  "29/04/2024 to 05/05/2024": [
    ["130", "46", "457"],
    ["178", "60", "479"],
    ["370", "01", "137"],
    ["200", "20", "127"],
    ["359", "74", "149"],
    ["567", "84", "158"],
    ["330", "67", "890"],
  ],
  "06/05/2024 to 12/05/2024": [
    ["299", "04", "257"],
    ["133", "79", "667"],
    ["134", "86", "169"],
    ["590", "41", "470"],
    ["229", "37", "269"],
    ["289", "97", "115"],
    ["136", "00", "578"],
  ],
  "13/05/2024 to 19/05/2024": [
    ["558", "81", "128"],
    ["138", "26", "150"],
    ["250", "73", "166"],
    ["157", "31", "399"],
    ["126", "96", "169"],
    ["167", "43", "238"],
    ["236", "18", "477"],
  ],
  "20/05/2024 to 26/05/2024": [
    ["399", "17", "467"],
    ["126", "95", "690"],
    ["480", "29", "568"],
    ["120", "34", "266"],
    ["389", "08", "468"],
    ["890", "73", "229"],
    ["567", "87", "359"],
  ],
  "27/05/2024 to 02/06/2024": [
    ["589", "24", "130"],
    ["233", "86", "349"],
    ["490", "31", "119"],
    ["370", "04", "257"],
    ["790", "61", "119"],
    ["339", "52", "156"],
    ["579", "12", "499"],
  ],
  "03/06/2024 to 09/06/2024": [
    ["334", "09", "559"],
    ["140", "51", "380"],
    ["126", "96", "277"],
    ["279", "82", "390"],
    ["550", "03", "157"],
    ["155", "18", "224"],
    ["890", "74", "347"],
  ],
  "10/06/2024 to 16/06/2024": [
    ["470", "17", "377"],
    ["667", "92", "246"],
    ["138", "20", "370"],
    ["880", "66", "178"],
    ["579", "19", "180"],
    ["468", "83", "247"],
    ["670", "30", "127"],
  ],
  "17/06/2024 to 23/06/2024": [
    ["567", "81", "380"],
    ["145", "08", "459"],
    ["689", "39", "234"],
    ["348", "51", "245"],
    ["136", "06", "349"],
    ["167", "46", "259"],
    ["780", "54", "356"],
  ],
  "24/06/2024 to 30/06/2024": [
    ["670", "30", "578"],
    ["147", "26", "240"],
    ["460", "02", "156"],
    ["450", "97", "557"],
    ["377", "71", "236"],
    ["468", "84", "789"],
    ["118", "07", "566"],
  ],
  "01/07/2024 to 07/07/2024": [
    ["360", "98", "189"],
    ["145", "04", "446"],
    ["337", "39", "469"],
    ["680", "42", "138"],
    ["150", "67", "340"],
    ["400", "44", "347"],
    ["270", "91", "236"],
  ],
  "08/07/2024 to 14/07/2024": [
    ["790", "63", "157"],
    ["256", "32", "589"],
    ["239", "48", "170"],
    ["780", "50", "479"],
    ["180", "93", "346"],
    ["370", "07", "467"],
    ["190", "03", "779"],
  ],
  "15/07/2024 to 21/07/2024": [
    ["179", "71", "678"],
    ["234", "98", "459"],
    ["149", "42", "660"],
    ["468", "81", "155"],
    ["178", "63", "689"],
    ["168", "57", "250"],
    ["289", "91", "380"],
  ],
  "22/07/2024 to 28/07/2024": [
    ["459", "88", "369"],
    ["136", "06", "268"],
    ["236", "11", "678"],
    ["789", "41", "236"],
    ["450", "90", "190"],
    ["780", "55", "159"],
    ["337", "39", "469"],
  ],
  "29/07/2024 to 04/08/2024": [
    ["567", "81", "380"],
    ["145", "08", "459"],
    ["689", "39", "234"],
    ["348", "51", "245"],
    ["136", "06", "349"],
    ["167", "46", "259"],
    ["780", "54", "356"],
  ],
  "05/08/2024 to 11/08/2024": [
    ["778", "25", "177"],
    ["270", "93", "166"],
    ["689", "39", "126"],
    ["299", "03", "337"],
    ["145", "02", "679"],
    ["190", "09", "379"],
    ["167", "46", "259"],
  ],
  "12/08/2024 to 18/08/2024": [
    ["247", "32", "778"],
    ["126", "99", "289"],
    ["128", "16", "268"],
    ["246", "25", "168"],
    ["119", "10", "136"],
    ["170", "77", "700"],
    ["134", "83", "580"],
  ],
  "19/08/2024 to 25/08/2024": [
    ["236", "14", "130"],
    ["337", "31", "489"],
    ["170", "88", "189"],
    ["167", "43", "247"],
    ["255", "29", "225"],
    ["678", "12", "390"],
    ["357", "56", "114"],
  ],
  "26/08/2024 to 01/09/2024": [
    ["179", "70", "000"],
    ["489", "19", "469"],
    ["580", "32", "444"],
    ["170", "84", "220"],
    ["266", "49", "289"],
    ["469", "93", "300"],
    ["588", "10", "280"],
  ],
  "02/09/2024 to 08/09/2024": [
    ["227", "13", "599"],
    ["456", "58", "288"],
    ["337", "30", "479"],
    ["356", "45", "690"],
    ["199", "90", "460"],
    ["119", "18", "800"],
    ["255", "24", "770"],
  ],
  "09/09/2024 to 15/09/2024": [
    ["600", "62", "147"],
    ["112", "40", "145"],
    ["288", "88", "800"],
    ["489", "15", "366"],
    ["457", "67", "377"],
    ["246", "21", "227"],
    ["467", "73", "166"],
  ],
};

export const MAYADAY = {
  "01/01/2024 to 01/07/2024": [
    ["379", "93", "670"],
    ["357", "50", "370"],
    ["336", "27", "124"],
    ["150", "65", "249"],
    ["780", "53", "670"],
    ["259", "62", "345"],
    ["780", "54", "455"],
  ],
  "01/08/2024 to 01/14/2024": [
    ["690", "51", "344"],
    ["300", "39", "469"],
    ["390", "26", "169"],
    ["489", "10", "569"],
    ["360", "91", "380"],
    ["115", "72", "778"],
    ["880", "67", "269"],
  ],
  "01/15/2024 to 01/21/2024": [
    ["140", "54", "789"],
    ["138", "28", "288"],
    ["250", "79", "568"],
    ["200", "29", "568"],
    ["339", "51", "678"],
    ["159", "57", "188"],
    ["268", "62", "589"],
  ],
  "01/22/2024 to 01/28/2024": [
    ["458", "77", "890"],
    ["224", "81", "128"],
    ["356", "48", "189"],
    ["199", "93", "166"],
    ["260", "87", "269"],
    ["668", "00", "578"],
    ["367", "64", "789"],
  ],
  "01/29/2024 to 02/04/2024": [
    ["470", "14", "248"],
    ["689", "30", "479"],
    ["234", "94", "680"],
    ["146", "14", "248"],
    ["189", "85", "159"],
    ["379", "95", "690"],
    ["360", "90", "677"],
  ],
  "02/05/2024 to 02/11/2024": [
    ["177", "50", "136"],
    ["440", "87", "467"],
    ["778", "23", "599"],
    ["244", "04", "167"],
    ["135", "95", "113"],
    ["479", "06", "466"],
    ["234", "93", "256"],
  ],
  "02/12/2024 to 02/18/2024": [
    ["280", "06", "330"],
    ["123", "68", "350"],
    ["122", "50", "136"],
    ["789", "42", "237"],
    ["367", "62", "345"],
    ["669", "16", "358"],
    ["226", "03", "490"],
  ],
  "02/19/2024 to 02/25/2024": [
    ["120", "31", "380"],
    ["570", "26", "330"],
    ["115", "78", "134"],
    ["130", "49", "450"],
    ["469", "91", "489"],
    ["589", "20", "145"],
    ["246", "29", "234"],
  ],
  "02/26/2024 to 03/03/2024": [
    ["250", "73", "670"],
    ["567", "82", "570"],
    ["124", "79", "135"],
    ["139", "37", "566"],
    ["450", "95", "690"],
    ["590", "46", "367"],
    ["900", "95", "249"],
  ],
  "03/04/2024 to 03/10/2024": [
    ["234", "90", "677"],
    ["167", "40", "479"],
    ["359", "74", "257"],
    ["570", "28", "459"],
    ["135", "93", "229"],
    ["479", "07", "359"],
    ["367", "69", "667"],
  ],
  "03/11/2024 to 03/17/2024": [
    ["478", "90", "136"],
    ["689", "32", "237"],
    ["268", "63", "148"],
    ["139", "37", "368"],
    ["234", "97", "269"],
    ["230", "55", "267"],
    ["557", "72", "129"],
  ],
  "03/18/2024 to 03/24/2024": [
    ["237", "23", "300"],
    ["135", "97", "458"],
    ["577", "92", "345"],
    ["480", "28", "378"],
    ["159", "53", "599"],
    ["550", "03", "157"],
    ["128", "15", "555"],
  ],
  "03/25/2024 to 03/31/2024": [
    ["400", "43", "157"],
    ["240", "62", "778"],
    ["227", "11", "678"],
    ["500", "52", "156"],
    ["136", "02", "345"],
    ["134", "82", "147"],
    ["790", "64", "356"],
  ],
  "04/01/2024 to 04/07/2024": [
    ["790", "66", "349"],
    ["270", "98", "260"],
    ["470", "14", "248"],
    ["789", "40", "299"],
    ["457", "65", "168"],
    ["789", "45", "348"],
    ["559", "98", "477"],
  ],
  "04/08/2024 to 04/14/2024": [
    ["469", "96", "358"],
    ["136", "09", "126"],
    ["138", "25", "690"],
    ["123", "61", "290"],
    ["116", "84", "158"],
    ["100", "13", "300"],
    ["259", "67", "160"],
  ],
  "04/15/2024 to 04/21/2024": [
    ["146", "11", "245"],
    ["689", "37", "890"],
    ["235", "09", "135"],
    ["477", "88", "279"],
    ["357", "54", "149"],
    ["299", "06", "240"],
    ["225", "93", "599"],
  ],
  "04/22/2024 to 04/28/2024": [
    ["157", "38", "459"],
    ["668", "07", "124"],
    ["244", "00", "488"],
    ["123", "65", "113"],
    ["256", "31", "380"],
    ["112", "45", "113"],
    ["478", "95", "249"],
  ],
  "04/29/2024 to 05/05/2024": [
    ["334", "04", "455"],
    ["459", "86", "330"],
    ["357", "50", "280"],
    ["224", "80", "280"],
    ["144", "93", "256"],
    ["590", "44", "590"],
    ["440", "86", "880"],
  ],
  "05/06/2024 to 05/12/2024": [
    ["334", "04", "455"],
    ["459", "86", "330"],
    ["357", "50", "280"],
    ["224", "80", "280"],
    ["144", "93", "256"],
    ["590", "44", "590"],
    ["440", "86", "880"],
  ],
  "05/13/2024 to 05/19/2024": [
    ["440", "81", "335"],
    ["460", "02", "589"],
    ["179", "76", "880"],
    ["680", "44", "167"],
    ["230", "51", "146"],
    ["459", "80", "389"],
    ["557", "73", "490"],
  ],
  "05/20/2024 to 05/26/2024": [
    ["148", "39", "360"],
    ["600", "61", "579"],
    ["127", "02", "660"],
    ["678", "10", "235"],
    ["166", "39", "577"],
    ["180", "90", "460"],
    ["228", "26", "150"],
  ],
  "05/27/2024 to 06/02/2024": [
    ["135", "94", "347"],
    ["480", "22", "778"],
    ["157", "34", "356"],
    ["380", "19", "289"],
    ["568", "93", "346"],
    ["400", "41", "669"],
    ["668", "04", "789"],
  ],
  "06/03/2024 to 06/09/2024": [
    ["178", "66", "457"],
    ["447", "56", "790"],
    ["160", "74", "149"],
    ["188", "75", "267"],
    ["137", "19", "135"],
    ["233", "89", "469"],
    ["468", "89", "180"],
  ],
  "06/10/2024 to 06/16/2024": [
    ["144", "95", "177"],
    ["189", "85", "339"],
    ["455", "47", "250"],
    ["336", "20", "299"],
    ["370", "06", "899"],
    ["349", "60", "479"],
    ["134", "80", "280"],
  ],
  "06/17/2024 to 06/23/2024": [
    ["590", "47", "458"],
    ["337", "31", "245"],
    ["170", "81", "579"],
    ["448", "65", "456"],
    ["667", "92", "156"],
    ["224", "81", "560"],
    ["250", "71", "245"],
  ],
  "06/24/2024 to 06/30/2024": [
    ["890", "73", "120"],
    ["168", "50", "569"],
    ["400", "43", "670"],
    ["690", "51", "146"],
    ["249", "55", "159"],
    ["229", "38", "369"],
    ["480", "22", "138"],
  ],
  "07/01/2024 to 07/07/2024": [
    ["279", "83", "580"],
    ["678", "18", "459"],
    ["336", "25", "140"],
    ["247", "30", "578"],
    ["124", "70", "460"],
    ["678", "14", "239"],
    ["355", "31", "489"],
  ],
  "07/08/2024 to 07/14/2024": [
    ["799", "54", "680"],
    ["344", "10", "136"],
    ["158", "40", "334"],
    ["556", "68", "189"],
    ["233", "89", "469"],
    ["235", "08", "378"],
    ["379", "94", "446"],
  ],
  "07/15/2024 to 07/21/2024": [
    ["127", "03", "256"],
    ["479", "08", "134"],
    ["266", "48", "440"],
    ["570", "22", "390"],
    ["260", "84", "356"],
    ["899", "62", "688"],
    ["566", "79", "270"],
  ],
  "07/22/2024 to 07/28/2024": [
    ["448", "69", "379"],
    ["390", "22", "246"],
    ["119", "17", "160"],
    ["488", "08", "369"],
    ["250", "70", "145"],
    ["490", "35", "799"],
    ["127", "01", "344"],
  ],
  "07/29/2024 to 08/04/2024": [
    ["459", "87", "368"],
    ["180", "96", "277"],
    ["347", "43", "337"],
    ["148", "39", "568"],
    ["125", "87", "188"],
    ["366", "51", "236"],
    ["469", "99", "270"],
  ],
  "08/05/2024 to 08/11/2024": [
    ["778", "25", "177"],
    ["270", "93", "166"],
    ["689", "39", "126"],
    ["299", "03", "337"],
    ["145", "02", "679"],
    ["190", "09", "379"],
    ["390", "22", "246"],
  ],
  "08/12/2024 to 08/18/2024": [
    ["337", "33", "445"],
    ["188", "77", "299"],
    ["469", "99", "270"],
    ["190", "09", "379"],
    ["689", "39", "126"],
    ["146", "11", "236"],
    ["366", "51", "236"],
  ],
  "08/19/2024 to 08/25/2024": [
    ["123", "66", "114"],
    ["126", "90", "280"],
    ["188", "78", "288"],
    ["190", "09", "379"],
    ["110", "21", "236"],
    ["288", "88", "990"],
    ["470", "13", "337"],
  ],
  "08/26/2024 to 09/01/2024": [
    ["124", "72", "200"],
    ["122", "55", "690"],
    ["380", "16", "169"],
    ["257", "44", "158"],
    ["120", "33", "148"],
    ["349", "61", "489"],
    ["480", "29", "469"],
  ],
  "09/02/2024 to 09/08/2024": [
    ["278", "78", "279"],
    ["448", "67", "377"],
    ["170", "82", "499"],
    ["270", "93", "445"],
    ["680", "41", "335"],
    ["119", "19", "289"],
    ["178", "64", "400"],
  ],
  "09/09/2024 to 09/15/2024": [
    ["239", "45", "140"],
    ["300", "38", "800"],
    ["260", "81", "155"],
    ["110", "29", "388"],
    ["225", "96", "880"],
    ["233", "84", "680"],
    ["122", "55", "690"],
  ],
};
export const MAYANIGHT = {
  "01/01/2024 to 01/07/2024": [
    ["120", "31", "380"],
    ["118", "02", "480"],
    ["160", "75", "140"],
    ["280", "09", "270"],
    ["150", "64", "220"],
    ["120", "32", "480"],
    ["336", "21", "290"],
  ],
  "01/08/2024 to 01/14/2024": [
    ["223", "74", "220"],
    ["245", "11", "335"],
    ["135", "94", "130"],
    ["490", "31", "137"],
    ["455", "43", "120"],
    ["390", "26", "114"],
    ["170", "89", "270"],
  ],
  "01/15/2024 to 01/21/2024": [
    ["560", "12", "336"],
    ["115", "72", "480"],
    ["455", "47", "250"],
    ["240", "60", "226"],
    ["120", "33", "490"],
    ["113", "52", "336"],
    ["280", "04", "338"],
  ],
  "01/22/2024 to 01/28/2024": [
    ["344", "14", "130"],
    ["133", "70", "280"],
    ["150", "68", "116"],
    ["480", "21", "227"],
    ["350", "86", "240"],
    ["225", "90", "280"],
    ["160", "73", "120"],
  ],
  "01/29/2024 to 02/04/2024": [
    ["139", "32", "110"],
    ["150", "64", "130"],
    ["122", "51", "380"],
    ["390", "20", "118"],
    ["380", "12", "480"],
    ["490", "33", "157"],
    ["170", "86", "880"],
  ],
  "02/05/2024 to 02/11/2024": [
    ["280", "05", "122"],
    ["110", "21", "137"],
    ["120", "36", "330"],
    ["339", "54", "220"],
    ["113", "59", "135"],
    ["240", "66", "330"],
    ["220", "43", "120"],
  ],
  "02/12/2024 to 02/18/2024": [
    ["130", "47", "250"],
    ["123", "62", "110"],
    ["124", "70", "118"],
    ["440", "83", "120"],
    ["590", "45", "230"],
    ["120", "30", "280"],
    ["380", "13", "490"],
  ],
  "02/19/2024 to 02/25/2024": [
    ["220", "42", "390"],
    ["334", "08", "350"],
    ["200", "23", "120"],
    ["126", "99", "270"],
    ["350", "82", "480"],
    ["270", "97", "124"],
    ["360", "91", "380"],
  ],
  "02/26/2024 to 03/03/2024": [
    ["100", "10", "370"],
    ["240", "64", "112"],
    ["330", "66", "123"],
    ["240", "60", "280"],
    ["360", "98", "350"],
    ["368", "71", "146"],
    ["400", "47", "340"],
  ],
  "03/04/2024 to 03/10/2024": [
    ["330", "62", "156"],
    ["580", "36", "330"],
    ["117", "91", "380"],
    ["490", "37", "160"],
    ["220", "43", "120"],
    ["440", "83", "490"],
    ["200", "25", "230"],
  ],
  "03/11/2024 to 03/17/2024": [
    ["550", "09", "450"],
    ["270", "96", "330"],
    ["116", "89", "450"],
    ["123", "68", "260"],
    ["490", "32", "480"],
    ["230", "55", "780"],
    ["550", "01", "380"],
  ],
  "03/18/2024 to 03/24/2024": [
    ["129", "25", "113"],
    ["230", "51", "128"],
    ["120", "31", "380"],
    ["240", "63", "490"],
    ["780", "51", "290"],
    ["110", "20", "460"],
    ["220", "47", "160"],
  ],
  "03/25/2024 to 03/31/2024": [
    ["140", "55", "500"],
    ["125", "80", "190"],
    ["110", "29", "270"],
    ["127", "02", "480"],
    ["139", "33", "120"],
    ["123", "65", "140"],
    ["260", "81", "380"],
  ],
  "04/01/2024 to 04/07/2024": [
    ["113", "59", "135"],
    ["112", "40", "190"],
    ["390", "24", "220"],
    ["225", "92", "110"],
    ["500", "52", "345"],
    ["260", "86", "178"],
    ["226", "02", "156"],
  ],
  "04/08/2024 to 04/14/2024": [
    ["380", "16", "330"],
    ["350", "87", "160"],
    ["330", "65", "230"],
    ["690", "58", "260"],
    ["270", "95", "113"],
    ["220", "49", "225"],
    ["300", "35", "140"],
  ],
  "04/15/2024 to 04/21/2024": [
    ["480", "22", "660"],
    ["550", "08", "260"],
    ["680", "44", "220"],
    ["123", "65", "230"],
    ["160", "79", "270"],
    ["580", "36", "123"],
    ["680", "42", "570"],
  ],
  "04/22/2024 to 04/28/2024": [
    ["123", "64", "112"],
    ["260", "80", "280"],
    ["113", "56", "240"],
    ["550", "02", "390"],
    ["340", "78", "350"],
    ["220", "46", "150"],
    ["233", "85", "230"],
  ],
  "04/29/2024 to 05/05/2024": [
    ["146", "15", "780"],
    ["350", "84", "590"],
    ["160", "77", "133"],
    ["660", "21", "470"],
    ["190", "04", "130"],
    ["100", "19", "180"],
    ["270", "94", "220"],
  ],
  "05/06/2024 to 05/12/2024": [
    ["124", "79", "360"],
    ["120", "30", "370"],
    ["180", "95", "230"],
    ["330", "61", "100"],
    ["220", "42", "570"],
    ["138", "23", "247"],
    ["126", "90", "280"],
  ],
  "05/13/2024 to 05/19/2024": [
    ["190", "01", "380"],
    ["400", "41", "335"],
    ["490", "38", "350"],
    ["660", "25", "140"],
    ["239", "49", "568"],
    ["168", "52", "390"],
    ["578", "06", "123"],
  ],
  "05/20/2024 to 05/26/2024": [
    ["220", "44", "130"],
    ["450", "90", "370"],
    ["560", "15", "230"],
    ["114", "69", "234"],
    ["123", "65", "690"],
    ["224", "81", "146"],
    ["478", "98", "233"],
  ],
  "05/27/2024 to 06/02/2024": [
    ["150", "61", "560"],
    ["117", "97", "160"],
    ["280", "03", "120"],
    ["660", "28", "350"],
    ["158", "43", "238"],
    ["780", "53", "229"],
    ["456", "57", "188"],
  ],
  "06/03/2024 to 06/09/2024": [
    ["120", "37", "340"],
    ["380", "18", "170"],
    ["470", "14", "220"],
    ["260", "89", "450"],
    ["700", "77", "359"],
    ["440", "84", "789"],
    ["689", "32", "147"],
  ],
  "06/10/2024 to 06/16/2024": [
    ["230", "52", "570"],
    ["225", "93", "120"],
    ["220", "49", "450"],
    ["200", "25", "140"],
    ["157", "33", "788"],
    ["340", "79", "234"],
    ["148", "38", "279"],
  ],
  "06/17/2024 to 06/23/2024": [
    ["480", "27", "250"],
    ["550", "00", "190"],
    ["455", "48", "260"],
    ["160", "73", "490"],
    ["189", "81", "344"],
    ["770", "43", "256"],
    ["136", "08", "279"],
  ],
  "06/24/2024 to 06/30/2024": [
    ["134", "81", "236"],
    ["456", "52", "138"],
    ["130", "49", "360"],
    ["180", "96", "268"],
    ["136", "07", "340"],
    ["113", "59", "234"],
    ["233", "80", "145"],
  ],

  "07/15/2024 to 07/21/2024": [
    ["690", "51", "344"],
    ["300", "39", "469"],
    ["390", "26", "169"],
    ["489", "10", "569"],
    ["360", "91", "380"],
    ["115", "72", "778"],
    ["880", "67", "269"],
  ],
  "07/22/2024 to 07/28/2024": [
    ["899", "60", "569"],
    ["900", "98", "116"],
    ["666", "88", "134"],
    ["228", "25", "168"],
    ["379", "90", "389"],
    ["456", "56", "349"],
    ["124", "74", "266"],
  ],
  "07/29/2024 to 08/04/2024": [
    ["148", "33", "337"],
    ["667", "98", "134"],
    ["256", "30", "235"],
    ["234", "91", "146"],
    ["335", "16", "114"],
    ["580", "37", "890"],
    ["500", "56", "880"],
  ],
  "08/05/2024 to 08/11/2024": [
    ["237", "25", "267"],
    ["120", "31", "380"],
    ["240", "63", "490"],
    ["255", "24", "220"],
    ["235", "03", "580"],
    ["300", "36", "330"],
    ["120", "38", "440"],
  ],
  "08/12/2024 to 08/18/2024": [
    ["567", "82", "138"],
    ["100", "12", "110"],
    ["126", "91", "380"],
    ["570", "25", "500"],
    ["112", "44", "680"],
    ["560", "14", "680"],
    ["120", "30", "280"],
  ],
  "08/19/2024 to 08/25/2024": [
    ["220", "44", "770"],
    ["350", "80", "460"],
    ["112", "47", "250"],
    ["780", "52", "679"],
    ["220", "44", "770"],
    ["350", "80", "460"],
    ["300", "38", "224"],
  ],
  "08/26/2024 to 09/01/2024": [
    ["126", "90", "460"],
    ["550", "03", "490"],
    ["260", "86", "114"],
    ["389", "06", "880"],
    ["126", "90", "460"],
    ["550", "03", "490"],
    ["270", "91", "380"],
  ],
  "09/02/2024 to 09/08/2024": [
    ["120", "30", "280"],
    ["150", "61", "380"],
    ["150", "62", "147"],
    ["888", "46", "330"],
    ["160", "70", "280"],
    ["780", "54", "266"],
    ["230", "55", "267"],
  ],
  "09/09/2024 to 09/15/2024": [
    ["300", "38", "224"],
    ["366", "51", "128"],
    ["344", "16", "330"],
    ["122", "53", "580"],
    ["125", "81", "128"],
    ["200", "22", "390"],
    ["550", "03", "157"],
  ],
};

export const SUPREMEDAY = {
  "01/01/2024 to 07/01/2024": [
    ["569", "00", "389"],
    ["240", "68", "189"],
    ["356", "46", "790"],
    ["578", "01", "128"],
    ["349", "66", "358"],
    ["568", "97", "160"],
    ["246", "28", "170"]
  ],
  "08/01/2024 to 14/01/2024": [
    ["250", "79", "225"],
    ["569", "08", "440"],
    ["589", "20", "244"],
    ["458", "79", "568"],
    ["139", "36", "178"],
    ["138", "26", "123"],
    ["678", "10", "118"]
  ],
  "15/01/2024 to 21/01/2024": [
    ["158", "46", "169"],
    ["247", "38", "378"],
    ["577", "97", "700"],
    ["138", "20", "235"],
    ["189", "85", "690"],
    ["179", "70", "668"],
    ["280", "06", "259"]
  ],
  "22/01/2024 to 28/01/2024": [
    ["127", "09", "144"],
    ["139", "39", "180"],
    ["230", "52", "129"],
    ["560", "11", "236"],
    ["***", "*", "***"],
    ["136", "01", "344"],
    ["550", "07", "458"]
  ],
  "29/01/2024 to 04/02/2024": [
    ["135", "91", "128"],
    ["120", "32", "390"],
    ["157", "35", "159"],
    ["459", "81", "236"],
    ["239", "45", "780"],
    ["566", "79", "667"],
    ["338", "45", "780"]
  ],
  "05/02/2024 to 11/02/2024": [
    ["224", "86", "268"],
    ["677", "09", "199"],
    ["700", "71", "155"],
    ["289", "93", "779"],
    ["134", "82", "589"],
    ["223", "75", "267"],
    ["667", "93", "580"]
  ],
  "12/02/2024 to 18/02/2024": [
    ["177", "59", "450"],
    ["889", "55", "122"],
    ["139", "33", "670"],
    ["145", "08", "134"],
    ["136", "06", "169"],
    ["236", "15", "780"],
    ["170", "81", "119"]
  ],
  "19/02/2024 to 25/02/2024": [
    ["377", "74", "149"],
    ["128", "11", "344"],
    ["688", "22", "480"],
    ["167", "49", "135"],
    ["123", "65", "889"],
    ["226", "02", "480"],
    ["334", "05", "168"]
  ],
  "26/02/2024 to 03/03/2024": [
    ["770", "41", "669"],
    ["779", "35", "113"],
    ["440", "86", "123"],
    ["179", "76", "899"],
    ["469", "92", "237"],
    ["560", "15", "780"],
    ["567", "86", "880"]
  ],
  "04/03/2024 to 10/03/2024": [
    ["225", "96", "268"],
    ["168", "55", "267"],
    ["147", "21", "560"],
    ["469", "94", "347"],
    ["234", "92", "336"],
    ["280", "04", "590"],
    ["138", "21", "290"]
  ],
  "11/03/2024 to 17/03/2024": [
    ["148", "35", "249"],
    ["160", "76", "123"],
    ["268", "64", "257"],
    ["490", "35", "500"],
    ["356", "45", "348"],
    ["229", "33", "788"],
    ["459", "84", "149"]
  ],
  "18/03/2024 to 24/03/2024": [
    ["150", "67", "179"],
    ["278", "71", "128"],
    ["358", "62", "660"],
    ["133", "75", "140"],
    ["590", "40", "235"],
    ["360", "90", "127"],
    ["368", "75", "177"]
  ],
  "25/03/2024 to 31/03/2024": [
    ["***", "*", "***"],
    ["228", "23", "247"],
    ["139", "34", "149"],
    ["349", "62", "110"],
    ["299", "09", "199"],
    ["350", "89", "568"],
    ["149", "43", "157"]
  ],
  "01/04/2024 to 07/04/2024": [
    ["113", "54", "770"],
    ["550", "08", "288"],
    ["389", "08", "125"],
    ["112", "46", "466"],
    ["270", "91", "119"],
    ["489", "11", "137"],
    ["250", "70", "479"]
  ],
  "08/04/2024 to 14/04/2024": [
    ["390", "25", "357"],
    ["178", "64", "257"],
    ["578", "02", "589"],
    ["247", "39", "135"],
    ["120", "31", "290"],
    ["245", "15", "447"],
    ["137", "13", "445"]
  ],
  "15/04/2024 to 21/04/2024": [
    ["278", "75", "366"],
    ["250", "76", "330"],
    ["126", "98", "459"],
    ["199", "98", "477"],
    ["356", "41", "227"],
    ["136", "05", "339"],
    ["580", "35", "249"]
  ],
  "22/04/2024 to 28/04/2024": [
    ["456", "55", "889"],
    ["700", "71", "380"],
    ["130", "48", "125"],
    ["399", "16", "790"],
    ["880", "66", "367"],
    ["190", "05", "357"],
    ["349", "61", "380"]
  ],
  "29/04/2024 to 05/05/2024": [
    ["478", "98", "558"],
    ["256", "37", "458"],
    ["149", "47", "160"],
    ["678", "12", "156"],
    ["114", "66", "457"],
    ["345", "25", "168"],
    ["468", "88", "233"]
  ],
  "06/05/2024 to 12/05/2024": [
    ["244", "01", "669"],
    ["670", "38", "279"],
    ["290", "12", "228"],
    ["236", "11", "227"],
    ["379", "90", "190"],
    ["126", "90", "280"],
    ["568", "97", "179"]
  ],
  "13/05/2024 to 19/05/2024": [
    ["500", "55", "113"],
    ["116", "81", "227"],
    ["680", "47", "124"],
    ["156", "22", "138"],
    ["490", "38", "125"],
    ["149", "45", "230"],
    ["124", "73", "157"]
  ],
  "20/05/2024 to 26/05/2024": [
    ["366", "59", "117"],
    ["458", "78", "990"],
    ["244", "06", "150"],
    ["137", "15", "168"],
    ["128", "10", "136"],
    ["679", "22", "499"],
    ["100", "10", "334"]
  ],
  "27/05/2024 to 02/06/2024": [
    ["269", "77", "890"],
    ["234", "96", "114"],
    ["244", "00", "145"],
    ["449", "73", "157"],
    ["350", "84", "266"],
    ["470", "19", "559"],
    ["578", "07", "124"]
  ],
  "03/06/2024 to 09/06/2024": [
    ["370", "03", "139"],
    ["278", "72", "589"],
    ["128", "11", "236"],
    ["160", "77", "179"],
    ["378", "89", "469"],
    ["789", "44", "680"],
    ["160", "79", "180"]
  ],
  "10/06/2024 to 16/06/2024": [
    ["120", "33", "148"],
    ["158", "48", "134"],
    ["689", "32", "688"],
    ["890", "75", "357"],
    ["345", "26", "178"],
    ["227", "15", "267"],
    ["470", "19", "289"]
  ],
  "17/06/2024 to 23/06/2024": [
    ["990", "85", "780"],
    ["679", "20", "550"],
    ["559", "94", "446"],
    ["477", "88", "125"],
    ["457", "69", "144"],
    ["188", "78", "350"],
    ["990", "88", "369"]
  ],
  "24/06/2024 to 30/06/2024": [
    ["800", "88", "134"],
    ["366", "55", "348"],
    ["169", "69", "135"],
    ["668", "09", "450"],
    ["135", "98", "189"],
    ["357", "52", "237"],
    ["256", "34", "789"]
  ],
  "01/07/2024 to 07/07/2024": [
    ["667", "98", "170"],
    ["138", "26", "169"],
    ["570", "26", "448"],
    ["368", "71", "146"],
    ["136", "00", "235"],
    ["469", "95", "159"],
    ["569", "02", "660"]
  ],
  "08/07/2024 to 14/07/2024": [
    ["460", "08", "567"],
    ["239", "42", "480"],
    ["178", "66", "367"],
    ["223", "77", "269"],
    ["467", "77", "124"],
    ["135", "95", "456"],
    ["245", "15", "780"]
  ],
  "15/07/2024 to 21/07/2024": [
    ["280", "03", "139"],
    ["600", "69", "667"],
    ["348", "54", "167"],
    ["136", "07", "160"],
    ["178", "62", "345"],
    ["990", "81", "119"],
    ["680", "45", "267"]
  ],
  "22/07/2024 to 28/07/2024": [
    ["569", "03", "256"],
    ["460", "08", "558"],
    ["248", "44", "149"],
    ["569", "05", "357"],
    ["478", "92", "129"],
    ["499", "29", "270"],
    ["577", "92", "660"]
  ],
  "29/07/2024 to 04/08/2024": [
    ["377", "78", "567"],
    ["257", "46", "150"],
    ["227", "12", "589"],
    ["899", "64", "158"],
    ["220", "45", "140"],
    ["118", "09", "135"],
    ["779", "37", "449"]
  ],
  "05/08/2024 to 11/08/2024": [
    ["558", "88", "125"],
    ["145", "01", "128"],
    ["157", "33", "689"],
    ["460", "03", "247"],
    ["128", "16", "114"],
    ["388", "90", "370"],
    ["458", "71", "128"]
  ],
  "12/08/2024 to 18/08/2024": [
    ["680", "41", "588"],
    ["145", "05", "230"],
    ["134", "83", "238"],
    ["***", "*", "***"],
    ["127", "09", "144"],
    ["456", "59", "577"],
    ["260", "84", "590"]
  ],
  "19/08/2024 to 25/08/2024": [
    ["560", "14", "167"],
    ["157", "36", "600"],
    ["470", "16", "114"],
    ["560", "14", "680"],
    ["113", "52", "660"],
    ["390", "22", "246"],
    ["580", "34", "149"]
  ],
  "26/08/2024 to 01/09/2024": [
    ["100", "11", "344"],
    ["689", "36", "169"],
    ["349", "60", "118"],
    ["488", "06", "114"],
    ["136", "08", "477"],
    ["124", "79", "126"],
    ["369", "83", "247"]
  ],
  "02/09/2024 to 08/09/2024": [
    ["489", "12", "129"],
    ["160", "77", "368"],
    ["336", "25", "168"],
    ["468", "80", "389"],
    ["460", "08", "125"],
    ["379", "98", "189"],
    ["250", "71", "290"]
  ],
  "09/09/2024 to 15/09/2024": [
    ["450", "97", "133"],
    ["119", "16", "150"],
    ["790", "65", "168"],
    ["236", "10", "460"],
    ["200", "25", "500"],
    ["188", "76", "277"],
    ["160", "70", "460"]
  ],
  "16/09/2024 to 22/09/2024": [
    ["990", "89", "225"],
    ["200", "21", "560"],
    ["133", "70", "569"],
    ["350", "84", "266"],
    ["799", "54", "112"],
    ["133", "73", "580"],
    ["157", "39", "199"]
  ],
  "23/09/2024 to 29/09/2024": [
    ["577", "94", "356"],
    ["770", "47", "223"],
    ["557", "79", "270"],
    ["480", "25", "230"],
    ["460", "06", "367"],
    ["670", "33", "256"],
    ["180", "90", "299"]
  ],
  "30/09/2024 to 06/10/2024": [
    ["279", "88", "990"],
    ["778", "20", "118"],
    ["149", "42", "237"],
    ["257", "41", "236"],
    ["126", "98", "170"],
    ["679", "29", "450"],
    ["139", "30", "370"]
  ],
  "07/10/2024 to 13/10/2024": [
    ["490", "34", "158"],
    ["190", "00", "479"],
    ["467", "79", "568"],
    ["570", "22", "200"],
    ["567", "89", "450"],
    ["136", "08", "189"],
    ["115", "77", "269"]
  ],
  "14/10/2024 to 20/10/2024": [
    ["224", "81", "678"],
    ["134", "83", "337"],
    ["790", "66", "259"],
    ["238", "39", "135"],
    ["255", "20", "127"],
    ["357", "56", "277"],
    ["156", "22", "589"]
  ],
  "21/10/2024 to 27/10/2024": [
    ["223", "79", "126"],
    ["135", "95", "889"],
    ["147", "24", "248"],
    ["450", "90", "190"],
    ["299", "05", "168"],
    ["100", "11", "380"],
    ["580", "39", "360"]
  ],
  "28/10/2024 to 03/11/2024": [
    ["368", "77", "467"],
    ["134", "83", "157"],
    ["677", "08", "378"],
    ["138", "26", "349"],
    ["379", "93", "779"],
    ["120", "34", "158"],
    ["340", "70", "479"]
  ],
  "04/11/2024 to 10/11/2024": [
    ["224", "87", "269"],
    ["490", "36", "277"],
    ["588", "15", "799"],
    ["489", "14", "257"],
    ["388", "99", "144"],
    ["335", "16", "457"],
    ["115", "74", "680"]
  ],
  "11/11/2024 to 17/11/2024": [
    ["158", "44", "130"],
    ["389", "06", "899"],
    ["348", "50", "578"],
    ["566", "72", "336"],
    ["227", "10", "190"],
    ["690", "58", "459"],
    ["167", "46", "259"]
  ],
  "18/11/2024 to 24/11/2024": [
    ["689", "31", "489"],
    ["235", "09", "234"],
    ["589", "28", "125"],
    ["368", "76", "466"],
    ["246", "23", "120"],
    ["359", "75", "366"],
    ["127", "03", "346"]
  ],
  "25/11/2024 to 01/12/2024": [
    ["789", "42", "660"],
    ["268", "69", "126"],
    ["590", "43", "788"],
    ["278", "73", "166"],
    ["134", "86", "240"],
    ["116", "85", "889"],
    ["289", "92", "147"]
  ],
  "02/12/2024 to 08/12/2024": [
    ["280", "02", "110"],
    ["155", "18", "800"],
    ["145", "07", "124"],
    ["356", "46", "880"],
    ["478", "99", "270"],
    ["558", "83", "490"],
    ["890", "79", "577"]
  ],
  "09/12/2024 to 15/12/2024": [
    ["370", "01", "137"],
    ["140", "53", "148"],
    ["179", "78", "468"],
    ["149", "44", "347"],
    ["330", "66", "178"],
    ["159", "51", "245"],
    ["780", "50", "389"]
  ],
  "16/12/2024 to 22/12/2024": [
    ["470", "13", "256"],
    ["460", "08", "567"],
    ["189", "82", "589"],
    ["244", "04", "248"],
    ["357", "56", "123"],
    ["559", "91", "579"],
    ["235", "01", "489"]
  ],
  "23/12/2024 to 29/12/2024": [
    ["669", "19", "469"],
    ["556", "65", "168"],
    ["247", "34", "239"],
    ["129", "25", "258"],
    ["130", "47", "449"],
    ["670", "38", "170"],
    ["233", "85", "348"]
  ],
  "30/12/2024 to 05/01/2025": [
    ["339", "50", "578"],
    ["128", "14", "338"],
    ["480", "29", "135"],
    ["188", "75", "690"],
    ["146", "16", "790"],
    ["230", "59", "568"],
    ["369", "82", "147"]
  ],
  "06/01/2025 to 12/01/2025": [
    ["238", "37", "133"],
    ["679", "20", "460"],
    ["678", "15", "456"],
    ["600", "64", "699"],
    ["789", "46", "268"],
    ["233", "88", "134"],
    ["169", "68", "279"]
  ],
  "13/01/2025 to 19/01/2025": [
    ["120", "35", "168"],
    ["255", "27", "160"],
    ["260", "81", "344"],
    ["479", "04", "347"],
    ["355", "37", "124"],
    ["780", "57", "458"],
    ["580", "38", "378"]
  ],
  "20/01/2025 to 26/01/2025": [
    ["448", "64", "220"],
    ["112", "49", "568"],
    ["146", "13", "238"],
    ["390", "27", "368"],
    ["133", "77", "250"],
    ["180", "95", "690"],
    ["***", "*", "***"]
  ],
  "27/01/2025 to 02/02/2025": [
    ["660", "24", "338"],
    ["136", "05", "348"],
    ["400", "40", "677"],
    ["235", "07", "467"],
    ["269", "72", "237"],
    ["234", "93", "148"],
    ["239", "42", "156"]
  ],
  "03/02/2025 to 09/02/2025": [
    ["359", "75", "357"],
    ["189", "84", "130"],
    ["118", "06", "448"],
    ["457", "63", "256"],
    ["568", "90", "370"],
    ["179", "77", "890"],
    ["388", "99", "360"]
  ],
  "10/02/2025 to 16/02/2025": [
    ["140", "54", "446"],
    ["129", "27", "124"],
    ["340", "70", "145"],
    ["899", "60", "118"],
    ["137", "12", "147"],
    ["470", "19", "450"],
    ["368", "70", "460"]
  ],
  "17/02/2025 to 23/02/2025": [
    ["389", "00", "569"],
    ["167", "49", "270"],
    ["177", "57", "269"],
    ["277", "66", "358"],
    ["690", "55", "249"],
    ["236", "10", "479"],
    ["289", "99", "379"]
  ],
  "24/02/2025 to 02/03/2025": [
    ["789", "41", "245"],
    ["335", "17", "115"],
    ["668", "02", "246"],
    ["800", "87", "458"],
    ["478", "95", "168"],
    ["150", "63", "689"],
    ["557", "78", "125"]
  ],
  "03/03/2025 to 09/03/2025": [
    ["158", "47", "188"],
    ["138", "29", "135"],
    ["259", "64", "248"],
    ["340", "73", "139"],
    ["390", "28", "170"],
    ["499", "26", "367"],
    ["466", "69", "126"]
  ],
  "10/03/2025 to 16/03/2025": [
    ["100", "15", "122"],
    ["300", "34", "356"],
    ["459", "88", "233"],
    ["278", "77", "368"],
    ["***", "*", "***"],
    ["269", "72", "156"],
    ["189", "84", "590"]
  ],
  "17/03/2025 to 23/03/2025": [
    ["114", "61", "588"],
    ["250", "74", "347"],
    ["334", "00", "127"],
    ["559", "98", "468"],
    ["146", "15", "339"],
    ["288", "89", "225"],
    ["790", "65", "159"]
  ],
  "24/03/2025 to 30/03/2025": [
    ["900", "97", "278"],
    ["489", "15", "348"],
    ["479", "03", "346"],
    ["116", "88", "369"],
    ["238", "32", "345"],
    ["360", "99", "180"],
    ["267", "56", "169"]
  ],
  "31/03/2025 to 06/04/2025": [
    ["469", "95", "258"],
    ["249", "52", "246"],
    ["550", "00", "136"],
    ["567", "89", "379"],
    ["330", "68", "378"],
    ["237", "20", "190"],
    ["137", "11", "146"]
  ],
  "07/04/2025 to 13/04/2025": [
    ["118", "07", "179"],
    ["245", "13", "238"],
    ["123", "64", "680"],
    ["455", "44", "158"],
    ["224", "89", "234"],
    ["456", "53", "166"],
    ["247", "35", "140"]
  ],
  "14/04/2025 to 20/04/2025": [
    ["679", "29", "135"],
    ["299", "07", "223"],
    ["129", "25", "230"],
    ["257", "41", "470"],
    ["347", "48", "350"],
    ["240", "60", "389"],
    ["124", "70", "569"]
  ],
  "21/04/2025 to 27/04/2025": [
    ["157", "31", "344"],
    ["789", "45", "799"],
    ["128", "14", "130"],
    ["246", "25", "690"],
    ["689", "36", "358"],
    ["169", "65", "357"],
    ["158", "43", "229"]
  ],
  "28/04/2025 to 04/05/2025": [
    ["699", "40", "136"],
    ["588", "15", "168"],
    ["579", "10", "145"],
    ["279", "82", "237"],
    ["670", "37", "133"],
    ["260", "80", "370"],
    ["190", "02", "147"]
  ],
  "05/05/2025 to 11/05/2025": [
    ["556", "61", "236"],
    ["579", "11", "245"],
    ["148", "32", "679"],
    ["346", "37", "340"],
    ["478", "97", "566"],
    ["278", "78", "170"],
    ["189", "82", "589"]
  ],
  "12/05/2025 to 18/05/2025": [
    ["246", "23", "445"],
    ["168", "51", "146"],
    ["577", "97", "115"],
    ["334", "03", "355"],
    ["899", "68", "378"],
    ["300", "33", "157"],
    ["370", "06", "790"]
  ],
  "19/05/2025 to 25/05/2025": [
    ["133", "76", "330"],
    ["468", "81", "678"],
    ["256", "32", "200"],
    ["280", "04", "789"],
    ["480", "22", "345"],
    ["457", "65", "780"],
    ["390", "24", "130"]
  ],
  "26/05/2025 to 01/06/2025": [
    ["489", "16", "169"],
    ["568", "95", "267"],
    ["167", "43", "788"],
    ["155", "18", "567"],
    ["260", "81", "146"],
    ["235", "07", "250"],
    ["119", "14", "770"]
  ],
  "02/06/2025 to 08/06/2025": [
    ["700", "77", "188"],
    ["369", "84", "239"],
    ["688", "26", "880"],
    ["268", "61", "380"],
    ["144", "90", "479"],
    ["570", "23", "689"],
    ["455", "44", "680"]
  ],
  "09/06/2025 to 15/06/2025": [
    ["780", "54", "266"],
    ["127", "01", "560"],
    ["300", "36", "169"],
    ["137", "18", "350"],
    ["467", "74", "789"],
    ["369", "80", "389"],
    ["236", "10", "226"]
  ],
  "16/06/2025 to 22/06/2025": [
    ["579", "12", "390"],
    ["379", "94", "130"],
    ["359", "70", "460"],
    ["668", "07", "179"],
    ["550", "00", "145"],
    ["378", "87", "566"],
    ["280", "05", "690"]
  ],
  "23/06/2025 to 29/06/2025": [
    ["159", "50", "190"],
    ["400", "49", "388"],
    ["890", "72", "156"],
    ["157", "35", "230"],
    ["368", "74", "257"],
    ["459", "84", "220"],
    ["170", "89", "478"]
  ],
  "30/06/2025 to 06/07/2025": [
    ["340", "72", "570"],
    ["279", "80", "299"],
    ["330", "60", "578"],
    ["180", "99", "234"],
    ["128", "15", "140"],
    ["480", "20", "569"],
    ["336", "20", "370"]
  ],
  "07/07/2025 to 13/07/2025": [
    ["799", "55", "159"],
    ["228", "23", "256"],
    ["260", "88", "567"],
    ["470", "11", "380"],
    ["125", "80", "389"],
    ["447", "51", "678"],
    ["550", "08", "224"]
  ],
  "14/07/2025 to 20/07/2025": [
    ["149", "40", "488"],
    ["270", "93", "120"],
    ["127", "02", "156"],
    ["489", "15", "690"],
    ["137", "11", "146"],
    ["390", "26", "178"],
    ["167", "41", "560"]
  ],
  "21/07/2025 to 27/07/2025": [
    ["800", "86", "790"],
    ["680", "40", "370"],
    ["289", "95", "258"],
    ["469", "96", "448"],
    ["470", "19", "234"],
    ["148", "31", "146"],
    ["500", "50", "244"]
  ],
  "28/07/2025 to 03/08/2025": [
    ["123", "65", "140"],
    ["100", "12", "660"],
    ["580", "33", "779"],
    ["170", "83", "157"],
    ["235", "00", "136"],
    ["349", "68", "378"],
    ["189", "88", "350"]
  ],
  "04/08/2025 to 10/08/2025": [
    ["355", "38", "459"],
    ["179", "70", "127"],
    ["180", "97", "133"],
    ["450", "92", "679"],
    ["238", "31", "155"],
    ["789", "48", "567"],
    ["239", "41", "245"]
  ],
  "11/08/2025 to 17/08/2025": [
    ["690", "58", "260"],
    ["577", "90", "145"],
    ["199", "92", "237"],
    ["790", "68", "170"],
    ["***", "*", "***"],
    ["147", "21", "344"],
    ["789", "45", "447"]
  ],
  "18/08/2025 to 24/08/2025": [
    ["770", "44", "590"],
    ["660", "25", "780"],
    ["134", "87", "890"],
    ["579", "10", "190"],
    ["367", "60", "578"],
    ["589", "22", "129"],
    ["160", "78", "170"]
  ],
  "25/08/2025 to 31/08/2025": [
    ["348", "53", "139"],
    ["100", "16", "178"],
    ["256", "30", "280"],
    ["469", "94", "257"],
    ["440", "88", "468"],
    ["237", "24", "446"],
    ["238", "39", "126"]
  ],
  "01/09/2025 to 07/09/2025": [
    ["180", "96", "457"],
    ["588", "13", "148"],
    ["224", "82", "480"],
    ["499", "28", "800"],
    ["234", "97", "359"],
    ["246", "22", "147"],
    ["129", "22", "390"]
  ],
  "08/09/2025 to 14/09/2025": [
    ["179", "77", "269"],
    ["346", "38", "567"],
    ["380", "16", "358"],
    ["158", "44", "347"],
    ["466", "67", "115"],
    ["560", "11", "335"],
    ["138", "24", "789"]
  ],
  "15/09/2025 to 21/09/2025": [
    ["250", "70", "479"],
    ["699", "45", "168"],
    ["689", "31", "290"],
    ["277", "69", "478"],
    ["669", "17", "179"],
    ["349", "60", "370"],
    ["469", "98", "279"]
  ],
  "22/09/2025 to 28/09/2025": [
    ["259", "66", "178"],
    ["369", "84", "167"],
    ["247", "38", "233"],
    ["568", "94", "356"],
    ["124", "77", "890"],
    ["499", "22", "138"],
    ["134", "82", "246"]
  ],
  "29/09/2025 to 05/10/2025": [
    ["366", "59", "135"],
    ["455", "40", "235"],
    ["690", "56", "790"],
    ["150", "65", "258"],
    ["340", "71", "137"],
    ["467", "71", "678"],
    ["260", "87", "377"]
  ],
  "06/10/2025 to 12/10/2025": [
    ["688", "22", "336"],
    ["449", "78", "288"],
    ["270", "94", "789"],
    ["456", "51", "399"],
    ["490", "37", "250"],
    ["127", "01", "245"],
    ["380", "12", "156"]
  ],
  "13/10/2025 to 19/10/2025": [
    ["460", "05", "168"],
    ["240", "65", "249"],
    ["146", "17", "124"],
    ["138", "25", "258"],
    ["379", "94", "130"],
    ["158", "44", "239"],
    ["570", "20", "190"]
  ],
  "20/10/2025 to 26/10/2025": [
    ["160", "70", "136"],
    ["679", "20", "280"],
    ["237", "25", "799"],
    ["357", "51", "678"],
    ["166", "31", "146"],
    ["589", "29", "568"],
    ["137", "18", "134"]
  ],
  "27/10/2025 to 02/11/2025": [
    ["778", "24", "112"],
    ["334", "03", "580"],
    ["360", "99", "126"],
    ["560", "15", "159"],
    ["800", "88", "378"],
    ["590", "46", "358"],
    ["680", "44", "167"]
  ],
  "03/11/2025 to 09/11/2025": [
    ["269", "77", "188"],
    ["899", "63", "256"],
    ["577", "99", "478"],
    ["670", "31", "146"],
    ["156", "28", "125"],
    ["267", "58", "189"],
    ["120", "32", "147"]
  ],
  "10/11/2025 to 16/11/2025": [
    ["136", "08", "440"],
    ["390", "22", "138"],
    ["148", "34", "680"],
    ["227", "18", "477"],
    ["348", "55", "357"],
    ["250", "70", "569"],
    ["128", "17", "368"]
  ],
  "17/11/2025 to 23/11/2025": [
    ["347", "49", "117"],
    ["299", "03", "139"],
    ["200", "27", "566"],
    ["135", "95", "230"],
    ["157", "37", "223"],
    ["280", "01", "380"],
    ["279", "87", "458"]
  ],
  "24/11/2025 to 30/11/2025": [
    ["290", "16", "268"],
    ["558", "83", "670"],
    ["160", "77", "278"],
    ["238", "39", "144"],
    ["559", "98", "170"],
    ["780", "50", "127"],
    ["234", "93", "346"]
  ],
  "01/12/2025 to 07/12/2025": [
    ["220", "47", "359"],
    ["557", "72", "480"],
    ["490", "39", "469"],
    ["669", "16", "169"],
    ["110", "24", "248"],
    ["133", "79", "270"],
    ["470", "13", "148"]
  ],
  "08/12/2025 to 14/12/2025": [
    ["149", "49", "450"],
    ["228", "27", "458"],
    ["370", "01", "146"],
    ["500", "53", "580"],
    ["160", "71", "245"],
    ["667", "97", "467"],
    ["489", "10", "190"]
  ],
  "15/12/2025 to 21/12/2025": [
    ["226", "06", "123"],
    ["357", "54", "446"],
    ["356", "48", "459"],
    ["256", "31", "137"],
    ["124", "77", "179"],
    ["240", "63", "157"],
    ["278", "70", "578"]
  ],
  "22/12/2025 to 28/12/2025": [
    ["129", "29", "379"],
    ["300", "34", "248"],
    ["113", "58", "279"],
    ["389", "07", "340"],
    ["590", "44", "130"],
    ["259", "65", "348"],
    ["690", "54", "338"]
  ],
  "29/12/2025 to 04/01/2026": [
    ["800", "85", "258"],
    ["277", "66", "114"],
    ["560", "15", "339"],
    ["380", "16", "123"],
    ["135", "92", "147"],
    ["178", "60", "479"],
    ["117", "99", "469"]
  ],
  "05/01/2026 to 11/01/2026": [
    ["770", "46", "259"],
    ["180", "95", "177"],
    ["230", "59", "270"],
    ["678", "15", "357"],
    ["468", "87", "359"],
    ["345", "20", "190"],
    ["157", "30", "145"]
  ],
  "12/01/2026 to 18/01/2026": [
    ["127", "05", "140"],
    ["390", "23", "337"],
    ["169", "63", "256"],
    ["155", "16", "790"],
    ["267", "58", "116"],
    ["599", "37", "700"],
    ["125", "86", "277"]
  ],
  "19/01/2026 to 25/01/2026": [
    ["667", "92", "660"],
    ["234", "96", "268"],
    ["146", "10", "479"],
    ["349", "69", "478"],
    ["257", "41", "579"],
    ["379", "91", "236"],
    ["789", "44", "347"]
  ],
  "26/01/2026 to 01/02/2026": [
    ["***", "*", "***"],
    ["358", "62", "570"],
    ["128", "19", "126"],
    ["690", "51", "290"],
    ["168", "53", "355"],
    ["890", "73", "148"],
    ["167", "43", "490"]
  ],
  "02/02/2026 to 08/02/2026": [
    ["238", "37", "269"],
    ["569", "03", "157"],
    ["255", "26", "259"],
    ["467", "76", "169"],
    ["227", "13", "788"],
    ["678", "16", "150"],
    ["379", "94", "239"]
  ],
  "09/02/2026 to 15/02/2026": [
    ["380", "19", "144"],
    ["178", "64", "158"],
    ["589", "20", "479"],
    ["188", "78", "369"],
    ["189", "83", "670"],
    ["367", "66", "330"],
    ["159", "56", "358"]
  ],
  "16/02/2026 to 22/02/2026": [
    ["137", "12", "336"],
    ["900", "98", "440"],
    ["177", "54", "149"],
    ["247", "36", "114"],
    ["224", "80", "460"],
    ["578", "00", "190"],
    ["400", "44", "266"]
  ],
  "23/02/2026 to 01/03/2026": [
    ["668", "01", "489"],
    ["335", "16", "790"],
    ["590", "48", "567"],
    ["340", "72", "345"],
    ["480", "22", "390"],
    ["278", "76", "169"],
    ["244", "01", "678"]
  ],
  "02/03/2026 to 08/03/2026": [
    ["445", "38", "134"],
    ["688", "26", "240"],
    ["***", "*", "***"],
    ["370", "05", "249"],
    ["560", "10", "235"],
    ["267", "50", "550"],
    ["250", "70", "479"]
  ],
  "09/03/2026 to 15/03/2026": [
    ["339", "55", "348"],
    ["680", "46", "457"],
    ["230", "51", "470"],
    ["368", "71", "245"],
    ["579", "17", "377"],
    ["360", "93", "779"],
    ["679", "24", "347"]
  ],
  "16/03/2026 to 22/03/2026": [
    ["260", "85", "780"],
    ["569", "07", "458"],
    ["459", "82", "200"],
    ["126", "90", "578"],
    ["289", "99", "478"],
    ["115", "73", "490"],
    ["667", "91", "489"]
  ]
};
export const SUPREMENIGHT = {
  "01/01/2024 to 07/01/2024": [
    ['137', '16', '123'],
    ['178', '61', '236'],
    ['289', '93', '256'],
    ['369', '88', '378'],
    ['280', '07', '890'],
    ['467', '73', '580'],
    ['360', '98', '567'],
  ],
  "08/01/2024 to 14/01/2024": [
    ['124', '76', '268'],
    ['270', '99', '234'],
    ['356', '49', '117'],
    ['168', '58', '224'],
    ['235', '03', '157'],
    ['145', '00', '244'],
    ['578', '01', '155'],
  ],
  "15/01/2024 to 21/01/2024": [
    ['256', '34', '680'],
    ['236', '11', '489'],
    ['120', '36', '169'],
    ['349', '69', '289'],
    ['450', '97', '160'],
    ['158', '48', '125'],
    ['122', '53', '139'],
  ],
  "22/01/2024 to 28/01/2024": [
    ['150', '69', '199'],
    ['133', '70', '668'],
    ['450', '96', '178'],
    ['469', '90', '389'],
    ['***', '**', '***'],
    ['155', '11', '579'],
    ['469', '97', '368'],
  ],
  "29/01/2024 to 04/02/2024": [
    ['124', '77', '890'],
    ['127', '07', '160'],
    ['589', '28', '134'],
    ['139', '32', '480'],
    ['567', '88', '189'],
    ['144', '91', '678'],
    ['880', '60', '145'],
  ],
  "05/02/2024 to 11/02/2024": [
    ['447', '51', '290'],
    ['260', '89', '234'],
    ['446', '42', '255'],
    ['299', '01', '119'],
    ['249', '52', '778'],
    ['158', '44', '789'],
    ['156', '21', '344'],
  ],
  "12/02/2024 to 18/02/2024": [
    ['445', '33', '229'],
    ['266', '42', '336'],
    ['470', '10', '235'],
    ['115', '73', '247'],
    ['126', '93', '238'],
    ['230', '55', '348'],
    ['389', '00', '280'],
  ],
  "19/02/2024 to 25/02/2024": [
    ['244', '06', '123'],
    ['450', '95', '357'],
    ['250', '75', '168'],
    ['350', '87', '160'],
    ['138', '23', '166'],
    ['670', '39', '559'],
    ['179', '76', '240'],
  ],
  "26/02/2024 to 03/03/2024": [
    ['190', '05', '357'],
    ['356', '41', '470'],
    ['568', '92', '147'],
    ['680', '46', '240'],
    ['789', '41', '146'],
    ['278', '73', '779'],
    ['479', '08', '440'],
  ],
  "04/03/2024 to 10/03/2024": [
    ['136', '06', '457'],
    ['160', '72', '390'],
    ['460', '00', '235'],
    ['368', '73', '157'],
    ['300', '39', '135'],
    ['379', '95', '348'],
    ['189', '81', '146'],
  ],
  "11/03/2024 to 17/03/2024": [
    ['225', '99', '126'],
    ['368', '76', '114'],
    ['447', '56', '466'],
    ['158', '41', '128'],
    ['248', '41', '560'],
    ['677', '02', '129'],
    ['166', '35', '780'],
  ],
  "18/03/2024 to 24/03/2024": [
    ['138', '25', '168'],
    ['678', '19', '469'],
    ['579', '13', '445'],
    ['233', '87', '377'],
    ['126', '93', '580'],
    ['156', '21', '146'],
    ['570', '20', '479'],
  ],
  "25/03/2024 to 31/03/2024": [
    ['***', '**', '***'],
    ['770', '46', '268'],
    ['790', '65', '690'],
    ['678', '10', '488'],
    ['670', '37', '890'],
    ['225', '98', '440'],
    ['168', '53', '120'],
  ],
  "01/04/2024 to 07/04/2024": [
    ['300', '37', '449'],
    ['345', '29', '469'],
    ['268', '60', '145'],
    ['459', '80', '578'],
    ['340', '74', '257'],
    ['689', '33', '256'],
    ['455', '46', '240'],
  ],
  "08/04/2024 to 14/04/2024": [
    ['456', '51', '128'],
    ['370', '07', '269'],
    ['220', '47', '566'],
    ['268', '68', '134'],
    ['178', '68', '369'],
    ['278', '75', '500'],
    ['237', '24', '130'],
  ],
  "15/04/2024 to 21/04/2024": [
    ['450', '99', '270'],
    ['167', '44', '266'],
    ['160', '74', '158'],
    ['799', '55', '267'],
    ['567', '87', '124'],
    ['470', '11', '669'],
    ['278', '79', '469'],
  ],
  "22/04/2024 to 28/04/2024": [
    ['123', '66', '556'],
    ['127', '05', '177'],
    ['567', '81', '128'],
    ['680', '46', '123'],
    ['138', '26', '178'],
    ['446', '45', '780'],
    ['356', '49', '180'],
  ],
  "29/04/2024 to 05/05/2024": [
    ['358', '66', '600'],
    ['124', '78', '369'],
    ['337', '38', '279'],
    ['460', '09', '126'],
    ['177', '53', '689'],
    ['128', '11', '146'],
    ['590', '46', '259'],
  ],
  "06/05/2024 to 12/05/2024": [
    ['480', '27', '269'],
    ['225', '90', '136'],
    ['280', '06', '556'],
    ['357', '54', '338'],
    ['440', '83', '256'],
    ['149', '40', '136'],
    ['240', '62', '570'],
  ],
  "13/05/2024 to 19/05/2024": [
    ['256', '39', '135'],
    ['278', '77', '188'],
    ['155', '18', '170'],
    ['117', '95', '799'],
    ['678', '14', '789'],
    ['150', '64', '455'],
    ['559', '94', '239'],
  ],
  "20/05/2024 to 26/05/2024": [
    ['228', '20', '550'],
    ['678', '12', '336'],
    ['123', '65', '230'],
    ['467', '73', '580'],
    ['112', '48', '260'],
    ['144', '97', '890'],
    ['389', '01', '137'],
  ],
  "27/05/2024 to 02/06/2024": [
    ['120', '31', '128'],
    ['179', '75', '690'],
    ['459', '85', '357'],
    ['367', '66', '123'],
    ['159', '58', '369'],
    ['360', '99', '667'],
    ['147', '28', '189'],
  ],
  "03/06/2024 to 09/06/2024": [
    ['449', '79', '360'],
    ['470', '12', '570'],
    ['379', '95', '690'],
    ['120', '33', '346'],
    ['248', '48', '125'],
    ['778', '20', '190'],
    ['400', '47', '223'],
  ],
  "10/06/2024 to 16/06/2024": [
    ['456', '51', '678'],
    ['179', '72', '345'],
    ['146', '11', '489'],
    ['558', '84', '149'],
    ['368', '73', '670'],
    ['258', '57', '359'],
    ['135', '99', '126'],
  ],
  "17/06/2024 to 23/06/2024": [
    ['237', '26', '240'],
    ['356', '43', '148'],
    ['249', '58', '288'],
    ['388', '90', '136'],
    ['137', '12', '228'],
    ['236', '15', '122'],
    ['355', '35', '267'],
  ],
  "24/06/2024 to 30/06/2024": [
    ['127', '07', '890'],
    ['225', '96', '150'],
    ['448', '64', '770'],
    ['589', '21', '489'],
    ['337', '38', '558'],
    ['467', '71', '146'],
    ['230', '50', '127'],
  ],
  "01/07/2024 to 07/07/2024": [
    ['678', '13', '247'],
    ['340', '76', '358'],
    ['456', '50', '136'],
    ['467', '75', '348'],
    ['680', '45', '456'],
    ['489', '19', '126'],
    ['124', '76', '150'],
  ],
  "08/07/2024 to 14/07/2024": [
    ['380', '16', '268'],
    ['680', '49', '469'],
    ['399', '11', '245'],
    ['257', '43', '346'],
    ['345', '21', '128'],
    ['468', '81', '579'],
    ['390', '27', '179'],
  ],
  "15/07/2024 to 21/07/2024": [
    ['668', '05', '500'],
    ['168', '54', '455'],
    ['445', '39', '270'],
    ['260', '81', '489'],
    ['188', '79', '234'],
    ['278', '75', '159'],
    ['699', '41', '380'],
  ],
  "22/07/2024 to 28/07/2024": [
    ['238', '34', '257'],
    ['233', '89', '180'],
    ['138', '20', '299'],
    ['448', '65', '113'],
    ['149', '44', '680'],
    ['150', '63', '355'],
    ['236', '17', '449'],
  ],
  "29/07/2024 to 04/08/2024": [
    ['237', '20', '118'],
    ['567', '86', '277'],
    ['690', '53', '157'],
    ['145', '02', '570'],
    ['359', '71', '344'],
    ['123', '62', '129'],
    ['260', '84', '680'],
  ],
  "05/08/2024 to 11/08/2024": [
    ['336', '22', '237'],
    ['478', '90', '370'],
    ['137', '15', '168'],
    ['467', '75', '456'],
    ['178', '64', '158'],
    ['378', '88', '189'],
    ['459', '84', '590'],
  ],
  "12/08/2024 to 18/08/2024": [
    ['458', '74', '338'],
    ['689', '33', '157'],
    ['146', '17', '467'],
    ['***', '**', '***'],
    ['150', '62', '480'],
    ['135', '93', '445'],
    ['290', '17', '250'],
  ],
  "19/08/2024 to 25/08/2024": [
    ['267', '55', '159'],
    ['189', '85', '690'],
    ['199', '90', '118'],
    ['139', '30', '578'],
    ['148', '33', '788'],
    ['158', '41', '245'],
    ['135', '90', '299'],
  ],
  "26/08/2024 to 01/09/2024": [
    ['157', '35', '780'],
    ['377', '72', '570'],
    ['560', '19', '135'],
    ['345', '27', '179'],
    ['116', '86', '457'],
    ['127', '06', '178'],
    ['279', '87', '377'],
  ],
  "02/09/2024 to 08/09/2024": [
    ['447', '59', '234'],
    ['770', '44', '338'],
    ['146', '11', '100'],
    ['457', '69', '667'],
    ['157', '34', '347'],
    ['560', '13', '139'],
    ['349', '63', '120'],
  ],
  "09/09/2024 to 15/09/2024": [
    ['700', '75', '168'],
    ['134', '80', '668'],
    ['347', '44', '149'],
    ['368', '73', '238'],
    ['137', '15', '456'],
    ['138', '25', '348'],
    ['689', '37', '368'],
  ],
  "16/09/2024 to 22/09/2024": [
    ['178', '63', '670'],
    ['128', '18', '279'],
    ['159', '50', '136'],
    ['349', '66', '240'],
    ['479', '01', '470'],
    ['148', '36', '240'],
    ['348', '52', '589'],
  ],
  "23/09/2024 to 29/09/2024": [
    ['445', '32', '246'],
    ['379', '98', '125'],
    ['377', '76', '169'],
    ['668', '01', '380'],
    ['117', '93', '166'],
    ['237', '25', '447'],
    ['350', '80', '488'],
  ],
  "30/09/2024 to 06/10/2024": [
    ['278', '76', '556'],
    ['128', '14', '149'],
    ['450', '98', '134'],
    ['400', '48', '477'],
    ['570', '22', '246'],
    ['135', '91', '146'],
    ['468', '80', '569'],
  ],
  "07/10/2024 to 13/10/2024": [
    ['377', '72', '660'],
    ['238', '34', '130'],
    ['446', '40', '235'],
    ['289', '96', '367'],
    ['170', '84', '590'],
    ['240', '65', '159'],
    ['155', '11', '669'],
  ],
  "14/10/2024 to 20/10/2024": [
    ['579', '17', '458'],
    ['469', '93', '148'],
    ['336', '23', '599'],
    ['460', '05', '140'],
    ['446', '44', '257'],
    ['337', '39', '360'],
    ['500', '56', '899'],
  ],
  "21/10/2024 to 27/10/2024": [
    ['300', '34', '130'],
    ['234', '99', '180'],
    ['223', '71', '489'],
    ['114', '60', '244'],
    ['459', '85', '267'],
    ['570', '20', '145'],
    ['117', '98', '125'],
  ],
  "28/10/2024 to 03/11/2024": [
    ['270', '98', '134'],
    ['335', '15', '159'],
    ['257', '47', '133'],
    ['246', '20', '280'],
    ['226', '05', '140'],
    ['557', '70', '118'],
    ['178', '66', '367'],
  ],
  "04/11/2024 to 10/11/2024": [
    ['122', '59', '360'],
    ['578', '08', '350'],
    ['689', '35', '500'],
    ['390', '27', '458'],
    ['789', '42', '778'],
    ['188', '75', '113'],
    ['478', '94', '770'],
  ],
  "11/11/2024 to 17/11/2024": [
    ['190', '01', '470'],
    ['356', '49', '900'],
    ['150', '60', '389'],
    ['568', '92', '129'],
    ['160', '76', '277'],
    ['567', '82', '345'],
    ['156', '21', '128'],
  ],
  "18/11/2024 to 24/11/2024": [
    ['235', '06', '268'],
    ['124', '78', '567'],
    ['247', '35', '357'],
    ['135', '94', '789'],
    ['579', '12', '345'],
    ['790', '63', '166'],
    ['448', '69', '270'],
  ],
  "25/11/2024 to 01/12/2024": [
    ['340', '73', '238'],
    ['245', '11', '380'],
    ['690', '51', '100'],
    ['445', '39', '289'],
    ['449', '76', '358'],
    ['147', '20', '370'],
    ['144', '90', '136'],
  ],
  "02/12/2024 to 08/12/2024": [
    ['479', '08', '378'],
    ['799', '53', '580'],
    ['224', '87', '269'],
    ['499', '24', '347'],
    ['466', '65', '230'],
    ['588', '14', '167'],
    ['569', '04', '356'],
  ],
  "09/12/2024 to 15/12/2024": [
    ['600', '66', '349'],
    ['678', '11', '290'],
    ['338', '45', '267'],
    ['550', '01', '137'],
    ['250', '70', '127'],
    ['180', '96', '457'],
    ['469', '92', '237'],
  ],
  "16/12/2024 to 22/12/2024": [
    ['990', '81', '227'],
    ['126', '93', '120'],
    ['169', '67', '115'],
    ['590', '49', '135'],
    ['239', '45', '366'],
    ['890', '79', '360'],
    ['266', '40', '334'],
  ],
  "23/12/2024 to 29/12/2024": [
    ['440', '88', '170'],
    ['157', '34', '257'],
    ['367', '60', '190'],
    ['189', '85', '339'],
    ['133', '71', '380'],
    ['256', '30', '280'],
    ['270', '91', '489'],
  ],
  "30/12/2024 to 05/01/2025": [
    ['399', '16', '114'],
    ['134', '84', '167'],
    ['358', '69', '379'],
    ['177', '56', '123'],
    ['146', '15', '500'],
    ['127', '06', '259'],
    ['558', '88', '567'],
  ],
  "06/01/2025 to 12/01/2025": [
    ['556', '63', '670'],
    ['136', '01', '588'],
    ['499', '22', '480'],
    ['338', '43', '247'],
    ['468', '87', '124'],
    ['779', '37', '467'],
    ['248', '44', '239'],
  ],
  "13/01/2025 to 19/01/2025": [
    ['140', '53', '355'],
    ['277', '68', '125'],
    ['112', '41', '579'],
    ['488', '05', '690'],
    ['144', '95', '230'],
    ['134', '85', '159'],
    ['788', '33', '157'],
  ],
  "20/01/2025 to 26/01/2025": [
    ['568', '90', '460'],
    ['139', '38', '288'],
    ['110', '21', '560'],
    ['127', '01', '236'],
    ['113', '54', '356'],
    ['145', '06', '457'],
    ['***', '**', '***'],
  ],
  "27/01/2025 to 02/02/2025": [
    ['168', '57', '458'],
    ['240', '60', '190'],
    ['679', '23', '120'],
    ['300', '38', '170'],
    ['459', '84', '220'],
    ['700', '70', '569'],
    ['158', '40', '460'],
  ],
  "03/02/2025 to 09/02/2025": [
    ['255', '27', '160'],
    ['180', '95', '447'],
    ['680', '43', '490'],
    ['477', '87', '890'],
    ['359', '78', '378'],
    ['370', '01', '128'],
    ['347', '42', '589'],
  ],
  "10/02/2025 to 16/02/2025": [
    ['388', '93', '580'],
    ['258', '50', '244'],
    ['138', '28', '468'],
    ['467', '71', '470'],
    ['345', '25', '780'],
    ['137', '15', '348'],
    ['668', '02', '147'],
  ],
  "17/02/2025 to 23/02/2025": [
    ['899', '67', '179'],
    ['139', '32', '480'],
    ['158', '40', '299'],
    ['270', '99', '478'],
    ['368', '76', '259'],
    ['268', '65', '889'],
    ['279', '81', '290'],
  ],
  "24/02/2025 to 02/03/2025": [
    ['550', '05', '267'],
    ['235', '06', '556'],
    ['245', '11', '119'],
    ['125', '82', '679'],
    ['456', '59', '234'],
    ['460', '09', '559'],
    ['369', '86', '240'],
  ],
  "03/03/2025 to 09/03/2025": [
    ['567', '87', '124'],
    ['566', '71', '669'],
    ['150', '69', '289'],
    ['367', '64', '789'],
    ['238', '35', '140'],
    ['370', '02', '156'],
    ['570', '28', '350'],
  ],
  "10/03/2025 to 16/03/2025": [
    ['116', '83', '256'],
    ['236', '16', '790'],
    ['280', '07', '557'],
    ['129', '28', '170'],
    ['***', '**', '***'],
    ['699', '44', '167'],
    ['599', '30', '235'],
  ],
  "17/03/2025 to 23/03/2025": [
    ['577', '93', '355'],
    ['147', '26', '169'],
    ['149', '47', '278'],
    ['136', '08', '459'],
    ['349', '61', '245'],
    ['250', '73', '580'],
    ['160', '75', '168'],
  ],
  "24/03/2025 to 30/03/2025": [
    ['120', '33', '490'],
    ['560', '10', '127'],
    ['228', '25', '249'],
    ['268', '67', '269'],
    ['460', '07', '359'],
    ['122', '59', '900'],
    ['100', '19', '450'],
  ],
  "31/03/2025 to 06/04/2025": [
    ['117', '94', '130'],
    ['123', '68', '468'],
    ['467', '71', '399'],
    ['500', '51', '579'],
    ['136', '07', '179'],
    ['246', '22', '480'],
    ['240', '68', '378'],
  ],
  "07/04/2025 to 13/04/2025": [
    ['356', '49', '126'],
    ['366', '50', '334'],
    ['457', '67', '250'],
    ['990', '85', '447'],
    ['780', '50', '677'],
    ['689', '31', '137'],
    ['178', '65', '168'],
  ],
  "14/04/2025 to 20/04/2025": [
    ['227', '12', '255'],
    ['123', '62', '200'],
    ['118', '00', '145'],
    ['360', '94', '239'],
    ['167', '40', '280'],
    ['478', '96', '457'],
    ['778', '21', '380'],
  ],
  "21/04/2025 to 27/04/2025": [
    ['260', '85', '348'],
    ['124', '76', '899'],
    ['670', '33', '580'],
    ['339', '51', '155'],
    ['138', '20', '569'],
    ['446', '47', '188'],
    ['357', '54', '789'],
  ],
  "28/04/2025 to 04/05/2025": [
    ['119', '19', '199'],
    ['680', '48', '990'],
    ['238', '35', '168'],
    ['456', '55', '159'],
    ['479', '00', '569'],
    ['190', '07', '368'],
    ['348', '52', '147'],
  ],
  "05/05/2025 to 11/05/2025": [
    ['356', '45', '249'],
    ['440', '89', '289'],
    ['144', '91', '227'],
    ['139', '39', '469'],
    ['126', '97', '458'],
    ['127', '08', '125'],
    ['258', '56', '150'],
  ],
  "12/05/2025 to 18/05/2025": [
    ['357', '57', '278'],
    ['489', '13', '346'],
    ['667', '90', '488'],
    ['336', '26', '349'],
    ['279', '81', '146'],
    ['256', '32', '147'],
    ['578', '09', '234'],
  ],
  "19/05/2025 to 25/05/2025": [
    ['459', '87', '566'],
    ['455', '46', '268'],
    ['380', '10', '569'],
    ['168', '59', '388'],
    ['570', '28', '567'],
    ['223', '73', '689'],
    ['778', '21', '560'],
  ],
  "26/05/2025 to 01/06/2025": [
    ['490', '32', '345'],
    ['170', '80', '226'],
    ['880', '67', '188'],
    ['470', '15', '366'],
    ['338', '41', '290'],
    ['100', '15', '456'],
    ['580', '32', '480'],
  ],
  "02/06/2025 to 08/06/2025": [
    ['136', '03', '300'],
    ['579', '12', '499'],
    ['489', '10', '235'],
    ['158', '49', '450'],
    ['240', '68', '134'],
    ['700', '72', '390'],
    ['600', '69', '135'],
  ],
  "09/06/2025 to 15/06/2025": [
    ['358', '63', '788'],
    ['146', '15', '159'],
    ['690', '51', '399'],
    ['129', '24', '239'],
    ['688', '28', '350'],
    ['115', '70', '389'],
    ['359', '79', '289'],
  ],
  "16/06/2025 to 22/06/2025": [
    ['334', '00', '479'],
    ['114', '61', '236'],
    ['378', '83', '139'],
    ['167', '49', '577'],
    ['180', '99', '469'],
    ['128', '10', '488'],
    ['135', '92', '589'],
  ],
  "23/06/2025 to 29/06/2025": [
    ['230', '57', '557'],
    ['348', '50', '460'],
    ['480', '28', '279'],
    ['680', '46', '259'],
    ['290', '12', '255'],
    ['337', '31', '678'],
    ['379', '99', '469'],
  ],
  "30/06/2025 to 06/07/2025": [
    ['189', '81', '100'],
    ['125', '86', '240'],
    ['157', '34', '789'],
    ['400', '48', '800'],
    ['367', '60', '569'],
    ['280', '04', '167'],
    ['247', '30', '578'],
  ],
  "07/07/2025 to 13/07/2025": [
    ['360', '98', '233'],
    ['149', '43', '238'],
    ['146', '12', '679'],
    ['570', '22', '237'],
    ['346', '33', '148'],
    ['790', '60', '127'],
    ['115', '72', '480'],
  ],
  "14/07/2025 to 20/07/2025": [
    ['169', '63', '580'],
    ['156', '25', '249'],
    ['889', '58', '233'],
    ['590', '47', '368'],
    ['459', '80', '370'],
    ['277', '68', '567'],
    ['270', '96', '457'],
  ],
  "21/07/2025 to 27/07/2025": [
    ['299', '08', '279'],
    ['220', '41', '335'],
    ['378', '83', '346'],
    ['110', '29', '135'],
    ['179', '77', '449'],
    ['490', '38', '134'],
    ['126', '99', '289'],
  ],
  "28/07/2025 to 03/08/2025": [
    ['137', '11', '470'],
    ['799', '54', '400'],
    ['244', '05', '456'],
    ['189', '87', '160'],
    ['123', '60', '118'],
    ['148', '38', '224'],
    ['200', '20', '460'],
  ],
  "04/08/2025 to 10/08/2025": [
    ['223', '72', '688'],
    ['226', '08', '125'],
    ['260', '80', '578'],
    ['130', '43', '689'],
    ['779', '33', '157'],
    ['780', '55', '357'],
    ['379', '98', '378'],
  ],
  "11/08/2025 to 17/08/2025": [
    ['234', '90', '550'],
    ['344', '17', '133'],
    ['445', '38', '116'],
    ['458', '74', '266'],
    ['***', '**', '***'],
    ['169', '66', '240'],
    ['134', '87', '368'],
  ],
  "18/08/2025 to 24/08/2025": [
    ['155', '16', '358'],
    ['479', '00', '389'],
    ['140', '54', '167'],
    ['678', '15', '168'],
    ['677', '07', '359'],
    ['350', '81', '119'],
    ['129', '20', '145'],
  ],
  "25/08/2025 to 31/08/2025": [
    ['447', '55', '177'],
    ['490', '39', '568'],
    ['390', '22', '589'],
    ['190', '05', '249'],
    ['245', '13', '157'],
    ['279', '88', '189'],
    ['237', '20', '389'],
  ],
  "01/09/2025 to 07/09/2025": [
    ['369', '87', '340'],
    ['230', '59', '135'],
    ['456', '51', '236'],
    ['670', '30', '145'],
    ['200', '27', '700'],
    ['156', '20', '460'],
    ['368', '72', '147'],
  ],
  "08/09/2025 to 14/09/2025": [
    ['246', '23', '689'],
    ['234', '96', '114'],
    ['469', '91', '560'],
    ['449', '70', '299'],
    ['799', '56', '178'],
    ['233', '82', '679'],
    ['779', '37', '359'],
  ],
  "15/09/2025 to 21/09/2025": [
    ['116', '84', '149'],
    ['668', '06', '150'],
    ['357', '53', '139'],
    ['278', '71', '128'],
    ['300', '33', '148'],
    ['677', '09', '180'],
    ['256', '33', '490'],
  ],
  "22/09/2025 to 28/09/2025": [
    ['250', '74', '356'],
    ['370', '05', '140'],
    ['499', '29', '360'],
    ['277', '64', '455'],
    ['126', '90', '145'],
    ['238', '32', '679'],
    ['237', '24', '167'],
  ],
  "29/09/2025 to 05/10/2025": [
    ['488', '02', '336'],
    ['258', '53', '788'],
    ['146', '12', '778'],
    ['459', '88', '134'],
    ['900', '92', '147'],
    ['190', '07', '115'],
    ['349', '68', '260'],
  ],
  "06/10/2025 to 12/10/2025": [
    ['557', '76', '790'],
    ['477', '80', '280'],
    ['267', '55', '230'],
    ['144', '94', '248'],
    ['114', '66', '358'],
    ['789', '44', '446'],
    ['137', '13', '490'],
  ],
  "13/10/2025 to 19/10/2025": [
    ['155', '10', '578'],
    ['366', '56', '259'],
    ['469', '95', '889'],
    ['345', '24', '356'],
    ['800', '81', '380'],
    ['450', '98', '378'],
    ['157', '31', '489'],
  ],
  "20/10/2025 to 26/10/2025": [
    ['677', '07', '458'],
    ['560', '17', '188'],
    ['477', '81', '146'],
    ['670', '35', '168'],
    ['339', '58', '279'],
    ['467', '73', '139'],
    ['460', '00', '190'],
  ],
  "27/10/2025 to 02/11/2025": [
    ['189', '86', '600'],
    ['479', '02', '156'],
    ['599', '39', '135'],
    ['680', '43', '247'],
    ['345', '22', '589'],
    ['690', '51', '579'],
    ['257', '44', '590'],
  ],
  "03/11/2025 to 09/11/2025": [
    ['790', '69', '180'],
    ['344', '12', '480'],
    ['370', '07', '269'],
    ['122', '54', '130'],
    ['239', '45', '140'],
    ['147', '29', '478'],
    ['345', '26', '114'],
  ],
  "10/11/2025 to 16/11/2025": [
    ['788', '38', '116'],
    ['450', '96', '169'],
    ['379', '99', '360'],
    ['679', '25', '113'],
    ['789', '40', '299'],
    ['248', '49', '126'],
    ['150', '64', '167'],
  ],
  "17/11/2025 to 23/11/2025": [
    ['226', '06', '880'],
    ['347', '49', '135'],
    ['588', '15', '113'],
    ['366', '51', '137'],
    ['123', '62', '660'],
    ['377', '76', '367'],
    ['570', '29', '469'],
  ],
  "24/11/2025 to 30/11/2025": [
    ['189', '84', '257'],
    ['447', '52', '129'],
    ['689', '31', '290'],
    ['569', '09', '559'],
    ['457', '65', '230'],
    ['470', '11', '560'],
    ['117', '91', '146'],
  ],
  "01/12/2025 to 07/12/2025": [
    ['288', '83', '157'],
    ['580', '32', '589'],
    ['225', '95', '889'],
    ['235', '07', '179'],
    ['259', '63', '337'],
    ['448', '64', '158'],
    ['170', '89', '450'],
  ],
  "08/12/2025 to 14/12/2025": [
    ['490', '30', '479'],
    ['567', '85', '780'],
    ['590', '42', '480'],
    ['380', '19', '388'],
    ['256', '37', '340'],
    ['178', '63', '238'],
    ['140', '59', '478'],
  ],
  "15/12/2025 to 21/12/2025": [
    ['199', '98', '800'],
    ['255', '21', '579'],
    ['368', '78', '134'],
    ['166', '31', '489'],
    ['358', '68', '378'],
    ['280', '03', '580'],
    ['679', '22', '345'],
  ],
  "22/12/2025 to 28/12/2025": [
    ['349', '66', '150'],
    ['127', '04', '248'],
    ['577', '97', '449'],
    ['258', '50', '136'],
    ['669', '13', '788'],
    ['240', '66', '123'],
    ['190', '06', '268'],
  ],
  "29/12/2025 to 04/01/2026": [
    ['779', '32', '138'],
    ['477', '89', '568'],
    ['357', '56', '790'],
    ['145', '04', '455'],
    ['178', '64', '149'],
    ['456', '55', '267'],
    ['479', '04', '112'],
  ],
  "05/01/2026 to 11/01/2026": [
    ['590', '46', '330'],
    ['390', '20', '578'],
    ['890', '73', '599'],
    ['880', '60', '460'],
    ['677', '03', '247'],
    ['370', '06', '169'],
    ['380', '18', '378'],
  ],
  "12/01/2026 to 18/01/2026": [
    ['467', '76', '600'],
    ['569', '05', '258'],
    ['550', '08', '350'],
    ['128', '13', '256'],
    ['468', '80', '235'],
    ['120', '32', '129'],
    ['450', '96', '358'],
  ],
  "19/01/2026 to 25/01/2026": [
    ['458', '77', '179'],
    ['690', '56', '457'],
    ['200', '23', '148'],
    ['579', '18', '189'],
    ['669', '18', '459'],
    ['260', '85', '267'],
    ['190', '00', '127'],
  ],
  "26/01/2026 to 01/02/2026": [
    ['***', '**', '***'],
    ['144', '95', '113'],
    ['349', '63', '247'],
    ['156', '21', '290'],
    ['125', '87', '160'],
    ['560', '14', '789'],
    ['356', '42', '589'],
  ],
  "02/02/2026 to 08/02/2026": [
    ['577', '92', '390'],
    ['446', '47', '160'],
    ['558', '83', '490'],
    ['348', '54', '347'],
    ['457', '69', '478'],
    ['280', '09', '360'],
    ['345', '26', '358'],
  ],
  "09/02/2026 to 15/02/2026": [
    ['180', '95', '366'],
    ['788', '36', '899'],
    ['134', '80', '569'],
    ['389', '09', '270'],
    ['480', '21', '678'],
    ['170', '85', '159'],
    ['368', '70', '460'],
  ],
  "16/02/2026 to 22/02/2026": [
    ['369', '84', '257'],
    ['388', '94', '680'],
    ['223', '75', '799'],
    ['147', '22', '679'],
    ['689', '30', '479'],
    ['140', '56', '367'],
    ['236', '11', '470'],
  ],
  "23/02/2026 to 01/03/2026": [
    ['778', '26', '150'],
    ['339', '52', '237'],
    ['445', '33', '157'],
    ['188', '74', '149'],
    ['125', '88', '468'],
    ['399', '17', '359'],
    ['280', '03', '238'],
  ],
  "02/03/2026 to 08/03/2026": [
    ['688', '29', '667'],
    ['568', '93', '247'],
    ['***', '**', '***'],
    ['110', '21', '137'],
    ['338', '46', '358'],
    ['356', '42', '156'],
    ['467', '74', '239'],
  ],
  "09/03/2026 to 15/03/2026": [
    ['370', '05', '159'],
    ['228', '20', '389'],
    ['340', '77', '124'],
    ['138', '21', '489'],
    ['220', '44', '257'],
    ['990', '87', '160'],
    ['680', '43', '580'],
  ],
  "16/03/2026 to 22/03/2026": [
    ['223', '72', '679'],
    ['255', '29', '135'],
    ['789', '40', '460'],
    ['245', '12', '390'],
    ['226', '03', '139'],
    ['478', '92', '570'],
    ['479', '01', '146'],
  ],
  };

  export const VEDAMORNING = {
  "30/12/2024 to 05/01/2025": [
    ["559", "92", "688"],
    ["180", "92", "200"],
    ["568", "97", "115"],
    ["490", "37", "160"],
    ["379", "94", "158"],
    ["235", "06", "899"],
    ["366", "50", "235"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["999", "73", "670"],
    ["237", "29", "144"],
    ["369", "83", "256"],
    ["347", "49", "199"],
    ["599", "33", "247"],
    ["144", "97", "133"],
    ["580", "34", "400"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["334", "06", "466"],
    ["469", "99", "225"],
    ["357", "59", "388"],
    ["228", "26", "169"],
    ["699", "48", "477"],
    ["456", "56", "466"],
    ["118", "09", "126"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["248", "43", "689"],
    ["266", "43", "148"],
    ["227", "18", "189"],
    ["144", "91", "669"],
    ["222", "64", "680"],
    ["248", "44", "446"],
    ["246", "25", "500"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["680", "47", "340"],
    ["239", "48", "800"],
    ["690", "57", "269"],
    ["578", "00", "145"],
    ["445", "37", "250"],
    ["238", "38", "468"],
    ["137", "12", "778"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["800", "80", "226"],
    ["890", "70", "235"],
    ["588", "17", "700"],
    ["148", "31", "489"],
    ["259", "63", "157"],
    ["678", "14", "158"],
    ["577", "93", "238"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["900", "90", "460"],
    ["166", "34", "239"],
    ["136", "05", "357"],
    ["223", "72", "237"],
    ["245", "19", "559"],
    ["480", "20", "389"],
    ["227", "14", "149"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["122", "57", "566"],
    ["890", "75", "500"],
    ["344", "10", "000"],
    ["380", "15", "500"],
    ["390", "21", "579"],
    ["790", "63", "139"],
    ["347", "43", "580"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["667", "96", "457"],
    ["688", "27", "278"],
    ["378", "88", "666"],
    ["444", "28", "116"],
    ["150", "64", "888"],
    ["169", "63", "445"],
    ["129", "26", "330"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["347", "40", "000"],
    ["588", "12", "679"],
    ["390", "28", "378"],
    ["159", "56", "880"],
    ["110", "28", "440"],
    ["500", "52", "499"],
    ["330", "64", "699"],
  ],

  "10/03/2025 to 16/03/2025": [
    ["555", "59", "270"],
    ["149", "44", "356"],
    ["579", "19", "568"],
    ["449", "74", "455"],
    ["679", "22", "679"],
    ["889", "59", "117"],
    ["377", "70", "127"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["447", "58", "350"],
    ["127", "05", "159"],
    ["339", "57", "223"],
    ["125", "81", "236"],
    ["367", "65", "357"],
    ["599", "31", "128"],
    ["137", "16", "349"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["467", "76", "330"],
    ["236", "19", "126"],
    ["479", "05", "555"],
    ["668", "02", "345"],
    ["117", "97", "269"],
    ["550", "09", "360"],
    ["249", "54", "789"],
  ],
};

export const YUGMORNING = {
  "30/12/2024 to 05/01/2025": [
    ["559", "92", "688"],
    ["180", "92", "200"],
    ["568", "97", "115"],
    ["490", "37", "160"],
    ["379", "94", "158"],
    ["235", "06", "899"],
    ["366", "50", "235"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["999", "73", "670"],
    ["237", "29", "144"],
    ["369", "83", "256"],
    ["347", "49", "199"],
    ["599", "33", "247"],
    ["144", "97", "133"],
    ["580", "34", "400"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["334", "06", "466"],
    ["469", "99", "225"],
    ["357", "59", "388"],
    ["228", "26", "169"],
    ["699", "48", "477"],
    ["456", "56", "466"],
    ["118", "09", "126"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["248", "43", "689"],
    ["266", "43", "148"],
    ["227", "18", "189"],
    ["144", "91", "669"],
    ["222", "64", "680"],
    ["248", "44", "446"],
    ["246", "25", "500"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["680", "47", "340"],
    ["239", "48", "800"],
    ["690", "57", "269"],
    ["578", "00", "145"],
    ["445", "37", "250"],
    ["238", "38", "468"],
    ["137", "12", "778"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["800", "80", "226"],
    ["890", "70", "235"],
    ["588", "17", "700"],
    ["148", "31", "489"],
    ["259", "63", "157"],
    ["678", "14", "158"],
    ["577", "93", "238"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["900", "90", "460"],
    ["166", "34", "239"],
    ["136", "05", "357"],
    ["223", "72", "237"],
    ["245", "19", "559"],
    ["480", "20", "389"],
    ["227", "14", "149"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["122", "57", "566"],
    ["890", "75", "500"],
    ["344", "10", "000"],
    ["380", "15", "500"],
    ["390", "21", "579"],
    ["790", "63", "139"],
    ["347", "43", "580"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["667", "96", "457"],
    ["688", "27", "278"],
    ["378", "88", "666"],
    ["444", "28", "116"],
    ["150", "64", "888"],
    ["169", "63", "445"],
    ["129", "26", "330"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["347", "40", "000"],
    ["588", "12", "679"],
    ["390", "28", "378"],
    ["159", "56", "880"],
    ["110", "28", "440"],
    ["500", "52", "499"],
    ["330", "64", "699"],
  ],
  "10/03/2025 to 16/03/2025": [
    ["124", "78", "233"],
    ["277", "65", "177"],
    ["479", "02", "200"],
    ["356", "45", "889"],
    ["800", "86", "457"],
    ["445", "38", "288"],
    ["489", "13", "256"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["139", "32", "147"],
    ["368", "75", "140"],
    ["200", "23", "689"],
    ["122", "57", "160"],
    ["160", "73", "779"],
    ["580", "31", "669"],
    ["440", "86", "240"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["149", "40", "569"],
    ["188", "77", "115"],
    ["579", "13", "111"],
    ["134", "84", "446"],
    ["447", "51", "236"],
    ["157", "31", "678"],
    ["550", "07", "340"],
  ],
};
export const DHARMMORNING = {
  "30/12/2025 to 05/01/2025": [
    ["589", "20", "190"],
    ["114", "65", "140"],
    ["290", "13", "689"],
    ["450", "97", "340"],
    ["450", "98", "189"],
    ["349", "68", "567"],
    ["130", "46", "367"],
  ],

  "06/01/2025 to 12/01/2025": [
    ["330", "61", "245"],
    ["330", "65", "177"],
    ["579", "15", "258"],
    ["499", "21", "380"],
    ["112", "42", "390"],
    ["789", "46", "169"],
    ["358", "67", "557"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["228", "26", "268"],
    ["190", "04", "455"],
    ["480", "28", "558"],
    ["778", "29", "559"],
    ["244", "03", "337"],
    ["678", "16", "277"],
    ["167", "46", "358"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["157", "32", "688"],
    ["666", "84", "770"],
    ["270", "90", "000"],
    ["589", "21", "146"],
    ["278", "77", "368"],
    ["233", "83", "229"],
    ["599", "31", "560"],
  ],
  "26/01/2025 to 01/02/2025": [
    ["344", "13", "580"],
    ["468", "84", "347"],
    ["568", "99", "360"],
    ["228", "29", "225"],
    ["899", "68", "369"],
    ["190", "04", "112"],
    ["568", "92", "336"],
  ],
  "02/02/2025 to 08/02/2025": [
    ["888", "47", "368"],
    ["280", "06", "240"],
    ["228", "23", "599"],
    ["369", "88", "350"],
    ["590", "44", "149"],
    ["568", "90", "578"],
    ["566", "70", "578"],
  ],
  "09/02/2025 to 15/02/2025": [
    ["116", "85", "500"],
    ["112", "43", "139"],
    ["345", "27", "458"],
    ["469", "98", "990"],
    ["270", "96", "457"],
    ["188", "79", "360"],
    ["670", "37", "179"],
  ],
  "16/02/2025 to 22/02/2025": [
    ["277", "63", "120"],
    ["228", "28", "350"],
    ["660", "27", "179"],
    ["222", "60", "488"],
    ["290", "10", "334"],
    ["159", "59", "379"],
    ["445", "38", "567"],
  ],
  "23/02/2025 to 01/03/2025": [
    ["333", "91", "470"],
    ["138", "23", "355"],
    ["258", "58", "990"],
    ["368", "79", "289"],
    ["790", "65", "339"],
    ["456", "52", "345"],
    ["235", "03", "120"],
  ],
  "02/03/2025 to 08/03/2025": [
    ["700", "71", "560"],
    ["128", "16", "880"],
    ["200", "20", "569"],
    ["400", "41", "128"],
    ["666", "89", "568"],
    ["149", "45", "258"],
    ["567", "86", "240"],
  ],
  "09/03/2025 to 15/03/2025": [
    ["158", "47", "269"],
    ["269", "76", "240"],
    ["177", "50", "488"],
    ["268", "66", "259"],
    ["233", "88", "567"],
    ["335", "11", "380"],
    ["356", "42", "589"],
  ],
  "16/03/2025 to 22/03/2025": [
    ["277", "63", "120"],
    ["228", "28", "350"],
    ["660", "27", "179"],
    ["222", "60", "488"],
    ["290", "10", "334"],
    ["159", "59", "379"],
    ["445", "38", "567"],
  ],
  "23/03/2025 to 30/03/2025": [
    ["238", "36", "259"],
    ["799", "50", "550"],
    ["990", "89", "333"],
    ["278", "73", "139"],
    ["336", "28", "459"],
    ["290", "11", "380"],
    ["357", "52", "237"],
  ],
};

export const VEDADAY = {
  "30/12/2024 to 05/01/2025": [
    ["255", "21", "227"],
    ["128", "19", "450"],
    ["137", "13", "166"],
    ["299", "09", "559"],
    ["169", "62", "688"],
    ["145", "07", "890"],
    ["446", "40", "280"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["678", "17", "250"],
    ["390", "29", "388"],
    ["399", "17", "368"],
    ["377", "75", "366"],
    ["799", "50", "389"],
    ["259", "62", "129"],
    ["499", "22", "156"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["688", "23", "355"],
    ["555", "55", "799"],
    ["566", "72", "200"],
    ["468", "87", "458"],
    ["689", "35", "249"],
    ["467", "71", "236"],
    ["234", "90", "127"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["227", "11", "128"],
    ["125", "83", "139"],
    ["450", "99", "180"],
    ["566", "78", "224"],
    ["223", "78", "666"],
    ["157", "34", "167"],
    ["270", "93", "247"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["223", "76", "114"],
    ["889", "57", "188"],
    ["477", "89", "117"],
    ["560", "10", "118"],
    ["259", "68", "567"],
    ["678", "14", "220"],
    ["150", "66", "899"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["168", "53", "788"],
    ["269", "75", "500"],
    ["900", "91", "137"],
    ["120", "32", "246"],
    ["469", "99", "180"],
    ["778", "20", "226"],
    ["350", "82", "138"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["111", "39", "333"],
    ["245", "10", "280"],
    ["447", "53", "120"],
    ["788", "32", "138"],
    ["346", "39", "289"],
    ["238", "37", "890"],
    ["478", "95", "159"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["557", "72", "200"],
    ["888", "46", "114"],
    ["790", "62", "660"],
    ["470", "10", "136"],
    ["460", "01", "588"],
    ["138", "23", "355"],
    ["400", "46", "268"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["257", "43", "670"],
    ["339", "56", "123"],
    ["268", "65", "168"],
    ["240", "61", "227"],
    ["356", "45", "500"],
    ["268", "61", "560"],
    ["220", "45", "258"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["257", "46", "880"],
    ["259", "69", "478"],
    ["127", "05", "249"],
    ["167", "42", "589"],
    ["490", "39", "667"],
    ["445", "39", "144"],
    ["330", "69", "577"],
  ],
  "10/03/2025 to 16/03/2025": [
    ["158", "48", "369"],
    ["800", "87", "179"],
    ["346", "38", "134"],
    ["450", "95", "447"],
    ["277", "64", "888"],
    ["348", "56", "880"],
    ["122", "58", "189"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["288", "84", "699"],
    ["599", "30", "190"],
    ["144", "95", "122"],
    ["557", "73", "148"],
    ["556", "63", "139"],
    ["447", "59", "117"],
    ["555", "57", "467"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["670", "31", "489"],
    ["335", "17", "467"],
    ["115", "70", "334"],
    ["666", "82", "255"],
    ["444", "21", "579"],
    ["455", "43", "238"],
    ["770", "40", "118"],
  ],
};
export const YUGDAY = {
  "30/12/2024 to 05/01/2025": [
    ["133", "70", "370"],
    ["368", "76", "178"],
    ["189", "87", "133"],
    ["889", "58", "666"],
    ["227", "13", "580"],
    ["190", "09", "270"],
    ["350", "87", "124"],
  ],

  "30/12/2024 to 05/01/2025": [
    ["133", "70", "370"],
    ["368", "76", "178"],
    ["189", "87", "133"],
    ["889", "58", "666"],
    ["227", "13", "580"],
    ["190", "09", "270"],
    ["350", "87", "124"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["257", "46", "880"],
    ["259", "69", "478"],
    ["127", "05", "249"],
    ["167", "42", "589"],
    ["490", "39", "667"],
    ["445", "39", "144"],
    ["330", "69", "577"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["158", "48", "369"],
    ["800", "87", "179"],
    ["346", "38", "134"],
    ["450", "95", "447"],
    ["277", "64", "888"],
    ["348", "56", "880"],
    ["122", "58", "189"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["288", "84", "699"],
    ["599", "30", "190"],
    ["144", "95", "122"],
    ["557", "73", "148"],
    ["556", "63", "139"],
    ["447", "59", "117"],
    ["555", "57", "467"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["670", "31", "489"],
    ["335", "17", "467"],
    ["115", "70", "334"],
    ["666", "82", "255"],
    ["444", "21", "579"],
    ["455", "43", "238"],
    ["770", "40", "118"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["269", "70", "299"],
    ["139", "35", "690"],
    ["359", "78", "567"],
    ["118", "08", "800"],
    ["349", "60", "226"],
    ["148", "31", "669"],
    ["480", "29", "199"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["190", "05", "500"],
    ["455", "49", "667"],
    ["789", "47", "700"],
    ["446", "47", "269"],
    ["118", "09", "117"],
    ["139", "39", "180"],
    ["690", "51", "119"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["467", "70", "145"],
    ["259", "61", "146"],
    ["299", "05", "230"],
    ["267", "55", "456"],
    ["220", "49", "270"],
    ["135", "95", "456"],
    ["399", "18", "369"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["235", "03", "490"],
    ["133", "72", "255"],
    ["358", "65", "780"],
    ["478", "99", "135"],
    ["899", "64", "257"],
    ["880", "66", "556"],
    ["566", "74", "130"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["457", "60", "569"],
    ["245", "14", "347"],
    ["135", "98", "378"],
    ["470", "17", "188"],
    ["679", "23", "139"],
    ["360", "90", "479"],
    ["160", "79", "126"],
  ],
  "10/03/2025 to 16/03/2025": [
    ["688", "20", "488"],
    ["159", "50", "569"],
    ["990", "81", "579"],
    ["338", "41", "155"],
    ["590", "49", "379"],
    ["127", "04", "347"],
    ["450", "91", "335"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["269", "70", "235"],
    ["350", "87", "449"],
    ["577", "94", "158"],
    ["279", "82", "138"],
    ["270", "92", "570"],
    ["567", "87", "269"],
    ["229", "39", "126"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["579", "13", "346"],
    ["199", "91", "588"],
    ["225", "91", "380"],
    ["156", "28", "134"],
    ["689", "39", "289"],
    ["457", "69", "568"],
    ["279", "82", "138"],
  ],
};
export const DHARMDAY = {
  "30/12/2024 to 05/01/2025": [
    ["225", "91", "380"],
    ["156", "28", "134"],
    ["149", "46", "790"],
    ["149", "40", "578"],
    ["338", "40", "299"],
    ["557", "74", "167"],
    ["289", "95", "348"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["300", "38", "134"],
    ["388", "95", "339"],
    ["247", "38", "378"],
    ["499", "20", "118"],
    ["499", "21", "579"],
    ["125", "87", "377"],
    ["678", "16", "114"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["149", "40", "127"],
    ["277", "63", "229"],
    ["450", "96", "457"],
    ["148", "38", "459"],
    ["399", "12", "255"],
    ["224", "81", "146"],
    ["377", "79", "478"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["800", "80", "569"],
    ["369", "89", "126"],
    ["469", "99", "289"],
    ["290", "12", "336"],
    ["289", "94", "149"],
    ["379", "94", "130"],
    ["170", "84", "149"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["479", "03", "238"],
    ["167", "41", "100"],
    ["668", "07", "250"],
    ["290", "16", "367"],
    ["199", "93", "157"],
    ["478", "96", "178"],
    ["370", "08", "125"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["139", "31", "470"],
    ["368", "71", "579"],
    ["169", "63", "139"],
    ["390", "24", "257"],
    ["169", "64", "590"],
    ["389", "07", "566"],
    ["246", "27", "269"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["256", "35", "159"],
    ["560", "10", "370"],
    ["189", "82", "589"],
    ["357", "51", "146"],
    ["259", "66", "150"],
    ["170", "80", "136"],
    ["400", "43", "355"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["229", "32", "255"],
    ["558", "82", "237"],
    ["580", "32", "147"],
    ["246", "20", "235"],
    ["699", "45", "339"],
    ["123", "68", "459"],
    ["489", "19", "379"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["269", "71", "137"],
    ["458", "75", "799"],
    ["368", "70", "578"],
    ["116", "80", "479"],
    ["233", "83", "599"],
    ["146", "12", "129"],
    ["679", "21", "155"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["139", "37", "449"],
    ["890", "79", "469"],
    ["370", "00", "190"],
    ["680", "41", "678"],
    ["588", "11", "470"],
    ["388", "97", "449"],
    ["136", "02", "138"],
  ],
  "10/03/2025 to 16/03/2025": [
    ["159", "51", "245"],
    ["136", "03", "157"],
    ["379", "91", "489"],
    ["788", "31", "380"],
    ["270", "92", "345"],
    ["138", "22", "156"],
    ["256", "39", "135"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["258", "59", "135"],
    ["349", "64", "257"],
    ["449", "71", "227"],
    ["240", "65", "168"],
    ["477", "82", "156"],
    ["330", "66", "178"],
    ["489", "17", "124"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["500", "57", "458"],
    ["348", "58", "116"],
    ["580", "32", "147"],
    ["489", "17", "124"],
    ["449", "71", "227"],
    ["349", "64", "257"],
    ["138", "22", "156"],
  ],
};

export const VEDANIGHT = {
  "30/12/2024 to 05/01/2025": [
    ["156", "28", "134"],
    ["289", "95", "348"],
    ["149", "40", "578"],
    ["149", "46", "790"],
    ["338", "40", "299"],
    ["557", "74", "167"],
    ["225", "91", "380"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["236", "15", "447"],
    ["580", "31", "335"],
    ["667", "92", "156"],
    ["188", "74", "149"],
    ["688", "29", "388"],
    ["117", "92", "345"],
    ["134", "82", "129"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["160", "76", "367"],
    ["459", "82", "589"],
    ["700", "79", "289"],
    ["180", "96", "330"],
    ["337", "30", "280"],
    ["158", "43", "779"],
    ["460", "00", "479"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["190", "07", "179"],
    ["177", "59", "135"],
    ["490", "37", "124"],
    ["126", "93", "599"],
    ["279", "80", "136"],
    ["580", "33", "689"],
    ["670", "38", "170"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["236", "15", "447"],
    ["580", "31", "335"],
    ["667", "92", "156"],
    ["188", "74", "149"],
    ["688", "29", "388"],
    ["117", "92", "345"],
    ["134", "82", "129"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["160", "76", "367"],
    ["459", "82", "589"],
    ["700", "79", "289"],
    ["180", "96", "330"],
    ["337", "30", "280"],
    ["158", "43", "779"],
    ["460", "00", "479"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["146", "11", "344"],
    ["459", "80", "569"],
    ["126", "97", "278"],
    ["277", "61", "399"],
    ["158", "41", "678"],
    ["126", "90", "145"],
    ["160", "72", "345"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["149", "43", "346"],
    ["157", "32", "129"],
    ["378", "85", "159"],
    ["478", "93", "157"],
    ["460", "09", "379"],
    ["700", "78", "260"],
    ["488", "03", "445"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["360", "95", "889"],
    ["239", "45", "249"],
    ["280", "06", "349"],
    ["169", "61", "489"],
    ["247", "36", "790"],
    ["238", "36", "259"],
    ["459", "85", "168"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["245", "15", "555"],
    ["235", "02", "138"],
    ["240", "69", "135"],
    ["279", "85", "177"],
    ["138", "20", "190"],
    ["356", "46", "259"],
    ["350", "81", "678"],
  ],
  "10/03/2025 to 16/03/2025": [
    ["446", "42", "589"],
    ["290", "14", "257"],
    ["268", "62", "499"],
    ["580", "32", "129"],
    ["280", "00", "479"],
    ["259", "68", "279"],
    ["457", "66", "222"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["578", "08", "260"],
    ["277", "62", "255"],
    ["339", "56", "358"],
    ["112", "46", "349"],
    ["336", "29", "289"],
    ["259", "64", "239"],
    ["469", "92", "688"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["680", "45", "122"],
    ["380", "19", "135"],
    ["348", "59", "478"],
    ["568", "98", "378"],
    ["247", "32", "589"],
    ["158", "45", "348"],
    ["167", "43", "490"],
  ],
};
export const YUGNIGHT = {
  "30/12/2024 to 05/01/2025": [
    ["148", "32", "138"],
    ["678", "17", "160"],
    ["569", "06", "114"],
    ["250", "78", "170"],
    ["556", "63", "256"],
    ["118", "00", "136"],
    ["190", "02", "156"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["147", "25", "690"],
    ["179", "79", "135"],
    ["379", "90", "127"],
    ["236", "13", "580"],
    ["150", "60", "334"],
    ["126", "96", "880"],
    ["700", "78", "134"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["110", "25", "366"],
    ["244", "01", "579"],
    ["250", "74", "347"],
    ["277", "63", "120"],
    ["258", "59", "180"],
    ["789", "42", "228"],
    ["699", "46", "457"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["447", "50", "136"],
    ["247", "33", "355"],
    ["469", "96", "466"],
    ["129", "26", "358"],
    ["168", "50", "460"],
    ["500", "55", "230"],
    ["679", "29", "126"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["580", "37", "467"],
    ["668", "00", "578"],
    ["147", "20", "389"],
    ["788", "35", "367"],
    ["330", "66", "123"],
    ["359", "72", "570"],
    ["366", "54", "149"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["135", "90", "190"],
    ["124", "71", "128"],
    ["558", "86", "114"],
    ["455", "40", "226"],
    ["239", "44", "338"],
    ["346", "37", "250"],
    ["500", "56", "880"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["140", "57", "890"],
    ["379", "90", "145"],
    ["139", "35", "159"],
    ["259", "62", "228"],
    ["446", "40", "235"],
    ["689", "31", "128"],
    ["145", "09", "144"],
  ],
  "17/02/2025 to 23/02/2025": [
  ["124", "70", "190"],
  ["248", "48", "170"],
  ["138", "22", "156"],
  ["240", "67", "269"],
  ["235", "09", "478"],
  ["550", "00", "280"],
  ["199", "99", "450"],
  ],
  "24/02/2025 to 02/03/2025": [
  ["278", "76", "367"],
  ["688", "28", "116"],
  ["780", "56", "268"],
  ["189", "80", "226"],
  ["579", "12", "138"],
  ["178", "60", "235"],
  ["690", "51", "678"],
  ],
  "03/03/2025 to 09/03/2025": [
  ["125", "89", "144"],
  ["257", "41", "344"],
  ["118", "06", "358"],
  ["117", "90", "244"],
  ["135", "91", "137"],
  ["799", "56", "240"],
  ["288", "88", "666"],
  ],
  "10/03/2025 to 16/03/2025": [
  ["110", "23", "490"],
  ["778", "29", "577"],
  ["567", "88", "125"],
  ["156", "25", "348"],
  ["459", "88", "170"],
  ["235", "07", "124"],
  ["299", "02", "480"],
  ],
  "17/03/2025 to 23/03/2025": [
  ["669", "19", "388"],
  ["478", "99", "117"],
  ["560", "15", "690"],
  ["379", "97", "160"],
  ["689", "30", "127"],
  ["890", "77", "160"],
  ["134", "86", "457"],
  ],
  "24/03/2025 to 30/03/2025": [
  ["560", "16", "349"],
  ["237", "27", "269"],
  ["348", "55", "230"],
  ["149", "47", "179"],
  ["689", "34", "248"],
  ["890", "78", "189"],
  ["228", "26", "268"],
  ],
};
export const DHARMNIGHT = {
  "30/12/2024 to 05/01/2025": [
  ["560", "16", "349"],
  ["237", "27", "269"],
  ["348", "55", "230"],
  ["149", "47", "179"],
  ["689", "34", "248"],
  ["890", "78", "189"],
  ["228", "26", "268"],
  ],
  "06/01/2025 to 12/01/2025": [
  ["268", "65", "267"],
  ["238", "31", "399"],
  ["147", "24", "680"],
  ["137", "16", "178"],
  ["567", "81", "335"],
  ["578", "06", "277"],
  ["478", "99", "289"],
  ],
  "13/01/2025 to 19/01/2025": [
  ["146", "12", "228"],
  ["167", "43", "148"],
  ["559", "90", "190"],
  ["159", "54", "239"],
  ["145", "07", "124"],
  ["134", "86", "114"],
  ["359", "71", "579"],
  ],
  "20/01/2025 to 26/01/2025": [
  ["130", "40", "127"],
  ["119", "15", "140"],
  ["166", "33", "238"],
  ["390", "28", "279"],
  ["240", "61", "236"],
  ["199", "93", "229"],
  ["668", "04", "590"],
  ],
  "27/01/2025 to 02/02/2025": [
  ["179", "73", "157"],
  ["135", "93", "599"],
  ["159", "57", "449"],
  ["125", "80", "136"],
  ["679", "28", "378"],
  ["558", "89", "180"],
  ["600", "62", "345"],
  ],
  "03/02/2025 to 09/02/2025": [
  ["479", "06", "457"],
  ["146", "19", "270"],
  ["139", "34", "149"],
  ["477", "84", "266"],
  ["178", "61", "380"],
  ["228", "20", "127"],
  ["490", "37", "890"],
  ],
  "10/02/2025 to 16/02/2025": [
  ["113", "50", "226"],
  ["248", "42", "129"],
  ["137", "15", "159"],
  ["379", "90", "136"],
  ["588", "10", "677"],
  ["689", "31", "236"],
  ["559", "95", "249"],
  ],
  "17/02/2025 to 23/02/2025": [
  ["246", "21", "344"],
  ["144", "91", "236"],
  ["330", "61", "119"],
  ["245", "19", "126"],
  ["135", "96", "457"],
  ["367", "64", "149"],
  ["570", "29", "360"],
  ],
  "24/02/2025 to 02/03/2025": [
  ["146", "12", "156"],
  ["466", "69", "117"],
  ["680", "43", "337"],
  ["279", "86", "457"],
  ["168", "51", "245"],
  ["660", "28", "800"],
  ["118", "08", "233"],
  ],
  "03/03/2025 to 09/04/2025": [
  ["490", "31", "579"],
  ["233", "85", "348"],
  ["390", "20", "479"],
  ["448", "60", "190"],
  ["130", "48", "558"],
  ["389", "07", "368"],
  ["499", "25", "168"],
  ],
  "20/01/2025 to 26/01/2025": [
  ["278", "76", "367"],
  ["688", "28", "116"],
  ["780", "56", "268"],
  ["189", "80", "226"],
  ["579", "12", "138"],
  ["178", "60", "235"],
  ["690", "51", "678"],
  ],
  "27/01/2025 to 02/02/2025": [
  ["124", "70", "190"],
  ["248", "48", "170"],
  ["138", "22", "156"],
  ["240", "67", "269"],
  ["235", "09", "478"],
  ["550", "00", "280"],
  ["199", "99", "450"],
  ],
  "03/02/2025 to 09/02/2025": [
  ["140", "57", "890"],
  ["379", "90", "145"],
  ["139", "35", "159"],
  ["259", "62", "228"],
  ["446", "40", "235"],
  ["689", "31", "128"],
  ["145", "09", "144"],
  ],
  "10/03/2025 to 16/03/2025": [
  ["268", "65", "267"],
  ["238", "31", "399"],
  ["147", "24", "680"],
  ["137", "16", "178"],
  ["567", "81", "335"],
  ["578", "06", "277"],
  ["478", "99", "289"],
  ],
  "17/03/2025 to 23/03/2025": [
  ["146", "12", "228"],
  ["167", "43", "148"],
  ["559", "90", "190"],
  ["159", "54", "239"],
  ["145", "07", "124"],
  ["134", "86", "114"],
  ["359", "71", "579"],
  ],
  "24/03/2025 to 30/03/2025": [
  ["130", "40", "127"],
  ["119", "15", "140"],
  ["166", "33", "238"],
  ["390", "28", "279"],
  ["240", "61", "236"],
  ["199", "93", "229"],
  ["668", "04", "590"],
  ],
};
export const LAXMIMORNING = {
  "30/12/2024 to 05/01/2025": [
  ["226", "04", "130"],
  ["146", "17", "179"],
  ["667", "97", "179"],
  ["689", "31", "155"],
  ["237", "22", "589"],
  ["112", "49", "180"],
  ["899", "64", "455"],
  ],
  "06/01/2025 to 12/01/2025": [
  ["128", "11", "399"],
  ["167", "43", "355"],
  ["457", "63", "490"],
  ["667", "96", "367"],
  ["370", "01", "489"],
  ["347", "40", "389"],
  ["378", "80", "136"],
  ],
  "13/01/2025 to 19/01/2025": [
  ["260", "87", "278"],
  ["234", "90", "190"],
  ["149", "43", "238"],
  ["236", "19", "180"],
  ["124", "71", "678"],
  ["670", "35", "249"],
  ["778", "24", "257"],
  ],
  "20/01/2025 to 26/01/2025": [
  ["112", "40", "136"],
  ["256", "33", "670"],
  ["378", "82", "679"],
  ["344", "15", "113"],
  ["790", "65", "889"],
  ["489", "11", "236"],
  ["240", "60", "299"],
  ],
  "27/01/2025 to 02/02/2025": [
  ["378", "84", "455"],
  ["380", "10", "145"],
  ["277", "67", "467"],
  ["490", "35", "799"],
  ["388", "95", "456"],
  ["788", "36", "123"],
  ["579", "18", "350"],
  ],
  "03/02/2025 to 09/02/2025": [
  ["269", "78", "477"],
  ["357", "50", "569"],
  ["568", "91", "380"],
  ["149", "48", "459"],
  ["370", "07", "124"],
  ["450", "97", "278"],
  ["689", "35", "230"],
  ],
  "10/02/2025 to 16/02/2025": [
  ["489", "10", "299"],
  ["367", "62", "336"],
  ["134", "89", "379"],
  ["227", "18", "567"],
  ["790", "67", "250"],
  ["149", "45", "780"],
  ["590", "46", "123"],
  ],
  "17/02/2025 to 23/02/2025": [
  ["440", "86", "790"],
  ["560", "19", "469"],
  ["236", "11", "137"],
  ["356", "42", "778"],
  ["166", "33", "490"],
  ["668", "06", "466"],
  ["479", "04", "158"],
  ],
  "24/02/2025 to 02/03/2025": [
  ["139", "31", "669"],
  ["299", "04", "770"],
  ["245", "15", "177"],
  ["260", "89", "900"],
  ["390", "29", "568"],
  ["236", "19", "360"],
  ["370", "03", "139"],
  ],
  "03/03/2025 to 09/03/2025": [
  ["560", "14", "239"],
  ["250", "79", "289"],
  ["237", "24", "167"],
  ["259", "63", "139"],
  ["357", "52", "660"],
  ["244", "05", "168"],
  ["467", "77", "890"],
  ],
  "10/03/2025 to 16/03/2025": [
  ["569", "08", "125"],
  ["330", "68", "369"],
  ["458", "72", "589"],
  ["780", "51", "137"],
  ["569", "01", "344"],
  ["360", "93", "670"],
  ["900", "98", "279"],
  ],
  "17/03/2025 to 23/03/2025": [
  ["347", "47", "890"],
  ["457", "68", "288"],
  ["770", "43", "779"],
  ["460", "09", "135"],
  ["568", "95", "500"],
  ["260", "80", "127"],
  ["599", "38", "125"],
  ],
  "24/03/2025 to 30/03/2025": [
  ["389", "07", "188"],
  ["117", "95", "456"],
  ["789", "45", "447"],
  ["279", "81", "155"],
  ["668", "00", "578"],
  ["134", "85", "690"],
  ["469", "97", "133"],
  ],
  "31/03/2025 to 06/04/2025": [
  ["117", "95", "140"],
  ["590", "48", "567"],
  ["560", "11", "290"],
  ["890", "76", "150"],
  ["770", "48", "189"],
  ["258", "55", "799"],
  ["346", "39", "180"],
  ],
  "07/04/2025 to 13/04/2025": [
  ["358", "61", "236"],
  ["357", "53", "157"],
  ["137", "19", "289"],
  ["250", "74", "400"],
  ["345", "28", "800"],
  ["380", "16", "899"],
  ["500", "57", "368"],
  ],
  "14/04/2025 to 20/04/2025": [
  ["115", "78", "440"],
  ["335", "17", "467"],
  ["250", "74", "455"],
  ["670", "35", "140"],
  ["560", "11", "344"],
  ["135", "98", "279"],
  ["117", "91", "236"],
  ],
  "21/04/2025 to 27/04/2025": [
  ["120", "31", "155"],
  ["578", "00", "299"],
  ["378", "86", "259"],
  ["158", "40", "190"],
  ["449", "72", "679"],
  ["335", "17", "566"],
  ["346", "30", "118"],
  ],
  "28/04/2025 to 04/05/2025": [
  ["233", "87", "377"],
  ["240", "69", "360"],
  ["466", "61", "137"],
  ["289", "90", "460"],
  ["467", "76", "169"],
  ["488", "01", "100"],
  ["115", "76", "349"],
  ],
  "05/05/2025 to 11/05/2025": [
  ["370", "04", "590"],
  ["377", "72", "246"],
  ["450", "96", "790"],
  ["112", "45", "159"],
  ["459", "88", "134"],
  ["559", "90", "280"],
  ["135", "97", "340"],
  ],
  "12/05/2025 to 18/05/2025": [
  ["890", "78", "990"],
  ["145", "09", "360"],
  ["250", "72", "480"],
  ["170", "88", "125"],
  ["358", "62", "778"],
  ["380", "12", "129"],
  ["470", "16", "123"],
  ],
  "19/05/2025 to 25/05/2025": [
  ["178", "62", "589"],
  ["680", "46", "150"],
  ["258", "58", "459"],
  ["669", "15", "140"],
  ["578", "03", "139"],
  ["677", "00", "389"],
  ["700", "71", "227"],
  ],
};
export const SHRIMORNING = {
  "30/12/2024 to 05/01/2025": [
  ["279", "87", "890"],
  ["249", "57", "124"],
  ["679", "28", "459"],
  ["467", "73", "300"],
  ["456", "52", "589"],
  ["230", "54", "149"],
  ["239", "47", "124"],
  ],
  "06/01/2025 to 12/01/2025": [
  ["126", "97", "557"],
  ["469", "99", "135"],
  ["390", "21", "560"],
  ["480", "24", "158"],
  ["167", "40", "190"],
  ["460", "09", "577"],
  ["340", "70", "145"],
  ],
  "13/01/2025 to 19/01/2025": [
  ["600", "62", "110"],
  ["230", "56", "150"],
  ["177", "57", "700"],
  ["389", "09", "360"],
  ["350", "80", "479"],
  ["299", "08", "468"],
  ["236", "15", "690"],
  ],
  "20/01/2025 to 26/01/2025": [
  ["129", "23", "247"],
  ["466", "65", "159"],
  ["258", "56", "268"],
  ["160", "71", "146"],
  ["189", "84", "590"],
  ["459", "82", "129"],
  ["267", "58", "459"],
  ],
  "27/01/2025 to 02/02/2025": [
  ["789", "44", "455"],
  ["137", "12", "129"],
  ["669", "17", "124"],
  ["590", "42", "480"],
  ["469", "99", "126"],
  ["246", "27", "340"],
  ["340", "77", "269"],
  ],
  "03/02/2025 to 09/02/2025": [
  ["350", "84", "158"],
  ["468", "81", "380"],
  ["267", "54", "590"],
  ["245", "12", "156"],
  ["367", "62", "589"],
  ["358", "63", "120"],
  ["468", "81", "470"],
  ],
  "10/02/2025 to 16/02/2025": [
  ["119", "15", "690"],
  ["899", "68", "459"],
  ["369", "88", "350"],
  ["135", "90", "118"],
  ["568", "99", "234"],
  ["370", "05", "159"],
  ["129", "20", "235"],
  ],
  "17/02/2025 to 23/02/2025": [
  ["679", "29", "559"],
  ["669", "15", "258"],
  ["480", "20", "460"],
  ["239", "48", "170"],
  ["370", "01", "100"],
  ["266", "45", "249"],
  ["224", "81", "128"],
  ],
  "24/02/2025 to 02/03/2025": [
  ["126", "99", "234"],
  ["567", "87", "278"],
  ["256", "32", "129"],
  ["160", "78", "260"],
  ["247", "37", "278"],
  ["146", "18", "170"],
  ["599", "37", "269"],
  ],
  "03/03/2025 to 09/03/2025": [
  ["149", "41", "579"],
  ["346", "38", "468"],
  ["145", "00", "488"],
  ["290", "14", "356"],
  ["160", "73", "689"],
  ["270", "93", "139"],
  ["559", "99", "135"],
  ],
  "10/03/2025 to 16/03/2025": [
  ["279", "82", "688"],
  ["579", "12", "237"],
  ["168", "51", "128"],
  ["346", "31", "119"],
  ["569", "07", "467"],
  ["145", "07", "133"],
  ["248", "44", "158"],
  ],
  "17/03/2025 to 23/03/2025": [
  ["457", "61", "470"],
  ["123", "64", "257"],
  ["338", "42", "679"],
  ["577", "90", "235"],
  ["137", "19", "289"],
  ["680", "41", "489"],
  ["128", "17", "340"],
  ],
  "24/03/2025 to 30/03/2025": [
  ["450", "96", "880"],
  ["113", "50", "127"],
  ["129", "29", "199"],
  ["358", "69", "469"],
  ["246", "22", "237"],
  ["239", "44", "158"],
  ["990", "80", "145"],
  ],
  "31/03/2025 to 06/04/2025": [
  ["170", "88", "350"],
  ["240", "64", "130"],
  ["247", "31", "579"],
  ["558", "84", "680"],
  ["240", "62", "237"],
  ["230", "55", "348"],
  ["268", "69", "126"],
  ],
  "07/04/2025 to 13/04/2025": [
  ["490", "35", "249"],
  ["890", "73", "139"],
  ["188", "71", "489"],
  ["236", "13", "256"],
  ["447", "52", "778"],
  ["128", "12", "480"],
  ["690", "52", "345"],
  ],
  "14/04/2025 to 20/04/2025": [
  ["360", "93", "256"],
  ["349", "65", "159"],
  ["126", "95", "780"],
  ["499", "26", "367"],
  ["225", "91", "146"],
  ["119", "18", "189"],
  ["223", "75", "249"],
  ],
  "21/04/2025 to 27/04/2025": [
  ["470", "16", "169"],
  ["788", "32", "156"],
  ["689", "38", "459"],
  ["467", "78", "378"],
  ["239", "42", "200"],
  ["290", "13", "247"],
  ["239", "45", "168"],
  ],
  "28/04/2025 to 04/05/2025": [
  ["557", "78", "134"],
  ["128", "14", "149"],
  ["380", "18", "260"],
  ["248", "45", "690"],
  ["259", "60", "578"],
  ["448", "68", "350"],
  ["457", "62", "138"],
  ],
  "05/05/2025 to 11/05/2025": [
  ["480", "20", "479"],
  ["577", "93", "148"],
  ["234", "92", "589"],
  ["247", "30", "127"],
  ["168", "53", "490"],
  ["346", "37", "124"],
  ["400", "47", "467"],
  ],
  "12/05/2025 to 18/05/2025": [
  ["680", "49", "270"],
  ["115", "77", "700"],
  ["590", "42", "499"],
  ["118", "06", "169"],
  ["460", "00", "479"],
  ["679", "22", "138"],
  ["148", "31", "489"],
  ],
  "19/05/2025 to 25/05/2025": [
  ["300", "34", "266"],
  ["170", "84", "789"],
  ["235", "01", "245"],
  ["470", "18", "170"],
  ["226", "08", "378"],
  ["469", "90", "569"],
  ["779", "30", "578"],
  ],
};
export const RAMAMORNING = {
  "30/12/2024 to 05/01/2025": [
  ["288", "89", "379"],
  ["680", "43", "256"],
  ["478", "93", "670"],
  ["480", "24", "590"],
  ["366", "55", "159"],
  ["378", "85", "258"],
  ["147", "20", "677"],
  ],
  "06/01/2025 to 12/01/2025": [
  ["780", "52", "570"],
  ["460", "03", "346"],
  ["125", "84", "455"],
  ["289", "99", "568"],
  ["690", "57", "467"],
  ["129", "23", "689"],
  ["469", "91", "290"],
  ],
  "13/01/2025 to 19/01/2025": [
  ["189", "85", "339"],
  ["566", "70", "000"],
  ["360", "96", "790"],
  ["169", "62", "679"],
  ["400", "41", "146"],
  ["160", "71", "380"],
  ["448", "60", "578"],
  ],
  "20/01/2025 to 26/01/2025": [
  ["259", "64", "789"],
  ["459", "82", "147"],
  ["390", "20", "479"],
  ["124", "77", "278"],
  ["233", "80", "389"],
  ["136", "07", "458"],
  ["359", "78", "279"],
  ],
  "27/01/2025 to 02/02/2025": [
  ["699", "44", "248"],
  ["156", "25", "456"],
  ["260", "86", "880"],
  ["367", "69", "126"],
  ["778", "29", "450"],
  ["349", "65", "249"],
  ["440", "88", "134"],
  ],
  "03/02/2025 to 09/02/2025": [
  ["190", "06", "268"],
  ["449", "73", "346"],
  ["127", "01", "560"],
  ["568", "95", "780"],
  ["167", "47", "250"],
  ["239", "43", "120"],
  ["457", "63", "256"],
  ],
  "10/02/2025 to 16/02/2025": [
  ["690", "52", "499"],
  ["890", "79", "360"],
  ["589", "28", "990"],
  ["447", "51", "290"],
  ["160", "70", "569"],
  ["356", "44", "680"],
  ["145", "09", "388"],
  ],
  "17/02/2025 to 23/02/2025": [
  ["347", "40", "235"],
  ["180", "93", "355"],
  ["230", "59", "478"],
  ["340", "71", "137"],
  ["490", "31", "579"],
  ["900", "90", "668"],
  ["467", "75", "168"],
  ],
  "24/02/2025 to 02/03/2025": [
  ["479", "03", "689"],
  ["267", "55", "159"],
  ["157", "32", "200"],
  ["590", "47", "359"],
  ["166", "38", "369"],
  ["138", "29", "559"],
  ["246", "21", "678"],
  ],
  "03/03/2025 to 09/03/2025": [
  ["670", "36", "169"],
  ["450", "91", "227"],
  ["129", "25", "357"],
  ["145", "09", "270"],
  ["789", "41", "560"],
  ["280", "00", "389"],
  ["140", "50", "460"],
  ],
  "10/03/2025 to 16/03/2025": [
  ["249", "52", "110"],
  ["578", "01", "146"],
  ["467", "77", "890"],
  ["167", "46", "556"],
  ["440", "87", "160"],
  ["570", "25", "348"],
  ["144", "96", "349"],
  ],
  "17/03/2025 to 23/03/2025": [
  ["247", "34", "158"],
  ["880", "69", "289"],
  ["477", "89", "469"],
  ["157", "32", "589"],
  ["248", "40", "118"],
  ["237", "20", "569"],
  ["149", "47", "700"],
  ],
  "24/03/2025 to 30/03/2025": [
  ["358", "65", "113"],
  ["229", "31", "489"],
  ["168", "54", "239"],
  ["790", "62", "390"],
  ["130", "44", "257"],
  ["230", "54", "356"],
  ["258", "51", "560"],
  ],
  "31/03/2025 to 06/04/2025": [
  ["499", "27", "278"],
  ["558", "86", "169"],
  ["445", "37", "368"],
  ["156", "23", "689"],
  ["457", "60", "479"],
  ["350", "87", "124"],
  ["455", "41", "236"],
  ],
  "07/04/2025 to 13/04/2025": [
  ["668", "04", "167"],
  ["246", "21", "344"],
  ["288", "81", "579"],
  ["178", "67", "700"],
  ["259", "62", "570"],
  ["280", "03", "148"],
  ["440", "89", "568"],
  ],
  "14/04/2025 to 20/04/2025": [
  ["349", "68", "477"],
  ["299", "07", "250"],
  ["670", "33", "580"],
  ["126", "98", "459"],
  ["346", "35", "140"],
  ["135", "94", "266"],
  ["347", "48", "134"],
  ],
  "21/04/2025 to 27/04/2025": [
  ["260", "85", "357"],
  ["469", "92", "246"],
  ["157", "31", "245"],
  ["458", "70", "370"],
  ["589", "26", "600"],
  ["269", "77", "179"],
  ["240", "64", "158"],
  ],
  "28/04/2025 to 04/05/2025": [
  ["247", "36", "367"],
  ["116", "82", "138"],
  ["178", "60", "569"],
  ["390", "22", "237"],
  ["577", "93", "139"],
  ["250", "71", "245"],
  ["479", "01", "489"],
  ],
  "05/05/2025 to 11/05/2025": [
  ["389", "04", "248"],
  ["256", "39", "199"],
  ["770", "41", "678"],
  ["450", "96", "268"],
  ["478", "95", "690"],
  ["170", "88", "369"],
  ["590", "42", "129"],
  ],
  "12/05/2025 to 18/05/2025": [
  ["124", "79", "126"],
  ["689", "31", "470"],
  ["236", "18", "440"],
  ["358", "66", "169"],
  ["158", "42", "480"],
  ["580", "35", "366"],
  ["699", "44", "149"],
  ],
  "19/05/2025 to 25/05/2025": [
  ["378", "80", "578"],
  ["458", "73", "779"],
  ["129", "20", "370"],
  ["350", "85", "168"],
  ["146", "19", "568"],
  ["899", "62", "237"],
  ["570", "22", "156"],
  ],
};
export const RADHADAY = {
  "30/12/2024 to 05/01/2025": [
  ["123", "61", "560"],
  ["667", "96", "169"],
  ["235", "02", "129"],
  ["256", "31", "579"],
  ["478", "90", "145"],
  ["245", "17", "359"],
  ["390", "28", "350"],
  ],
  "06/01/2025 to 12/01/2025": [
  ["238", "39", "450"],
  ["257", "40", "190"],
  ["150", "61", "290"],
  ["115", "78", "378"],
  ["560", "14", "149"],
  ["569", "08", "369"],
  ["567", "86", "240"],
  ],
  "13/01/2025 to 19/01/2025": [
  ["569", "03", "139"],
  ["250", "79", "667"],
  ["479", "01", "128"],
  ["680", "41", "128"],
  ["145", "07", "250"],
  ["480", "25", "140"],
  ["244", "05", "249"],
  ],
  "20/01/2025 to 26/01/2025": [
  ["255", "28", "189"],
  ["246", "23", "238"],
  ["159", "58", "125"],
  ["189", "85", "456"],
  ["580", "31", "146"],
  ["580", "32", "156"],
  ["179", "70", "235"],
  ],
  "27/01/2025 to 02/02/2025": [
  ["450", "96", "150"],
  ["660", "23", "120"],
  ["146", "10", "136"],
  ["160", "76", "330"],
  ["170", "80", "235"],
  ["670", "30", "569"],
  ["579", "19", "450"],
  ],
  "03/02/2025 to 09/02/2025": [
  ["570", "20", "244"],
  ["129", "20", "299"],
  ["149", "40", "569"],
  ["235", "06", "240"],
  ["149", "47", "179"],
  ["169", "61", "245"],
  ["125", "83", "148"],
  ],
  "10/02/2025 to 16/02/2025": [
  ["450", "97", "179"],
  ["569", "05", "357"],
  ["589", "25", "168"],
  ["389", "08", "125"],
  ["129", "25", "230"],
  ["225", "94", "112"],
  ["260", "89", "360"],
  ],
  "17/02/2025 to 23/02/2025": [
  ["169", "67", "359"],
  ["560", "19", "478"],
  ["136", "08", "189"],
  ["250", "76", "169"],
  ["569", "07", "160"],
  ["780", "56", "150"],
  ["560", "16", "240"],
  ],
  "24/02/2025 to 02/03/2025": [
  ["139", "30", "190"],
  ["570", "27", "359"],
  ["155", "13", "120"],
  ["122", "58", "350"],
  ["235", "05", "159"],
  ["790", "69", "289"],
  ["129", "24", "356"],
  ],
  "03/03/2025 to 09/03/2025": [
  ["578", "09", "469"],
  ["679", "29", "469"],
  ["179", "78", "279"],
  ["240", "67", "124"],
  ["679", "28", "567"],
  ["155", "19", "388"],
  ["258", "50", "389"],
  ],
  "10/03/2025 to 16/03/2025": [
  ["579", "19", "135"],
  ["248", "41", "128"],
  ["357", "53", "355"],
  ["180", "92", "345"],
  ["255", "20", "280"],
  ["268", "68", "567"],
  ["117", "98", "189"],
  ],
  "17/03/2025 to 23/03/2025": [
  ["268", "60", "578"],
  ["457", "68", "350"],
  ["159", "50", "280"],
  ["790", "63", "139"],
  ["250", "79", "234"],
  ["357", "51", "560"],
  ["569", "01", "236"],
  ],
  "24/03/2025 to 30/03/2025": [
  ["159", "57", "890"],
  ["260", "85", "447"],
  ["248", "45", "780"],
  ["248", "45", "780"],
  ["578", "09", "289"],
  ["248", "44", "356"],
  ["346", "35", "366"],
  ],
  "31/03/2025 to 06/04/2025": [
  ["890", "72", "480"],
  ["350", "86", "790"],
  ["238", "38", "378"],
  ["169", "61", "678"],
  ["116", "82", "679"],
  ["139", "38", "125"],
  ["567", "87", "557"],
  ],
  "07/04/2025 to 13/04/2025": [
  ["340", "76", "178"],
  ["139", "35", "690"],
  ["260", "80", "226"],
  ["469", "91", "399"],
  ["367", "60", "460"],
  ["690", "52", "246"],
  ["112", "43", "300"],
  ],
  "14/04/2025 to 20/04/2025": [
  ["149", "43", "580"],
  ["900", "93", "689"],
  ["440", "87", "124"],
  ["440", "87", "124"],
  ["110", "20", "460"],
  ["500", "53", "689"],
  ["118", "09", "289"],
  ],
  "21/04/2025 to 27/04/2025": [
  ["140", "52", "679"],
  ["466", "68", "378"],
  ["799", "56", "150"],
  ["388", "99", "469"],
  ["560", "19", "478"],
  ["179", "72", "480"],
  ["169", "65", "889"],
  ],
  "28/04/2025 to 04/05/2025": [
  ["130", "45", "456"],
  ["570", "25", "690"],
  ["234", "94", "347"],
  ["250", "74", "248"],
  ["237", "24", "266"],
  ["190", "02", "679"],
  ["244", "01", "128"],
  ],
  "05/05/2025 to 11/05/2025": [
  ["100", "13", "689"],
  ["267", "51", "245"],
  ["349", "60", "235"],
  ["235", "08", "459"],
  ["346", "32", "156"],
  ["149", "40", "145"],
  ["568", "90", "136"],
  ],
  "12/05/2025 to 18/05/2025": [
  ["458", "71", "245"],
  ["347", "49", "478"],
  ["660", "20", "550"],
  ["235", "00", "190"],
  ["346", "36", "268"],
  ["189", "84", "789"],
  ["179", "73", "238"],
  ],
  "19/05/2025 to 25/05/2025": [
  ["450", "91", "678"],
  ["270", "97", "223"],
  ["235", "03", "120"],
  ["567", "82", "129"],
  ["137", "17", "566"],
  ["189", "82", "390"],
  ["800", "87", "449"],
  ],
};
export const SHRIDAY = {
  "30/12/2024 to 05/01/2025": [
  ["490", "32", "589"],
  ["560", "16", "790"],
  ["149", "45", "348"],
  ["677", "09", "568"],
  ["356", "45", "889"],
  ["280", "00", "145"],
  ["169", "69", "270"],
  ],
  "06/01/2025 to 12/01/2025": [
  ["890", "72", "147"],
  ["358", "60", "668"],
  ["360", "97", "557"],
  ["256", "30", "235"],
  ["459", "83", "670"],
  ["138", "20", "569"],
  ["245", "12", "570"],
  ],
  "13/01/2025 to 19/01/2025": [
  ["578", "07", "557"],
  ["450", "98", "279"],
  ["489", "16", "448"],
  ["347", "46", "790"],
  ["147", "22", "499"],
  ["235", "05", "357"],
  ["190", "07", "115"],
  ],
  "20/01/2025 to 26/01/2025": [
  ["230", "54", "356"],
  ["589", "27", "458"],
  ["225", "98", "189"],
  ["478", "93", "788"],
  ["780", "51", "380"],
  ["256", "34", "347"],
  ["488", "00", "136"],
  ],
  "27/01/2025 to 02/02/2025": [
  ["670", "31", "588"],
  ["360", "92", "679"],
  ["899", "63", "148"],
  ["235", "07", "124"],
  ["123", "68", "170"],
  ["289", "99", "450"],
  ["200", "21", "669"],
  ],
  "03/02/2025 to 09/02/2025": [
  ["130", "40", "244"],
  ["234", "97", "359"],
  ["450", "95", "168"],
  ["499", "28", "468"],
  ["146", "16", "457"],
  ["358", "69", "360"],
  ["339", "52", "589"],
  ],
  "10/02/2025 to 16/02/2025": [
  ["568", "92", "246"],
  ["459", "84", "789"],
  ["137", "13", "247"],
  ["780", "54", "356"],
  ["479", "09", "450"],
  ["500", "51", "489"],
  ["140", "52", "345"],
  ],
  "17/02/2025 to 23/02/2025": [
  ["130", "44", "347"],
  ["679", "25", "690"],
  ["477", "80", "235"],
  ["490", "30", "389"],
  ["126", "98", "279"],
  ["200", "23", "256"],
  ["567", "89", "478"],
  ],
  "24/02/2025 to 02/03/2025": [
  ["369", "82", "237"],
  ["470", "10", "460"],
  ["800", "84", "149"],
  ["140", "53", "247"],
  ["689", "31", "588"],
  ["359", "75", "500"],
  ["677", "00", "145"],
  ],
  "03/03/2025 to 09/03/2025": [
  ["250", "73", "139"],
  ["459", "88", "350"],
  ["569", "01", "245"],
  ["780", "57", "278"],
  ["559", "96", "600"],
  ["280", "09", "478"],
  ["299", "04", "680"],
  ],
  "10/03/2025 to 16/03/2025": [
  ["379", "91", "335"],
  ["140", "56", "457"],
  ["269", "70", "488"],
  ["447", "53", "346"],
  ["458", "78", "567"],
  ["349", "68", "459"],
  ["128", "12", "589"],
  ],
  "17/03/2025 to 23/03/2025": [
  ["367", "69", "126"],
  ["457", "68", "440"],
  ["578", "07", "278"],
  ["789", "42", "138"],
  ["499", "26", "150"],
  ["560", "13", "148"],
  ["130", "47", "124"],
  ],
  "24/03/2025 to 30/03/2025": [
  ["790", "67", "377"],
  ["289", "90", "569"],
  ["139", "31", "678"],
  ["459", "84", "257"],
  ["140", "58", "134"],
  ["789", "45", "780"],
  ["236", "14", "590"],
  ],
  "31/03/2025 to 06/04/2025": [
  ["168", "52", "480"],
  ["157", "35", "348"],
  ["690", "50", "550"],
  ["126", "96", "358"],
  ["467", "74", "356"],
  ["580", "38", "477"],
  ["150", "62", "129"],
  ],
  "07/04/2025 to 13/04/2025": [
  ["119", "10", "668"],
  ["679", "26", "349"],
  ["359", "75", "140"],
  ["189", "82", "589"],
  ["344", "15", "258"],
  ["600", "60", "190"],
  ["150", "61", "236"],
  ],
  "14/04/2025 to 20/04/2025": [
  ["589", "22", "156"],
  ["460", "04", "356"],
  ["490", "31", "245"],
  ["146", "11", "560"],
  ["780", "57", "133"],
  ["140", "50", "118"],
  ["249", "51", "100"],
  ],
  "21/04/2025 to 27/04/2025": [
  ["257", "44", "400"],
  ["258", "59", "478"],
  ["679", "20", "479"],
  ["234", "95", "168"],
  ["560", "10", "145"],
  ["559", "90", "569"],
  ["347", "42", "156"],
  ],
  "28/04/2025 to 04/05/2025": [
  ["890", "78", "288"],
  ["247", "33", "120"],
  ["599", "38", "125"],
  ["889", "51", "128"],
  ["380", "17", "566"],
  ["270", "90", "145"],
  ["677", "04", "130"],
  ],
  "05/05/2025 to 11/05/2025": [
  ["290", "17", "467"],
  ["357", "50", "479"],
  ["129", "29", "450"],
  ["490", "31", "579"],
  ["169", "64", "248"],
  ["124", "77", "250"],
  ["340", "76", "457"],
  ],
  "12/05/2025 to 18/05/2025": [
  ["369", "80", "235"],
  ["368", "76", "150"],
  ["679", "21", "470"],
  ["129", "23", "256"],
  ["167", "44", "789"],
  ["490", "36", "600"],
  ["467", "78", "260"],
  ],
  "19/05/2025 to 25/05/2025": [
  ["200", "29", "379"],
  ["889", "53", "139"],
  ["569", "01", "236"],
  ["569", "01", "236"],
  ["589", "29", "126"],
  ["799", "53", "120"],
  ["489", "18", "170"],
  ],
};
export const RAMADAY = {
  "30/12/2024 to 05/01/2025": [
  ["490", "38", "468"],
  ["235", "07", "458"],
  ["119", "16", "169"],
  ["778", "28", "369"],
  ["258", "57", "359"],
  ["800", "83", "580"],
  ["290", "19", "450"],
  ],
  "06/01/2025 to 12/01/2025": [
  ["299", "02", "679"],
  ["250", "78", "468"],
  ["237", "23", "120"],
  ["235", "05", "159"],
  ["458", "74", "590"],
  ["789", "49", "478"],
  ["234", "93", "346"],
  ],
  "13/01/2025 to 19/01/2025": [
  ["223", "71", "399"],
  ["259", "63", "580"],
  ["117", "94", "257"],
  ["567", "89", "360"],
  ["380", "13", "346"],
  ["378", "84", "158"],
  ["134", "81", "146"],
  ],
  "20/01/2025 to 26/01/2025": [
  ["300", "31", "579"],
  ["468", "86", "457"],
  ["250", "79", "234"],
  ["299", "05", "780"],
  ["344", "13", "670"],
  ["145", "01", "380"],
  ["467", "71", "155"],
  ],
  "27/01/2025 to 02/02/2025": [
  ["788", "35", "339"],
  ["245", "12", "228"],
  ["139", "37", "359"],
  ["680", "44", "680"],
  ["260", "89", "199"],
  ["779", "39", "289"],
  ["235", "04", "149"],
  ],
  "03/02/2025 to 09/02/2025": [
  ["570", "20", "677"],
  ["890", "79", "379"],
  ["899", "66", "178"],
  ["160", "76", "790"],
  ["688", "25", "348"],
  ["239", "43", "346"],
  ["220", "41", "380"],
  ],
  "10/02/2025 to 16/02/2025": [
  ["250", "79", "388"],
  ["258", "50", "479"],
  ["260", "89", "135"],
  ["336", "23", "157"],
  ["340", "70", "299"],
  ["119", "16", "178"],
  ["459", "87", "179"],
  ],
  "17/02/2025 to 23/02/2025": [
  ["140", "53", "580"],
  ["489", "16", "150"],
  ["780", "58", "189"],
  ["220", "41", "579"],
  ["356", "43", "580"],
  ["469", "96", "349"],
  ["245", "19", "135"],
  ],
  "24/02/2025 to 02/03/2025": [
  ["389", "08", "350"],
  ["170", "82", "589"],
  ["159", "54", "239"],
  ["159", "56", "123"],
  ["270", "98", "459"],
  ["900", "93", "788"],
  ["589", "24", "347"],
  ],
  "03/03/2025 to 09/03/2025": [
  ["470", "11", "245"],
  ["160", "73", "300"],
  ["270", "98", "558"],
  ["129", "26", "240"],
  ["123", "68", "378"],
  ["258", "58", "260"],
  ["340", "77", "467"],
  ],
  "10/03/2025 to 16/03/2025": [
  ["478", "91", "489"],
  ["689", "37", "557"],
  ["578", "04", "590"],
  ["389", "08", "170"],
  ["456", "51", "236"],
  ["150", "65", "690"],
  ["259", "65", "168"],
  ],
  "17/03/2025 to 23/03/2025": [
  ["570", "24", "167"],
  ["379", "94", "158"],
  ["155", "17", "890"],
  ["240", "60", "578"],
  ["349", "67", "250"],
  ["256", "33", "670"],
  ["129", "20", "145"],
  ],
  "24/03/2025 to 30/03/2025": [
  ["125", "86", "169"],
  ["267", "54", "400"],
  ["357", "50", "136"],
  ["360", "91", "579"],
  ["127", "02", "156"],
  ["580", "30", "677"],
  ["580", "30", "677"],
  ],
  "31/03/2025 to 06/04/2025": [
  ["228", "27", "179"],
  ["120", "31", "245"],
  ["690", "51", "678"],
  ["140", "59", "270"],
  ["389", "08", "459"],
  ["280", "06", "349"],
  ["240", "63", "256"],
  ],
  "07/04/2025 to 13/04/2025": [
  ["120", "31", "489"],
  ["230", "59", "126"],
  ["144", "99", "568"],
  ["190", "06", "790"],
  ["259", "65", "348"],
  ["157", "38", "189"],
  ["169", "65", "177"],
  ],
  "14/04/2025 to 20/04/2025": [
  ["350", "89", "478"],
  ["257", "46", "169"],
  ["580", "32", "390"],
  ["127", "03", "256"],
  ["138", "29", "289"],
  ["578", "09", "559"],
  ["200", "29", "270"],
  ],
  "21/04/2025 to 27/04/2025": [
  ["357", "51", "489"],
  ["235", "02", "660"],
  ["560", "14", "248"],
  ["150", "63", "120"],
  ["490", "33", "670"],
  ["178", "65", "140"],
  ["466", "68", "288"],
  ],
  "28/04/2025 to 04/05/2025": [
  ["120", "31", "245"],
  ["489", "11", "290"],
  ["670", "37", "340"],
  ["167", "44", "590"],
  ["349", "67", "160"],
  ["169", "68", "378"],
  ["237", "20", "118"],
  ],
  "05/05/2025 to 11/05/2025": [
  ["350", "87", "124"],
  ["266", "47", "278"],
  ["140", "58", "468"],
  ["589", "20", "190"],
  ["570", "20", "578"],
  ["139", "37", "557"],
  ["880", "62", "138"],
  ],
  "12/05/2025 to 18/05/2025": [
  ["128", "14", "347"],
  ["150", "60", "578"],
  ["280", "07", "115"],
  ["130", "44", "356"],
  ["100", "10", "479"],
  ["589", "27", "160"],
  ["346", "34", "770"],
  ],
  "19/05/2025 to 25/05/2025": [
  ["126", "92", "345"],
  ["347", "48", "125"],
  ["456", "55", "159"],
  ["136", "01", "489"],
  ["270", "91", "560"],
  ["130", "40", "370"],
  ["127", "07", "160"],
  ],
};
export const RADHANIGHT = {
  "30/12/2024 to 05/01/2025": [
  ["490", "32", "589"],
  ["560", "16", "790"],
  ["149", "45", "348"],
  ["677", "09", "568"],
  ["356", "45", "889"],
  ["280", "00", "145"],
  ["169", "69", "270"],
  ],
  "06/01/2025 to 12/01/2025": [
  ["347", "40", "569"],
  ["456", "59", "478"],
  ["246", "23", "580"],
  ["129", "28", "350"],
  ["690", "50", "479"],
  ["248", "42", "589"],
  ["889", "54", "590"],
  ],
  "13/01/2025 to 19/01/2025": [
  ["358", "64", "158"],
  ["569", "02", "570"],
  ["138", "27", "467"],
  ["290", "18", "440"],
  ["380", "16", "150"],
  ["137", "18", "350"],
  ["277", "66", "123"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["149", "44", "130"],
    ["689", "39", "270"],
    ["230", "59", "360"],
    ["260", "84", "455"],
    ["457", "64", "590"],
    ["247", "33", "157"],
    ["260", "84", "455"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["336", "28", "567"],
    ["150", "67", "278"],
    ["360", "91", "380"],
    ["270", "96", "240"],
    ["468", "80", "479"],
    ["489", "10", "280"],
    ["600", "62", "228"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["140", "52", "570"],
    ["149", "40", "569"],
    ["580", "31", "678"],
    ["139", "38", "170"],
    ["450", "99", "126"],
    ["790", "60", "334"],
    ["145", "02", "570"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["459", "88", "189"],
    ["590", "49", "126"],
    ["458", "71", "579"],
    ["230", "56", "349"],
    ["589", "21", "344"],
    ["350", "85", "690"],
    ["890", "73", "157"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["358", "69", "478"],
    ["679", "20", "226"],
    ["249", "54", "680"],
    ["234", "95", "159"],
    ["200", "21", "137"],
    ["469", "94", "347"],
    ["559", "96", "790"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["670", "31", "245"],
    ["500", "59", "478"],
    ["240", "68", "125"],
    ["600", "60", "479"],
    ["456", "51", "678"],
    ["460", "02", "156"],
    ["129", "22", "345"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["459", "82", "129"],
    ["290", "10", "389"],
    ["120", "38", "134"],
    ["250", "77", "160"],
    ["789", "48", "189"],
    ["356", "41", "678"],
    ["148", "31", "579"],
  ],
  "10/03/2025 to 16/03/2025": [
    ["690", "58", "369"],
    ["345", "28", "440"],
    ["270", "90", "460"],
    ["450", "91", "380"],
    ["240", "62", "480"],
    ["230", "52", "589"],
    ["288", "80", "370"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["580", "34", "158"],
    ["890", "77", "359"],
    ["360", "98", "125"],
    ["567", "81", "579"],
    ["559", "99", "126"],
    ["590", "41", "678"],
    ["137", "17", "179"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["560", "19", "568"],
    ["570", "26", "448"],
    ["130", "48", "170"],
    ["125", "81", "579"],
    ["289", "96", "790"],
    ["270", "99", "469"],
    ["580", "33", "670"],
  ],
  "31/03/2025 to 06/04/2025": [
    ["250", "72", "200"],
    ["569", "04", "248"],
    ["788", "31", "146"],
    ["256", "37", "359"],
    ["690", "57", "557"],
    ["130", "44", "356"],
    ["357", "52", "589"],
  ],
  "07/04/2025 to 13/04/2025": [
    ["670", "34", "149"],
    ["346", "37", "458"],
    ["589", "20", "389"],
    ["568", "94", "130"],
    ["345", "29", "126"],
    ["467", "74", "248"],
    ["179", "74", "149"],
  ],
  "14/04/2025 to 20/04/2025": [
    ["137", "19", "180"],
    ["378", "87", "359"],
    ["400", "48", "125"],
    ["157", "34", "149"],
    ["344", "13", "779"],
    ["235", "00", "127"],
    ["580", "30", "460"],
  ],
  "21/04/2025 to 27/04/2025": [
    ["780", "58", "459"],
    ["450", "90", "145"],
    ["680", "48", "990"],
    ["357", "59", "379"],
    ["556", "64", "130"],
    ["469", "96", "150"],
    ["379", "91", "119"],
  ],
  "28/04/2025 to 04/05/2025": [
    ["140", "58", "567"],
    ["135", "98", "125"],
    ["678", "11", "245"],
    ["358", "64", "338"],
    ["679", "22", "129"],
    ["289", "93", "157"],
    ["479", "00", "578"],
  ],
  "05/05/2025 to 11/05/2025": [
    ["590", "47", "223"],
    ["468", "85", "690"],
    ["290", "15", "230"],
    ["669", "14", "167"],
    ["780", "53", "599"],
    ["138", "24", "590"],
    ["255", "21", "146"],
  ],
  "12/05/2025 to 18/05/2025": [
    ["457", "62", "138"],
    ["168", "55", "690"],
    ["136", "04", "257"],
    ["280", "07", "890"],
    ["578", "09", "667"],
    ["458", "78", "350"],
    ["160", "74", "356"],
  ],
  "19/05/2025 to 25/05/2025": [
    ["290", "10", "127"],
    ["790", "69", "577"],
    ["490", "30", "578"],
    ["359", "72", "589"],
    ["240", "67", "340"],
    ["679", "26", "259"],
    ["224", "89", "270"],
  ],
};
export const SHRINIGHT = {
  "30/12/2024 to 05/01/2025": [
    ["180", "95", "249"],
    ["890", "71", "236"],
    ["570", "22", "390"],
    ["369", "89", "478"],
    ["127", "09", "450"],
    ["124", "71", "245"],
    ["236", "15", "267"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["300", "38", "378"],
    ["149", "41", "560"],
    ["780", "59", "900"],
    ["237", "25", "267"],
    ["490", "32", "156"],
    ["199", "90", "136"],
    ["300", "32", "138"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["178", "62", "480"],
    ["368", "71", "470"],
    ["379", "90", "370"],
    ["126", "98", "170"],
    ["120", "31", "236"],
    ["139", "31", "290"],
    ["144", "97", "188"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["590", "42", "679"],
    ["780", "59", "450"],
    ["790", "60", "389"],
    ["128", "18", "369"],
    ["160", "78", "440"],
    ["358", "63", "599"],
    ["123", "64", "680"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["237", "20", "235"],
    ["490", "39", "270"],
    ["146", "13", "120"],
    ["478", "90", "460"],
    ["289", "91", "119"],
    ["780", "55", "267"],
    ["679", "22", "200"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["467", "75", "267"],
    ["257", "47", "566"],
    ["268", "66", "169"],
    ["360", "92", "480"],
    ["158", "44", "680"],
    ["900", "97", "124"],
    ["135", "92", "129"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["489", "10", "569"],
    ["246", "20", "578"],
    ["239", "43", "689"],
    ["345", "23", "256"],
    ["690", "50", "479"],
    ["249", "53", "229"],
    ["470", "14", "455"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["456", "53", "157"],
    ["479", "08", "369"],
    ["137", "10", "460"],
    ["900", "99", "270"],
    ["578", "01", "579"],
    ["240", "69", "478"],
    ["125", "88", "170"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["699", "41", "380"],
    ["379", "93", "247"],
    ["250", "71", "146"],
    ["590", "41", "245"],
    ["120", "32", "129"],
    ["159", "51", "335"],
    ["269", "75", "258"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["278", "76", "268"],
    ["349", "64", "455"],
    ["270", "90", "569"],
    ["370", "04", "149"],
    ["248", "45", "357"],
    ["689", "31", "380"],
    ["346", "30", "127"],
  ],
  "10/03/2025 to 16/03/2025": [
    ["568", "98", "260"],
    ["568", "98", "260"],
    ["589", "22", "390"],
    ["238", "30", "488"],
    ["599", "38", "279"],
    ["179", "79", "289"],
    ["269", "71", "669"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["160", "78", "369"],
    ["338", "44", "158"],
    ["489", "12", "147"],
    ["689", "32", "589"],
    ["579", "16", "169"],
    ["357", "50", "127"],
    ["567", "86", "367"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["789", "41", "678"],
    ["135", "97", "269"],
    ["270", "92", "255"],
    ["378", "88", "170"],
    ["367", "62", "336"],
    ["389", "00", "569"],
    ["690", "53", "247"],
  ],
  "31/03/2025 to 06/04/2025": [
    ["220", "40", "460"],
    ["290", "14", "130"],
    ["470", "19", "270"],
    ["135", "99", "450"],
    ["240", "68", "800"],
    ["178", "69", "577"],
    ["179", "77", "359"],
  ],
  "07/04/2025 to 13/04/2025": [
    ["258", "55", "159"],
    ["570", "20", "280"],
    ["148", "30", "235"],
    ["455", "42", "660"],
    ["480", "28", "125"],
    ["459", "88", "468"],
    ["248", "45", "690"],
  ],
  "14/04/2025 to 20/04/2025": [
    ["160", "70", "145"],
    ["369", "81", "489"],
    ["350", "83", "120"],
    ["129", "24", "130"],
    ["240", "66", "457"],
    ["678", "10", "118"],
    ["358", "60", "370"],
  ],
  "21/04/2025 to 27/04/2025": [
    ["480", "21", "470"],
    ["567", "80", "190"],
    ["230", "55", "249"],
    ["135", "99", "360"],
    ["557", "79", "577"],
    ["356", "43", "157"],
    ["130", "40", "550"],
  ],
  "28/04/2025 to 04/05/2025": [
    ["559", "95", "690"],
    ["899", "67", "124"],
    ["169", "65", "456"],
    ["250", "74", "149"],
    ["890", "74", "455"],
    ["345", "22", "237"],
    ["233", "81", "678"],
  ],
  "05/05/2025 to 11/05/2025": [
    ["669", "11", "146"],
    ["350", "89", "180"],
    ["378", "84", "149"],
    ["479", "09", "126"],
    ["347", "41", "678"],
    ["144", "98", "468"],
    ["560", "17", "340"],
  ],
  "12/05/2025 to 18/05/2025": [
    ["390", "26", "169"],
    ["679", "21", "236"],
    ["260", "80", "668"],
    ["128", "17", "566"],
    ["567", "80", "280"],
    ["256", "32", "589"],
    ["139", "31", "100"],
  ],
  "19/05/2025 to 25/05/2025": [
    ["147", "22", "778"],
    ["490", "34", "220"],
    ["256", "31", "245"],
    ["127", "09", "478"],
    ["360", "99", "568"],
    ["470", "15", "348"],
    ["279", "80", "578"],
  ],
};
export const RAMANIGHT = {
  "30/12/2024 to 05/01/2025": [
    ["689", "35", "267"],
    ["120", "33", "346"],
    ["449", "71", "100"],
    ["367", "68", "189"],
    ["268", "67", "124"],
    ["260", "87", "179"],
    ["290", "13", "139"],
  ],
  "06/01/2025 to 12/01/2025": [
    ["146", "10", "569"],
    ["370", "06", "150"],
    ["380", "15", "113"],
    ["490", "39", "469"],
    ["670", "30", "118"],
    ["348", "56", "169"],
    ["457", "65", "159"],
  ],
  "13/01/2025 to 19/01/2025": [
    ["459", "83", "490"],
    ["125", "87", "160"],
    ["370", "06", "457"],
    ["589", "22", "138"],
    ["780", "51", "245"],
    ["170", "87", "124"],
    ["490", "33", "139"],
  ],
  "20/01/2025 to 26/01/2025": [
    ["290", "12", "156"],
    ["349", "63", "346"],
    ["130", "44", "239"],
    ["578", "06", "899"],
    ["370", "04", "356"],
    ["127", "00", "118"],
    ["257", "44", "220"],
  ],
  "27/01/2025 to 02/02/2025": [
    ["234", "91", "245"],
    ["236", "15", "258"],
    ["128", "17", "467"],
    ["668", "00", "460"],
    ["348", "54", "130"],
    ["356", "41", "669"],
    ["358", "66", "123"],
  ],
  "03/02/2025 to 09/02/2025": [
    ["150", "65", "140"],
    ["389", "00", "190"],
    ["260", "85", "357"],
    ["389", "06", "349"],
    ["578", "08", "189"],
    ["780", "56", "178"],
    ["789", "47", "124"],
  ],
  "10/02/2025 to 16/02/2025": [
    ["248", "49", "126"],
    ["157", "30", "460"],
    ["245", "13", "300"],
    ["667", "91", "344"],
    ["390", "23", "139"],
    ["499", "22", "156"],
    ["368", "74", "590"],
  ],
  "17/02/2025 to 23/02/2025": [
    ["670", "39", "379"],
    ["127", "09", "360"],
    ["377", "75", "230"],
    ["679", "25", "140"],
    ["226", "09", "379"],
    ["890", "77", "700"],
    ["149", "43", "238"],
  ],
  "24/02/2025 to 02/03/2025": [
    ["249", "52", "679"],
    ["113", "59", "289"],
    ["358", "62", "660"],
    ["448", "66", "169"],
    ["470", "14", "130"],
    ["248", "43", "689"],
    ["335", "11", "290"],
  ],
  "03/03/2025 to 09/03/2025": [
    ["250", "74", "347"],
    ["359", "79", "126"],
    ["346", "34", "248"],
    ["125", "88", "170"],
    ["250", "79", "568"],
    ["258", "54", "590"],
    ["140", "57", "124"],
  ],
  "10/03/2025 to 16/03/2025": [
    ["280", "08", "350"],
    ["177", "55", "267"],
    ["190", "06", "880"],
    ["123", "68", "279"],
    ["579", "11", "489"],
    ["348", "59", "478"],
    ["360", "98", "125"],
  ],
  "17/03/2025 to 23/03/2025": [
    ["337", "31", "290"],
    ["170", "86", "899"],
    ["470", "17", "124"],
    ["346", "31", "290"],
    ["348", "54", "789"],
    ["170", "80", "235"],
    ["446", "48", "378"],
  ],
  "24/03/2025 to 30/03/2025": [
    ["577", "90", "578"],
    ["05", "159", "489"],
    ["16", "123", "780"],
    ["52", "679", "789"],
    ["40", "460", "690"],
    ["54", "130", "125"],
    ["85", "168"],
  ],
  "31/03/2025 to 06/04/2025": [
    ["667", "99", "289"],
    ["470", "10", "280"],
    ["389", "07", "340"],
    ["129", "28", "288"],
    ["290", "19", "379"],
    ["124", "77", "179"],
    ["160", "71", "146"],
  ],
  "07/04/2025 to 13/04/2025": [
    ["780", "57", "278"],
    ["123", "62", "570"],
    ["356", "44", "257"],
    ["250", "70", "127"],
    ["389", "05", "456"],
    ["279", "85", "258"],
    ["356", "41", "489"],
  ],
  "14/04/2025 to 20/04/2025": [
    ["455", "40", "569"],
    ["348", "52", "129"],
    ["890", "70", "145"],
    ["246", "22", "237"],
    ["340", "75", "249"],
    ["280", "07", "278"],
    ["378", "81", "489"],
  ],
  "21/04/2025 to 27/04/2025": [
    ["125", "86", "367"],
    ["260", "81", "236"],
    ["120", "36", "259"],
    ["789", "44", "112"],
    ["277", "61", "489"],
    ["139", "31", "290"],
    ["280", "04", "239"],
  ],
  "28/04/2025 to 04/05/2025": [
    ["460", "01", "146"],
    ["880", "69", "450"],
    ["469", "91", "380"],
    ["124", "78", "350"],
    ["567", "85", "168"],
    ["290", "11", "128"],
    ["700", "78", "189"],
  ],
  "05/05/2025 to 11/05/2025": [
    ["127", "07", "458"],
    ["689", "34", "158"],
    ["239", "44", "590"],
    ["240", "69", "126"],
    ["577", "93", "670"],
    ["235", "06", "466"],
    ["124", "74", "158"],
  ],
  "12/05/2025 to 18/05/2025": [
    ["230", "54", "248"],
    ["378", "89", "270"],
    ["123", "68", "170"],
    ["129", "25", "140"],
    ["778", "20", "235"],
    ["234", "99", "360"],
    ["389", "05", "348"],
  ],
  "19/05/2025 to 25/05/2025": [
    ["468", "87", "278"],
    ["159", "59", "270"],
    ["359", "79", "577"],
    ["389", "01", "245"],
    ["139", "34", "130"],
    ["347", "48", "369"],
    ["124", "71", "380"],
  ],
};
